import UnifiedMessagesModule from "../components/UnifiedMessagesModule";
import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import ScoutCenterPage from "./ScoutCenterPage";
import WorkManagementCenter from "./WorkManagementCenter";
import PublisherDashboard from "./PublisherDashboard";
import EmployeeDashboard from "./EmployeeDashboard";
import {
  PublisherCrmBadgeButton,
  PublisherCrmDrawer,
  PublisherCrmModal,
  PublisherCrmSlideOver,
} from "../components/PublisherCrmModule";
import {
  GiftActiveDetailsContent,
  GiftAwardsContent,
  GiftDispatchManagementContent,
  PublisherBalancesContent,
  GiftMonthlyTrackingContent,
  GiftReportsContent,
} from "./GiftPrimeManagement";
import { MASTER_NOTES, MASTER_PHONES, MASTER_MANAGERS } from "../data/masterPublishersData";


// Yalnızca telefon ve tablet görünümünü sıkılaştırır.
// Masaüstü stilleri, veri akışı ve işlem fonksiyonları değiştirilmez.
function useMobileOnlyResponsiveLayout(scopeClass, enabled = true) {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") return undefined;

    const bodyClass = `${scopeClass}-active`;
    const styleId = `${scopeClass}-style`;
    document.body.classList.add(bodyClass);

    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      const scope = `body.${bodyClass}`;

      style.textContent = `
        @media (max-width: 1023px) {
          ${scope},
          ${scope} #root {
            width: 100%;
            max-width: 100%;
            overflow-x: hidden;
          }

          ${scope} main {
            width: 100%;
            min-width: 0;
            max-width: 100vw;
          }

          ${scope} table {
            display: block;
            width: 100%;
            max-width: 100%;
            overflow-x: auto;
            overscroll-behavior-inline: contain;
            -webkit-overflow-scrolling: touch;
          }

          ${scope} iframe,
          ${scope} video,
          ${scope} canvas {
            max-width: 100%;
          }

          ${scope} [class*="fixed"][class*="inset-0"] {
            overflow-y: auto;
            overscroll-behavior: contain;
          }
        }

        @media (max-width: 767px) {
          ${scope} {
            font-size: 13px;
            -webkit-text-size-adjust: 100%;
            text-size-adjust: 100%;
          }

          ${scope} *,
          ${scope} *::before,
          ${scope} *::after {
            box-sizing: border-box;
          }

          ${scope} h1,
          ${scope} [class~="text-5xl"],
          ${scope} [class~="text-4xl"] {
            font-size: clamp(1.7rem, 7.5vw, 2rem) !important;
            line-height: 1.12 !important;
            letter-spacing: -0.025em !important;
          }

          ${scope} h2,
          ${scope} [class~="text-3xl"] {
            font-size: clamp(1.35rem, 5.8vw, 1.6rem) !important;
            line-height: 1.18 !important;
          }

          ${scope} h3,
          ${scope} [class~="text-2xl"] {
            font-size: 1.15rem !important;
            line-height: 1.25 !important;
          }

          ${scope} [class~="text-xl"] {
            font-size: 1rem !important;
            line-height: 1.35 !important;
          }

          ${scope} p,
          ${scope} li {
            line-height: 1.55;
          }

          ${scope} [class~="p-10"],
          ${scope} [class~="p-9"],
          ${scope} [class~="p-8"],
          ${scope} [class~="p-7"],
          ${scope} [class~="p-6"],
          ${scope} [class~="p-5"] {
            padding: 1rem !important;
          }

          ${scope} [class~="px-10"],
          ${scope} [class~="px-9"],
          ${scope} [class~="px-8"],
          ${scope} [class~="px-7"],
          ${scope} [class~="px-6"],
          ${scope} [class~="px-5"] {
            padding-left: 1rem !important;
            padding-right: 1rem !important;
          }

          ${scope} [class~="py-10"],
          ${scope} [class~="py-9"],
          ${scope} [class~="py-8"],
          ${scope} [class~="py-7"],
          ${scope} [class~="py-6"] {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
          }

          ${scope} [class~="gap-10"],
          ${scope} [class~="gap-9"],
          ${scope} [class~="gap-8"],
          ${scope} [class~="gap-7"],
          ${scope} [class~="gap-6"],
          ${scope} [class~="gap-5"] {
            gap: 0.8rem !important;
          }

          ${scope} [class~="mt-10"],
          ${scope} [class~="mt-9"],
          ${scope} [class~="mt-8"],
          ${scope} [class~="mt-7"],
          ${scope} [class~="mt-6"] {
            margin-top: 1rem !important;
          }

          ${scope} [class~="mb-10"],
          ${scope} [class~="mb-9"],
          ${scope} [class~="mb-8"],
          ${scope} [class~="mb-7"],
          ${scope} [class~="mb-6"] {
            margin-bottom: 1rem !important;
          }

          ${scope} [class*="grid-cols-2"],
          ${scope} [class*="grid-cols-3"],
          ${scope} [class*="grid-cols-4"],
          ${scope} [class*="grid-cols-5"],
          ${scope} [class*="grid-cols-6"],
          ${scope} [class*="grid-cols-["] {
            grid-template-columns: minmax(0, 1fr) !important;
          }

          ${scope} form [class~="flex"] {
            flex-wrap: wrap;
          }

          ${scope} button,
          ${scope} [role="button"] {
            max-width: 100%;
            min-height: 38px;
            white-space: normal;
            touch-action: manipulation;
          }

          ${scope} input,
          ${scope} select,
          ${scope} textarea {
            width: 100%;
            max-width: 100%;
            min-height: 42px;
            font-size: 16px !important;
          }

          ${scope} textarea {
            min-height: 96px;
          }

          ${scope} table {
            font-size: 11px;
          }

          ${scope} th,
          ${scope} td {
            padding: 0.55rem 0.65rem !important;
            white-space: nowrap;
          }

          ${scope} svg[class*="h-["],
          ${scope} canvas[class*="h-["] {
            height: 230px !important;
            max-height: 42vh;
          }

          ${scope} iframe {
            min-height: 230px !important;
            height: 48vh !important;
          }

          ${scope} video {
            max-height: 52vh;
          }

          ${scope} img {
            max-width: 100%;
          }

          ${scope} [class*="fixed"][class*="inset-0"] {
            align-items: flex-start !important;
            padding: max(0.75rem, env(safe-area-inset-top)) 0.75rem max(0.75rem, env(safe-area-inset-bottom)) !important;
          }

          ${scope} [class*="fixed"][class*="inset-0"] > [class*="max-w-"] {
            width: 100% !important;
            max-width: 100% !important;
            max-height: calc(100dvh - 1.5rem) !important;
            margin: auto !important;
            overflow-y: auto !important;
          }

          ${scope} [class*="rounded-[2"],
          ${scope} [class*="rounded-[3"] {
            border-radius: 1.1rem !important;
          }

          ${scope} [class*="tracking-[0.3"],
          ${scope} [class*="tracking-[0.4"] {
            letter-spacing: 0.16em !important;
          }

          ${scope} [class*="max-w-7xl"],
          ${scope} [class*="max-w-6xl"],
          ${scope} [class*="max-w-5xl"],
          ${scope} [class*="max-w-4xl"],
          ${scope} [class*="max-w-3xl"] {
            max-width: 100% !important;
          }
        }

        @media (max-width: 380px) {
          ${scope} h1,
          ${scope} [class~="text-5xl"],
          ${scope} [class~="text-4xl"] {
            font-size: 1.55rem !important;
          }

          ${scope} h2,
          ${scope} [class~="text-3xl"] {
            font-size: 1.25rem !important;
          }

          ${scope} button,
          ${scope} [role="button"] {
            font-size: 11px !important;
          }
        }
      `;

      document.head.appendChild(style);
    }

    return () => {
      document.body.classList.remove(bodyClass);
    };
  }, [scopeClass, enabled]);
}

const ADMIN_THEME_STYLES = `
  .wm-admin-theme {
    --admin-gold: #d6a800;
    --admin-gold-dark: #9b7600;
    --admin-gold-soft: #fff8df;
    --admin-page: #f4f6f8;
    --admin-surface: #ffffff;
    --admin-surface-soft: #f8fafc;
    --admin-text: #182230;
    --admin-text-soft: #475467;
    --admin-muted: #667085;
    --admin-border: #d9dee7;
  }

  /* Tema anahtarı */
  .wm-admin-theme-switch {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px;
    border: 1px solid rgba(255,255,255,.10);
    border-radius: 12px;
    background: rgba(255,255,255,.035);
  }

  .wm-admin-theme-button {
    min-height: 32px;
    padding: 0 11px;
    border: 1px solid transparent;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 700;
    transition: background-color .15s ease, color .15s ease, border-color .15s ease;
  }

  .wm-admin-dark .wm-admin-theme-button {
    color: rgba(255,255,255,.55);
  }

  .wm-admin-dark .wm-admin-theme-button.is-active {
    background: #eab308;
    border-color: rgba(250,204,21,.55);
    color: #080808;
  }

  /* ================================================================
     AÇIK TEMA
     Mevcut JSX, API, state ve işlem fonksiyonlarına dokunmaz.
     ================================================================ */
  .wm-admin-light {
    background: var(--admin-page) !important;
    color: var(--admin-text) !important;
    color-scheme: light;
  }

  /* Koyu temanın dekoratif sabit arka planlarını açık modda gizle.
     z-50 modal overlay'leri etkilenmez. */
  .wm-admin-light > .fixed.inset-0:not(.z-50) {
    display: none !important;
  }

  .wm-admin-light main {
    background: var(--admin-page) !important;
    color: var(--admin-text) !important;
  }

  .wm-admin-light aside {
    background: #ffffff !important;
    border-color: var(--admin-border) !important;
    box-shadow: 1px 0 0 rgba(16,24,40,.03);
  }

  /* Ana yüzeyler */
  .wm-admin-light [class*="bg-white/"] {
    background-color: var(--admin-surface) !important;
  }

  .wm-admin-light [class*="bg-black/"]:not([class*="fixed"]) {
    background-color: var(--admin-surface-soft) !important;
  }

  .wm-admin-light [class*="bg-[#070707]"],
  .wm-admin-light [class*="bg-[#080808]"],
  .wm-admin-light [class*="bg-[#090909]"],
  .wm-admin-light [class*="bg-[#0a0a0a]"],
  .wm-admin-light [class*="bg-[#0b0b0b]"],
  .wm-admin-light [class*="bg-[#101010]"] {
    background-color: #ffffff !important;
  }

  /* Modal overlay koyu kalır, modal kartı açık olur */
  .wm-admin-light [class*="fixed"][class*="inset-0"][class*="bg-black"] {
    background-color: rgba(15,23,42,.48) !important;
  }

  .wm-admin-light [class*="fixed"][class*="inset-0"] > [class*="bg-[#0b0b0b]"] {
    background-color: #ffffff !important;
  }

  /* Yazılar */
  .wm-admin-light [class~="text-white"] {
    color: var(--admin-text) !important;
  }

  .wm-admin-light [class*="text-white/"] {
    color: var(--admin-muted) !important;
  }

  .wm-admin-light [class*="text-yellow-"] {
    color: var(--admin-gold-dark) !important;
  }

  .wm-admin-light [class*="fill-white"] {
    fill: #667085 !important;
  }

  .wm-admin-light [class*="fill-yellow"] {
    fill: #9b7600 !important;
  }

  /* Border'lar */
  .wm-admin-light [class*="border-white"] {
    border-color: var(--admin-border) !important;
  }

  .wm-admin-light [class*="border-yellow-"] {
    border-color: rgba(183,137,0,.34) !important;
  }

  /* Gold soft alanlar (sadece statik arka planlar, hover olmayanlar) */
  .wm-admin-light [class*="bg-yellow-500/"]:not([class*="hover:"]),
  .wm-admin-light [class*="bg-yellow-400/"]:not([class*="hover:"]) {
    background-color: var(--admin-gold-soft) !important;
  }

  /* Ana gold butonlar orijinal karakterini korur */
  .wm-admin-light [class~="bg-yellow-500"] {
    background-color: #eab308 !important;
    color: #111111 !important;
    border-color: #d6a800 !important;
  }

  .wm-admin-light [class~="hover:bg-yellow-500"]:hover,
  .wm-admin-light [class~="hover:bg-yellow-400"]:hover {
    background-color: #facc15 !important;
    color: #111111 !important;
  }

  /* Semantik renkler açık zeminde yüksek kontrast ve okunaklılık */
  .wm-admin-light [class*="text-green-"],
  .wm-admin-light [class*="text-emerald-"] {
    color: #047857 !important;
  }

  .wm-admin-light [class*="bg-green-"],
  .wm-admin-light [class*="bg-emerald-"] {
    background-color: #ecfdf5 !important;
  }

  .wm-admin-light [class*="border-green-"],
  .wm-admin-light [class*="border-emerald-"] {
    border-color: #a7f3d0 !important;
  }

  .wm-admin-light [class*="text-red-"],
  .wm-admin-light [class*="text-rose-"] {
    color: #be123c !important;
  }

  .wm-admin-light [class*="bg-red-"],
  .wm-admin-light [class*="bg-rose-"] {
    background-color: #fff1f2 !important;
  }

  .wm-admin-light [class*="border-red-"],
  .wm-admin-light [class*="border-rose-"] {
    border-color: #fecdd3 !important;
  }

  .wm-admin-light [class*="text-purple-"] {
    color: #6b21a8 !important;
  }

  .wm-admin-light [class*="bg-purple-"] {
    background-color: #faf5ff !important;
  }

  .wm-admin-light [class*="border-purple-"] {
    border-color: #e9d5ff !important;
  }

  .wm-admin-light [class*="text-amber-"] {
    color: #92400e !important;
  }

  .wm-admin-light [class*="bg-amber-"] {
    background-color: #fffbeb !important;
  }

  .wm-admin-light [class*="border-amber-"] {
    border-color: #fde68a !important;
  }

  .wm-admin-light [class*="text-fuchsia-"] {
    color: #8b3fa4 !important;
  }

  .wm-admin-light [class*="bg-fuchsia-"] {
    background-color: #fdf4ff !important;
  }

  .wm-admin-light [class*="border-fuchsia-"] {
    border-color: #f0abfc !important;
  }

  .wm-admin-light [class*="text-cyan-"] {
    color: #0e7490 !important;
  }

  .wm-admin-light [class*="bg-cyan-"] {
    background-color: #ecfeff !important;
  }

  .wm-admin-light [class*="border-cyan-"] {
    border-color: #a5f3fc !important;
  }

  /* Denetim Tablosu Özel Stilleri */
  .wm-audit-table-row {
    transition: background-color .15s ease;
  }
  .wm-audit-table-row:hover {
    background-color: rgba(255,255,255,.03);
  }
  .wm-admin-light .wm-audit-table-row {
    background-color: #ffffff;
    border-bottom: 1px solid #edf2f7 !important;
  }
  .wm-admin-light .wm-audit-table-row:hover {
    background-color: #f8fafc !important;
  }
  .wm-admin-light .wm-audit-table-header {
    background-color: #f1f5f9 !important;
    border-bottom: 1px solid #cbd5e1 !important;
    color: #475467 !important;
  }

  /* Form alanları */
  .wm-admin-light input,
  .wm-admin-light select,
  .wm-admin-light textarea,
  .wm-admin-light .form-input,
  .wm-admin-light .form-textarea {
    background: #ffffff !important;
    color: var(--admin-text) !important;
    border-color: #cfd6df !important;
    color-scheme: light !important;
  }

  .wm-admin-light input::placeholder,
  .wm-admin-light textarea::placeholder {
    color: #98a2b3 !important;
  }

  .wm-admin-light input:focus,
  .wm-admin-light select:focus,
  .wm-admin-light textarea:focus,
  .wm-admin-light .form-input:focus,
  .wm-admin-light .form-textarea:focus {
    border-color: #c99a12 !important;
    box-shadow: 0 0 0 3px rgba(201,154,18,.10) !important;
  }

  .wm-admin-light option {
    background: #ffffff !important;
    color: #182230 !important;
  }

  /* Kart ve tablo hiyerarşisi */
  .wm-admin-light [class*="shadow-[0_18px"],
  .wm-admin-light [class*="shadow-[0_20px"] {
    box-shadow:
      0 1px 2px rgba(16,24,40,.03),
      0 8px 24px rgba(16,24,40,.055) !important;
  }

  .wm-admin-light [class*="uppercase"][class*="bg-white/"] {
    background-color: #f7f8fa !important;
  }

  .wm-admin-light [class*="hover:bg-white"]:hover {
    background-color: #f8fafc !important;
  }

  .wm-admin-light [class*="hover:bg-yellow"]:hover {
    background-color: #fff9e8 !important;
  }

  /* Accordion / aktif menü */
  .wm-admin-light aside button {
    color: #344054;
  }

  .wm-admin-light aside button:hover {
    background-color: #f8fafc !important;
  }

  .wm-admin-light aside [class*="bg-yellow-500/"] {
    background-color: #fff8df !important;
    color: #8a6800 !important;
    border-color: rgba(183,137,0,.32) !important;
  }

  /* Grafik ve koyu özel yüzeyleri açık moda taşı */
  .wm-admin-light [class*="bg-[radial-gradient"] {
    background:
      radial-gradient(circle at top right, rgba(234,179,8,.10), transparent 30%),
      linear-gradient(180deg,#ffffff 0%,#f4f6f8 100%) !important;
  }

  .wm-admin-light svg text {
    fill: #0f172a !important;
    font-weight: 700 !important;
  }
  .wm-admin-light svg line[stroke*="255,255,255"] {
    stroke: rgba(0, 0, 0, 0.12) !important;
  }
  .wm-admin-light svg > rect[fill="rgba(0,0,0,0.18)"] {
    fill: rgba(255,255,255,.72) !important;
  }

  /* Tema anahtarı açık mod */
  .wm-admin-light .wm-admin-theme-switch {
    background: #eef1f5;
    border-color: #d9dee7;
  }

  .wm-admin-light .wm-admin-theme-button {
    color: #667085;
  }

  .wm-admin-light .wm-admin-theme-button.is-active {
    background: #ffffff;
    border-color: #d7b64a;
    color: #9b7600;
    box-shadow: 0 1px 3px rgba(16,24,40,.08);
  }

  /* Scrollbar */
  .wm-admin-light * {
    scrollbar-color: rgba(183,137,0,.50) #eef1f4;
  }

  /* ================================================================
     AÇIK TEMA V3
     Sadece görsel katman:
     - Yazılar daha net ve koyu
     - Kart/kutu yüzeyleri yumuşak geçişli gri
     - Mevcut işlev, API, state ve JSX akışı değiştirilmez
     ================================================================ */

  .wm-admin-light {
    --admin-page: #eef2f6;
    --admin-surface: #f6f8fa;
    --admin-surface-soft: #e9eef3;
    --admin-text: #101828;
    --admin-text-soft: #1d2939;
    --admin-muted: #475467;
    --admin-border: #cbd5df;
  }

  /* Genel zemin */
  .wm-admin-light,
  .wm-admin-light main {
    background:
      linear-gradient(
        180deg,
        #f4f6f8 0%,
        #eef2f5 45%,
        #e8edf2 100%
      ) !important;
  }

  /* Başlıklar ve ana metinler daha net */
  .wm-admin-light h1,
  .wm-admin-light h2,
  .wm-admin-light h3,
  .wm-admin-light h4,
  .wm-admin-light [class~="text-white"] {
    color: #101828 !important;
  }

  .wm-admin-light [class*="text-white/82"],
  .wm-admin-light [class*="text-white/80"],
  .wm-admin-light [class*="text-white/78"],
  .wm-admin-light [class*="text-white/68"],
  .wm-admin-light [class*="text-white/65"] {
    color: #1d2939 !important;
  }

  .wm-admin-light [class*="text-white/55"],
  .wm-admin-light [class*="text-white/48"],
  .wm-admin-light [class*="text-white/46"],
  .wm-admin-light [class*="text-white/45"],
  .wm-admin-light [class*="text-white/40"],
  .wm-admin-light [class*="text-white/35"],
  .wm-admin-light [class*="text-white/30"],
  .wm-admin-light [class*="text-white/25"] {
    color: #475467 !important;
  }

  /* Ana kartlar ve çerçeveli kutular:
     küçük badge/buton/uyarı renklerini bozmamak için yalnızca div yüzeyleri */
  .wm-admin-light div[class*="rounded-"][class*="border"]
    :not(button) {
  }

  .wm-admin-light div[class*="rounded-"][class*="border"]
    {
    background:
      linear-gradient(
        180deg,
        #f7f9fb 0%,
        #edf1f5 48%,
        #e3e8ee 100%
      ) !important;
    border-color: #cbd4de !important;
    box-shadow:
      0 1px 2px rgba(16,24,40,.035),
      0 8px 24px rgba(16,24,40,.06) !important;
  }

  /* Semantik / durum kutuları kendi renklerini korusun */
  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-red-"] {
    background: #fef3f2 !important;
    border-color: #fecdca !important;
  }

  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-green-"],
  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-emerald-"] {
    background: #ecfdf3 !important;
    border-color: #abefc6 !important;
  }

  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-yellow-"] {
    background:
      linear-gradient(
        180deg,
        #fff9e9 0%,
        #f7edc8 100%
      ) !important;
    border-color: rgba(183,137,0,.32) !important;
  }

  /* Header ve büyük ana paneller biraz daha belirgin */
  .wm-admin-light header[class*="rounded-"],
  .wm-admin-light main > div > div[class*="rounded-"][class*="border"] {
    background:
      linear-gradient(
        180deg,
        #f8fafc 0%,
        #edf1f5 50%,
        #e1e7ed 100%
      ) !important;
    border-color: #c7d0da !important;
  }

  /* Stat kartlar */
  .wm-admin-light .grid > div[class*="rounded-"][class*="border"] {
    background:
      linear-gradient(
        180deg,
        #f7f9fb 0%,
        #edf1f5 52%,
        #e2e7ed 100%
      ) !important;
  }

  /* Form alanları daha okunaklı */
  .wm-admin-light input,
  .wm-admin-light select,
  .wm-admin-light textarea,
  .wm-admin-light .form-input,
  .wm-admin-light .form-textarea {
    background:
      linear-gradient(
        180deg,
        #ffffff 0%,
        #f4f7fa 100%
      ) !important;
    color: #101828 !important;
    border-color: #c7d0da !important;
  }

  .wm-admin-light input::placeholder,
  .wm-admin-light textarea::placeholder {
    color: #7d8999 !important;
  }

  /* Tablolar */
  .wm-admin-light thead {
    background:
      linear-gradient(
        180deg,
        #f5f7fa 0%,
        #e9eef3 100%
      ) !important;
  }

  .wm-admin-light tbody tr {
    background: rgba(247,249,251,.78) !important;
  }

  .wm-admin-light tbody tr:nth-child(even) {
    background: rgba(238,242,246,.92) !important;
  }

  .wm-admin-light tbody tr:hover {
    background: rgba(255,248,222,.70) !important;
  }

  /* Performans / grafik gibi radial-gradient kullanan büyük kutular */
  .wm-admin-light [class*="bg-[radial-gradient"] {
    background:
      radial-gradient(
        circle at top right,
        rgba(234,179,8,.10),
        transparent 26%
      ),
      linear-gradient(
        180deg,
        #edf1f5 0%,
        #e2e7ed 52%,
        #d8dee5 100%
      ) !important;
    border-color: #c5ced8 !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.72),
      0 10px 28px rgba(16,24,40,.07) !important;
  }

  /* Grafik iç yüzeyi */
  .wm-admin-light svg > rect[fill="rgba(0,0,0,0.18)"] {
    fill: rgba(255,255,255,.78) !important;
  }

  .wm-admin-light svg [class*="fill-yellow-"] {
    fill: #8f6a00 !important;
  }

  /* Sol menü metinleri net */
  .wm-admin-light aside button,
  .wm-admin-light aside span {
    color: #253247;
  }

  /* Gold vurgular açık temada koyu ve belirgin */
  .wm-admin-light [class*="text-yellow-"] {
    color: #8f6a00 !important;
  }

  /* Butonlar arka plan gradyanlarından etkilenmesin */
  .wm-admin-light button[class*="bg-yellow-500"] {
    background: #eab308 !important;
    color: #101010 !important;
    border-color: #d6a800 !important;
    box-shadow: none !important;
  }

  .wm-admin-light button[class*="bg-white"],
  .wm-admin-light button[class*="bg-black"],
  .wm-admin-light button[class*="bg-[#"] {
    background: #f8fafc !important;
    color: #1d2939 !important;
    border-color: #cbd5df !important;
  }

  /* Tema seçici */
  .wm-admin-light .wm-admin-theme-switch {
    background:
      linear-gradient(180deg,#f3f6f9 0%,#e5eaf0 100%) !important;
    border-color: #cbd5df !important;
  }

  .wm-admin-light .wm-admin-theme-button {
    background: transparent !important;
    color: #667085 !important;
    box-shadow: none !important;
  }

  .wm-admin-light .wm-admin-theme-button.is-active {
    background: #ffffff !important;
    color: #8f6a00 !important;
    border-color: #d7b64a !important;
    box-shadow: 0 1px 3px rgba(16,24,40,.08) !important;
  }

`;

const API_USERS_LIST = "/api/users-list.php";
const API_USER_ADD = "/api/user-add.php";
const API_USER_UPDATE = "/api/user-update.php";
const API_USER_DELETE = "/api/user-delete.php";
const API_USER_NOTE_UPDATE = "/api/user-note-update.php";
const API_PASSWORD_UPDATE = "/api/password-update.php";
const API_BULK_ASSIGN_MANAGER = "/api/bulk-assign-manager.php";
const API_SYNC_PUBLISHERS_MASTER = "/api/sync-publishers-master.php";
const API_BULK_UPLOAD = "/api/bulk-upload.php";
const API_BULK_PASSWORD_UPDATE = "/api/bulk-password-update.php";
const API_MESSAGES_LIST = "/api/messages-list.php";
const API_PASSWORD_RESET_LIST = "/api/password-reset-list.php";
const API_ADMIN_PERFORMANCE = "/api/employee-performance-summary.php";
const API_ACADEMY_LIST = "/api/academy-list.php";
const API_ACADEMY_SAVE = "/api/academy-save.php";
const API_ACADEMY_DELETE = "/api/academy-delete.php";
const API_PERFORMANCE_UPLOAD = "/api/performance-upload.php";
const API_PERFORMANCE_DELETE = "/api/performance-delete.php";
const API_PERFORMANCE_SUMMARY = "/api/performance-upload-summary.php";
const API_PERFORMANCE_EXPORT = "/api/performance-export.php";
const API_PUBLISHER_REPORT_DIFF = "/api/publisher-report-diff.php";
const API_TRAINING_LIST = "/api/training-list.php";
const API_TRAINING_SAVE = "/api/training-save.php";
const API_TRAINING_UPLOAD = "/api/training-upload.php";
const API_TRAINING_DELETE = "/api/training-delete.php";
const API_TRAINING_DETAIL = "/api/training-detail.php";
const API_REWARD_LIST = "/api/reward-list.php";
const API_REWARD_SAVE = "/api/reward-save.php";
const API_REWARD_UPLOAD = "/api/reward-upload.php";
const API_REWARD_DELETE = "/api/reward-delete.php";
const API_FAQ_LIST = "/api/faq-list.php";
const API_FAQ_SAVE = "/api/faq-save.php";
const API_FAQ_DELETE = "/api/faq-delete.php";
const API_FEATURED_PUBLISHER_LIST = "/api/featured-publisher-list.php";
const API_FEATURED_PUBLISHER_SAVE = "/api/featured-publisher-save.php";
const API_FEATURED_PUBLISHER_DELETE = "/api/featured-publisher-delete.php";
const API_TIKTOK_PROFILE_FETCH = "/api/tiktok-profile-fetch.php";
const API_SYNC_ALL_TIKTOK_AVATARS = "/api/sync-all-tiktok-avatars.php";
const API_TIER_REWARD_LIST = "/api/tier-reward-list.php";
const API_TIER_REWARD_SAVE = "/api/tier-reward-save.php";
const API_TIER_REWARD_DELETE = "/api/tier-reward-delete.php";
const API_GIFT_CAMPAIGN_SAVE = "/api/gift-campaign-save.php";
const API_GIFT_CAMPAIGN_CALCULATE = "/api/gift-campaign-calculate.php";
const API_GIFT_CAMPAIGN_PUBLISH = "/api/gift-campaign-publish.php";
const API_GIFT_CAMPAIGN_UNPUBLISH = "/api/gift-campaign-unpublish.php";
const API_GIFT_CAMPAIGN_LIST = "/api/gift-campaign-list.php";
const API_GIFT_WINNERS_LIST = "/api/gift-winners-list.php";
const API_GIFT_WINNER_MANUAL_UPDATE = "/api/gift-winner-manual-update.php";
const API_AGENCY_TRACKING_LIST = "/api/agency-tracking-list.php";
const API_AGENCY_TRACKING_SAVE = "/api/agency-tracking-save.php";
const API_ADMIN_CONSENT_LIST = "/api/admin-consent-list.php";
const API_ADMIN_VISITOR_LIST = "/api/admin-visitor-list.php";
const API_ACTIVE_SESSIONS_LIST = "/api/active-sessions-list.php";

const managementSubModules = [
  { key: "publisher_list", label: "Yayıncı Paneli" },
  { key: "publisher_messages", label: "Yayıncı Mesajları" },
  { key: "publisher_content", label: "Yayıncı İçerikleri" },
  { key: "manager_list", label: "Yönetici Paneli" },
  { key: "manager_messages_performance", label: "Yönetici Mesajları" },
  { key: "manager_content", label: "Yönetici İçerikleri" },
];

const publisherSubModules = managementSubModules.filter((m) => m.key.startsWith("publisher_"));
const managerSubModules = managementSubModules.filter((m) => m.key.startsWith("manager_"));

const publisherTrackingSubModules = [
  { key: "scout_dashboard", label: "Yayıncı Aday Takibi" },
  { key: "scout_followup", label: "Yeni Yayıncı Takibi" },
  { key: "scout_publisher_tracking", label: "Yayıncı Takibi" },
  { key: "scout_reports", label: "Yayıncı Raporları" },
];

const scoutSubModules = publisherTrackingSubModules;

const workManagementSubModules = [];

const reportSubModules = [
  { key: "reports_overview", label: "Rapor Merkezi" },
  { key: "powerbi_permissions", label: "Rapor Yetkileri" },
  { key: "publisher_reports", label: "Yayıncı Raporları" },
  { key: "manager_report_definitions", label: "Yönetici Raporları" },
  { key: "admin_reports", label: "Admin Raporları" },
  { key: "report_filters", label: "RLS / Filtre Kuralları" },
];

const giftPrimeSubModules = [
  { key: "gift_active_details", label: "Yayıncı Aktiflik Detayları" },
  { key: "gift_awards", label: "Hediye / Prim İşlemleri" },
  { key: "gift_balances", label: "Wolf Media Yayıncı Bakiyeleri" },
  { key: "gift_monthly_tracking", label: "Aylık Gönderim Takibi" },
  { key: "gift_reports", label: "Raporlar" },
];

const otherSettingsSubModules = [
  { key: "publisher_training", label: "Eğitim Merkezi" },
  { key: "featured_publishers", label: "Öne Çıkan Yayıncılar" },
  { key: "manager_assignment", label: "Yayıncı Eşleştirme" },
  { key: "manager_permissions", label: "Yönetici Yetkileri" },
  { key: "manager_reports", label: "Ekip Raporları" },
  { key: "editor_requests", label: "Editör & Zakan Talepleri" },
  { key: "content_settings", label: "İçerik Ayarları" },
  { key: "reward_settings", label: "Etkinlik / Ödül" },
  { key: "faq", label: "Sık Sorulan Sorular" },
  { key: "gifts", label: "Şifre Talepleri" },
  { key: "approvals", label: "Onay ve Ziyaret Takibi" },
  { key: "settings", label: "Sistem Ayarları" },
  { key: "role_permissions", label: "Rol Yetkileri" },
];

const powerBiReports = [
  { id: 1, type: "Yayıncı", name: "Yayıncı Performans Raporu", table: "Yayıncı_PublisherDashboard", filter: "HiddenID + Tarih", role: "publisher_rls", status: "Aktif" },
  { id: 2, type: "Yayıncı", name: "Yayıncı Kademe Raporu", table: "PublisherTierSummary", filter: "HiddenID", role: "publisher_rls", status: "Aktif" },
  { id: 3, type: "Yönetici", name: "Yönetici Ekip Performans Raporu", table: "ManagerTeamPerformance", filter: "Yönetici Kullanıcı Adı + Tarih", role: "manager_team_rls", status: "Aktif" },
  { id: 4, type: "Yönetici", name: "Yönetici Top Liste Raporu", table: "ManagerTopList", filter: "Yönetici Kullanıcı Adı + Dönem", role: "manager_team_rls", status: "Aktif" },
  { id: 5, type: "Admin", name: "Genel Ajans Raporu", table: "AgencyOverview", filter: "Tüm Veri", role: "admin_full_access", status: "Aktif" },
];

const eventRows = [
  { title: "Mayıs Elmas Yarışı", target: "Kademe 4+", type: "Yarışma", status: "Aktif", seen: "71%" },
  { title: "Haftalık Yayın Süresi Fırsatı", target: "Tüm Yayıncılar", type: "Kampanya", status: "Aktif", seen: "58%" },
];

const faqRows = [
  { title: "Elmas hedefimi nereden takip ederim?", target: "Tüm Yayıncılar", type: "Soru", status: "Aktif", seen: "-" },
  { title: "Rapor açılmazsa ne yapmalıyım?", target: "Tüm Yayıncılar", type: "Soru", status: "Aktif", seen: "-" },
];

const emptyPublisherForm = {
  fullName: "",
  system_username: "",
  username: "",
  email: "",
  password: "",
  phone: "",
  hiddenId: "",
  assignedEmployeeUsername: "",
  powerBIRole: "",
  agencyTrackingStatus: "Aktif",
  status: "Aktif",
  note: "",
  image: "",
  isFeatured: false,
};

const emptyManagerForm = {
  fullName: "",
  username: "",
  password: "",
  phone: "",
  email: "",
  status: "Aktif",
};

const emptyScoutForm = {
  fullName: "",
  username: "",
  password: "",
  phone: "",
  email: "",
  status: "Aktif",
};

const emptyPasswordForm = {
  newPassword: "",
  confirmPassword: "",
};

const emptyTrainingForm = {
  id: "",
  title: "",
  description: "",
  contentType: "video",
  targetGroup: "all",
  fileUrl: "",
  externalUrl: "",
  status: "Aktif",
};

function safeNumber(value) {
  return Number(value) || 0;
}

function formatNumber(value) {
  return safeNumber(value).toLocaleString("tr-TR");
}

function toInputDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getDefaultReportRange() {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);

  return {
    start: toInputDate(start),
    end: toInputDate(today),
  };
}

function getPublisherHiddenId(publisher) {
  return String(
    publisher?.hiddenId ||
      publisher?.hidden_id ||
      publisher?.hiddenID ||
      publisher?.hiddenid ||
      ""
  ).trim();
}

function normalizeUsername(value) {
  return String(value || "").toLowerCase().replace(/[@\s]/g, "").trim();
}

export function isUserSuperAdmin(user = {}) {
  const role = String(user?.role || "").toLowerCase().trim();
  const username = String(user?.username || "").toLowerCase().trim();
  const systemUsername = String(user?.system_username || "").toLowerCase().trim();

  // Müdür, yönetici, scout, editör veya yayıncı ise kesinlikle admin DEĞİLDİR
  if (
    role === "manager" ||
    role === "scout" ||
    role === "editor" ||
    role === "publisher" ||
    role === "employee" ||
    role === "director" ||
    role === "mudur" ||
    role === "yonetici"
  ) {
    return false;
  }

  return (
    role === "admin" ||
    role === "superadmin" ||
    username === "admin" ||
    username === "wolf.admin" ||
    systemUsername === "admin" ||
    systemUsername === "wolf.admin" ||
    (!role && !username)
  );
}

function deduplicatePublishersByHiddenId(publishers = []) {
  if (!Array.isArray(publishers) || publishers.length <= 1) {
    return publishers || [];
  }

  const seenHiddenIds = new Map();
  const noHiddenIdList = [];

  publishers.forEach((pub, index) => {
    const rawHiddenId = getPublisherHiddenId(pub);

    if (!rawHiddenId || rawHiddenId === "-" || rawHiddenId === "0" || rawHiddenId.toLowerCase() === "null") {
      noHiddenIdList.push(pub);
      return;
    }

    const key = rawHiddenId.toLowerCase();
    const existing = seenHiddenIds.get(key);

    if (!existing) {
      seenHiddenIds.set(key, { ...pub, _originalIndex: index });
    } else {
      const existingId = Number(existing.id) || 0;
      const currentId = Number(pub.id) || 0;

      const existingCreatedAt = existing.createdAt || existing.raw?.createdAt || existing.raw?.created_at || "";
      const currentCreatedAt = pub.createdAt || pub.raw?.createdAt || pub.raw?.created_at || "";

      let isCurrentNewer = false;

      if (currentId > 0 && existingId > 0 && currentId !== existingId) {
        isCurrentNewer = currentId > existingId;
      } else if (existingCreatedAt && currentCreatedAt && existingCreatedAt !== currentCreatedAt) {
        const timeExisting = new Date(String(existingCreatedAt).replace(" ", "T")).getTime() || 0;
        const timeCurrent = new Date(String(currentCreatedAt).replace(" ", "T")).getTime() || 0;
        isCurrentNewer = timeCurrent >= timeExisting;
      } else {
        isCurrentNewer = true;
      }

      if (isCurrentNewer) {
        seenHiddenIds.set(key, { ...pub, _originalIndex: index });
      }
    }
  });

  const deduplicated = Array.from(seenHiddenIds.values()).map((item) => {
    const { _originalIndex, ...rest } = item;
    return rest;
  });

  return [...deduplicated, ...noHiddenIdList];
}

function formatDateForDisplay(value) {
  if (!value) return "-";
  const [year, month, day] = String(value).split("-");
  if (!year || !month || !day) return value;
  return `${day}.${month}.${year}`;
}

function formatDurationFromSeconds(seconds) {
  const total = safeNumber(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  return `${hours} sa ${minutes} dk`;
}

function parseInputDate(value) {
  const [year, month, day] = String(value || "").split("-").map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
}

function addDaysInputDate(value, amount) {
  const date = parseInputDate(value);
  date.setDate(date.getDate() + amount);
  return toInputDate(date);
}

function getDateRangeDayCount(startDate, endDate) {
  const start = parseInputDate(startDate);
  const end = parseInputDate(endDate);
  const diff = end.getTime() - start.getTime();

  return Math.max(1, Math.floor(diff / (1000 * 60 * 60 * 24)) + 1);
}

function getPreviousEqualDateRange(startDate, endDate) {
  const dayCount = getDateRangeDayCount(startDate, endDate);

  return {
    start: addDaysInputDate(startDate, -dayCount),
    end: addDaysInputDate(startDate, -1),
  };
}

function getSummaryNumber(summary, keys = []) {
  for (const key of keys) {
    const value = summary?.[key];

    if (value !== undefined && value !== null && value !== "") {
      return safeNumber(value);
    }
  }

  return 0;
}

function getTrendPercent(current, previous) {
  const currentValue = safeNumber(current);
  const previousValue = safeNumber(previous);

  if (previousValue === 0 && currentValue === 0) return 0;
  if (previousValue === 0 && currentValue > 0) return 100;

  return Math.round(((currentValue - previousValue) / previousValue) * 100);
}

function CompareNote({
  current,
  previous,
  formatter = formatNumber,
  prefix = "",
  suffix = "",
}) {
  const currentValue = safeNumber(current);
  const previousValue = safeNumber(previous);
  const diff = currentValue - previousValue;
  const percent = getTrendPercent(currentValue, previousValue);

  const colorClass =
    diff > 0
      ? "text-green-400"
      : diff < 0
        ? "text-red-400"
        : "text-white/40";

  const icon = diff > 0 ? "▲" : diff < 0 ? "▼" : "■";

  return (
    <div className={`mt-1 text-[11px] font-bold ${colorClass}`}>
      {icon} %{Math.abs(percent)}{" "}
      <span className="text-white/35">
        Önceki: {prefix}
        {formatter(previousValue)}
        {suffix}
      </span>
    </div>
  );
}



function SvgDiamondTooltip({ point, chartWidth = 1000 }) {
  if (!point) return null;

  const boxWidth = 210;
  const boxHeight = 48;
  const x = Math.min(Math.max(point.x - boxWidth / 2, 8), chartWidth - boxWidth - 8);
  const y = Math.max(point.y - boxHeight - 14, 8);

  return (
    <g pointerEvents="none">
      <rect
        x={x}
        y={y}
        width={boxWidth}
        height={boxHeight}
        rx="14"
        fill="rgba(5,5,5,0.94)"
        stroke="rgba(250,204,21,0.46)"
      />
      <text x={x + 14} y={y + 19} className="fill-white/55 text-[11px] font-semibold">
        {point.dateText}
      </text>
      <text x={x + 14} y={y + 36} className="fill-yellow-300 text-[13px] font-black">
        Elmas: {formatNumber(point.value)}
      </text>
    </g>
  );
}

function getPublisherTierInfo(source = {}, diamondOverride) {
  const diamondValue =
    diamondOverride !== undefined && diamondOverride !== null
      ? safeNumber(diamondOverride)
      : safeNumber(
          source?.performanceDiamonds ??
            source?.currentDiamonds ??
            source?.totalDiamonds ??
            source?.total_diamonds ??
            source?.diamonds ??
            source?.elmas ??
            source?.previousMonthDiamonds ??
            0
        );

  const rawTier = String(
    source?.tier ||
      source?.kademe ||
      source?.tierLabel ||
      source?.kademeLabel ||
      ""
  );

  let tierNo = 1;

  if (diamondValue >= 3000000) tierNo = 10;
  else if (diamondValue >= 1600000) tierNo = 9;
  else if (diamondValue >= 1200000) tierNo = 8;
  else if (diamondValue >= 800000) tierNo = 7;
  else if (diamondValue >= 500000) tierNo = 6;
  else if (diamondValue >= 300000) tierNo = 5;
  else if (diamondValue >= 150000) tierNo = 4;
  else if (diamondValue >= 80000) tierNo = 3;
  else if (diamondValue >= 40000) tierNo = 2;
  else {
    const parsedTier = Number(rawTier.match(/\d+/)?.[0] || 0);
    tierNo = parsedTier > 0 ? parsedTier : 1;
  }

  if (tierNo >= 10) {
    return {
      tierNo,
      tierLabel: "Tier 10",
      kademeLabel: "Kademe 10",
      groupLabel: "Top",
      badgeClass:
        "border-yellow-300/60 bg-yellow-400/15 text-yellow-200 shadow-[0_0_18px_rgba(250,204,21,.18)]",
      textClass: "text-yellow-200",
      rowClass: "border-yellow-400/25 bg-yellow-500/[0.055]",
    };
  }

  if (tierNo >= 9) {
    return {
      tierNo,
      tierLabel: "Tier 9",
      kademeLabel: "Kademe 9",
      groupLabel: "Top",
      badgeClass:
        "border-yellow-300/60 bg-yellow-400/15 text-yellow-200 shadow-[0_0_18px_rgba(250,204,21,.18)]",
      textClass: "text-yellow-200",
      rowClass: "border-yellow-400/25 bg-yellow-500/[0.055]",
    };
  }

  if (tierNo >= 6) {
    return {
      tierNo,
      tierLabel: `Tier ${tierNo}`,
      kademeLabel: `Kademe ${tierNo}`,
      groupLabel: "Pre-Top",
      badgeClass: "border-fuchsia-400/50 bg-fuchsia-500/12 text-fuchsia-200",
      textClass: "text-fuchsia-200",
      rowClass: "border-fuchsia-400/20 bg-fuchsia-500/[0.045]",
    };
  }

  if (tierNo >= 3) {
    return {
      tierNo,
      tierLabel: `Tier ${tierNo}`,
      kademeLabel: `Kademe ${tierNo}`,
      groupLabel: "Mature",
      badgeClass: "border-cyan-400/45 bg-cyan-500/12 text-cyan-200",
      textClass: "text-cyan-200",
      rowClass: "border-cyan-400/20 bg-cyan-500/[0.045]",
    };
  }

  if (tierNo === 2) {
    return {
      tierNo,
      tierLabel: "Tier 2",
      kademeLabel: "Kademe 2",
      groupLabel: "G4",
      badgeClass: "border-emerald-400/45 bg-emerald-500/12 text-emerald-200",
      textClass: "text-emerald-200",
      rowClass: "border-emerald-400/20 bg-emerald-500/[0.045]",
    };
  }

  return {
    tierNo: 1,
    tierLabel: "Tier 1",
    kademeLabel: "Kademe 1",
    groupLabel: "G0-G3",
    badgeClass: "border-white/20 bg-white/[0.045] text-white/65",
    textClass: "text-white/70",
    rowClass: "border-white/10 bg-white/[0.025]",
  };
}

function sortPublishersByTierDesc(list = []) {
  return [...list].sort((a, b) => {
    const tierA = getPublisherTierInfo(a).tierNo;
    const tierB = getPublisherTierInfo(b).tierNo;

    if (tierB !== tierA) return tierB - tierA;

    const diamondsA = safeNumber(
      a?.performanceDiamonds ??
        a?.currentDiamonds ??
        a?.totalDiamonds ??
        a?.total_diamonds ??
        a?.diamonds ??
        0
    );

    const diamondsB = safeNumber(
      b?.performanceDiamonds ??
        b?.currentDiamonds ??
        b?.totalDiamonds ??
        b?.total_diamonds ??
        b?.diamonds ??
        0
    );

    return diamondsB - diamondsA;
  });
}

function PublisherTierBadge({ publisher = {}, diamonds, compact = false }) {
  const tierInfo = getPublisherTierInfo(publisher, diamonds);
  const sizeClass = compact ? "px-2 py-0.5 text-[9px]" : "px-2.5 py-1 text-[10px]";

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${compact ? "mt-1" : "mt-2"}`}>
      <span
        className={`inline-flex shrink-0 items-center rounded-full border font-medium leading-none ${sizeClass} ${tierInfo.badgeClass}`}
      >
        {tierInfo.groupLabel}
      </span>

      <span
        className={`inline-flex shrink-0 items-center rounded-full border font-medium leading-none ${sizeClass} ${tierInfo.badgeClass}`}
      >
        {tierInfo.tierLabel}
      </span>
    </div>
  );
}

function PublisherNameWithTier({ publisher = {}, diamonds, label, className = "", nameClassName = "" }) {
  const tierInfo = getPublisherTierInfo(publisher, diamonds);
  const displayName = label || publisher?.fullName || publisher?.username || "-";

  return (
    <div className={`flex min-w-0 items-center ${className}`}>
      <span className={`truncate ${tierInfo.textClass} ${nameClassName}`}>
        {displayName}
      </span>
    </div>
  );
}


const TARGET_GROUP_OPTIONS = [
  { value: "all", label: "Tüm Yayıncılar", badgeClass: "border-yellow-400/45 bg-yellow-500/12 text-yellow-200", rowClass: "border-yellow-400/20 bg-yellow-500/[0.035]" },
  { value: "top", label: "Top", badgeClass: "border-yellow-300/60 bg-yellow-400/15 text-yellow-200 shadow-[0_0_18px_rgba(250,204,21,.14)]", rowClass: "border-yellow-400/25 bg-yellow-500/[0.055]" },
  { value: "pre_top", label: "Pre-Top", badgeClass: "border-fuchsia-400/50 bg-fuchsia-500/12 text-fuchsia-200", rowClass: "border-fuchsia-400/20 bg-fuchsia-500/[0.045]" },
  { value: "mature", label: "Mature", badgeClass: "border-cyan-400/45 bg-cyan-500/12 text-cyan-200", rowClass: "border-cyan-400/20 bg-cyan-500/[0.045]" },
  { value: "g4", label: "G4", badgeClass: "border-emerald-400/45 bg-emerald-500/12 text-emerald-200", rowClass: "border-emerald-400/20 bg-emerald-500/[0.045]" },
  { value: "g0_g3", label: "G0-G3", badgeClass: "border-white/20 bg-white/[0.045] text-white/65", rowClass: "border-white/10 bg-white/[0.025]" },
];

function normalizeTargetGroup(value) {
  const text = String(value || "all").trim();
  const normalized = text.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");

  if (["all", "tum_yayincilar", "tüm_yayıncılar", "tüm_yayincilar", "tum_yayıncılar"].includes(normalized)) return "all";
  if (["top", "tier_9_plus", "tier_10", "tier_9"].includes(normalized)) return "top";
  if (["pre_top", "pretop", "pre_top", "tier_6_8", "tier_6_plus"].includes(normalized)) return "pre_top";
  if (["mature", "tier_3_5", "tier_5_plus", "kademe_5_ve_üzeri", "kademe_5_ve_uzeri"].includes(normalized)) return "mature";
  if (["g4", "tier_2", "kademe_2"].includes(normalized)) return "g4";
  if (["g0_g3", "g0_g3", "g0-g3", "tier_1", "kademe_1"].includes(normalized)) return "g0_g3";

  const byLabel = TARGET_GROUP_OPTIONS.find(
    (item) => item.label.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_") === normalized
  );

  return byLabel?.value || "all";
}

function getTargetGroupInfo(value) {
  const normalized = normalizeTargetGroup(value);
  return TARGET_GROUP_OPTIONS.find((item) => item.value === normalized) || TARGET_GROUP_OPTIONS[0];
}

function getTargetGroupLabel(value) {
  return getTargetGroupInfo(value).label;
}

function TargetGroupBadge({ value, compact = false }) {
  const info = getTargetGroupInfo(value);

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full border font-semibold leading-none ${
        compact ? "px-2 py-0.5 text-[9px]" : "px-3 py-1 text-[11px]"
      } ${info.badgeClass}`}
    >
      {info.label}
    </span>
  );
}

function getTargetGroupFromTierInfo(tierInfo = {}) {
  const group = String(tierInfo.groupLabel || "").toLowerCase();

  if (group === "top") return "top";
  if (group === "pre-top" || group === "pre_top" || group === "pretop") return "pre_top";
  if (group === "mature") return "mature";
  if (group === "g4") return "g4";
  return "g0_g3";
}

function targetGroupMatchesPublisher(targetGroup, publisher = {}, diamonds) {
  const target = normalizeTargetGroup(targetGroup);
  if (target === "all") return true;

  const publisherGroup = getTargetGroupFromTierInfo(
    getPublisherTierInfo(publisher, diamonds)
  );

  return target === publisherGroup;
}

function formatAgencyTenure(value) {
  if (!value) return "-";

  const start = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(start.getTime())) return "-";

  const today = new Date();
  const diffMs = today.getTime() - start.getTime();
  const diffDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));

  let months =
    (today.getFullYear() - start.getFullYear()) * 12 +
    (today.getMonth() - start.getMonth());

  if (today.getDate() < start.getDate()) {
    months -= 1;
  }

  if (months < 1) return `${diffDays} gün`;

  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  if (years > 0 && remainingMonths > 0) {
    return `${years} yıl ${remainingMonths} ay`;
  }

  if (years > 0) return `${years} yıl`;

  return `${months} ay`;
}

function formatLastLiveDate(value) {
  if (!value) return "-";
  return formatDateForDisplay(String(value).slice(0, 10));
}

function formatAverageDiamondsPerLive(value) {
  const numberValue = safeNumber(value);
  if (numberValue <= 0) return "-";
  return formatNumber(numberValue);
}

function getPerformanceHiddenId(item) {
  return String(
    item?.hiddenId ||
      item?.hidden_id ||
      item?.hiddenID ||
      item?.hiddenid ||
      ""
  ).trim();
}

function buildPublisherPerformanceRows(publisherRows, performanceData) {
  const performanceMap = {};
  const usernameMap = {};

  (performanceData?.publishers || performanceData?.data || []).forEach((item) => {
    const hiddenId = getPerformanceHiddenId(item);
    if (hiddenId) {
      performanceMap[hiddenId] = item;
    }
    const uName = normalizeUsername(item.username || "");
    if (uName) {
      usernameMap[uName] = item;
    }
  });

  const uniquePublisherRows = deduplicatePublishersByHiddenId(publisherRows || []);

  return uniquePublisherRows.map((publisher) => {
    const hiddenId = getPublisherHiddenId(publisher);
    const uName = normalizeUsername(publisher.username || publisher.name || "");
    const perf = (hiddenId && performanceMap[hiddenId]) || (uName && usernameMap[uName]) || {};

    const liveSeconds = safeNumber(
      perf.totalLiveSeconds ||
        perf.total_live_seconds ||
        perf.liveSeconds ||
        perf.live_seconds
    );

    const liveCount = safeNumber(
      perf.totalLiveCount ||
        perf.total_live_count ||
        perf.liveCount ||
        perf.live_count
    );

    const diamonds = safeNumber(
      perf.totalDiamonds ||
        perf.total_diamonds ||
        perf.diamonds
    );

    const avgDiamondsPerLive =
      safeNumber(perf.avgDiamondsPerLive || perf.avg_diamonds_per_live) ||
      (liveCount > 0 ? Math.round(diamonds / liveCount) : 0);

    return {
      ...publisher,
      performanceHiddenId: hiddenId,
      performanceLiveSeconds: liveSeconds,
      performanceLiveCount: liveCount,
      performanceDiamonds: diamonds,
      currentDiamonds: diamonds,
      performanceAvgDiamondsPerLive: avgDiamondsPerLive,
      performanceLastLiveDate:
        perf.lastLiveDate ||
        perf.last_live_date ||
        perf.maxReportDate ||
        perf.max_report_date ||
        perf.lastReportDate ||
        perf.last_report_date ||
        "",
    };
  });
}

function runTests() {
  console.assert(managementSubModules.length === 6, "Yönetim Paneli ana modülleri eksik");
  console.assert(otherSettingsSubModules.some((item) => item.key === "publisher_training"), "Eğitim Merkezi Diğer Ayarlar altında olmalı");
  console.assert(otherSettingsSubModules.some((item) => item.key === "featured_publishers"), "Öne Çıkan Yayıncılar Diğer Ayarlar altında olmalı");
  console.assert(otherSettingsSubModules.some((item) => item.key === "manager_assignment"), "Yayıncı Eşleştirme Diğer Ayarlar altında olmalı");
  console.assert(otherSettingsSubModules.some((item) => item.key === "manager_permissions"), "Yönetici Yetkileri Diğer Ayarlar altında olmalı");
  console.assert(otherSettingsSubModules.some((item) => item.key === "manager_reports"), "Ekip Raporları Diğer Ayarlar altında olmalı");
  console.assert(reportSubModules.some((item) => item.key === "powerbi_permissions"), "Rapor yetkileri modülü eksik");
  console.assert(otherSettingsSubModules.some((item) => item.key === "content_settings"), "İçerik ayarları Diğer Ayarlar altında olmalı");
  console.assert(otherSettingsSubModules.some((item) => item.key === "gifts" && item.label === "Şifre Talepleri"), "Şifre Talepleri modülü eksik");
  console.assert(!managementSubModules.some((item) => item.label.includes("Editör")), "Editör modülü admin panelinde olmamalı");
  console.assert(publisherTrackingSubModules.length === 4, "Yayıncı takip modülleri eksik");
  console.assert(publisherTrackingSubModules.some((item) => item.key === "scout_dashboard" && item.label === "Yayıncı Aday Takibi"), "Yayıncı Aday Takibi eksik");
  console.assert(publisherTrackingSubModules.some((item) => item.key === "scout_followup" && item.label === "Yeni Yayıncı Takibi"), "Yeni Yayıncı Takibi eksik");
  console.assert(publisherTrackingSubModules.some((item) => item.key === "scout_publisher_tracking" && item.label === "Yayıncı Takibi"), "Yayıncı Takibi eksik");
  console.assert(publisherTrackingSubModules.some((item) => item.key === "scout_reports" && item.label === "Yayıncı Raporları"), "Yayıncı Raporları eksik");
  console.assert(typeof API_USER_ADD === "string", "user-add.php endpoint eksik");
  console.assert(typeof API_USER_UPDATE === "string", "user-update.php endpoint eksik");
  console.assert(typeof API_USER_DELETE === "string", "user-delete.php endpoint eksik");
  console.assert(typeof API_PASSWORD_UPDATE === "string", "password-update.php endpoint eksik");
  console.assert(typeof API_BULK_UPLOAD === "string", "bulk-upload.php endpoint eksik");
  console.assert(parseJsonResponse('{"success":true}').success === true, "JSON parse testi hatalı");
}

runTests();

function parseJsonResponse(text) {
  try {
    return JSON.parse(text);
  } catch {
    const preview = String(text || "").slice(0, 140).replace(/\s+/g, " ").trim();
    throw new Error(preview ? `API JSON döndürmedi. Gelen cevap: ${preview}` : "API boş cevap döndürdü.");
  }
}

async function requestJson(url, options = {}) {
  const response = await fetch(url, options);
  const text = await response.text();
  const result = parseJsonResponse(text);

  if (!response.ok || result.success === false) {
    const detail = result.error ? `${result.message || "İşlem başarısız."} Detay: ${result.error}` : (result.message || `İşlem başarısız. HTTP ${response.status}`);
    throw new Error(detail);
  }

  return result;
}

function getUsersFromApiResponse(result) {
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result?.users)) return result.users;
  return [];
}

function getRole(user) {
  return String(user.role || user.userRole || user.type || user.rol || "").toLowerCase().trim();
}

const OFFICIAL_MANAGERS = [
  { id: "mgr-005", fullName: "Tuğçe", username: "wolfmedia005", phone: "5527280635", email: "wolfmedia005@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-066", fullName: "Sude Ceyda", username: "wolfmedia066", phone: "05455041750", email: "wolfmedia006@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-003", fullName: "Sena", username: "wolfmedia003", phone: "5462212839", email: "wolfmedia003@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-mudur", fullName: "Müdür", username: "mudur", phone: "5555555555", email: "5555555555@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-014", fullName: "KURTBEY", username: "wolfmedia014", phone: "5320000014", email: "wolfmedia014@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-013", fullName: "ÖZGE HANIM", username: "wolfmedia013", phone: "5320000013", email: "wolfmedia013@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-012", fullName: "ÖZLEM HANIM", username: "wolfmedia012", phone: "5320000012", email: "wolfmedia012@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-001", fullName: "Yiğitkan", username: "wolfmedia001", phone: "5453666467", email: "wolfmedia004@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" },
  { id: "mgr-support", fullName: "Support", username: "Support", phone: "5435332555", email: "support@wolfmediaajans.com", powerBIRole: "manager_team_rls", status: "Aktif" }
];

const OFFICIAL_MANAGER_USERNAMES = OFFICIAL_MANAGERS.map((m) => m.username.toLowerCase());

function getOfficialManager(key) {
  if (!key) return null;
  const s = String(key).toLowerCase().trim();
  if (s === "havuz" || s === "boş" || s === "-" || s === "" || s === "unassigned") return null;

  if (s === "wolfmedia005" || s.includes("tuğçe") || s.includes("tugce") || s.includes("ece")) return OFFICIAL_MANAGERS[0];
  if (s === "wolfmedia066" || s === "wolfmedia006" || s.includes("sude") || s.includes("ceyda")) return OFFICIAL_MANAGERS[1];
  if (s === "wolfmedia003" || s.includes("sena")) return OFFICIAL_MANAGERS[2];
  if (s === "mudur" || s === "müdür" || s.includes("müdür")) return OFFICIAL_MANAGERS[3];
  if (s === "wolfmedia014" || s.includes("kurtbey")) return OFFICIAL_MANAGERS[4];
  if (s === "wolfmedia013" || s.includes("özge") || s.includes("ozge")) return OFFICIAL_MANAGERS[5];
  if (s === "wolfmedia012" || s.includes("özlem") || s.includes("ozlem")) return OFFICIAL_MANAGERS[6];
  if (s === "wolfmedia001" || s === "wolfmedia004" || s.includes("yiğitkan") || s.includes("yigitkan") || s.includes("suzan")) return OFFICIAL_MANAGERS[7];
  if (s === "support" || s.includes("support")) return OFFICIAL_MANAGERS[8];

  return null;
}

function isManagerRole(user) {
  const uClean = String(user.username || user.userName || user.kullaniciAdi || user.kullanici_adi || "").toLowerCase().trim();
  return OFFICIAL_MANAGER_USERNAMES.includes(uClean);
}

function isPublisherRole(user) {
  if (isManagerRole(user)) return false;
  const role = getRole(user);
  return role === "publisher" || role === "yayinci" || role === "yayıncı" || role === "" || !role;
}

function isScoutRole(user) {
  const role = getRole(user);
  return role === "scout" || role === "scout_manager";
}

function normalizePublisherRecord(user, index = 0, allUsers = []) {
  const cleanUsername = String(user.username || user.userName || user.kullaniciAdi || user.kullanici_adi || "").toLowerCase().replace(/[@\s]+/g, "");
  const cleanHiddenId = String(user.hiddenId || user.hiddenID || user.hidden_id || user.hiddenid || user.id || "").trim();

  // 1. Resolve Phone with master fallback
  let resolvedPhone = user.phone || user.telefon || user.mobile || "";
  if (!resolvedPhone || resolvedPhone === "-" || resolvedPhone === "null" || resolvedPhone === "undefined") {
    resolvedPhone = (cleanHiddenId && MASTER_PHONES[cleanHiddenId]) || (cleanUsername && MASTER_PHONES[cleanUsername]) || "-";
  }

  // 2. Resolve Note with master fallback
  let resolvedNote = user.note || user.raw?.note || "";
  if (!resolvedNote) {
    resolvedNote = (cleanHiddenId && MASTER_NOTES[cleanHiddenId]) || (cleanUsername && MASTER_NOTES[cleanUsername]) || "";
  }

  // 3. Resolve Manager with master fallback
  let rawKey = user.assignedEmployeeUsername || user.employeeUsername || user.representative || user.managerUsername || user.managerName || user.representativeName || "";
  if (!rawKey || rawKey === "-" || rawKey === "havuz" || rawKey === "boş") {
    rawKey = (cleanHiddenId && MASTER_MANAGERS[cleanHiddenId]) || (cleanUsername && MASTER_MANAGERS[cleanUsername]) || "";
  }

  const official = getOfficialManager(rawKey);
  const managerKey = official ? official.username : rawKey;
  const managerRecord = official || allUsers.find((candidate) => {
    return (
      candidate.username && String(candidate.username).toLowerCase() === String(managerKey).toLowerCase()
    ) || (
      candidate.id && String(candidate.id) === String(managerKey)
    ) || (
      candidate.fullName && String(candidate.fullName).toLowerCase() === String(managerKey).toLowerCase()
    );
  });
  const canonicalName = managerRecord?.fullName || (official ? official.fullName : (managerKey === "-" ? "-" : managerKey)) || "-";
  const canonicalUsername = managerRecord?.username || (official ? official.username : (managerKey === "-" ? "" : managerKey)) || "";

  return {
    raw: user,
    id: user.id || user.userId || user.hiddenId || user.hiddenid || index + 1,
    fullName: user.fullName || user.name || user.full_name || user.adSoyad || user.ad_soyad || "-",
    username: user.username || user.userName || user.kullaniciAdi || user.kullanici_adi || "-",
    phone: resolvedPhone,
    email: user.email || user.mail || "",
    hiddenId: user.hiddenId || user.hiddenID || user.hidden_id || user.hiddenid || "-",
    assignedEmployeeUsername: canonicalUsername,
    managerName: canonicalName,
    status: user.status || user.durum || "Aktif",
    tier: user.tier || user.kademe || "-",
    currentDiamonds: safeNumber(
      user.currentDiamonds ||
        user.totalDiamonds ||
        user.total_diamonds ||
        user.diamonds ||
        user.elmas ||
        user.previousMonthDiamonds ||
        user.lastMonthDiamonds ||
        0
    ),
    powerBIRole:
      user.powerBIRole ||
      user.powerbiRole ||
      user.powerbi_role ||
      user.reportRole ||
      user.raporRol ||
      "-",
    agencyTrackingStatus: normalizeAgencyTrackingStatus(
      user.agencyTrackingStatus ||
        user.agency_tracking_status ||
        user.agencyTracking ||
        user.agency_tracking ||
        user.raw?.agencyTrackingStatus ||
        user.raw?.agency_tracking_status ||
        "Aktif"
    ),
    system_username: user.system_username || user.systemUsername || "",
    tiktok_username: user.tiktok_username || user.tiktokUsername || "",
    image: user.image || user.profileImage || user.avatar || "",
    note: resolvedNote,

    createdAt:
      user.createdAt ||
      user.created_at ||
      user.created ||
      user.registeredAt ||
      user.registered_at ||
      user.kayitTarihi ||
      user.kayit_tarihi ||
      "",
  };
}

function normalizeManagerRecord(user, index = 0, allUsers = []) {
  const rawUsername = user.username || user.userName || user.kullaniciAdi || user.kullanici_adi || "-";
  const official = getOfficialManager(rawUsername) || getOfficialManager(user.fullName);
  const username = official ? official.username : rawUsername;
  const fullName = official ? official.fullName : (user.fullName || user.name || user.full_name || user.adSoyad || user.ad_soyad || "-");
  const phone = official?.phone || user.phone || user.telefon || user.mobile || "-";
  const email = official?.email || user.email || user.mail || "-";

  const publisherCount = allUsers.filter((candidate) => {
    if (!isPublisherRole(candidate)) return false;
    const assigned = candidate.assignedEmployeeUsername || candidate.employeeUsername || candidate.representative || candidate.managerUsername || candidate.managerName || "";
    const candidateOfficial = getOfficialManager(assigned);
    return candidateOfficial && candidateOfficial.username.toLowerCase() === username.toLowerCase();
  }).length;

  return {
    raw: user,
    id: user.id || user.userId || `mgr-${index + 1}`,
    fullName,
    username,
    phone,
    email,
    publisherCount: Number(user.publisherCount ?? publisherCount),
    status: user.status || user.durum || "Aktif",
    powerBIRole: user.powerBIRole || user.powerbiRole || user.powerbi_role || user.reportRole || "manager_team_rls",
  };
}

function normalizeScoutRecord(user, index = 0) {
  return {
    raw: user,
    id: user.id || user.userId || index + 1,
    fullName: user.fullName || user.name || user.full_name || user.adSoyad || user.ad_soyad || "-",
    username: user.username || user.userName || user.kullaniciAdi || user.kullanici_adi || "-",
    phone: user.phone || user.telefon || user.mobile || "-",
    email: user.email || user.mail || "-",
    status: user.status || user.durum || "Aktif",
    role: getRole(user) || "scout",
  };
}

function useAdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadUsers() {
    try {
      setLoading(true);
      setError("");
      const result = await requestJson(API_USERS_LIST, { cache: "no-store" });
      setUsers(getUsersFromApiResponse(result));
    } catch (err) {
      setUsers([]);
      setError(err.message || "API bağlantısı kurulamadı.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadUsers();
  }, []);

  return { users, loading, error, setError, reload: loadUsers };
}

function buildPublisherRows(users = []) {
  const rawRows = (users || [])
    .filter(isPublisherRole)
    .map((user, index) => normalizePublisherRecord(user, index, users || []));

  const deduplicatedRows = deduplicatePublishersByHiddenId(rawRows);

  return sortPublishersByTierDesc(deduplicatedRows);
}

function buildManagerRows(users = []) {
  return OFFICIAL_MANAGERS.map((off, index) => {
    const matched = (users || []).find((u) => {
      const uClean = String(u.username || u.userName || u.kullaniciAdi || u.kullanici_adi || "").toLowerCase().trim();
      return uClean === off.username.toLowerCase();
    });
    const base = matched ? { ...off, ...matched } : off;
    return normalizeManagerRecord(base, index, users || []);
  });
}

function buildScoutRows(users = []) {
  return (users || [])
    .filter(isScoutRole)
    .map((user, index) => normalizeScoutRecord(user, index));
}

function parseCsvLine(line) {
  const result = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    const next = line[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) {
      result.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }

  result.push(current.trim());
  return result;
}

function csvToPublisherRows(text) {
  const lines = text.replace(/\r/g, "").split("\n").map((line) => line.trim()).filter(Boolean);
  if (lines.length < 2) return [];

  const firstLine = lines[0];
  const isTsv = firstLine.includes("\t");
  const isSemicolon = !isTsv && firstLine.includes(";");

  const parseLine = (l) => {
    if (isTsv) return l.split("\t").map((s) => s.trim().replace(/^"(.*)"$/, "$1"));
    if (isSemicolon) return l.split(";").map((s) => s.trim().replace(/^"(.*)"$/, "$1"));
    return parseCsvLine(l);
  };

  const headers = parseLine(firstLine).map((header) => header.trim());

  return lines.slice(1).map((line) => {
    const values = parseLine(line);
    const row = {};

    headers.forEach((header, index) => {
      row[header] = values[index] || "";
    });

    const fullName = row.fullName || row.full_name || row.adSoyad || row["Ad Soyadı"] || row["İSİM"] || row["ISIM"] || row["İsim"] || "";
    const username = row.username || row.userName || row["Kullanıcı adı"] || row["KULLANICI ADI"] || row["Kullanıcı Adı"] || "";
    const phone = row.phone || row.telefon || row["Telefon"] || row["Telefon No"] || row["TELEFON"] || "";
    const hiddenId = row.hiddenId || row.hiddenID || row.hidden_id || row["Hidden ID"] || row.Id || row["ID"] || "";
    const rawEmployee = row.employeeUsername || row.assignedEmployeeUsername || row.representative || row["Yönetici"] || row["Temsilci"] || row["YÖNETİCİ"] || "";
    const official = getOfficialManager(rawEmployee);
    const employeeUsername = official ? official.username : rawEmployee;
    const powerBIRole = row.powerBIRole || row.powerbiRole || row.powerbi_role || row["Rapor Rol"] || "publisher_rls";
    const status = row.status || row.durum || row["Durum"] || "Aktif";
    const note = row.note || row.not || row["NOT"] || row["Not"] || "";

    return {
      fullName,
      username,
      phone,
      hiddenId,
      employeeUsername,
      powerBIRole,
      status,
      note,
    };
  }).filter((row) => row.username);
}

function csvToPasswordRows(text) {
  const lines = text.replace(/\r/g, "").split("\n").map((line) => line.trim()).filter(Boolean);
  if (lines.length < 2) return [];

  const headers = parseCsvLine(lines[0]).map((header) => header.trim());

  return lines.slice(1).map((line) => {
    const values = parseCsvLine(line);
    const row = {};

    headers.forEach((header, index) => {
      row[header] = values[index] || "";
    });

    return {
      username: row.username || row.userName || row["Kullanıcı adı"] || "",
      newPassword: row.newPassword || row.password || row.sifre || row["Şifre"] || row["Yeni Şifre"] || "",
    };
  }).filter((row) => row.username && row.newPassword);
}

function Card({ children, className = "" }) {
  return <div className={`rounded-[1.45rem] border border-white/[0.08] bg-white/[0.03] shadow-[0_18px_60px_rgba(0,0,0,.32)] ${className}`}>{children}</div>;
}

function Pill({ children, tone = "default" }) {
  const toneClass = tone === "gold" ? "border-yellow-500/30 bg-yellow-500/15 text-yellow-200" : tone === "red" ? "border-red-500/25 bg-red-500/10 text-red-300" : tone === "green" ? "border-green-500/25 bg-green-500/10 text-green-300" : "border-white/10 bg-white/[0.035] text-white/45";
  return <span className={`rounded-full border px-3 py-1 text-[11px] font-bold ${toneClass}`}>{children}</span>;
}

function StatusBadge({ status }) {
  const tone = status === "Aktif" ? "green" : status === "Eksik" || status === "Pasif" ? "red" : "gold";
  return <Pill tone={tone}>{status || "-"}</Pill>;
}

function SectionHeader({ eyebrow, title, desc, action }) {
  return (
    <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.36em] text-yellow-300/80">{eyebrow}</div>
        <h2 className="mt-2 text-2xl font-black tracking-tight text-white lg:text-3xl">{title}</h2>
        <p className="mt-2 max-w-4xl text-[13px] leading-6 text-white/46">{desc}</p>
      </div>
      {action}
    </div>
  );
}

function ActionButton({ children, variant = "gold", onClick, type = "button", disabled = false }) {
  const cls = variant === "gold" ? "border-yellow-500/30 bg-yellow-500 text-black hover:bg-yellow-400" : "border-white/10 bg-white/[0.035] text-white/65 hover:border-yellow-500/30 hover:text-yellow-300";
  return <button type={type} onClick={onClick} disabled={disabled} className={`rounded-xl border px-4 py-2.5 text-xs font-black transition disabled:cursor-not-allowed disabled:opacity-50 ${cls}`}>{children}</button>;
}

function SearchBox({ placeholder, value, onChange }) {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-black/30 px-4 py-3">
      <span className="text-white/35">⌕</span>
      <input value={value || ""} onChange={onChange} placeholder={placeholder} className="w-full bg-transparent text-sm text-white outline-none placeholder:text-white/30" />
    </div>
  );
}

function ApiNotice({ loading, error, onReload }) {
  if (loading) return <div className="mt-3 rounded-xl border border-white/10 bg-white/[0.035] px-4 py-2 text-xs font-semibold text-white/45">API verisi yükleniyor...</div>;
  if (!error) return null;
  return (
    <div className="mt-3 flex flex-col gap-3 rounded-xl border border-red-500/20 bg-red-500/10 px-4 py-3 text-xs font-semibold text-red-200 sm:flex-row sm:items-center sm:justify-between">
      <span>{error}</span>
      <button type="button" onClick={onReload} className="rounded-lg border border-red-300/20 px-3 py-1.5 text-red-100 hover:bg-red-500/15">Tekrar Dene</button>
    </div>
  );
}

function EmptyState({ text }) {
  return <div className="border-t border-white/10 p-6 text-sm text-white/45">{text}</div>;
}

function FormInput({ label, name, value, onChange, type = "text", placeholder }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-bold text-white/45">{label}</span>
      <input type={type} name={name} value={value || ""} onChange={onChange} placeholder={placeholder || label} className="w-full rounded-2xl border border-white/10 bg-white/[0.035] px-4 py-3 text-sm text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35" />
    </label>
  );
}

function FormSelect({ label, name, value, onChange, children }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-bold text-white/45">{label}</span>
      <select name={name} value={value || ""} onChange={onChange} className="w-full rounded-2xl border border-white/10 bg-[#101010] px-4 py-3 text-sm text-white outline-none focus:border-yellow-500/35">
        {children}
      </select>
    </label>
  );
}

function RowActionButton({ children, danger = false, onClick }) {
  return (
    <button type="button" onClick={onClick} className={`rounded-xl border px-3 py-2 text-xs font-semibold transition ${danger ? "border-red-500/25 bg-red-500/10 text-red-300 hover:bg-red-500/20" : "border-white/10 bg-white/[0.035] text-white/68 hover:border-yellow-500/30 hover:text-yellow-300"}`}>
      {children}
    </button>
  );
}

function Sidebar({ activeKey, setActiveKey, currentAdmin }) {
  const isSuperAdmin = isUserSuperAdmin(currentAdmin);
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("wm_admin_sidebar_collapsed") === "true";
    } catch (e) {
      return false;
    }
  });

  const [hoveredGroup, setHoveredGroup] = useState(null);

  const [openGroups, setOpenGroups] = useState({
    management: false, scout: false, reports: false, gift: false, settings: false,
  });

  function toggleCollapsed() {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("wm_admin_sidebar_collapsed", String(next));
      } catch (e) {}
      return next;
    });
  }

  // Ctrl+[ kısayolu ile kenar çubuğunu açma / kapama
  useEffect(() => {
    function handleKeyDown(e) {
      if ((e.ctrlKey || e.metaKey) && e.key === "[") {
        e.preventDefault();
        toggleCollapsed();
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const navigationGroups = [
    {
      key: "dashboard",
      isDirect: true,
      title: "Yönetim Özeti",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>
        </svg>
      ),
      badge: "Canlı",
    },
    {
      groupKey: "management",
      title: "Yönetim Paneli",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      items: managementSubModules,
    },
    {
      groupKey: "scout",
      title: "Yayıncı Takip Modülü",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
        </svg>
      ),
      items: publisherTrackingSubModules,
    },

    {
      groupKey: "reports",
      title: "Raporlar",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/>
        </svg>
      ),
      items: reportSubModules,
    },
    ...(isSuperAdmin
      ? [
          {
            groupKey: "gift",
            title: "Hediye Prim Yönetimi",
            iconSvg: (
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 12 20 22 4 22 4 12"/><rect width="20" height="5" x="2" y="7"/><line x1="12" x2="12" y1="22" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
              </svg>
            ),
            items: giftPrimeSubModules,
          },
        ]
      : []),
    {
      groupKey: "settings",
      title: "Diğer Ayarlar",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>
        </svg>
      ),
      items: otherSettingsSubModules,
    },
  ];

  return (
    <aside
      className={`sticky top-0 hidden h-screen shrink-0 border-r transition-all duration-300 ease-in-out backdrop-blur-xl lg:flex flex-col justify-between z-40 ${
        collapsed ? "w-[76px] p-2.5" : "w-[285px] p-4"
      } border-slate-200 dark:border-white/10 bg-white/95 dark:bg-black/85 shadow-sm`}
    >
      {/* 🚀 ÜST LOGO / BAŞLIK ALANI (WOLF-HEAD.PNG KULLANIMI) */}
      <div className="shrink-0 pb-3 border-b border-slate-200 dark:border-white/10">
        {collapsed ? (
          <button
            type="button"
            onClick={toggleCollapsed}
            title="Kenar çubuğunu genişlet"
            className="flex h-11 w-11 mx-auto items-center justify-center rounded-2xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.04] hover:bg-slate-100 dark:hover:bg-white/10 transition shadow-sm"
          >
            <img src="/wolf-head.png" alt="Wolf Media" className="h-8 w-8 object-contain" />
          </button>
        ) : (
          <div className="flex items-center justify-between px-1">
            <div className="flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.04] shadow-sm">
                <img src="/wolf-head.png" alt="Wolf Media" className="h-7 w-7 object-contain" />
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="font-black text-sm tracking-tight text-slate-900 dark:text-white">WOLF MEDIA</span>
                  <span className="rounded bg-yellow-500/20 border border-yellow-500/30 px-1 py-0.2 text-[9px] font-extrabold text-amber-700 dark:text-yellow-300">PRO</span>
                </div>
                <div className="text-[11px] font-semibold text-slate-500 dark:text-white/40 truncate">TikTok LIVE Backstage</div>
              </div>
            </div>
            <button
              type="button"
              onClick={toggleCollapsed}
              title="Kenar çubuğunu daralt"
              className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 dark:border-white/10 bg-slate-100 dark:bg-white/[0.04] text-slate-600 dark:text-white/60 hover:bg-slate-200 dark:hover:bg-white/10 transition"
            >
              ◧
            </button>
          </div>
        )}
      </div>

      {/* 📋 MENÜ LİSTESİ (SADE & PROFESYONEL SVG İKONLAR) */}
      <div className="my-3 flex-1 overflow-y-auto overflow-x-hidden space-y-1.5 pr-0.5 custom-scrollbar">
        {navigationGroups.map((group) => {
          if (group.isDirect) {
            const isDirectActive = activeKey === group.targetKey || activeKey === "dashboard";
            return (
              <div key={group.key} className="relative">
                {collapsed ? (
                  <div
                    onMouseEnter={() => setHoveredGroup(group.key)}
                    onMouseLeave={() => setHoveredGroup(null)}
                    className="relative flex justify-center py-1"
                  >
                    <button
                      type="button"
                      onClick={() => { setActiveKey("dashboard"); setOpenGroups({ management: false, scout: false, reports: false, gift: false, settings: false }); }}
                      title={group.title}
                      className={`flex h-11 w-11 items-center justify-center rounded-2xl transition ${
                        isDirectActive
                          ? "bg-amber-500 text-black font-black shadow-md scale-105"
                          : "border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.03] text-slate-700 dark:text-white/70 hover:border-yellow-500 hover:text-amber-600"
                      }`}
                    >
                      {group.iconSvg}
                    </button>

                    {hoveredGroup === group.key && (
                      <div className="absolute left-[64px] top-1 z-50 min-w-[170px] rounded-xl border border-slate-200 dark:border-white/10 bg-white/95 dark:bg-[#12141f]/95 p-2.5 shadow-2xl backdrop-blur-xl animate-in fade-in zoom-in-95">
                        <div className="font-bold text-xs text-slate-900 dark:text-white flex items-center justify-between">
                          <span>{group.title}</span>
                          <span className="rounded bg-yellow-500/20 px-1 text-[9px] font-black text-amber-700 dark:text-yellow-300">Canlı</span>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => { setActiveKey("dashboard"); setOpenGroups({ management: false, scout: false, reports: false, gift: false, settings: false }); }}
                    className={`flex w-full items-center justify-between rounded-xl border px-3.5 py-2.5 text-left text-xs font-bold transition shadow-sm ${
                      isDirectActive
                        ? "border-yellow-500 bg-yellow-500 text-black font-black shadow-md"
                        : "border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.025] text-slate-800 dark:text-white/80 hover:border-yellow-500/40 hover:bg-slate-50 dark:hover:bg-white/[0.05]"
                    }`}
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="text-slate-600 dark:text-white/70">{group.iconSvg}</span>
                      <span>{group.title}</span>
                    </div>
                    <span className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                      isDirectActive ? "bg-black/20 text-black" : "border border-yellow-500/30 bg-yellow-500/15 text-amber-700 dark:text-yellow-300"
                    }`}>
                      {group.badge}
                    </span>
                  </button>
                )}
              </div>
            );
          }

          const hasActiveChild = group.items?.some((it) => it.key === activeKey);
          const isOpen = (openGroups[group.groupKey] ?? false) || (activeKey !== "dashboard" && hasActiveChild);

          return (
            <div key={group.groupKey} className="relative">
              {collapsed ? (
                <div
                  onMouseEnter={() => setHoveredGroup(group.groupKey)}
                  onMouseLeave={() => setHoveredGroup(null)}
                  className="relative flex justify-center py-1"
                >
                  <button
                    type="button"
                    onClick={() => {
                      if (group.items?.[0]?.key) {
                        setActiveKey(group.items[0].key);
                      }
                    }}
                    title={group.title}
                    className={`flex h-11 w-11 items-center justify-center rounded-2xl transition ${
                      hasActiveChild
                        ? "bg-gradient-to-br from-yellow-500 to-amber-500 text-black font-black shadow-md scale-105"
                        : "border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.03] text-slate-700 dark:text-white/70 hover:border-yellow-500 hover:text-amber-600"
                    }`}
                  >
                    {group.iconSvg}
                  </button>

                  {hoveredGroup === group.groupKey && (
                    <div className="absolute left-[64px] top-0 z-50 min-w-[210px] rounded-2xl border border-slate-200 dark:border-white/10 bg-white/95 dark:bg-[#12141f]/95 p-3 shadow-2xl backdrop-blur-2xl animate-in fade-in zoom-in-95">
                      <div className="mb-2 pb-1.5 border-b border-slate-100 dark:border-white/10 font-black text-xs text-slate-900 dark:text-white flex items-center gap-1.5">
                        <span className="text-slate-600 dark:text-white/70">{group.iconSvg}</span>
                        <span>{group.title}</span>
                      </div>
                      <div className="space-y-1">
                        {group.items.map((sub) => (
                          <button
                            key={sub.key}
                            type="button"
                            onClick={() => {
                              setActiveKey(sub.key);
                              setHoveredGroup(null);
                            }}
                            className={`block w-full text-left rounded-lg px-2.5 py-1.5 text-xs font-semibold transition ${
                              activeKey === sub.key
                                ? "bg-amber-500 text-black font-black"
                                : "text-slate-700 dark:text-white/70 hover:bg-slate-100 dark:hover:bg-white/[0.06] hover:text-slate-900 dark:hover:text-white"
                            }`}
                          >
                            {sub.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="rounded-xl border border-slate-200/90 dark:border-white/10 bg-white/70 dark:bg-white/[0.02] overflow-hidden">
                  <button
                    type="button"
                    onClick={() => {
                      setOpenGroups((prev) => ({
                        ...prev,
                        [group.groupKey]: !prev[group.groupKey],
                      }));
                    }}
                    className={`flex w-full items-center justify-between px-3.5 py-2.5 text-left text-xs font-bold transition ${
                      hasActiveChild
                        ? "bg-amber-500/10 text-amber-700 dark:text-yellow-300 font-black"
                        : "text-slate-800 dark:text-white/80 hover:bg-slate-50 dark:hover:bg-white/[0.04]"
                    }`}
                  >
                    <div className="flex items-center gap-2.5">
                      <span className="text-slate-600 dark:text-white/70">{group.iconSvg}</span>
                      <span>{group.title}</span>
                    </div>
                    <span className="text-[11px] font-bold text-slate-400 dark:text-white/40">
                      {isOpen ? "▾" : "▸"}
                    </span>
                  </button>

                  {isOpen && (
                    <div className="px-2 py-1.5 space-y-0.5 bg-slate-50/70 dark:bg-black/20 border-t border-slate-100 dark:border-white/5">
                      {group.items.map((sub) => {
                        const isSubActive = activeKey === sub.key;
                        return (
                          <button
                            key={sub.key}
                            type="button"
                            onClick={() => setActiveKey(sub.key)}
                            className={`block w-full text-left rounded-lg px-3 py-1.5 text-xs transition ${
                              isSubActive
                                ? "bg-amber-500 text-black font-black shadow-sm"
                                : "text-slate-700 dark:text-white/60 font-semibold hover:bg-white dark:hover:bg-white/[0.05] hover:text-slate-900 dark:hover:text-white"
                            }`}
                          >
                            {sub.label}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* 🚀 ALT KENAR ÇUBUĞU DARALT / GENİŞLET BUTONU */}
      <div className="shrink-0 pt-3 border-t border-slate-200 dark:border-white/10">
        {collapsed ? (
          <button
            type="button"
            onClick={toggleCollapsed}
            title="Kenar çubuğunu genişlet (Ctrl+[)"
            className="flex h-11 w-full items-center justify-center rounded-xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.03] text-slate-700 dark:text-white/70 hover:bg-slate-100 dark:hover:bg-white/[0.08] transition shadow-sm text-base font-black"
          >
            <span>◨</span>
          </button>
        ) : (
          <button
            type="button"
            onClick={toggleCollapsed}
            title="Kenar çubuğunu daralt (Ctrl+[)"
            className="flex w-full items-center justify-between rounded-xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.03] px-3.5 py-2.5 text-xs font-bold text-slate-700 dark:text-white/70 hover:bg-slate-100 dark:hover:bg-white/[0.08] transition shadow-sm"
          >
            <div className="flex items-center gap-2">
              <span className="text-sm">◧</span>
              <span>Kenar çubuğunu daralt</span>
            </div>
            <span className="text-[10px] text-slate-400 font-semibold">Ctrl+[</span>
          </button>
        )}
      </div>
    </aside>
  );
}

function MobileMenu({ activeKey, setActiveKey, currentAdmin }) {
  const isSuperAdmin = isUserSuperAdmin(currentAdmin);
  const allItems = [
    { key: "dashboard", label: "Yönetim Özeti" },
    ...managementSubModules,
    ...scoutSubModules,
    ...reportSubModules,
    ...(isSuperAdmin ? giftPrimeSubModules : []),
    ...otherSettingsSubModules,
  ];
  return (
    <div className="mb-4 rounded-2xl border border-white/10 bg-black/35 p-3 lg:hidden">
      <select value={activeKey} onChange={(event) => setActiveKey(event.target.value)} className="w-full rounded-xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white outline-none [color-scheme:dark]">
        {allItems.map((item) => <option key={item.key} value={item.key}>{item.label}</option>)}
      </select>
    </div>
  );
}

function Header({ activeLabel, apiError, onReportUploadClick, onNewRecord, onBulkClick, onBulkPasswordClick, theme, setTheme }) {
  return (
    <header className="mb-5 rounded-[1.6rem] border border-white/[0.08] bg-white/[0.035] p-5 shadow-[0_18px_65px_rgba(0,0,0,.35)]">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.38em] text-yellow-300/80">Wolf Media Yönetim Merkezi</div>
          <h1 className="mt-2 text-3xl font-black tracking-tight text-white lg:text-4xl">Admin Paneli</h1>
          <p className="mt-2 text-[13px] leading-6 text-white/46">Yayıncı, yönetici, rapor ve ayar süreçleri tek ekranda yönetilir.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2.5">
          <button
            type="button"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="inline-flex items-center gap-2 rounded-full border border-slate-300 dark:border-white/20 bg-white/95 dark:bg-[#18181c] px-4 py-2 text-xs font-black text-slate-800 dark:text-white shadow-sm hover:border-yellow-500/50 hover:bg-slate-50 dark:hover:bg-white/[0.12] transition-all active:scale-95"
            title={theme === "dark" ? "Açık temaya geç" : "Koyu temaya geç"}
          >
            <span className="text-sm">{theme === "dark" ? "☀️" : "🌙"}</span>
            <span>{theme === "dark" ? "Açık" : "Koyu"}</span>
          </button>
          <ActionButton variant="dark" onClick={onReportUploadClick}>Rapor Yükle</ActionButton>
          <ActionButton variant="dark" onClick={onBulkPasswordClick}>Toplu Şifre</ActionButton>
          <ActionButton variant="dark" onClick={onBulkClick}>Toplu Yükle</ActionButton>
          <ActionButton onClick={onNewRecord}>Yeni Kayıt</ActionButton>
        </div>
      </div>
      <div className="mt-4 rounded-2xl border border-white/10 bg-black/25 px-4 py-3 text-sm text-white/45">
        Aktif ekran: <span className="font-bold text-yellow-300">{activeLabel}</span>
      </div>
      {apiError && <div className="mt-3 rounded-xl border border-red-500/20 bg-red-500/10 px-4 py-2 text-xs font-semibold text-red-200">{apiError}</div>}
    </header>
  );
}

function StatCard({ title, value, note, danger, trend }) {
  return (
    <Card className="p-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="h-[2px] w-10 rounded-full bg-yellow-400/70" />
        <Pill tone={danger ? "red" : "default"}>
          {danger ? "Risk" : "Aktif"}
        </Pill>
      </div>

      <div className="text-[13px] text-white/45">{title}</div>
      <div className="mt-2 text-3xl font-black text-white">{value}</div>
      <div className="mt-2 text-xs text-white/35">{note}</div>

      {trend}
    </Card>
  );
}

function DashboardContent({
  setActiveKey,
  publisherRows = [],
  managerRows = [],
  adminPerformance,
  agencyOverallPerformance,
  previousAdminPerformance,
  adminPerformanceLoading,
  adminPerformanceError,
  reportStartDate,
  reportEndDate,
  setReportStartDate,
  setReportEndDate,
  selectedManagerFilter,
  setSelectedManagerFilter,
  selectedPublisherFilter,
  setSelectedPublisherFilter,
  filteredPublisherRowsForPerformance = [],
  currentAdmin,
}) {
  const [activeDiamondPoint, setActiveDiamondPoint] = useState(null);
  const [publisherSearchQuery, setPublisherSearchQuery] = useState("");
  const [isPublisherDropdownOpen, setIsPublisherDropdownOpen] = useState(false);
  const publisherSearchRef = useRef(null);

  const selectedPublisherObj = useMemo(() => {
    if (!selectedPublisherFilter || selectedPublisherFilter === "all") return null;
    return publisherRows.find(
      (p) =>
        String(p.id) === String(selectedPublisherFilter) ||
        String(p.hiddenId) === String(selectedPublisherFilter) ||
        String(p.username) === String(selectedPublisherFilter)
    );
  }, [selectedPublisherFilter, publisherRows]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (publisherSearchRef.current && !publisherSearchRef.current.contains(e.target)) {
        setIsPublisherDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const autocompletePublisherList = useMemo(() => {
    const rawQuery = publisherSearchQuery.trim().toLowerCase().replace(/[@\s]/g, "");

    let list = publisherRows;
    if (selectedManagerFilter && selectedManagerFilter !== "all") {
      const targetManager = String(selectedManagerFilter).toLowerCase().trim();
      const matchedMgr = (managerRows || []).find(
        (m) =>
          String(m.username || "").toLowerCase().trim() === targetManager ||
          String(m.id || "") === targetManager
      );
      const mgrFullName = matchedMgr ? String(matchedMgr.fullName || "").toLowerCase().trim() : "";

      list = list.filter((publisher) => {
        const assigned = String(publisher.assignedEmployeeUsername || publisher.representative || "").toLowerCase().trim();
        const mName = String(publisher.managerName || "").toLowerCase().trim();
        return (
          assigned === targetManager ||
          mName === targetManager ||
          (mgrFullName && (assigned === mgrFullName || mName === mgrFullName))
        );
      });
    }

    if (!rawQuery) {
      return list.slice(0, 40);
    }

    const exactPrefixMatches = [];
    const containsMatches = [];

    list.forEach((pub) => {
      const uName = String(pub.username || "").toLowerCase().replace(/[@\s]/g, "");
      const fName = String(pub.fullName || "").toLowerCase();
      const hId = String(pub.hiddenId || "").toLowerCase();

      if (uName.startsWith(rawQuery) || fName.startsWith(rawQuery) || hId.startsWith(rawQuery)) {
        exactPrefixMatches.push(pub);
      } else if (uName.includes(rawQuery) || fName.includes(rawQuery) || hId.includes(rawQuery)) {
        containsMatches.push(pub);
      }
    });

    return [...exactPrefixMatches, ...containsMatches].slice(0, 50);
  }, [publisherRows, managerRows, selectedManagerFilter, publisherSearchQuery]);

  function handleSelectPublisher(pub) {
    if (!pub || pub === "all") {
      setSelectedPublisherFilter("all");
      setPublisherSearchQuery("");
      setIsPublisherDropdownOpen(false);
      return;
    }

    setSelectedPublisherFilter(pub.id);
    setPublisherSearchQuery(`@${pub.username || pub.fullName}`);
    setIsPublisherDropdownOpen(false);

    if (pub.assignedEmployeeUsername && (!selectedManagerFilter || selectedManagerFilter === "all")) {
      const mgr = managerRows.find((m) => String(m.username) === String(pub.assignedEmployeeUsername));
      if (mgr) {
        setSelectedManagerFilter(mgr.username);
      }
    }
  }

  function handleClearPublisherSearch() {
    setSelectedPublisherFilter("all");
    setPublisherSearchQuery("");
    setIsPublisherDropdownOpen(false);
  }

  function handleManagerChange(event) {
    setSelectedManagerFilter(event.target.value);
    setSelectedPublisherFilter("all");
    setPublisherSearchQuery("");
  }

  function setDatePreset(presetKey) {
    const today = new Date();
    if (presetKey === "this_month") {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      setReportStartDate(toInputDate(start));
      setReportEndDate(toInputDate(today));
    } else if (presetKey === "last_7") {
      const start = new Date(today);
      start.setDate(today.getDate() - 6);
      setReportStartDate(toInputDate(start));
      setReportEndDate(toInputDate(today));
    } else if (presetKey === "last_30") {
      const start = new Date(today);
      start.setDate(today.getDate() - 29);
      setReportStartDate(toInputDate(start));
      setReportEndDate(toInputDate(today));
    } else if (presetKey === "last_month") {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth(), 0);
      setReportStartDate(toInputDate(start));
      setReportEndDate(toInputDate(end));
    }
  }

  const activeDatePreset = useMemo(() => {
    const today = new Date();
    const thisMonthStart = toInputDate(new Date(today.getFullYear(), today.getMonth(), 1));
    const todayStr = toInputDate(today);
    if (reportStartDate === thisMonthStart && reportEndDate === todayStr) return "this_month";

    const last7Start = toInputDate(new Date(today.getTime() - 6 * 86400000));
    if (reportStartDate === last7Start && reportEndDate === todayStr) return "last_7";

    const last30Start = toInputDate(new Date(today.getTime() - 29 * 86400000));
    if (reportStartDate === last30Start && reportEndDate === todayStr) return "last_30";

    const lastMonthStart = toInputDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
    const lastMonthEnd = toInputDate(new Date(today.getFullYear(), today.getMonth(), 0));
    if (reportStartDate === lastMonthStart && reportEndDate === lastMonthEnd) return "last_month";

    return "custom";
  }, [reportStartDate, reportEndDate]);

  // Agency overall summary calculations
  const effectiveAgencySummary = (agencyOverallPerformance || adminPerformance)?.summary || {};
  const agencyTotalDiamonds = safeNumber(effectiveAgencySummary.totalDiamonds || effectiveAgencySummary.total_diamonds);
  const agencyTotalLiveSeconds = safeNumber(effectiveAgencySummary.totalLiveSeconds || effectiveAgencySummary.total_live_seconds);
  const agencyTotalLiveCount = safeNumber(effectiveAgencySummary.totalLiveCount || effectiveAgencySummary.total_live_count);
  const agencyTotalHours = Math.floor(agencyTotalLiveSeconds / 3600);
  const agencyTotalMinutes = Math.floor((agencyTotalLiveSeconds % 3600) / 60);
  const assignedPublisherCount = publisherRows.filter((item) => item.assignedEmployeeUsername).length;
  const missingPublisherPowerBi = publisherRows.filter(
    (item) => item.powerBIRole === "-" || item.powerBIRole === "Eksik" || !item.powerBIRole
  ).length;

  const summary = adminPerformance?.summary || {};
  const daily = adminPerformance?.daily || [];

  const previousSummary = previousAdminPerformance?.summary || {};

  const previousTotalLiveCount = getSummaryNumber(previousSummary, [
    "totalLiveCount",
    "totalPublishCount",
    "total_live_count",
  ]);

  const previousTotalLiveSeconds = getSummaryNumber(previousSummary, [
    "totalLiveSeconds",
    "total_live_seconds",
  ]);

  const previousTotalDiamonds = getSummaryNumber(previousSummary, [
    "totalDiamonds",
    "total_diamonds",
  ]);

  const totalLiveCount = safeNumber(summary.totalLiveCount || summary.totalPublishCount || summary.total_live_count);
  const totalLiveSeconds = safeNumber(summary.totalLiveSeconds || summary.total_live_seconds);
  const totalDiamonds = safeNumber(summary.totalDiamonds || summary.total_diamonds);

  const totalHours = Math.floor(totalLiveSeconds / 3600);
  const totalMinutes = Math.floor((totalLiveSeconds % 3600) / 60);

  const chartWidth = 1200;
  const chartHeight = 360;
  const chartPadding = { top: 34, right: 34, bottom: 52, left: 78 };
  const chartInnerWidth = chartWidth - chartPadding.left - chartPadding.right;
  const chartInnerHeight = chartHeight - chartPadding.top - chartPadding.bottom;
  const chartMax = Math.max(...daily.map((item) => safeNumber(item.diamonds)), 1);

  const getChartX = (index) =>
    chartPadding.left +
    (daily.length === 1 ? chartInnerWidth / 2 : (index * chartInnerWidth) / (daily.length - 1));

  const getChartY = (value) =>
    chartPadding.top + chartInnerHeight - (safeNumber(value) / chartMax) * chartInnerHeight;

  const linePoints = daily
    .map((item, index) => `${getChartX(index)},${getChartY(item.diamonds)}`)
    .join(" ");

  const areaPoints = daily.length
    ? `${chartPadding.left},${chartPadding.top + chartInnerHeight} ${linePoints} ${
        chartPadding.left + chartInnerWidth
      },${chartPadding.top + chartInnerHeight}`
    : "";

  const yTicks = [chartMax, chartMax * 0.75, chartMax * 0.5, chartMax * 0.25, 0].map((item) =>
    Math.round(item)
  );

  const xLabelStep = Math.max(1, Math.ceil(daily.length / 8));



  const publisherPerformanceRows = useMemo(() => {
    return buildPublisherPerformanceRows(
      filteredPublisherRowsForPerformance,
      adminPerformance
    );
  }, [filteredPublisherRowsForPerformance, adminPerformance]);

  const topLiveRows = useMemo(() => {
    return [...publisherPerformanceRows]
      .filter((item) => item.performanceLiveSeconds > 0)
      .sort((a, b) => b.performanceLiveSeconds - a.performanceLiveSeconds)
      .slice(0, 10);
  }, [publisherPerformanceRows]);

  const topDiamondRows = useMemo(() => {
    return [...publisherPerformanceRows]
      .filter((item) => item.performanceDiamonds > 0)
      .sort((a, b) => b.performanceDiamonds - a.performanceDiamonds)
      .slice(0, 10);
  }, [publisherPerformanceRows]);

  const lowLiveRows = useMemo(() => {
    return [...publisherPerformanceRows]
      .filter((item) => item.performanceLiveSeconds > 0)
      .sort((a, b) => a.performanceLiveSeconds - b.performanceLiveSeconds)
      .slice(0, 10);
  }, [publisherPerformanceRows]);

  const lowDiamondRows = useMemo(() => {
    return [...publisherPerformanceRows]
      .filter((item) => item.performanceDiamonds > 0)
      .sort((a, b) => a.performanceDiamonds - b.performanceDiamonds)
      .slice(0, 10);
  }, [publisherPerformanceRows]);

  const noLiveRows = useMemo(() => {
    return [...publisherPerformanceRows]
      .filter(
        (item) =>
          item.performanceLiveSeconds === 0 &&
          item.performanceLiveCount === 0
      )
      .sort((a, b) =>
        String(a.username || "").localeCompare(String(b.username || ""), "tr")
      );
  }, [publisherPerformanceRows]);

  const top50DiamondRows = useMemo(() => {
    return [...publisherPerformanceRows]
      .sort((a, b) => {
        const diffDiamonds = safeNumber(b.performanceDiamonds) - safeNumber(a.performanceDiamonds);
        if (diffDiamonds !== 0) return diffDiamonds;
        return safeNumber(b.performanceLiveSeconds) - safeNumber(a.performanceLiveSeconds);
      })
      .slice(0, 50);
  }, [publisherPerformanceRows]);

  return (
    <div>
      <SectionHeader
        eyebrow="Yönetim Özeti"
        title="Genel operasyon görünümü"
        desc="Yayıncı, yönetici, rapor ve eğitim süreçleri tek ekranda özetlenir."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        <StatCard
          title="Toplam Yayıncı"
          value={formatNumber(publisherRows.length)}
          note="API üzerinden gelen yayıncı"
        />
        <StatCard
          title="Toplam Yönetici"
          value={formatNumber(managerRows.length)}
          note="API üzerinden gelen yönetici"
        />
        <StatCard
          title="Toplam Elmas"
          value={formatNumber(agencyTotalDiamonds)}
          note="Ajans genel toplam elmas"
        />
        <StatCard
          title="Toplam Süre"
          value={`${agencyTotalHours} sa ${agencyTotalMinutes} dk`}
          note="Ajans genel canlı yayın süresi"
        />
        <StatCard
          title="Toplam Yayın"
          value={formatNumber(agencyTotalLiveCount)}
          note="Ajans genel canlı yayın adedi"
        />
      </div>

      <Card className="mt-5 overflow-hidden p-5">
        <div className="mb-5 flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.36em] text-yellow-300/80">
              MySQL Performans Raporu
            </div>
            <h2 className="mt-2 text-2xl font-black tracking-tight text-white">
              Genel Performans Paneli
            </h2>
            <p className="mt-2 text-[13px] leading-6 text-white/46">
              Yönetici ve yayıncı filtresine göre MySQL performans verileri gösterilir.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={() => setDatePreset("this_month")}
              className={`rounded-xl border px-3 py-1.5 text-xs font-bold transition-all ${
                activeDatePreset === "this_month"
                  ? "border-yellow-400 bg-yellow-500/20 text-yellow-300 shadow-md shadow-yellow-500/10"
                  : "border-white/10 bg-white/5 text-white/65 hover:border-yellow-500/40 hover:text-white"
              }`}
            >
              📅 Bu Ay
            </button>
            <button
              type="button"
              onClick={() => setDatePreset("last_7")}
              className={`rounded-xl border px-3 py-1.5 text-xs font-bold transition-all ${
                activeDatePreset === "last_7"
                  ? "border-yellow-400 bg-yellow-500/20 text-yellow-300 shadow-md shadow-yellow-500/10"
                  : "border-white/10 bg-white/5 text-white/65 hover:border-yellow-500/40 hover:text-white"
              }`}
            >
              ⚡ Son 7 Gün
            </button>
            <button
              type="button"
              onClick={() => setDatePreset("last_30")}
              className={`rounded-xl border px-3 py-1.5 text-xs font-bold transition-all ${
                activeDatePreset === "last_30"
                  ? "border-yellow-400 bg-yellow-500/20 text-yellow-300 shadow-md shadow-yellow-500/10"
                  : "border-white/10 bg-white/5 text-white/65 hover:border-yellow-500/40 hover:text-white"
              }`}
            >
              📊 Son 30 Gün
            </button>
            <button
              type="button"
              onClick={() => setDatePreset("last_month")}
              className={`rounded-xl border px-3 py-1.5 text-xs font-bold transition-all ${
                activeDatePreset === "last_month"
                  ? "border-yellow-400 bg-yellow-500/20 text-yellow-300 shadow-md shadow-yellow-500/10"
                  : "border-white/10 bg-white/5 text-white/65 hover:border-yellow-500/40 hover:text-white"
              }`}
            >
              ⏮️ Geçen Ay
            </button>
            <Pill tone="gold">MySQL Live</Pill>
          </div>
        </div>

        <div className="grid gap-3 xl:grid-cols-[1.2fr_1fr_.8fr_.8fr]">
          {/* 1. YAYINCI (Autocomplete Arama Filtresi) */}
          <div className="relative" ref={publisherSearchRef}>
            <div className="mb-1.5 flex items-center justify-between">
              <span className="text-xs font-bold text-white/45">Yayıncı (Kullanıcı Adı / ID)</span>
              {selectedPublisherFilter !== "all" && (
                <button
                  type="button"
                  onClick={handleClearPublisherSearch}
                  className="text-[11px] font-semibold text-yellow-400 hover:underline"
                >
                  Tümünü Seç
                </button>
              )}
            </div>

            <div className="relative flex items-center">
              <input
                type="text"
                value={
                  isPublisherDropdownOpen
                    ? publisherSearchQuery
                    : selectedPublisherObj
                    ? `@${selectedPublisherObj.username || selectedPublisherObj.fullName}`
                    : publisherSearchQuery
                }
                onFocus={() => setIsPublisherDropdownOpen(true)}
                onChange={(e) => {
                  setPublisherSearchQuery(e.target.value);
                  setIsPublisherDropdownOpen(true);
                  if (selectedPublisherFilter !== "all") {
                    setSelectedPublisherFilter("all");
                  }
                }}
                placeholder="Yayıncı ara (örn: ay, za, harbi...)"
                className="w-full rounded-2xl border border-yellow-500/20 bg-[#070707] px-4 py-3 pr-10 text-sm text-white placeholder-white/25 outline-none focus:border-yellow-500/60 [color-scheme:dark]"
              />

              {selectedPublisherFilter !== "all" || publisherSearchQuery ? (
                <button
                  type="button"
                  onClick={handleClearPublisherSearch}
                  className="absolute right-3 text-white/40 hover:text-white"
                  title="Temizle"
                >
                  ✕
                </button>
              ) : (
                <span className="pointer-events-none absolute right-3 text-sm text-white/25">
                  🔍
                </span>
              )}
            </div>

            {/* Autocomplete Açılır Menü */}
            {isPublisherDropdownOpen && (
              <div className="absolute left-0 right-0 top-[102%] z-50 max-h-72 overflow-y-auto rounded-2xl border border-yellow-500/30 bg-[#0c0c0d]/95 p-2 shadow-2xl backdrop-blur-xl">
                <div
                  onClick={() => handleSelectPublisher("all")}
                  className={`flex cursor-pointer items-center justify-between rounded-xl px-3 py-2 text-xs font-bold transition-colors ${
                    selectedPublisherFilter === "all"
                      ? "bg-yellow-500/20 text-yellow-300"
                      : "text-white/70 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  <span>🌟 Tüm Yayıncılar (Tüm Ajans)</span>
                  <span className="text-[10px] text-white/40">{publisherRows.length} Yayıncı</span>
                </div>

                <div className="my-1 border-t border-white/10" />

                {autocompletePublisherList.length === 0 ? (
                  <div className="p-3 text-center text-xs text-white/40">
                    "{publisherSearchQuery}" ile eşleşen yayıncı bulunamadı.
                  </div>
                ) : (
                  autocompletePublisherList.map((pub) => {
                    const isSelected = String(selectedPublisherFilter) === String(pub.id);
                    return (
                      <div
                        key={pub.id}
                        onClick={() => handleSelectPublisher(pub)}
                        className={`flex cursor-pointer items-center justify-between rounded-xl px-3 py-2 text-xs transition-colors ${
                          isSelected
                            ? "bg-yellow-500/25 text-yellow-200 font-bold"
                            : "text-white/80 hover:bg-white/10 hover:text-white"
                        }`}
                      >
                        <div className="flex items-center gap-2.5 overflow-hidden">
                          <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-yellow-500/20 text-[11px] font-bold text-yellow-300">
                            {String(pub.username || pub.fullName || "?").charAt(0).toUpperCase()}
                          </div>
                          <div className="truncate">
                            <div className="font-bold text-white">
                              @{pub.username || pub.fullName}
                            </div>
                            {pub.fullName && pub.fullName !== pub.username && (
                              <div className="text-[11px] text-white/45 truncate">
                                {pub.fullName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="flex shrink-0 items-center gap-1.5 pl-2">
                          {pub.hiddenId && pub.hiddenId !== "-" && (
                            <span className="rounded-md bg-white/5 px-1.5 py-0.5 text-[10px] text-white/40">
                              ID: {pub.hiddenId}
                            </span>
                          )}
                          {pub.assignedEmployeeUsername && (
                            <span className="rounded-md bg-yellow-500/10 px-1.5 py-0.5 text-[10px] font-medium text-yellow-300/80">
                              {pub.managerName || pub.assignedEmployeeUsername}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>

          {/* 2. YÖNETİCİ (Dropdown) */}
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Yönetici</span>
            <select
              value={selectedManagerFilter}
              onChange={handleManagerChange}
              className="w-full rounded-2xl border border-yellow-500/20 bg-[#070707] px-4 py-3 text-sm text-white outline-none focus:border-yellow-500/45 [color-scheme:dark]"
            >
              <option value="all">Tüm Yöneticiler</option>
              {managerRows.map((manager) => (
                <option key={manager.username} value={manager.username}>
                  {manager.fullName} ({manager.username})
                </option>
              ))}
            </select>
          </label>

          {/* 3. BAŞLANGIÇ TARİHİ */}
          <FormInput
            label="Başlangıç Tarihi"
            type="date"
            name="reportStartDate"
            value={reportStartDate}
            onChange={(event) => setReportStartDate(event.target.value)}
          />

          {/* 4. BİTİŞ TARİHİ */}
          <FormInput
            label="Bitiş Tarihi"
            type="date"
            name="reportEndDate"
            value={reportEndDate}
            onChange={(event) => setReportEndDate(event.target.value)}
          />
        </div>

        <div className="mt-4 rounded-2xl border border-yellow-500/20 bg-yellow-500/10 px-4 py-3 text-sm font-semibold text-yellow-100">
          Seçili kapsam: {filteredPublisherRowsForPerformance.length} yayıncı •{" "}
          {formatDateForDisplay(reportStartDate)} - {formatDateForDisplay(reportEndDate)}
        </div>

        {adminPerformanceLoading && (
          <div className="mt-4 rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/45">
            MySQL verileri yükleniyor...
          </div>
        )}

        {adminPerformanceError && (
          <div className="mt-4 rounded-2xl border border-yellow-500/25 bg-yellow-500/10 p-5 text-sm font-semibold text-yellow-100">
            {adminPerformanceError}
          </div>
        )}

        {!adminPerformanceLoading && !adminPerformanceError && (
          <>
            <div className="mt-5 grid gap-4 md:grid-cols-3">
              <StatCard
                title="Toplam Yayın"
                value={formatNumber(totalLiveCount)}
                note="Seçili dönem yayın adedi"
                trend={
                  <CompareNote
                    current={totalLiveCount}
                    previous={previousTotalLiveCount}
                  />
                }
              />

              <StatCard
                title="Toplam Süre"
                value={`${totalHours} sa ${totalMinutes} dk`}
                note="Seçili dönem yayın süresi"
                trend={
                  <CompareNote
                    current={totalLiveSeconds}
                    previous={previousTotalLiveSeconds}
                    formatter={formatDurationFromSeconds}
                  />
                }
              />

              <StatCard
                title="Toplam Elmas"
                value={formatNumber(totalDiamonds)}
                note="Seçili dönem elmas"
                trend={
                  <CompareNote
                    current={totalDiamonds}
                    previous={previousTotalDiamonds}
                  />
                }
              />
            </div>

            <div className="mt-5 overflow-hidden rounded-[1.4rem] border border-yellow-500/25 bg-[radial-gradient(circle_at_top_right,rgba(234,179,8,.18),transparent_28%),linear-gradient(180deg,rgba(255,255,255,.045),rgba(0,0,0,.35))] p-4 shadow-[inset_0_1px_0_rgba(255,255,255,.08),0_0_45px_rgba(234,179,8,.08)]">
              <div className="mb-4 flex items-center justify-between">
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-yellow-300/80">
                    Elmas Trend Grafiği
                  </div>
                  <div className="mt-1 text-xs text-white/45">
                    Günlük MySQL verilerine göre çizilir.
                  </div>
                </div>
                <Pill tone="gold">Toplam: {formatNumber(totalDiamonds)}</Pill>
              </div>

              {daily.length === 0 ? (
                <div className="rounded-2xl border border-white/10 bg-black/25 p-6 text-sm text-white/45">
                  Seçili filtrelerde performans verisi bulunamadı.
                </div>
              ) : (
                <svg
                  viewBox={`0 0 ${chartWidth} ${chartHeight}`}
                  className="h-[360px] w-full"
                  preserveAspectRatio="none"
                >
                  <defs>
                    <linearGradient id="adminDiamondArea" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="rgb(234,179,8)" stopOpacity="0.42" />
                      <stop offset="55%" stopColor="rgb(234,179,8)" stopOpacity="0.12" />
                      <stop offset="100%" stopColor="rgb(234,179,8)" stopOpacity="0.02" />
                    </linearGradient>

                    <linearGradient id="adminDiamondLine" x1="0" y1="0" x2="1" y2="0">
                      <stop offset="0%" stopColor="rgb(161,98,7)" />
                      <stop offset="45%" stopColor="rgb(250,204,21)" />
                      <stop offset="100%" stopColor="rgb(253,224,71)" />
                    </linearGradient>
                  </defs>

                  <rect x="0" y="0" width={chartWidth} height={chartHeight} rx="26" fill="rgba(0,0,0,0.18)" />

                  {yTicks.map((tick) => {
                    const y = getChartY(tick);

                    return (
                      <g key={tick}>
                        <line
                          x1={chartPadding.left}
                          y1={y}
                          x2={chartPadding.left + chartInnerWidth}
                          y2={y}
                          stroke="rgba(234,179,8,0.16)"
                          strokeDasharray="5 9"
                        />
                        <text x={18} y={y + 4} className="fill-yellow-300/55 text-[11px] font-semibold">
                          {formatNumber(tick)}
                        </text>
                      </g>
                    );
                  })}

                  <polygon points={areaPoints} fill="url(#adminDiamondArea)" />

                  <polyline
                    points={linePoints}
                    fill="none"
                    stroke="url(#adminDiamondLine)"
                    strokeWidth="4"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                  />

                  {daily.map((item, index) => {
                    const point = {
                      x: getChartX(index),
                      y: getChartY(item.diamonds),
                      dateText: formatDateForDisplay(item.report_date),
                      value: safeNumber(item.diamonds),
                    };

                    return (
                      <circle
                        key={`${item.report_date}-dot`}
                        cx={point.x}
                        cy={point.y}
                        r="5"
                        fill="rgb(250,204,21)"
                        stroke="rgba(0,0,0,0.95)"
                        strokeWidth="2.5"
                        className="cursor-pointer transition hover:r-[6]"
                        onMouseEnter={() => setActiveDiamondPoint(point)}
                        onMouseLeave={() => setActiveDiamondPoint(null)}
                        onFocus={() => setActiveDiamondPoint(point)}
                        onBlur={() => setActiveDiamondPoint(null)}
                        onClick={() => setActiveDiamondPoint(point)}
                        onTouchStart={() => setActiveDiamondPoint(point)}
                      >
                        <title>
                          Elmas: {formatNumber(item.diamonds)}
                        </title>
                      </circle>
                    );
                  })}

                  <SvgDiamondTooltip point={activeDiamondPoint} chartWidth={chartWidth} />

                  {daily.map((item, index) => {
                    if (index % xLabelStep !== 0 && index !== daily.length - 1) return null;

                    return (
                      <text
                        key={`${item.report_date}-label`}
                        x={getChartX(index)}
                        y={chartHeight - 18}
                        textAnchor="middle"
                        className="fill-white/45 text-[11px] font-semibold"
                      >
                        {formatDateForDisplay(item.report_date).slice(0, 5)}
                      </text>
                    );
                  })}
                </svg>
                              )}
                            </div>

                            <PerformanceTopLists
                              topLiveRows={topLiveRows}
                              topDiamondRows={topDiamondRows}
                              lowLiveRows={lowLiveRows}
                              lowDiamondRows={lowDiamondRows}
                              noLiveRows={noLiveRows}
                              top50DiamondRows={top50DiamondRows}
                              allPublishers={publisherRows}
                              currentAdmin={currentAdmin}
                            />
                          </>
                        )}
                      </Card>

      <div className="mt-5 grid gap-4 xl:grid-cols-4">
        <OperationCard
          title="Eksik İşlemler"
          desc="Yönetici ataması, telefon, rapor rolü ve pasif kullanıcı kontrolleri."
          value={publisherRows.filter((item) => !item.assignedEmployeeUsername || !item.phone || item.phone === "-" || item.powerBIRole === "-" || !item.powerBIRole).length}
          label="eksik kayıt"
          buttonText="Eksikleri Gör"
          onOpen={() => setActiveKey("publisher_list")}
        />

        <OperationCard
          title="Rapor Durumu"
          desc="Rapor yükleme, tarih kontrolü ve performans veri takibi."
          value="Canlı"
          label="rapor"
          buttonText="Rapor Merkezi"
          onOpen={() => setActiveKey("reports_overview")}
        />

        <OperationCard
          title="Eğitim Takibi"
          desc="Yayıncı eğitimleri, görüntüleme oranı ve tamamlanma kontrolleri."
          value="Yeni"
          label="modül"
          buttonText="Eğitim Merkezi"
          onOpen={() => setActiveKey("publisher_training")}
        />

        <OperationCard
          title="Hızlı İşlemler"
          desc="Yayıncı ekleme, toplu yükleme, şifre işlemleri ve rapor kontrolleri."
          value="4"
          label="kısayol"
          buttonText="Yayıncılar"
          onOpen={() => setActiveKey("publisher_list")}
        />
      </div>
    </div>
  );
}

function PerformanceTopLists({
  topLiveRows,
  topDiamondRows,
  lowLiveRows,
  lowDiamondRows,
  noLiveRows,
  top50DiamondRows = [],
  allPublishers = [],
  currentAdmin,
}) {
  return (
    <div className="mt-5 space-y-4">
      <div className="grid gap-4 xl:grid-cols-2">
        <TopListTable
          title="En Çok Yayın Açan Top 10"
          rows={topLiveRows}
        />

        <TopListTable
          title="En Çok Kazanan Top 10"
          rows={topDiamondRows}
        />

        <TopListTable
          title="En Az Yayın Açan Top 10"
          rows={lowLiveRows}
        />

        <TopListTable
          title="En Az Kazanan Top 10"
          rows={lowDiamondRows}
        />
      </div>

      <NoLivePublisherList rows={noLiveRows} />

      {/* Seçili Tarihte En Çok Elmas Kazanan Top 50 Yayıncı & Öne Çıkartma Paneli */}
      <Top50DiamondFeaturedPublisherSection
        rows={top50DiamondRows}
        allPublishers={allPublishers}
        currentAdmin={currentAdmin}
      />
    </div>
  );
}

function TopListTable({ title, rows = [] }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-black/25 p-4">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="text-base font-black text-white">
          {title}
        </div>

        <span className="rounded-full border border-yellow-500/25 bg-yellow-500/10 px-3 py-1 text-[11px] font-black text-yellow-300">
          Top 10
        </span>
      </div>

      <div className="space-y-2">
        <div className="grid grid-cols-[1.45fr_.65fr_.8fr_.8fr] gap-3 px-4 pb-2 text-[10px] font-black uppercase tracking-[0.16em] text-white/35">
          <div>Kullanıcı Adı</div>
          <div>Yayın</div>
          <div>Süre</div>
          <div>Elmas</div>
        </div>

        <div className="max-h-[610px] overflow-y-auto pr-1 [scrollbar-color:rgba(234,179,8,.75)_rgba(255,255,255,.06)] [scrollbar-width:thin]">
          <div className="space-y-2">
            {rows.map((item, index) => (
              <div
                key={`${item.id}-${index}`}
                className="grid min-h-[66px] grid-cols-[1.45fr_.65fr_.8fr_.8fr] items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.035] px-4 py-3 text-sm text-white/70 shadow-[inset_0_1px_0_rgba(255,255,255,.04)] transition hover:border-yellow-500/30 hover:bg-yellow-500/[0.055]"
              >
                <div className="flex min-w-0 items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-yellow-500/35 bg-yellow-500/10 text-xs font-black text-yellow-300">
                    {index + 1}
                  </span>

                  <div className="min-w-0">
                    <div translate="no" className="notranslate">
                      <PublisherNameWithTier
                        publisher={item}
                        diamonds={item.performanceDiamonds}
                        label={item.username || "-"}
                        nameClassName="text-sm font-black"
                      />
                    </div>

                    <div className="mt-1">
                      <PublisherTierBadge
                        publisher={item}
                        diamonds={item.performanceDiamonds}
                        compact
                      />
                    </div>
                  </div>
                </div>

                <div className="font-black text-white">
                  {formatNumber(item.performanceLiveCount)}
                </div>

                <div className="font-black text-white/75">
                  {formatDurationFromSeconds(item.performanceLiveSeconds)}
                </div>

                <div className="font-black text-yellow-300">
                  {formatNumber(item.performanceDiamonds)}
                </div>
              </div>
            ))}

            {rows.length === 0 && (
              <div className="rounded-2xl border border-white/10 bg-white/[0.035] p-4 text-sm text-white/45">
                Veri bulunamadı.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function NoLivePublisherList({ rows = [] }) {
  return (
    <div className="rounded-2xl border border-red-500/20 bg-red-500/10 p-4">
      <div className="mb-1 text-base font-black text-white">
        Seçili Tarihte Yayın Açmayan Yayıncılar
      </div>

      <div className="mb-4 text-xs text-white/45">
        Seçilen tarih aralığında yayın açmayan yayıncılar listelenir. İlk 10 kayıt görünür, diğerleri aşağı kaydırılarak görüntülenir.
      </div>

      <div className="overflow-hidden rounded-2xl border border-white/10 bg-black/25">
        <div className="grid grid-cols-[1.1fr_.7fr_.8fr_.8fr] gap-3 bg-white/[0.04] px-4 py-3 text-[11px] font-black uppercase tracking-[0.14em] text-white/38">
          <div>Kullanıcı Adı</div>
          <div>Kıdem</div>
          <div>Son Yayın Tarihi</div>
          <div>Ort. Elmas</div>
        </div>

        <div className="max-h-[560px] overflow-y-auto [scrollbar-color:rgba(234,179,8,.75)_rgba(255,255,255,.06)] [scrollbar-width:thin]">
          {rows.map((item, index) => (
            <div
              key={`${item.id}-${index}`}
              className="grid min-h-[56px] grid-cols-[1.1fr_.7fr_.8fr_.8fr] items-center gap-3 border-t border-white/10 px-4 py-3 text-sm text-white/68 hover:bg-red-500/[0.04]"
            >
              <div className="min-w-0">
                <div translate="no" className="notranslate">
                  <PublisherNameWithTier
                    publisher={item}
                    label={`${index + 1}. ${item.username || "-"}`}
                    nameClassName="font-black"
                  />
                </div>
              </div>

              <div className="font-bold text-white/65">
                {formatAgencyTenure(item.createdAt)}
              </div>

              <div className="font-bold text-white/65">
                {formatLastLiveDate(item.performanceLastLiveDate)}
              </div>

              <div className="font-black text-yellow-300">
                {formatAverageDiamondsPerLive(item.performanceAvgDiamondsPerLive)}
              </div>
            </div>
          ))}

          {rows.length === 0 && (
            <div className="border-t border-white/10 p-4 text-sm text-white/45">
              Seçili tarihte yayın açmayan yayıncı bulunmuyor.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Top50DiamondFeaturedPublisherSection({
  rows = [],
  allPublishers = [],
  currentAdmin,
}) {
  const [search, setSearch] = useState("");
  const [featuredList, setFeaturedList] = useState([]);
  const [featuredLoading, setFeaturedLoading] = useState(false);
  const [togglingId, setTogglingId] = useState(null);
  const [syncingAll, setSyncingAll] = useState(false);
  const [syncProgress, setSyncProgress] = useState(null);

  const loadFeaturedList = useCallback(async () => {
    try {
      setFeaturedLoading(true);
      const res = await requestJson(API_FEATURED_PUBLISHER_LIST, { cache: "no-store" });
      setFeaturedList(Array.isArray(res.publishers) ? res.publishers : []);
    } catch (e) {
      console.warn("Öne çıkan yayıncılar listesi alınamadı:", e);
    } finally {
      setFeaturedLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFeaturedList();
  }, [loadFeaturedList]);

  async function handleToggleFeatured(user) {
    const userCleanUser = String(user.username || "").replace(/[@\s]+/g, "").toLowerCase();
    const isFeatured = featuredList.some((fp) => {
      const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
      return (
        (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
        String(fp.id) === String(user.id)
      );
    });

    try {
      setTogglingId(user.id);
      if (isFeatured) {
        const found = featuredList.find((fp) => {
          const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
          return (
            (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
            String(fp.id) === String(user.id)
          );
        });
        if (found && found.id) {
          const res = await fetch(API_FEATURED_PUBLISHER_DELETE, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: found.id }),
          });
          const data = await res.json();
          if (!data.success) {
            alert(data.message || "Öne çıkanlardan kaldırılamadı.");
          }
        }
      } else {
        let imageToSave = user.image || user.profileImage || "";
        let followerCountToSave = "0";
        if (!imageToSave && user.username) {
          try {
            const tkRes = await requestJson(`${API_TIKTOK_PROFILE_FETCH}?username=${encodeURIComponent(user.username)}`);
            if (tkRes && tkRes.success && tkRes.data) {
              if (tkRes.data.avatar) imageToSave = tkRes.data.avatar;
              if (tkRes.data.followerCount) followerCountToSave = String(tkRes.data.followerCount);
            }
          } catch (tkErr) {
            console.warn("TikTok fotoğrafı otomatik çekilemedi:", tkErr);
          }
        }

        const payload = new FormData();
        payload.append("name", user.fullName || user.username);
        payload.append("username", user.username || "");
        payload.append("tiktokUrl", `https://www.tiktok.com/@${user.username || ""}`);
        payload.append("imageBoxText", user.fullName || user.username);
        payload.append("followerCount", followerCountToSave);
        payload.append("status", "Aktif");
        payload.append("sortOrder", "0");
        payload.append("currentImage", imageToSave);
        payload.append("createdBy", currentAdmin?.username || "admin");

        const res = await fetch(API_FEATURED_PUBLISHER_SAVE, {
          method: "POST",
          body: payload,
        });
        const data = await res.json();
        if (!data.success) {
          alert(data.message || "Öne çıkanlara eklenemedi.");
        }
      }

      await loadFeaturedList();
    } catch (e) {
      console.error(e);
      alert("Öne çıkarma işlemi sırasında bağlantı hatası oluştu.");
    } finally {
      setTogglingId(null);
    }
  }

  async function handleSyncAllTiktokAvatars() {
    const targetRows = rows.length > 0 ? rows : allPublishers;
    if (!targetRows || targetRows.length === 0) {
      alert("Taranacak yayıncı bulunamadı.");
      return;
    }

    if (!window.confirm(`${targetRows.length} yayıncının TikTok profil fotoğrafları sırayla taranıp kaydedilecek. Başlatılsın mı?`)) {
      return;
    }

    setSyncingAll(true);
    let success = 0;
    const total = targetRows.length;

    for (let i = 0; i < total; i++) {
      const user = targetRows[i];
      const cleanUser = String(user.username || "").replace(/[@\s]+/g, "");
      setSyncProgress({
        current: i + 1,
        total,
        currentName: user.fullName || cleanUser,
        successCount: success,
      });

      if (cleanUser) {
        try {
          const res = await requestJson(`${API_TIKTOK_PROFILE_FETCH}?username=${encodeURIComponent(cleanUser)}&saveLocal=true`);
          if (res && res.success && res.data) {
            const avatarUrl = res.data.avatar || res.data.avatarRemote || "";
            const followerCount = res.data.followerCount || "0";

            const payload = new FormData();
            payload.append("name", user.fullName || cleanUser);
            payload.append("username", cleanUser);
            payload.append("tiktokUrl", `https://www.tiktok.com/@${cleanUser}`);
            payload.append("imageBoxText", user.fullName || cleanUser);
            payload.append("followerCount", String(followerCount));

            const isAlreadyFeatured = featuredList.some(
              (fp) => String(fp.username).replace(/[@\s]+/g, "").toLowerCase() === cleanUser.toLowerCase() && fp.status === "Aktif"
            );
            payload.append("status", isAlreadyFeatured ? "Aktif" : "Pasif");
            payload.append("sortOrder", "0");
            payload.append("currentImage", avatarUrl);
            payload.append("createdBy", currentAdmin?.username || "sync");

            await fetch(API_FEATURED_PUBLISHER_SAVE, {
              method: "POST",
              body: payload,
            });

            success++;
          }
        } catch (itemErr) {
          console.warn(`[TikTok Sync] @${cleanUser} çekilemedi:`, itemErr);
        }
      }

      await new Promise((r) => setTimeout(r, 60));
    }

    setSyncingAll(false);
    setSyncProgress(null);
    alert(`🎉 İşlem tamamlandı!\nToplam ${total} yayıncıdan ${success} tanesinin TikTok profil fotoğrafı başarıyla çekildi ve kaydedildi.`);
    await loadFeaturedList();
  }

  const uniqueRows = useMemo(() => {
    return deduplicatePublishersByHiddenId(rows);
  }, [rows]);

  const filteredRows = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return uniqueRows;
    return uniqueRows.filter((item) =>
      `${item.fullName} ${item.username} ${item.managerName} ${item.hiddenId}`.toLowerCase().includes(q)
    );
  }, [uniqueRows, search]);

  const featuredCount = useMemo(() => {
    return uniqueRows.filter((item) => {
      const clean = String(item.username || "").replace(/[@\s]+/g, "").toLowerCase();
      return featuredList.some((fp) => {
        const fpClean = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
        return (fpClean && clean && fpClean === clean) || String(fp.id) === String(item.id);
      });
    }).length;
  }, [uniqueRows, featuredList]);

  return (
    <div className="rounded-2xl border border-yellow-500/25 bg-[radial-gradient(circle_at_top_right,rgba(234,179,8,0.12),transparent_35%),linear-gradient(180deg,rgba(255,255,255,0.035),rgba(0,0,0,0.35))] p-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_0_50px_rgba(234,179,8,0.07)]">
      {/* Üst Başlık & Aksiyon Butonları */}
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded-lg border border-yellow-500/40 bg-yellow-500/15 text-sm">
              🏆
            </span>
            <h3 className="text-lg font-black text-white">
              Seçili Tarihte En Çok Elmas Kazanan Top 50 Yayıncı
            </h3>
            <span className="rounded-full border border-yellow-500/30 bg-yellow-500/10 px-3 py-0.5 text-xs font-black text-yellow-300 shadow-sm">
              Top 50
            </span>
          </div>
          <p className="mt-1 text-xs text-white/45">
            Seçilen tarih aralığında en yüksek kazanç sağlayan 50 yayıncı listelenir. Yanındaki butonu kullanarak ana sayfada öne çıkarabilirsiniz.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-xl border border-white/10 bg-black/40 px-3 py-2 text-xs font-bold text-white/70">
            Öne Çıkarılan: <strong className="text-yellow-300 font-black">{featuredCount}</strong> / {rows.length}
          </span>

          <button
            type="button"
            disabled={syncingAll}
            onClick={handleSyncAllTiktokAvatars}
            className="inline-flex items-center gap-1.5 rounded-xl border border-yellow-500/50 bg-gradient-to-r from-yellow-500/25 via-amber-500/20 to-yellow-500/25 px-3 py-2 text-xs font-black text-yellow-200 shadow-sm transition hover:border-yellow-400 hover:bg-yellow-500/35 hover:scale-105 active:scale-95 disabled:opacity-50"
            title="TikTok profil fotoğraflarını otomatik çek ve güncelle"
          >
            {syncingAll ? (
              <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
            ) : (
              <span>⚡</span>
            )}
            <span>{syncingAll ? `Taranıyor...` : "TikTok Fotoğraflarını Çek"}</span>
          </button>

          <button
            type="button"
            onClick={loadFeaturedList}
            disabled={featuredLoading}
            className="rounded-xl border border-white/10 bg-black/40 px-3 py-2 text-xs font-bold text-white/70 transition hover:border-yellow-500/35 hover:text-yellow-300"
          >
            {featuredLoading ? "Yenileniyor..." : "Öne Çıkanları Yenile"}
          </button>
        </div>
      </div>

      {/* İlerleme Çubuğu */}
      {syncProgress && (
        <div className="mb-4 rounded-2xl border border-yellow-500/40 bg-yellow-500/10 p-3.5 shadow-[0_0_20px_rgba(234,179,8,0.15)]">
          <div className="flex items-center justify-between text-xs font-black text-yellow-300">
            <span className="flex items-center gap-2">
              <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
              TikTok Fotoğrafı İndiriliyor: <strong className="text-white">{syncProgress.currentName}</strong>
            </span>
            <span>{syncProgress.current} / {syncProgress.total} (%{Math.round((syncProgress.current / syncProgress.total) * 100)})</span>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-black/40 border border-white/10">
            <div
              className="h-full bg-gradient-to-r from-yellow-500 to-amber-400 transition-all duration-300"
              style={{ width: `${(syncProgress.current / syncProgress.total) * 100}%` }}
            />
          </div>
        </div>
      )}

      {/* Arama Alanı */}
      <div className="mb-3">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Top 50 içinde yayıncı veya yönetici ara..."
          className="w-full rounded-xl border border-white/10 bg-black/40 px-3.5 py-2.5 text-xs text-white placeholder-white/35 outline-none focus:border-yellow-500/50"
        />
      </div>

      {/* Top 50 Tablo */}
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-black/25">
        <div className="grid grid-cols-[1.6fr_.9fr_.65fr_.75fr_.85fr_1.1fr] gap-3 bg-white/[0.04] px-4 py-3 text-[11px] font-black uppercase tracking-[0.14em] text-white/38">
          <div>Sıra & Yayıncı</div>
          <div>Bağlı Yönetici</div>
          <div>Yayın</div>
          <div>Süre</div>
          <div>Kazanılan Elmas</div>
          <div className="text-right">Öne Çıkar</div>
        </div>

        <div className="max-h-[640px] overflow-y-auto [scrollbar-color:rgba(234,179,8,.75)_rgba(255,255,255,.06)] [scrollbar-width:thin]">
          {filteredRows.map((item, index) => {
            const userCleanUser = String(item.username || "").replace(/[@\s]+/g, "").toLowerCase();
            const matchedFeatured = featuredList.find((fp) => {
              const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
              return (
                (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
                String(fp.id) === String(item.id)
              );
            });
            const isFeatured = Boolean(matchedFeatured);
            const publisherImg = item.image || item.profileImage || matchedFeatured?.image || matchedFeatured?.currentImage;
            const rank = index + 1;

            return (
              <div
                key={`${item.id}-${index}`}
                className={`grid min-h-[68px] grid-cols-[1.6fr_.9fr_.65fr_.75fr_.85fr_1.1fr] items-center gap-3 border-t border-white/10 px-4 py-2.5 text-sm transition hover:bg-yellow-500/[0.04] ${
                  isFeatured ? "bg-yellow-500/[0.035]" : ""
                }`}
              >
                {/* Sıra & Görsel & Yayıncı Bilgisi */}
                <div className="flex items-center gap-3 min-w-0">
                  {/* Sıra Rozeti */}
                  <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-xs font-black shadow-sm ${
                    rank === 1
                      ? "border border-yellow-400 bg-gradient-to-br from-yellow-400 to-amber-600 text-black font-black shadow-[0_0_12px_rgba(250,204,21,0.5)]"
                      : rank === 2
                      ? "border border-slate-300 bg-gradient-to-br from-slate-200 to-slate-400 text-black font-black"
                      : rank === 3
                      ? "border border-amber-600 bg-gradient-to-br from-amber-600 to-amber-800 text-white font-black"
                      : "border border-yellow-500/30 bg-yellow-500/10 text-yellow-300"
                  }`}>
                    {rank === 1 ? "🥇 1" : rank === 2 ? "🥈 2" : rank === 3 ? "🥉 3" : rank}
                  </span>

                  {/* Görsel */}
                  <div className="relative shrink-0 group/avatar">
                    {publisherImg ? (
                      <img
                        src={publisherImg}
                        alt={item.fullName || item.username}
                        className="h-11 w-11 rounded-full object-cover border-2 border-yellow-500/40 shadow-[0_0_10px_rgba(234,179,8,0.2)] group-hover/avatar:scale-105 transition-all duration-300"
                      />
                    ) : (
                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-yellow-500/30 bg-gradient-to-br from-yellow-500/20 via-black to-black text-xs font-black text-yellow-300 shadow-sm group-hover/avatar:scale-105 transition-all duration-300">
                        {(item.fullName || item.username || "WM").slice(0, 2).toUpperCase()}
                      </div>
                    )}
                    {isFeatured && (
                      <span className="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-yellow-400 text-[9px] shadow-sm animate-pulse" title="Öne Çıkarıldı">
                        ⭐
                      </span>
                    )}
                  </div>

                  {/* İsim & Kademe */}
                  <div className="min-w-0">
                    <div translate="no" className="notranslate">
                      <PublisherNameWithTier
                        publisher={item}
                        diamonds={item.performanceDiamonds}
                        label={item.fullName || item.username || "-"}
                        nameClassName="text-sm font-black text-white truncate"
                      />
                    </div>
                    <div className="mt-0.5 flex items-center gap-1.5 flex-wrap">
                      <span className="text-[11px] text-white/45">@{item.username || "-"}</span>
                      <PublisherTierBadge
                        publisher={item}
                        diamonds={item.performanceDiamonds}
                        compact
                      />
                      {isFeatured && (
                        <span className="inline-flex items-center gap-0.5 rounded-full border border-yellow-400/40 bg-yellow-400/15 px-1.5 py-0.2 text-[8px] font-black text-yellow-300 shadow-sm">
                          ⭐ ÖNE ÇIKAN
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Bağlı Yönetici */}
                <div className="text-xs font-bold text-white/70 truncate">
                  {item.managerName || item.assignedEmployeeUsername || "-"}
                </div>

                {/* Yayın Sayısı */}
                <div className="font-black text-white">
                  {formatNumber(item.performanceLiveCount)}
                </div>

                {/* Yayın Süresi */}
                <div className="font-bold text-white/70">
                  {formatDurationFromSeconds(item.performanceLiveSeconds)}
                </div>

                {/* Kazanılan Elmas */}
                <div className="font-black text-yellow-300 text-sm">
                  {formatNumber(item.performanceDiamonds)}
                </div>

                {/* Öne Çıkar Aksiyon Butonu */}
                <div className="flex justify-end">
                  <button
                    type="button"
                    disabled={togglingId === item.id}
                    onClick={() => handleToggleFeatured(item)}
                    className={`inline-flex items-center gap-1 rounded-xl px-3 py-1.5 text-xs font-bold transition shadow-sm ${
                      isFeatured
                        ? "border border-yellow-400 bg-yellow-500 text-black font-black shadow-[0_0_14px_rgba(250,204,21,0.45)] hover:bg-yellow-400 hover:scale-105 active:scale-95"
                        : "border border-yellow-500/30 bg-yellow-500/10 text-yellow-300 hover:border-yellow-500/50 hover:bg-yellow-500/20 hover:scale-105 active:scale-95"
                    }`}
                  >
                    {togglingId === item.id ? (
                      <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
                    ) : isFeatured ? (
                      "⭐ Öne Çıkarıldı"
                    ) : (
                      "☆ Öne Çıkar"
                    )}
                  </button>
                </div>
              </div>
            );
          })}

          {filteredRows.length === 0 && (
            <div className="border-t border-white/10 p-6 text-center text-sm text-white/45">
              Seçili kriterlerde yayıncı bulunamadı.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function OperationCard({ title, desc, value, label, buttonText, onOpen }) {
  return (
    <Card className="p-5">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <div className="text-xl font-black text-white">{title}</div>
          <p className="mt-2 text-[13px] leading-6 text-white/45">{desc}</p>
        </div>

        <div className="rounded-2xl border border-yellow-500/25 bg-yellow-500/10 px-3 py-2 text-right">
          <div className="text-lg font-black text-yellow-200">{value}</div>
          <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/35">{label}</div>
        </div>
      </div>

      <button
        type="button"
        onClick={onOpen}
        className="mt-4 w-full rounded-xl border border-yellow-500/25 bg-yellow-500/10 px-4 py-2.5 text-xs font-black text-yellow-200 hover:bg-yellow-500 hover:text-black"
      >
        {buttonText}
      </button>
    </Card>
  );
}

function PublisherModal({ mode, open, form, setForm, managers, saving, onChange, onFileChange, onClose, onSubmit }) {
  const [tiktokLoading, setTiktokLoading] = useState(false);
  const [tiktokMsg, setTiktokMsg] = useState("");

  if (!open) return null;
  const isEdit = mode === "edit";

  async function handleFetchTikTok() {
    const userToFetch = form.username?.trim();
    if (!userToFetch) {
      alert("Lütfen önce TikTok kullanıcı adını giriniz.");
      return;
    }

    try {
      setTiktokLoading(true);
      setTiktokMsg("TikTok profili taranıyor ve fotoğraf indiriliyor...");
      const res = await requestJson(`${API_TIKTOK_PROFILE_FETCH}?username=${encodeURIComponent(userToFetch)}`);
      
      if (res && res.success && res.data) {
        const d = res.data;
        if (setForm) {
          setForm((prev) => ({
            ...prev,
            fullName: prev.fullName || d.fullName || d.nickname || prev.username,
            image: d.avatar || d.avatarRemote || prev.image,
            isFeatured: true,
          }));
        }
        const followerTxt = d.followerCount > 0 ? ` • ${Number(d.followerCount).toLocaleString("tr-TR")} Takipçi` : "";
        setTiktokMsg(`✅ Başarılı! @${d.username} profili ve fotoğrafı aktarıldı.${followerTxt}`);
      } else {
        setTiktokMsg(res.message || "TikTok profili bulunamadı.");
      }
    } catch (err) {
      console.error(err);
      setTiktokMsg("Bağlantı hatası: Profil çekilemedi.");
    } finally {
      setTiktokLoading(false);
    }
  }

  return (
    <ModalShell title={isEdit ? "Yayıncı Düzenle" : "Yayıncı Ekle"} onClose={onClose}>
      <form onSubmit={onSubmit} className="grid gap-4">
        <FormInput label="Ad Soyadı" name="fullName" value={form.fullName} onChange={onChange} />
        
        {/* Sistem Giriş Adı (Ajans Giriş ID) */}
        <div>
          <FormInput 
            label="Sistem Giriş Adı (Ajans Giriş ID)" 
            name="system_username" 
            value={form.system_username || ""} 
            onChange={onChange} 
            placeholder="ornek: wolf.burakgaming" 
          />
          <div className="mt-1 text-[11px] text-yellow-300/80">
            💡 Yayıncının ajans paneline girişte kullanacağı kalıcı kullanıcı adıdır. (TikTok adı değişse bile değişmez).
          </div>
        </div>

        {/* TikTok Kullanıcı Adı & Otomatik Çek Butonu */}
        <div>
          <div className="flex items-end gap-2">
            <div className="flex-1">
              <FormInput label="TikTok Kullanıcı Adı" name="username" value={form.username} onChange={onChange} placeholder="ornek: burakgaming veya @gokceofficial" />
            </div>
            <button
              type="button"
              disabled={tiktokLoading || !form.username}
              onClick={handleFetchTikTok}
              className="mb-0.5 inline-flex h-11 items-center gap-1.5 rounded-xl border border-yellow-500/40 bg-gradient-to-r from-yellow-500/20 via-amber-500/15 to-yellow-500/20 px-3.5 text-xs font-black text-yellow-200 transition hover:border-yellow-400 hover:bg-yellow-500/30 hover:scale-105 active:scale-95 disabled:opacity-50"
              title="TikTok profil fotoğrafı, isim ve bilgileri otomatik çek"
            >
              {tiktokLoading ? (
                <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
              ) : (
                <span className="text-sm">✨</span>
              )}
              <span>{tiktokLoading ? "Çekiliyor..." : "TikTok'tan Getir"}</span>
            </button>
          </div>
          {tiktokMsg && (
            <div className={`mt-1.5 text-[11px] font-bold ${tiktokMsg.includes("✅") ? "text-emerald-300" : tiktokMsg.includes("...") ? "text-yellow-300" : "text-red-300"}`}>
              {tiktokMsg}
            </div>
          )}
        </div>

        <FormInput label={isEdit ? "Şifre (Değiştirmek istemiyorsanız boş bırakın)" : "Şifre"} name="password" type="password" placeholder={isEdit ? "Yeni şifre belirlemek için girin..." : "Şifre giriniz..."} value={form.password || ""} onChange={onChange} />
        <FormInput label="Telefon" name="phone" value={form.phone} onChange={onChange} />
        <FormInput label="Email" name="email" type="email" value={form.email} onChange={onChange} />
        <FormInput label="Hidden ID" name="hiddenId" value={form.hiddenId} onChange={onChange} />
        <FormSelect label="Yönetici" name="assignedEmployeeUsername" value={form.assignedEmployeeUsername} onChange={onChange}>
          <option value="">Yönetici seç</option>
          {managers.map((manager) => <option key={manager.username} value={manager.username}>{manager.fullName} ({manager.username})</option>)}
        </FormSelect>
        <FormInput label="Rapor Rol" name="powerBIRole" value={form.powerBIRole} onChange={onChange} />

        {/* Profil Görseli & Öne Çıkar Alanı */}
        <div className="rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4 space-y-3">
          <div className="text-xs font-bold uppercase tracking-wider text-yellow-300">
            Yayıncı Görseli & Vitrin
          </div>
          <div>
            <label className="block text-xs font-semibold text-white/60 mb-1.5">Profil Fotoğrafı Seç (Dosya)</label>
            <input
              type="file"
              accept="image/*"
              onChange={onFileChange}
              className="block w-full text-xs text-white/70 file:mr-3 file:rounded-xl file:border-0 file:bg-yellow-500 file:px-3 file:py-1.5 file:text-xs file:font-black file:text-black hover:file:bg-yellow-400 cursor-pointer"
            />
          </div>
          <FormInput label="Veya Görsel URL" name="image" value={form.image || ""} onChange={onChange} placeholder="https://... veya /uploads/..." />

          {form.image && (
            <div className="flex items-center gap-3 pt-1">
              <img src={form.image} alt="Önizleme" className="h-12 w-12 rounded-full object-cover border-2 border-yellow-400 shadow-sm" />
              <span className="text-xs text-white/60">Görsel Önizleme</span>
            </div>
          )}

          <label className="flex items-center gap-2.5 pt-2 cursor-pointer">
            <input
              type="checkbox"
              name="isFeatured"
              checked={Boolean(form.isFeatured)}
              onChange={onChange}
              className="h-4 w-4 rounded accent-yellow-400 cursor-pointer"
            />
            <span className="text-xs font-bold text-yellow-200">
              ⭐ Bu yayıncıyı anasayfa öne çıkanlarda yayınla (50 kişiye kadar)
            </span>
          </label>
        </div>

        <FormSelect label="Ajans Takibi" name="agencyTrackingStatus" value={form.agencyTrackingStatus || "Aktif"} onChange={onChange}>
          <option value="Aktif">Aktif</option>
          <option value="Pasif">Pasif</option>
        </FormSelect>
        <FormSelect label="Durum" name="status" value={form.status} onChange={onChange}>
          <option value="Aktif">Aktif</option>
          <option value="Pasif">Pasif</option>
        </FormSelect>
        <FormInput label="Yayıncı Notu" name="note" value={form.note || ""} onChange={onChange} placeholder="Yayıncı ile ilgili notlar..." />
        <ModalActions onClose={onClose} saving={saving} submitText="Kaydet ve Yayınla" />
      </form>
    </ModalShell>
  );
}

function ManagerModal({ mode, open, form, saving, onChange, onClose, onSubmit }) {
  if (!open) return null;
  const isEdit = mode === "edit";
  return (
    <ModalShell title={isEdit ? "Yönetici Düzenle" : "Yönetici Ekle"} onClose={onClose}>
      <form onSubmit={onSubmit} className="grid gap-4">
        <FormInput label="Ad Soyadı" name="fullName" value={form.fullName} onChange={onChange} />
        <FormInput label="Kullanıcı adı" name="username" value={form.username} onChange={onChange} />
        {!isEdit && <FormInput label="Şifre" name="password" type="password" value={form.password} onChange={onChange} />}
        <FormInput label="Telefon" name="phone" value={form.phone} onChange={onChange} />
        <FormInput label="Mail" name="email" type="email" value={form.email} onChange={onChange} />
        <FormSelect label="Durum" name="status" value={form.status} onChange={onChange}>
          <option value="Aktif">Aktif</option>
          <option value="Pasif">Pasif</option>
        </FormSelect>
        <ModalActions onClose={onClose} saving={saving} submitText={isEdit ? "Güncelle" : "Kaydet"} />
      </form>
    </ModalShell>
  );
}

function ScoutPersonnelModal({ mode, open, form, saving, onChange, onClose, onSubmit }) {
  if (!open) return null;
  const isEdit = mode === "edit";

  return (
    <ModalShell
      title={isEdit ? "Aday Takip Sorumlusunu Düzenle" : "Aday Takip Sorumlusu Ekle"}
      subtitle="Aday takip sorumluları sisteme kendi kullanıcı adı ve şifreleriyle giriş yapar."
      onClose={onClose}
    >
      <form onSubmit={onSubmit} className="grid gap-4">
        <FormInput label="Ad Soyadı" name="fullName" value={form.fullName} onChange={onChange} />
        <FormInput label="Kullanıcı adı" name="username" value={form.username} onChange={onChange} />
        {!isEdit && (
          <FormInput
            label="Geçici Şifre"
            name="password"
            type="password"
            value={form.password}
            onChange={onChange}
          />
        )}
        <FormInput label="Telefon" name="phone" value={form.phone} onChange={onChange} />
        <FormInput label="E-posta" name="email" type="email" value={form.email} onChange={onChange} />
        <FormSelect label="Durum" name="status" value={form.status} onChange={onChange}>
          <option value="Aktif">Aktif</option>
          <option value="Pasif">Pasif</option>
        </FormSelect>
        <ModalActions onClose={onClose} saving={saving} submitText={isEdit ? "Güncelle" : "Kaydet"} />
      </form>
    </ModalShell>
  );
}

function PasswordModal({ open, target, form, saving, onChange, onClose, onSubmit }) {
  if (!open || !target) return null;
  return (
    <ModalShell title="Şifre Düzenle" subtitle={`Kullanıcı: ${target.username || "-"}`} onClose={onClose}>
      <form onSubmit={onSubmit} className="grid gap-4">
        <FormInput label="Yeni şifre" name="newPassword" type="password" value={form.newPassword} onChange={onChange} />
        <FormInput label="Yeni şifre tekrar" name="confirmPassword" type="password" value={form.confirmPassword} onChange={onChange} />
        <ModalActions onClose={onClose} saving={saving} submitText="Şifreyi Kaydet" />
      </form>
    </ModalShell>
  );
}

function DeleteModal({ open, target, saving, onClose, onConfirm }) {
  if (!open || !target) return null;
  return (
    <ModalShell title="Kayıt Sil" subtitle={target.fullName || target.username} onClose={onClose}>
      <div className="rounded-2xl border border-red-500/20 bg-red-500/10 p-4 text-sm leading-6 text-red-200">Bu kayıt silinecek. İşlem geri alınamayabilir.</div>
      <div className="mt-5 flex justify-end gap-3">
        <ActionButton variant="dark" onClick={onClose}>İptal</ActionButton>
        <ActionButton onClick={onConfirm} disabled={saving}>{saving ? "Siliniyor..." : "Sil"}</ActionButton>
      </div>
    </ModalShell>
  );
}


const BULK_PUBLISHER_CSV_TEMPLATE = `fullName,username,phone,hiddenId,employeeUsername,powerBIRole,status
Örnek Yayıncı,ornek.yayinci,905551112233,123456789,wolfmedia001,publisher_rls,Aktif`;

const BULK_PASSWORD_CSV_TEMPLATE = `username,newPassword
ornek.yayinci,YeniSifre123`;

const REPORT_UPLOAD_CSV_TEMPLATE = `Dönem;Yayıncı Kimliği;Kullanıcı Adı;Kazanılan Elmaslar;Canlı Yayın Süresi;Canlı Yayın Sayısı;Net Erişim;Gösterim;Görüntülenme;İzleyiciler;Hediye Sayısı;Yeni Takipçiler
2026-09-25 ~ 2026-09-25;7534078718453497873;karakartal0421;125000;03:25:00;4;20000;44000;7200;4800;6000;125
2026-09-25 ~ 2026-09-25;7486099100518072336;alevikizi;85000;02:40:00;2;14000;30800;5040;3360;4080;90`;

function downloadCsvTemplate(fileName, content) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function CsvTemplateBox({ title, description, fileName, content }) {
  return (
    <div className="mt-4 rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="text-sm font-black text-yellow-200">{title}</div>
          <div className="mt-1 text-xs leading-5 text-white/48">{description}</div>
        </div>

        <button
          type="button"
          onClick={() => downloadCsvTemplate(fileName, content)}
          className="shrink-0 rounded-xl border border-yellow-500/30 bg-yellow-500 px-4 py-2 text-xs font-black text-black hover:bg-yellow-400"
        >
          Şablonu İndir
        </button>
      </div>

      <pre className="mt-3 max-h-28 overflow-auto whitespace-pre-wrap rounded-xl border border-white/10 bg-black/35 p-3 text-[11px] leading-5 text-white/68">
        {content}
      </pre>
    </div>
  );
}

function BulkUploadModal({ open, summary, saving, onClose, onFileChange }) {
  if (!open) return null;
  return (
    <ModalShell title="Toplu Yayıncı Yükleme" subtitle="CSV ile ekleme / güncelleme" onClose={onClose} wide>
      <div className="rounded-2xl border border-white/10 bg-black/25 p-4 text-sm leading-7 text-white/55">
        CSV başlıkları: <span className="text-yellow-300">fullName, username, phone, hiddenId, employeeUsername, powerBIRole, status</span>
      </div>

      <CsvTemplateBox
        title="Örnek kullanıcı toplu yükleme şablonu"
        description="Yeni yayıncı eklerken veya mevcut yayıncıyı güncellerken kullanılacak CSV örneği. Başlık satırını değiştirmeyin."
        fileName="toplu-yayinci-sablon.csv"
        content={BULK_PUBLISHER_CSV_TEMPLATE}
      />
      <label className="mt-5 flex cursor-pointer items-center justify-center rounded-2xl border border-yellow-500/25 bg-yellow-500/10 px-5 py-8 text-center text-sm font-bold text-yellow-200 hover:bg-yellow-500/15">
        {saving ? "Yükleniyor..." : "CSV dosyası seç"}
        <input type="file" accept=".xlsx,.xls,.csv,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" onChange={onFileChange} className="hidden" disabled={saving} />
      </label>
      {summary && (
        <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.035] p-4 text-sm text-white/70">
          Oluşturulan: <span className="text-yellow-300">{summary.createdCount || 0}</span> | Güncellenen: <span className="text-yellow-300">{summary.updatedCount || 0}</span> | Hatalı: <span className="text-red-300">{summary.errorCount || 0}</span>
          {summary.errors?.length ? <div className="mt-3 space-y-1 text-red-300">{summary.errors.map((item, index) => <div key={index}>{item}</div>)}</div> : null}
        </div>
      )}
    </ModalShell>
  );
}

function BulkPasswordUpdateModal({ open, summary, saving, onClose, onFileChange }) {
  if (!open) return null;

  return (
    <ModalShell title="Toplu Şifre Değişikliği" subtitle="CSV ile kullanıcı şifrelerini güncelle" onClose={onClose} wide>
      <div className="rounded-2xl border border-white/10 bg-black/25 p-4 text-sm leading-7 text-white/55">
        CSV başlıkları: <span className="text-yellow-300">username, newPassword</span>
      </div>

      <CsvTemplateBox
        title="Örnek toplu şifre şablonu"
        description="Her satırda kullanıcı adı ve atanacak yeni şifre yer almalı. Başlık satırını değiştirmeyin."
        fileName="toplu-sifre-sablon.csv"
        content={BULK_PASSWORD_CSV_TEMPLATE}
      />

      <label className="mt-5 flex cursor-pointer items-center justify-center rounded-2xl border border-yellow-500/25 bg-yellow-500/10 px-5 py-8 text-center text-sm font-bold text-yellow-200 hover:bg-yellow-500/15">
        {saving ? "Güncelleniyor..." : "CSV dosyası seç"}
        <input type="file" accept=".csv,text/csv" onChange={onFileChange} className="hidden" disabled={saving} />
      </label>

      {summary && (
        <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.035] p-4 text-sm text-white/70">
          Güncellenen: <span className="text-yellow-300">{summary.updatedCount || 0}</span> | Hatalı: <span className="text-red-300">{summary.errorCount || 0}</span>

          {summary.errors?.length ? (
            <div className="mt-3 space-y-1 text-red-300">
              {summary.errors.map((item, index) => <div key={index}>{item}</div>)}
            </div>
          ) : null}
        </div>
      )}
    </ModalShell>
  );
}

function ReportUploadModal({
  open,
  summary,
  saving,
  summaryRows = [],
  summaryLoading = false,
  onClose,
  onFileChange,
  onDeleteDate,
  onDeleteMonth,
  onDeleteAll,
}) {
  const [selectedExportMonth, setSelectedExportMonth] = useState("2026-09");

  const availableMonths = useMemo(() => {
    const monthSet = new Set();
    (summaryRows || []).forEach((r) => {
      const d = String(r.reportDate || "").slice(0, 7);
      if (d && d.length === 7) monthSet.add(d);
    });
    monthSet.add("2026-09");
    monthSet.add("2026-08");
    monthSet.add("2026-07");
    monthSet.add("2026-06");
    monthSet.add("2026-05");
    monthSet.add("2026-04");
    const arr = Array.from(monthSet).sort().reverse();
    const names = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
    return arr.map((m) => {
      const [y, mon] = m.split("-");
      const mName = names[Number(mon) - 1] || mon;
      return {
        key: m,
        label: `${mName} ${y}`
      };
    });
  }, [summaryRows]);

  if (!open) return null;

  const currentSelectedMonthLabel = availableMonths.find((m) => m.key === selectedExportMonth)?.label || selectedExportMonth;

  return (
    <ModalShell title="MySQL Rapor Yükleme, İndirme & Veri Yönetim Masası" subtitle="TikTok Backstage Excel (.xlsx) veya CSV formatında performans verilerini MySQL'e yükleyin, indirin veya seçtiğiniz raporları kalıcı olarak temizleyin" onClose={onClose} wide>
      {/* 📅 1. AY SEÇİMİ, İNDİRME VE AY SİLME ALANI */}
      <div className="rounded-2xl border border-yellow-500/40 bg-gradient-to-br from-yellow-500/20 via-amber-500/10 to-black p-4 shadow-lg">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="text-sm font-black text-yellow-200 flex items-center gap-2">
              <span>📅 AY SEÇİMİ, İNDİRME VE AY SİLME:</span>
            </div>
            <div className="mt-0.5 text-xs text-yellow-100/70">
              İstediğiniz ayı seçip o ayın tüm verilerini tek tıkla indirin veya MySQL'den kalıcı olarak silin.
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            <select
              value={selectedExportMonth}
              onChange={(e) => setSelectedExportMonth(e.target.value)}
              className="rounded-xl border border-yellow-500/50 bg-zinc-900 px-3 py-2 text-xs font-black text-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-500/40 cursor-pointer shadow-inner"
            >
              {availableMonths.map((m) => (
                <option key={m.key} value={m.key}>
                  {m.label} ({m.key})
                </option>
              ))}
            </select>
            <a
              href={`${API_PERFORMANCE_EXPORT}?month=${encodeURIComponent(selectedExportMonth)}`}
              download={`tiktok_performans_${selectedExportMonth}.csv`}
              className="inline-flex items-center gap-1.5 rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 px-3.5 py-2 text-xs font-black text-black shadow-lg hover:brightness-110 active:scale-95 transition cursor-pointer"
            >
              <span>📥 {currentSelectedMonthLabel} İndir</span>
            </a>
            <button
              type="button"
              disabled={saving}
              onClick={() => onDeleteMonth && onDeleteMonth(selectedExportMonth, currentSelectedMonthLabel)}
              className="inline-flex items-center gap-1.5 rounded-xl border border-rose-500/40 bg-rose-500/15 px-3 py-2 text-xs font-bold text-rose-300 hover:bg-rose-500/30 hover:border-rose-400 transition cursor-pointer disabled:opacity-50"
              title={`${currentSelectedMonthLabel} ayına ait tüm verileri MySQL'den tamamen siler`}
            >
              <span>🗑️ {currentSelectedMonthLabel} Ayını Sil</span>
            </button>
            <a
              href={API_PERFORMANCE_EXPORT}
              download="tiktok_tum_performans_kayitlari.csv"
              className="inline-flex items-center gap-1 rounded-xl border border-white/20 bg-white/5 px-2.5 py-2 text-xs font-bold text-white hover:bg-white/10 hover:border-yellow-500/50 transition cursor-pointer"
              title="Tüm ayların ve tüm geçmişin verilerini tek seferde indir"
            >
              <span>🌐 Tüm Geçmişi İndir</span>
            </a>
          </div>
        </div>
      </div>

      <CsvTemplateBox
        title="TikTok Backstage Standart Rapor Şablonu (.csv / Excel)"
        description="TikTok Backstage panelinden indirdiğiniz orijinal Excel (.xlsx) veya CSV dosyalarını doğrudan yükleyebilirsiniz. Sütun başlıkları: Dönem, Yayıncı Kimliği, Kullanıcı Adı, Elmaslar, Süre, Yayın Sayısı..."
        fileName="tiktok-backstage-sablon.csv"
        content={REPORT_UPLOAD_CSV_TEMPLATE}
      />

      {/* 📊 2. YÜKLÜ RAPOR GÜNLERİ VE GÜN BAZLI YÖNETİM TABLOSU */}
      <div className="mt-5 rounded-2xl border border-white/10 bg-black/25 p-4">
        <div className="mb-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div>
            <div className="text-sm font-black text-white">Yüklü Rapor Günleri & Yönetim Seçenekleri</div>
            <div className="mt-1 text-xs text-white/40">
              MySQL tarafında kayıtlı olan tarih, satır sayıları, gün bazlı indirme ve silme işlemleri.
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="rounded-full border border-yellow-500/25 bg-yellow-500/10 px-3 py-1 text-xs font-bold text-yellow-200">
              Son 90 gün
            </span>
            <button
              type="button"
              disabled={saving}
              onClick={() => onDeleteAll && onDeleteAll()}
              className="inline-flex items-center gap-1.5 rounded-full border border-rose-500/40 bg-rose-500/20 px-3 py-1 text-xs font-bold text-rose-200 hover:bg-rose-500/40 hover:border-rose-400 transition cursor-pointer disabled:opacity-50"
              title="Veritabanındaki tüm performans verilerini kalıcı olarak sıfırlar"
            >
              <span>🔥 Tüm Raporları Sıfırla</span>
            </button>
          </div>
        </div>

        {summaryLoading ? (
          <div className="rounded-xl border border-white/10 bg-white/[0.035] p-3 text-sm text-white/45">
            Yüklü rapor bilgileri alınıyor...
          </div>
        ) : summaryRows.length === 0 ? (
          <div className="rounded-xl border border-white/10 bg-white/[0.035] p-3 text-sm text-white/45">
            Henüz yüklü rapor verisi bulunamadı.
          </div>
        ) : (
          <div className="max-h-[260px] overflow-y-auto rounded-xl border border-white/10">
            <div className="grid grid-cols-[1.1fr_.7fr_.7fr_.9fr_1.3fr] gap-2 bg-white/[0.04] px-4 py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38">
              <div>Tarih</div>
              <div>Satır</div>
              <div>Yayıncı</div>
              <div>Son Yükleme</div>
              <div className="text-right">İşlemler</div>
            </div>

            {summaryRows.map((item) => (
              <div
                key={item.reportDate}
                className="grid grid-cols-[1.1fr_.7fr_.7fr_.9fr_1.3fr] gap-2 items-center border-t border-white/10 px-4 py-2.5 text-sm text-white/65"
              >
                <div className="font-bold text-yellow-200 font-mono">{formatDateForDisplay(item.reportDate)}</div>
                <div>{Number(item.rowCount || 0).toLocaleString("tr-TR")}</div>
                <div>{Number(item.publisherCount || 0).toLocaleString("tr-TR")}</div>
                <div className="text-xs text-white/40">{item.lastUploadAt || "-"}</div>
                <div className="flex items-center justify-end gap-1.5 text-right">
                  <a
                    href={`${API_PERFORMANCE_EXPORT}?date=${encodeURIComponent(item.reportDate)}`}
                    download={`tiktok_rapor_${item.reportDate}.csv`}
                    className="inline-flex items-center gap-1 rounded-lg border border-yellow-500/35 bg-yellow-500/15 px-2.5 py-1 text-xs font-bold text-yellow-300 hover:bg-yellow-500/30 hover:border-yellow-400 transition cursor-pointer"
                    title={`${formatDateForDisplay(item.reportDate)} gününün verilerini Excel olarak indir`}
                  >
                    <span>📥 İndir</span>
                  </a>
                  <button
                    type="button"
                    disabled={saving}
                    onClick={() => onDeleteDate && onDeleteDate(item.reportDate)}
                    className="inline-flex items-center gap-1 rounded-lg border border-rose-500/35 bg-rose-500/15 px-2 py-1 text-xs font-bold text-rose-300 hover:bg-rose-500/30 hover:border-rose-400 transition cursor-pointer disabled:opacity-50"
                    title={`${formatDateForDisplay(item.reportDate)} gününe ait tüm verileri MySQL'den tamamen sil`}
                  >
                    <span>🗑️ Sil</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 📤 3. EXCEL / CSV DOSYA SEÇ VE YÜKLE ALANI */}
      <label className="mt-5 flex cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed border-yellow-500/40 bg-yellow-500/10 px-5 py-7 text-center transition hover:border-yellow-400 hover:bg-yellow-500/15">
        <span className="text-2xl mb-1">📁</span>
        <span className="text-sm font-bold text-yellow-200">
          {saving ? "Dosya İşleniyor ve MySQL'e Aktarılıyor..." : "TikTok Excel (.xlsx, .xls) veya CSV Rapor Dosyası Seç / Yükle"}
        </span>
        <span className="mt-1 text-xs text-white/50">
          TikTok Backstage panelinden indirdiğiniz dosyayı hiçbir değişiklik yapmadan doğrudan yükleyebilirsiniz.
        </span>
        <input
          type="file"
          accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
          onChange={onFileChange}
          className="hidden"
          disabled={saving}
        />
      </label>

      {summary && (
        <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.035] p-4 text-sm text-white/70">
          <div className="font-bold text-yellow-300">Rapor yükleme işlemi tamamlandı.</div>
          {summary.message ? (
            <div className="mt-3 whitespace-pre-line text-white/55">
              {String(summary.message).replace(/<[^>]*>/g, "")}
            </div>
          ) : null}

          {summary.errors?.length ? (
            <div className="mt-3 space-y-1 text-red-300">
              {summary.errors.map((item, index) => <div key={index}>{item}</div>)}
            </div>
          ) : null}
        </div>
      )}
    </ModalShell>
  );
}

function ModalShell({ title, subtitle, children, onClose, wide = false }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className={`max-h-[92vh] w-full overflow-y-auto rounded-[2rem] border border-white/10 bg-[#0b0b0b] p-6 shadow-[0_20px_80px_rgba(0,0,0,0.55)] ${wide ? "max-w-3xl" : "max-w-xl"}`}>
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <h3 className="text-2xl font-black text-white">{title}</h3>
            {subtitle ? <p className="mt-2 text-sm text-white/50">{subtitle}</p> : null}
          </div>
          <button type="button" onClick={onClose} className="rounded-xl border border-white/10 px-3 py-2 text-sm text-white/70 hover:border-yellow-500/35 hover:text-yellow-300">Kapat</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function ModalActions({ onClose, saving, submitText }) {
  return (
    <div className="flex justify-end gap-3 pt-2">
      <ActionButton variant="dark" onClick={onClose}>İptal</ActionButton>
      <ActionButton type="submit" disabled={saving}>{saving ? "Kaydediliyor..." : submitText}</ActionButton>
    </div>
  );
}

function PublisherListContent({
  rows = [],
  managers = [],
  loading,
  error,
  onReload,
  onAdd,
  onEdit,
  onPassword,
  onDelete,
  onBulk,
  currentAdmin,
  theme,
  canEdit = true,
  canDelete = true,
}) {
  const [search, setSearch] = useState("");
  const [featuredList, setFeaturedList] = useState([]);
  const [featuredLoading, setFeaturedLoading] = useState(false);
  const [togglingId, setTogglingId] = useState(null);
  const [syncingAll, setSyncingAll] = useState(false);
  const [syncProgress, setSyncProgress] = useState(null);
  const [notesMap, setNotesMap] = useState({});
  const [noteModal, setNoteModal] = useState({ open: false, user: null, text: "", saving: false, error: "" });

  const isDark = theme === "dark" || (!theme && typeof document !== "undefined" && !document.querySelector(".wm-admin-light"));

  const loadFeaturedList = useCallback(async () => {
    try {
      setFeaturedLoading(true);
      const res = await requestJson(API_FEATURED_PUBLISHER_LIST, { cache: "no-store" });
      setFeaturedList(Array.isArray(res.publishers) ? res.publishers : []);
    } catch (e) {
      console.warn("Öne çıkan yayıncılar listesi alınamadı:", e);
    } finally {
      setFeaturedLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFeaturedList();
  }, [loadFeaturedList]);

  async function handleToggleFeatured(user) {
    const userCleanUser = String(user.username || "").replace(/[@\s]+/g, "").toLowerCase();
    const isFeatured = featuredList.some((fp) => {
      const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
      return (
        (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
        String(fp.id) === String(user.id)
      );
    });

    try {
      setTogglingId(user.id);
      if (isFeatured) {
        const found = featuredList.find((fp) => {
          const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
          return (
            (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
            String(fp.id) === String(user.id)
          );
        });
        if (found && found.id) {
          const res = await fetch(API_FEATURED_PUBLISHER_DELETE, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: found.id }),
          });
          const data = await res.json();
          if (!data.success) {
            alert(data.message || "Öne çıkanlardan kaldırılamadı.");
          }
        }
      } else {
        let imageToSave = user.image || user.profileImage || "";
        if (!imageToSave && user.username) {
          try {
            const tkRes = await requestJson(`${API_TIKTOK_PROFILE_FETCH}?username=${encodeURIComponent(user.username)}`);
            if (tkRes && tkRes.success && tkRes.data && tkRes.data.avatar) {
              imageToSave = tkRes.data.avatar;
            }
          } catch (tkErr) {
            console.warn("TikTok fotoğrafı otomatik çekilemedi:", tkErr);
          }
        }

        const payload = new FormData();
        payload.append("name", user.fullName || user.username);
        payload.append("username", user.username || "");
        payload.append("tiktokUrl", `https://www.tiktok.com/@${user.username || ""}`);
        payload.append("imageBoxText", user.fullName || user.username);
        payload.append("status", "Aktif");
        payload.append("sortOrder", "0");
        payload.append("currentImage", imageToSave);
        payload.append("createdBy", currentAdmin?.username || "admin");

        const res = await fetch(API_FEATURED_PUBLISHER_SAVE, {
          method: "POST",
          body: payload,
        });
        const data = await res.json();
        if (!data.success) {
          alert(data.message || "Öne çıkanlara eklenemedi.");
        }
      }

      await loadFeaturedList();
      if (onReload) onReload();
    } catch (e) {
      console.error(e);
      alert("Öne çıkarma işlemi sırasında bağlantı hatası oluştu.");
    } finally {
      setTogglingId(null);
    }
  }

  async function handleSyncAllTiktokAvatars() {
    if (!rows || rows.length === 0) {
      alert("Taranacak yayıncı bulunamadı.");
      return;
    }

    if (!window.confirm(`${rows.length} yayıncının TikTok profil fotoğrafları sırayla taranıp kaydedilecek. Başlatılsın mı?`)) {
      return;
    }

    setSyncingAll(true);
    let success = 0;
    const total = rows.length;

    for (let i = 0; i < total; i++) {
      const user = rows[i];
      const cleanUser = String(user.username || "").replace(/[@\s]+/g, "");
      setSyncProgress({
        current: i + 1,
        total,
        currentName: user.fullName || cleanUser,
        successCount: success,
      });

      if (cleanUser) {
        try {
          const res = await requestJson(`${API_TIKTOK_PROFILE_FETCH}?username=${encodeURIComponent(cleanUser)}&saveLocal=true`);
          if (res && res.success && res.data && (res.data.avatar || res.data.avatarRemote)) {
            const avatarUrl = res.data.avatar || res.data.avatarRemote;

            const payload = new FormData();
            payload.append("name", user.fullName || cleanUser);
            payload.append("username", cleanUser);
            payload.append("tiktokUrl", `https://www.tiktok.com/@${cleanUser}`);
            payload.append("imageBoxText", user.fullName || cleanUser);

            const isAlreadyFeatured = featuredList.some(
              (fp) => String(fp.username).replace(/[@\s]+/g, "").toLowerCase() === cleanUser.toLowerCase() && fp.status === "Aktif"
            );
            payload.append("status", isAlreadyFeatured ? "Aktif" : "Pasif");
            payload.append("sortOrder", "0");
            payload.append("currentImage", avatarUrl);
            payload.append("createdBy", currentAdmin?.username || "sync");

            await fetch(API_FEATURED_PUBLISHER_SAVE, {
              method: "POST",
              body: payload,
            });

            success++;
          }
        } catch (itemErr) {
          console.warn(`[TikTok Sync] @${cleanUser} çekilemedi:`, itemErr);
        }
      }

      await new Promise((r) => setTimeout(r, 60));
    }

    setSyncingAll(false);
    setSyncProgress(null);
    alert(`🎉 İşlem tamamlandı!\nToplam ${total} yayıncıdan ${success} tanesinin TikTok profil fotoğrafı başarıyla çekildi ve kaydedildi.`);
    await loadFeaturedList();
    if (onReload) onReload();
  }

  function openNoteModal(user) {
    const currentNote = notesMap[user.id] !== undefined ? notesMap[user.id] : (user.note || user.raw?.note || "");
    setNoteModal({ open: true, user, text: currentNote, saving: false, error: "" });
  }

  async function persistNoteToServer(user, noteText) {
    const payload = JSON.stringify({
      id: user.id,
      userId: user.id,
      username: user.username,
      note: noteText,
      action: "save_note",
    });

    // 1. Try dedicated note update endpoint
    try {
      const res = await fetch(API_USER_NOTE_UPDATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
      });
      const text = await res.text();
      if (text && text.trim().startsWith("{")) {
        const data = JSON.parse(text);
        if (data && data.success) return data;
      }
    } catch (e1) {
      console.warn("API_USER_NOTE_UPDATE failed, trying fallback:", e1);
    }

    // 2. Try users-list.php POST fallback
    try {
      const res = await fetch(API_USERS_LIST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
      });
      const text = await res.text();
      if (text && text.trim().startsWith("{")) {
        const data = JSON.parse(text);
        if (data && data.success) return data;
      }
    } catch (e2) {
      console.warn("API_USERS_LIST POST fallback failed:", e2);
    }

    // 3. Try user-update.php fallback
    try {
      const res = await fetch(API_USER_UPDATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
      });
      const text = await res.text();
      if (text && text.trim().startsWith("{")) {
        const data = JSON.parse(text);
        if (data && data.success) return data;
      }
    } catch (e3) {
      console.warn("API_USER_UPDATE fallback failed:", e3);
    }

    throw new Error("Sunucuya bağlanılamadı veya not kaydedilemedi. Lütfen bağlantınızı kontrol edin.");
  }

  async function handleSaveNote() {
    if (!noteModal.user) return;
    try {
      setNoteModal((prev) => ({ ...prev, saving: true, error: "" }));
      const savedNote = noteModal.text.trim();
      await persistNoteToServer(noteModal.user, savedNote);

      setNotesMap((prev) => ({ ...prev, [noteModal.user.id]: savedNote }));
      if (noteModal.user) {
        noteModal.user.note = savedNote;
        if (noteModal.user.raw) noteModal.user.raw.note = savedNote;
      }
      setNoteModal({ open: false, user: null, text: "", saving: false, error: "" });
    } catch (err) {
      setNoteModal((prev) => ({ ...prev, saving: false, error: err.message || "Hata oluştu" }));
    }
  }

  async function handleDeleteNote() {
    if (!noteModal.user) return;
    if (!window.confirm("Bu yayıncının notunu kalıcı olarak silmek istediğinize emin misiniz?")) return;
    try {
      setNoteModal((prev) => ({ ...prev, saving: true, error: "" }));
      await persistNoteToServer(noteModal.user, "");

      setNotesMap((prev) => ({ ...prev, [noteModal.user.id]: "" }));
      if (noteModal.user) {
        noteModal.user.note = "";
        if (noteModal.user.raw) noteModal.user.raw.note = "";
      }
      setNoteModal({ open: false, user: null, text: "", saving: false, error: "" });
    } catch (err) {
      setNoteModal((prev) => ({ ...prev, saving: false, error: err.message || "Silinemedi." }));
    }
  }

  const [syncingMaster, setSyncingMaster] = useState(false);
  const [masterSyncFeedback, setMasterSyncFeedback] = useState(null);

  const handleSyncMasterData = async () => {
    if (!window.confirm("1416 yayıncı, 9 resmi yönetici, telefonlar ve tüm kalıcı notlar sisteme aktarılıp senkronize edilsin mi?")) {
      return;
    }
    try {
      setSyncingMaster(true);
      setMasterSyncFeedback({ type: "info", message: "Master veriler eşitleniyor, lütfen bekleyiniz..." });
      const res = await fetch(API_SYNC_PUBLISHERS_MASTER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "sync_master" }),
      });
      const data = await res.json();
      if (data && data.success) {
        setMasterSyncFeedback({
          type: "success",
          message: `Başarıyla eşitlendi! ${data.publishers_processed || 1416} yayıncı, tüm telefonlar, 237 kalıcı not ve 9 yönetici kaydedildi.`,
        });
        if (typeof onReload === "function") {
          onReload();
        }
      } else {
        throw new Error(data?.message || "Eşitleme başarısız.");
      }
    } catch (err) {
      setMasterSyncFeedback({
        type: "error",
        message: `Hata: ${err.message || "Bilinmeyen hata."}`,
      });
    } finally {
      setSyncingMaster(false);
    }
  };

  const filteredRows = rows.filter((item) => {
    const query = search.toLowerCase().trim();
    if (!query) return true;
    const userNote = notesMap[item.id] !== undefined ? notesMap[item.id] : (item.note || item.raw?.note || "");
    return `${item.fullName} ${item.username} ${item.phone} ${item.hiddenId} ${item.managerName} ${item.agencyTrackingStatus} ${userNote}`.toLowerCase().includes(query);
  });

  return (
    <div style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}>
      <SectionHeader
        eyebrow="Yönetim Paneli"
        title="Yayıncı Paneli"
        desc="Yayıncı bilgileri, kullanıcı adı, profil görseli, öne çıkarma durumu, telefon, ID, bağlı yönetici ve durum bilgileri bu ekranda yönetilir."
        action={
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              disabled={syncingMaster}
              onClick={handleSyncMasterData}
              className={`inline-flex items-center gap-2 rounded-xl border px-3.5 py-2 text-xs font-bold transition shadow-sm ${
                isDark
                  ? "border-yellow-500/40 bg-yellow-500/15 text-yellow-300 hover:bg-yellow-500/25"
                  : "border-yellow-400 bg-yellow-50 text-yellow-900 hover:bg-yellow-100"
              }`}
              title="Master verileri (1416 yayıncı, 9 yönetici, tüm telefonlar ve kalıcı notları) sisteme senkronize eder"
            >
              {syncingMaster ? (
                <>
                  <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
                  <span>Eşitleniyor...</span>
                </>
              ) : (
                <>
                  <span>🔄</span>
                  <span>Master Listeyi Eşitle</span>
                </>
              )}
            </button>
            <button
              type="button"
              disabled={syncingAll}
              onClick={handleSyncAllTiktokAvatars}
              className="inline-flex items-center gap-2 rounded-xl border border-yellow-500/50 bg-gradient-to-r from-yellow-500/25 via-amber-500/20 to-yellow-500/25 px-3.5 py-2 text-xs font-black text-yellow-200 shadow-sm transition hover:border-yellow-400 hover:bg-yellow-500/35 hover:scale-105 active:scale-95 disabled:opacity-50"
              title="Tüm yayıncıların TikTok fotoğraflarını tek tıkla otomatik çek ve güncelle"
            >
              {syncingAll ? (
                <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
              ) : (
                <span className="text-sm">⚡</span>
              )}
              <span>{syncingAll ? `Çekiliyor (%${syncProgress ? Math.round((syncProgress.current / syncProgress.total) * 100) : 0})...` : "Tüm TikTok Fotoğraflarını Çek"}</span>
            </button>
            <ActionButton variant="dark" onClick={loadFeaturedList}>Öne Çıkanları Yenile</ActionButton>
            {onBulk && <ActionButton variant="dark" onClick={onBulk}>Toplu Yükle</ActionButton>}
            {onAdd && <ActionButton onClick={onAdd}>Yeni Yayıncı</ActionButton>}
          </div>
        }
      />

      {masterSyncFeedback && (
        <div
          className={`mb-4 flex items-center justify-between rounded-xl border p-4 text-xs font-semibold shadow-sm transition-all ${
            masterSyncFeedback.type === "success"
              ? isDark ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-emerald-300 bg-emerald-50 text-emerald-800"
              : masterSyncFeedback.type === "error"
              ? isDark ? "border-red-500/40 bg-red-500/10 text-red-300" : "border-red-300 bg-red-50 text-red-800"
              : isDark ? "border-blue-500/40 bg-blue-500/10 text-blue-300" : "border-blue-300 bg-blue-50 text-blue-800"
          }`}
        >
          <div className="flex items-center gap-2">
            <span>{masterSyncFeedback.type === "success" ? "✓" : masterSyncFeedback.type === "error" ? "⚠️" : "ℹ️"}</span>
            <span>{masterSyncFeedback.message}</span>
          </div>
          <button
            type="button"
            onClick={() => setMasterSyncFeedback(null)}
            className="rounded p-1 hover:bg-black/10 active:scale-95"
          >
            ✕
          </button>
        </div>
      )}

      {syncProgress && (
        <div className="mb-4 rounded-2xl border border-yellow-500/40 bg-yellow-500/10 p-4 shadow-[0_0_20px_rgba(234,179,8,0.15)]">
          <div className="flex items-center justify-between text-xs font-black text-yellow-300">
            <span className="flex items-center gap-2">
              <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
              TikTok Fotoğrafı İndiriliyor: <strong className={isDark ? "text-white" : "text-slate-900"}>{syncProgress.currentName}</strong>
            </span>
            <span>{syncProgress.current} / {syncProgress.total} (%{Math.round((syncProgress.current / syncProgress.total) * 100)})</span>
          </div>
          <div className="mt-2.5 h-2 w-full overflow-hidden rounded-full bg-black/40 border border-white/10">
            <div
              className="h-full bg-gradient-to-r from-yellow-500 to-amber-400 transition-all duration-300 shadow-[0_0_10px_rgba(250,204,21,0.6)]"
              style={{ width: `${(syncProgress.current / syncProgress.total) * 100}%` }}
            />
          </div>
          <div className="mt-1.5 text-[11px] text-white/60">
            Başarıyla indirilen ve kaydedilen: <strong className="text-emerald-400 font-black">{syncProgress.successCount}</strong> fotoğraf
          </div>
        </div>
      )}

      <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors ${
        isDark ? "bg-[#121620] border-[#1e2838]" : "bg-[#f4f7fb] border-[#e2e8f0]"
      }`}>
        <div className={`p-4 border-b ${isDark ? "border-[#1e2838] bg-[#121620]" : "border-[#e2e8f0] bg-[#f4f7fb]"}`}>
          <SearchBox value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Yayıncı ara (Ad, kullanıcı adı, telefon, ID)..." />
          <ApiNotice loading={loading || featuredLoading} error={error} onReload={() => { onReload(); loadFeaturedList(); }} />
        </div>

        <div className="overflow-x-auto min-w-full">
          <div className="min-w-[1380px]">
            {/* TABLO SÜTUN BAŞLIKLARI - 8 SÜTUN (SABİT PİKSEL HİZALI) */}
            <div className={`grid grid-cols-[minmax(220px,1.5fr)_minmax(160px,1.1fr)_130px_190px_140px_110px_minmax(150px,1.2fr)_290px] gap-3 px-5 py-3.5 text-[12px] font-[600] uppercase tracking-[0.06em] border-b items-center ${
              isDark ? "bg-[#182030] border-[#1e2838] text-[#8fa2be]" : "bg-[#edf3fa] border-[#e2e8f0] text-[#405674]"
            }`}>
              <div>AD SOYADI & GÖRSEL</div>
              <div>GİRİŞ ADI / TIKTOK</div>
              <div>TELEFON</div>
              <div>ID</div>
              <div>YÖNETİCİ</div>
              <div>AJANS TAKİBİ</div>
              <div>NOT</div>
              <div className="text-left">İŞLEMLER</div>
            </div>

            {!loading && filteredRows.length === 0 ? (
              <EmptyState text="Yayıncı kaydı bulunamadı." />
            ) : (
              filteredRows.map((user) => {
                const userCleanUser = String(user.username || "").replace(/[@\s]+/g, "").toLowerCase();
                const matchedFeatured = featuredList.find((fp) => {
                  const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
                  return (
                    (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
                    String(fp.id) === String(user.id)
                  );
                });
                const isFeatured = Boolean(matchedFeatured);
                const publisherImg = user.image || user.profileImage || matchedFeatured?.image || matchedFeatured?.currentImage;
                const userNote = notesMap[user.id] !== undefined ? notesMap[user.id] : (user.note || user.raw?.note || "");
                const agencyTrackingStatus = user.agencyTrackingStatus || (typeof getPublisherAgencyTrackingStatus === "function" ? getPublisherAgencyTrackingStatus(user) : "Aktif");

                return (
                  <div
                    key={user.id}
                    className={`grid grid-cols-[minmax(220px,1.5fr)_minmax(160px,1.1fr)_130px_190px_140px_110px_minmax(150px,1.2fr)_290px] gap-3 px-5 py-3.5 text-[14px] items-center border-b transition-colors ${
                      isDark
                        ? "bg-[#131925] border-[#1c2536] text-[#cbd5e1] hover:bg-[#1a2335]"
                        : "bg-white border-[#eef2f7] text-[#334155] hover:bg-[#ebf1f8]"
                    }`}
                  >
                    {/* 1. AD SOYADI & GÖRSEL */}
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="relative shrink-0">
                        {publisherImg ? (
                          <img
                            src={publisherImg}
                            alt={user.fullName}
                            className={`h-10 w-10 rounded-full object-cover border ${
                              isDark ? "border-[#2a374e]" : "border-[#cbd5e1]"
                            }`}
                          />
                        ) : (
                          <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border text-xs font-bold ${
                            isDark
                              ? "border-[#2a374e] bg-[#1c2434] text-yellow-300"
                              : "border-[#cbd5e1] bg-[#eef2f6] text-slate-700"
                          }`}>
                            {user.fullName?.slice(0, 2)?.toUpperCase() || "WM"}
                          </div>
                        )}
                        {isFeatured && (
                          <span
                            className="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-amber-400 text-[9px] shadow-sm"
                            title="Öne Çıkarıldı"
                          >
                            ⭐
                          </span>
                        )}
                      </div>

                      <div className="min-w-0">
                        <div className={`font-[600] text-[14px] truncate ${isDark ? "text-[#f8fafc]" : "text-[#0f172a]"}`}>
                          {user.fullName || "-"}
                        </div>
                        {typeof PublisherTierBadge === "function" && (
                          <div className="mt-0.5 flex items-center gap-1.5">
                            <PublisherTierBadge
                              publisher={user}
                              diamonds={user.performanceDiamonds}
                              compact
                            />
                            {isFeatured && (
                              <span className="inline-flex items-center gap-0.5 rounded px-1.5 py-0.2 text-[9px] font-bold bg-amber-400/15 text-amber-300 border border-amber-400/30">
                                ⭐ Öne Çıkan
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* 2. GİRİŞ ADI / TIKTOK */}
                    <div className="flex flex-col justify-center min-w-0">
                      <span
                        className={`font-mono text-[12px] font-semibold truncate ${
                          isDark ? "text-[#38bdf8]" : "text-[#0284c7]"
                        }`}
                        title={`Sistem Giriş Adı: ${user.system_username || user.systemUsername || ("wolf." + String(user.username || "").replace(/[@\s]+/g, "").toLowerCase())}`}
                      >
                        {user.system_username || user.systemUsername || ("wolf." + String(user.username || "").replace(/[@\s]+/g, "").toLowerCase())}
                      </span>
                      <span
                        className={`text-[12px] font-normal truncate mt-0.5 ${
                          isDark ? "text-[#8fa2be]" : "text-[#64748b]"
                        }`}
                        title={`TikTok: @${String(user.tiktok_username || user.username || "").replace(/^@/, "")}`}
                      >
                        @{String(user.tiktok_username || user.username || "").replace(/^@/, "")}
                      </span>
                    </div>

                    {/* 3. TELEFON */}
                    <div className={`font-mono tabular-nums text-[14px] whitespace-nowrap ${
                      isDark ? "text-[#e2e8f0]" : "text-[#1e293b]"
                    }`}>
                      {user.phone || "-"}
                    </div>

                    {/* 4. ID (Eksiksiz, rakamlar hizalı, taşma/kesilme yok) */}
                    <div className={`font-mono tabular-nums text-[14px] select-all whitespace-nowrap ${
                      isDark ? "text-[#e2e8f0]" : "text-[#1e293b]"
                    }`}>
                      {user.hiddenId || user.tiktok_id || "-"}
                    </div>

                    {/* 5. YÖNETİCİ */}
                    <div className={`text-[14px] truncate ${isDark ? "text-[#e2e8f0]" : "text-[#1e293b]"}`}>
                      {user.managerName || user.assignedEmployeeUsername || user.representative || "-"}
                    </div>

                    {/* 6. AJANS TAKİBİ (Düz metin: Rozet, çerçeve, nokta veya renkli hap yok) */}
                    <div className={`text-[14px] font-normal ${isDark ? "text-[#e2e8f0]" : "text-[#334155]"}`}>
                      {agencyTrackingStatus || "Aktif"}
                    </div>

                    {/* 7. NOT (Ajans Takibi ile İşlemler arasında) */}
                    <div className="flex items-center min-w-0">
                      {userNote ? (
                        <div className="flex items-center gap-1.5 min-w-0 max-w-[130px] 2xl:max-w-[160px]">
                          <span
                            onClick={() => openNoteModal(user)}
                            className={`truncate cursor-pointer text-[13px] font-normal transition ${
                              isDark ? "text-[#cbd5e1] hover:text-white hover:underline" : "text-[#334155] hover:text-[#0f172a] hover:underline"
                            }`}
                            title={`${userNote} (Düzenlemek için tıklayın)`}
                          >
                            {userNote}
                          </span>
                          <button
                            type="button"
                            onClick={() => openNoteModal(user)}
                            title="Notu düzenle"
                            className="text-[11px] opacity-40 hover:opacity-100 transition shrink-0"
                          >
                            ✏️
                          </button>
                        </div>
                      ) : (
                        <button
                          type="button"
                          onClick={() => openNoteModal(user)}
                          className={`text-[13px] font-normal transition underline-offset-2 hover:underline ${
                            isDark ? "text-[#8fa2be] hover:text-white" : "text-[#556987] hover:text-[#1e293b]"
                          }`}
                        >
                          Not ekle
                        </button>
                      )}
                    </div>

                    {/* 8. İŞLEMLER */}
                    <div className="flex items-center gap-1.5 whitespace-nowrap">
                      {canEdit && onEdit && (
                        <button
                          type="button"
                          onClick={() => onEdit(user)}
                          className={`rounded-[7px] px-2.5 py-1 text-[12px] font-medium border transition ${
                            isDark
                              ? "bg-[#1c2434] border-[#2e3c54] text-[#d1d5db] hover:bg-[#253248] hover:text-white"
                              : "bg-white border-[#cbd5e1] text-[#334155] hover:bg-[#f1f5f9] shadow-sm"
                          }`}
                        >
                          Düzenle
                        </button>
                      )}

                      {onPassword && (
                        <button
                          type="button"
                          onClick={() => onPassword(user)}
                          className={`rounded-[7px] px-2.5 py-1 text-[12px] font-medium border transition ${
                            isDark
                              ? "bg-[#1c2434] border-[#2e3c54] text-[#d1d5db] hover:bg-[#253248] hover:text-white"
                              : "bg-white border-[#cbd5e1] text-[#334155] hover:bg-[#f1f5f9] shadow-sm"
                          }`}
                        >
                          Şifre
                        </button>
                      )}

                      {canDelete && onDelete && (
                        <button
                          type="button"
                          onClick={() => onDelete(user, "publisher")}
                          className={`rounded-[7px] px-2.5 py-1 text-[12px] font-medium border transition ${
                            isDark
                              ? "bg-[#2a1b22] border-[#522933] text-[#f87171] hover:bg-[#38222c] hover:border-[#6b2f3d]"
                              : "bg-[#fff1f2] border-[#fecdd3] text-[#e11d48] hover:bg-[#ffe4e6] shadow-sm"
                          }`}
                        >
                          Sil
                        </button>
                      )}

                      <button
                        type="button"
                        disabled={togglingId === user.id}
                        onClick={() => handleToggleFeatured(user)}
                        className={`rounded-[7px] px-2.5 py-1 text-[12px] font-medium border transition ${
                          isFeatured
                            ? isDark
                              ? "bg-[#332b17] border-[#785e23] text-[#fef08a] hover:bg-[#42371c]"
                              : "bg-[#fefce8] border-[#fde047] text-[#a16207] hover:bg-[#fef9c3] shadow-sm"
                            : isDark
                            ? "bg-[#242018] border-[#4a3b1a] text-[#fbbf24] hover:bg-[#302a1e] hover:border-[#634e20]"
                            : "bg-[#fffbeb] border-[#fcd34d] text-[#b45309] hover:bg-[#fef3c7] shadow-sm"
                        }`}
                        title={isFeatured ? "Öne çıkanlardan kaldır" : "Anasayfa öne çıkan yayıncılara ekle (50 kişiye kadar)"}
                      >
                        {togglingId === user.id ? "..." : isFeatured ? "⭐ Öne Çıkarıldı" : "⭐ Öne Çıkar"}
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {/* NOT DÜZENLEME MODALI */}
      {noteModal.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn">
          <div
            className={`w-full max-w-md rounded-2xl p-5 shadow-2xl border transition-all ${
              isDark ? "bg-[#161c28] border-[#253248] text-white" : "bg-white border-slate-200 text-slate-800"
            }`}
            style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}
          >
            <div className="flex items-center justify-between pb-3 border-b border-white/10">
              <div>
                <h3 className="text-sm font-semibold">Yayıncı Notu</h3>
                <p className="text-xs text-slate-400 mt-0.5">
                  {noteModal.user?.fullName} (@{noteModal.user?.username})
                </p>
              </div>
              <button
                type="button"
                onClick={() => setNoteModal({ open: false, user: null, text: "", saving: false, error: "" })}
                className="text-slate-400 hover:text-white text-lg font-bold px-1"
              >
                ✕
              </button>
            </div>

            <div className="py-4">
              <label className="block text-xs font-medium text-slate-400 mb-1.5">
                Not İçeriği
              </label>
              <textarea
                autoFocus
                rows={4}
                value={noteModal.text}
                onChange={(e) => setNoteModal((prev) => ({ ...prev, text: e.target.value }))}
                placeholder="Yayıncı ile ilgili notunuzu yazın..."
                className={`w-full rounded-xl p-3 text-sm border focus:outline-none focus:ring-2 transition-all resize-none ${
                  isDark
                    ? "bg-[#0f131c] border-[#222d40] text-slate-100 focus:border-blue-500/60 focus:ring-blue-500/20"
                    : "bg-slate-50 border-slate-200 text-slate-800 focus:border-blue-500/60 focus:ring-blue-500/20"
                }`}
              />
              <p className={`mt-1.5 text-[11px] ${isDark ? "text-slate-400" : "text-slate-500"}`}>
                💡 Notlar yayıncı özelinde kalıcı olarak saklanır. Yönetici veya admin değiştirmediği sürece silinmez veya kaybolmaz.
              </p>
              {noteModal.error && (
                <div className="mt-2 text-xs font-medium text-red-400">
                  {noteModal.error}
                </div>
              )}
            </div>

            <div className="flex items-center justify-between pt-2 border-t border-white/10">
              {Boolean(notesMap[noteModal.user?.id] || noteModal.user?.note || noteModal.user?.raw?.note) ? (
                <button
                  type="button"
                  disabled={noteModal.saving}
                  onClick={handleDeleteNote}
                  className="px-3.5 py-1.5 text-xs font-semibold rounded-lg border border-red-500/40 bg-red-500/10 text-red-400 hover:bg-red-500/20 transition disabled:opacity-50"
                >
                  Notu Sil
                </button>
              ) : <div />}

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  disabled={noteModal.saving}
                  onClick={() => setNoteModal({ open: false, user: null, text: "", saving: false, error: "" })}
                  className={`px-3.5 py-1.5 text-xs font-medium rounded-lg border transition ${
                    isDark
                      ? "border-[#253248] bg-[#1a2233] text-slate-300 hover:bg-[#222c42]"
                      : "border-slate-200 bg-slate-100 text-slate-600 hover:bg-slate-200"
                  }`}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  disabled={noteModal.saving}
                  onClick={handleSaveNote}
                  className="px-4 py-1.5 text-xs font-semibold rounded-lg bg-blue-600 hover:bg-blue-500 text-white shadow-sm transition disabled:opacity-50"
                >
                  {noteModal.saving ? "Kaydediliyor..." : "Kaydet"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ManagerListContent({ rows = [], loading, error, onReload, onAdd, onEdit, onPassword, onDelete }) {
  const [search, setSearch] = useState("");
  const filteredRows = rows.filter((item) => {
    const query = search.toLowerCase().trim();
    if (!query) return true;
    return `${item.fullName} ${item.username} ${item.phone} ${item.email} ${item.publisherCount} ${item.powerBIRole} ${item.status}`.toLowerCase().includes(query);
  });

  return (
    <div>
      <SectionHeader eyebrow="Yönetim Paneli" title="Yönetici Paneli" desc="Yönetici bilgileri, kullanıcı adı, telefon, e-posta, bağlı yayıncı sayısı, rapor rolü, ajans takip tercihi ve durum bilgileri bu ekranda yönetilir." action={<ActionButton onClick={onAdd}>Yeni Yönetici</ActionButton>} />
      <Card className="overflow-hidden">
        <div className="border-b border-white/10 p-4"><SearchBox value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Yönetici ara..." /><ApiNotice loading={loading} error={error} onReload={onReload} /></div>
        <div className="hidden grid-cols-[1.1fr_1fr_.85fr_1.25fr_.85fr_.9fr_.75fr_1.4fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid"><div>Ad Soyadı</div><div>Kullanıcı adı</div><div>Telefon</div><div>Mail</div><div>Yayıncı</div><div>Rapor Rol</div><div>Durum</div><div>İşlemler</div></div>
        {!loading && filteredRows.length === 0 ? <EmptyState text="Yönetici kaydı bulunamadı." /> : filteredRows.map((user) => (
          <div key={user.id} className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-[1.1fr_1fr_.85fr_1.25fr_.85fr_.9fr_.75fr_1.4fr]">
            <div className="font-bold text-white">{user.fullName}</div><div>{user.username}</div><div>{user.phone}</div><div className="truncate">{user.email}</div><div>{user.publisherCount}</div><div>{user.powerBIRole}</div><div><StatusBadge status={user.status} /></div>
            <div className="flex flex-wrap gap-2"><RowActionButton onClick={() => onEdit(user)}>Düzenle</RowActionButton><RowActionButton onClick={() => onPassword(user)}>Şifre Düzenle</RowActionButton><RowActionButton danger onClick={() => onDelete(user, "manager")}>Sil</RowActionButton></div>
          </div>
        ))}
      </Card>
    </div>
  );
}

function ScoutPersonnelContent({ rows = [], loading, error, onReload, onAdd, onEdit, onPassword, onDelete }) {
  const [search, setSearch] = useState("");

  const filteredRows = rows.filter((item) => {
    const query = search.toLowerCase().trim();
    if (!query) return true;

    return `${item.fullName} ${item.username} ${item.phone} ${item.email} ${item.status}`
      .toLowerCase()
      .includes(query);
  });

  return (
    <div>
      <SectionHeader
        eyebrow="Aday Takip Yönetimi"
        title="Aday Takip Sorumluları"
        desc="Aday takip ekibine giriş yetkisi verin; kullanıcı bilgilerini, aktiflik durumunu ve şifrelerini yönetin."
        action={<ActionButton onClick={onAdd}>Yeni Aday Sorumlusu</ActionButton>}
      />

      <Card className="overflow-hidden">
        <div className="border-b border-white/10 p-4">
          <SearchBox
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Aday takip sorumlusu ara..."
          />
          <ApiNotice loading={loading} error={error} onReload={onReload} />
        </div>

        <div className="hidden grid-cols-[1.25fr_1fr_.9fr_1.25fr_.75fr_1.5fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid">
          <div>Ad Soyadı</div>
          <div>Kullanıcı Adı</div>
          <div>Telefon</div>
          <div>E-posta</div>
          <div>Durum</div>
          <div>İşlemler</div>
        </div>

        {!loading && filteredRows.length === 0 ? (
          <EmptyState text="Aday takip sorumlusu bulunamadı." />
        ) : (
          filteredRows.map((user) => (
            <div
              key={user.id}
              className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-[1.25fr_1fr_.9fr_1.25fr_.75fr_1.5fr]"
            >
              <div>
                <div className="font-bold text-white">{user.fullName}</div>
                <div className="mt-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-yellow-300/70">
                  Aday Sorumlusu
                </div>
              </div>
              <div>{user.username}</div>
              <div>{user.phone}</div>
              <div className="break-all">{user.email}</div>
              <div><StatusBadge status={user.status} /></div>
              <div className="flex flex-wrap gap-2">
                <RowActionButton onClick={() => onEdit(user)}>Düzenle</RowActionButton>
                <RowActionButton onClick={() => onPassword(user)}>Şifre Ver</RowActionButton>
                <RowActionButton danger onClick={() => onDelete(user, "scout")}>Sil</RowActionButton>
              </div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
}

function PublisherGenericContent({ title, desc }) {
  return <GenericPanel eyebrow="Yayıncı Yönetimi" title={title} desc={desc} items={["Ad Soyad", "Kullanıcı Adı", "Telefon", "Hidden ID", "Yönetici", "Durum", "Rapor Rolü", "Kademe"]} />;
}

function PublisherManagerAssignmentContent({
  publisherRows = [],
  managerRows = [],
  loading = false,
  error = "",
  onReload,
  currentAdmin,
  theme = "dark",
}) {
  const isDark = theme === "dark" || (!theme && typeof document !== "undefined" && !document.querySelector(".wm-admin-light"));
  const [search, setSearch] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [targetManager, setTargetManager] = useState("");
  const [filterMode, setFilterMode] = useState("all"); // "all" | "unassigned" | "assigned" | specific manager key
  const [assigning, setAssigning] = useState(false);
  const [syncingMaster, setSyncingMaster] = useState(false);
  const [inlineAssigningId, setInlineAssigningId] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [confirmModal, setConfirmModal] = useState({ open: false, targetUsername: "", targetName: "", count: 0 });
  const [localOverrides, setLocalOverrides] = useState({});

  // Helper to resolve manager info with local overrides
  const getPublisherManagerInfo = useCallback((user) => {
    const override = localOverrides[user.id];
    let assignedKey = override !== undefined
      ? override.assignedEmployeeUsername
      : (user.assignedEmployeeUsername || user.representative || user.managerUsername || "");
    if (assignedKey === "-") assignedKey = "";

    const official = getOfficialManager(assignedKey);
    let managerName = override !== undefined ? override.managerName : user.managerName;

    if (official) {
      assignedKey = official.username;
      managerName = official.fullName;
    } else if ((!managerName || managerName === "-") && assignedKey) {
      const found = managerRows.find((m) =>
        String(m.username).toLowerCase() === String(assignedKey).toLowerCase() ||
        String(m.fullName).toLowerCase() === String(assignedKey).toLowerCase()
      );
      if (found) {
        managerName = found.fullName || found.username;
        assignedKey = found.username || assignedKey;
      } else {
        managerName = assignedKey;
      }
    }

    const hasManager = Boolean(assignedKey && assignedKey !== "" && assignedKey !== "-");
    return {
      assignedKey,
      managerName: hasManager ? (managerName || assignedKey) : "Atanmamış",
      hasManager,
    };
  }, [localOverrides, managerRows]);

  // Publisher count per manager
  const managerPublisherCounts = useMemo(() => {
    const counts = {};
    managerRows.forEach((mgr) => {
      const key = mgr.username || mgr.fullName;
      counts[key] = 0;
    });

    publisherRows.forEach((p) => {
      const info = getPublisherManagerInfo(p);
      if (info.hasManager) {
        const matched = managerRows.find((m) =>
          String(m.username).toLowerCase() === String(info.assignedKey).toLowerCase() ||
          String(m.fullName).toLowerCase() === String(info.managerName).toLowerCase() ||
          String(m.username).toLowerCase() === String(info.managerName).toLowerCase()
        );
        if (matched) {
          const key = matched.username || matched.fullName;
          counts[key] = (counts[key] || 0) + 1;
        }
      }
    });

    return counts;
  }, [publisherRows, managerRows, getPublisherManagerInfo]);

  const handleSyncMasterData = async () => {
    if (!window.confirm("1416 yayıncı, 9 resmi yönetici ve kalıcı notlar sisteme aktarılıp senkronize edilsin mi?")) {
      return;
    }
    try {
      setSyncingMaster(true);
      setFeedback({ type: "info", message: "Master veriler eşitleniyor, lütfen bekleyiniz..." });
      const res = await fetch(API_SYNC_PUBLISHERS_MASTER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "sync_master" }),
      });
      const data = await res.json();
      if (data && data.success) {
        setFeedback({
          type: "success",
          message: `Başarıyla eşitlendi! ${data.publishers_processed || 1416} yayıncı işlendi (${data.publishers_updated || 0} güncellendi, ${data.publishers_inserted || 0} eklendi), ${data.notes_synced || 237} kalıcı not ve 9 yönetici sisteme kilitlendi.`,
        });
        if (typeof onReload === "function") {
          onReload();
        }
      } else {
        throw new Error(data?.message || "Eşitleme başarısız.");
      }
    } catch (err) {
      setFeedback({
        type: "error",
        message: `Master eşitleme hatası: ${err.message || "Bilinmeyen hata."}`,
      });
    } finally {
      setSyncingMaster(false);
    }
  };

  // Overall Statistics
  const stats = useMemo(() => {
    let assignedCount = 0;
    let unassignedCount = 0;
    publisherRows.forEach((p) => {
      const info = getPublisherManagerInfo(p);
      if (info.hasManager) assignedCount += 1;
      else unassignedCount += 1;
    });
    return {
      total: publisherRows.length,
      assignedCount,
      unassignedCount,
      selectedCount: selectedIds.size,
      totalManagers: managerRows.length,
    };
  }, [publisherRows, getPublisherManagerInfo, selectedIds.size, managerRows.length]);

  // Filtered rows
  const filteredRows = useMemo(() => {
    const q = search.toLowerCase().trim();
    return publisherRows.filter((p) => {
      const info = getPublisherManagerInfo(p);

      if (filterMode === "unassigned" && info.hasManager) return false;
      if (filterMode === "assigned" && !info.hasManager) return false;
      if (filterMode !== "all" && filterMode !== "unassigned" && filterMode !== "assigned") {
        const matchesKey = String(info.assignedKey).toLowerCase() === String(filterMode).toLowerCase();
        const matchesName = String(info.managerName).toLowerCase() === String(filterMode).toLowerCase();
        if (!matchesKey && !matchesName) return false;
      }

      if (q) {
        const fullString = `${p.fullName || ""} ${p.username || ""} ${p.system_username || ""} ${p.tiktok_username || ""} ${p.phone || ""} ${p.hiddenId || ""} ${info.managerName || ""} ${info.assignedKey || ""}`.toLowerCase();
        if (!fullString.includes(q)) return false;
      }

      return true;
    });
  }, [publisherRows, search, filterMode, getPublisherManagerInfo]);

  // Selection handlers
  const allFilteredSelected = filteredRows.length > 0 && filteredRows.every((p) => selectedIds.has(p.id));

  const handleToggleSelectAll = () => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (allFilteredSelected) {
        filteredRows.forEach((p) => next.delete(p.id));
      } else {
        filteredRows.forEach((p) => next.add(p.id));
      }
      return next;
    });
  };

  const handleToggleRow = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const handleSelectAllUnassigned = () => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      publisherRows.forEach((p) => {
        const info = getPublisherManagerInfo(p);
        if (!info.hasManager) {
          next.add(p.id);
        }
      });
      return next;
    });
    setFilterMode("unassigned");
  };

  const handleClearSelection = () => {
    setSelectedIds(new Set());
  };

  // Execution: Send assignment to API
  const executeAssignment = async (idsToAssign, managerUsername) => {
    const cleanManager = managerUsername === "__unassign__" ? "" : managerUsername;
    const payload = JSON.stringify({
      publisherIds: idsToAssign,
      managerUsername: cleanManager,
      representative: cleanManager,
      action: "bulk_assign_manager",
    });

    // 1. Try dedicated endpoint
    try {
      const res = await fetch(API_BULK_ASSIGN_MANAGER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
      });
      const text = await res.text();
      if (text && text.trim().startsWith("{")) {
        const data = JSON.parse(text);
        if (data && data.success) return data;
        if (data && data.message) throw new Error(data.message);
      }
    } catch (e1) {
      console.warn("API_BULK_ASSIGN_MANAGER failed, trying fallback:", e1);
    }

    // 2. Try users-list.php POST fallback
    try {
      const res = await fetch(API_USERS_LIST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
      });
      const text = await res.text();
      if (text && text.trim().startsWith("{")) {
        const data = JSON.parse(text);
        if (data && data.success) return data;
        if (data && data.message) throw new Error(data.message);
      }
    } catch (e2) {
      console.warn("API_USERS_LIST fallback failed:", e2);
    }

    throw new Error("Sunucuya bağlanılamadı veya atama kaydedilemedi. Lütfen bağlantınızı kontrol edin.");
  };

  // Bulk assignment click handler
  const handleBulkAssignClick = () => {
    if (selectedIds.size === 0) {
      setFeedback({ type: "error", message: "Lütfen en az bir yayıncı seçiniz." });
      return;
    }
    if (!targetManager) {
      setFeedback({ type: "error", message: "Lütfen atanacak yöneticiyi seçiniz." });
      return;
    }

    const targetRecord = managerRows.find((m) => m.username === targetManager || m.fullName === targetManager);
    const targetLabel = targetManager === "__unassign__"
      ? "Yöneticisiz (Atama Kaldır)"
      : (targetRecord?.fullName ? `${targetRecord.fullName} (@${targetRecord.username})` : `@${targetManager}`);

    setConfirmModal({
      open: true,
      targetUsername: targetManager,
      targetName: targetLabel,
      count: selectedIds.size,
    });
  };

  const handleConfirmAssignment = async () => {
    const ids = Array.from(selectedIds);
    const target = confirmModal.targetUsername;
    const targetLabel = confirmModal.targetName;
    setConfirmModal({ open: false, targetUsername: "", targetName: "", count: 0 });

    try {
      setAssigning(true);
      setFeedback(null);

      const targetRecord = managerRows.find((m) => m.username === target || m.fullName === target);
      const newMgrName = target === "__unassign__" ? "-" : (targetRecord?.fullName || target);
      const newAssignedUsername = target === "__unassign__" ? "" : (targetRecord?.username || target);

      // Optimistic UI state update
      setLocalOverrides((prev) => {
        const updated = { ...prev };
        ids.forEach((id) => {
          updated[id] = {
            assignedEmployeeUsername: newAssignedUsername,
            managerName: newMgrName,
          };
        });
        return updated;
      });

      // API call
      const res = await executeAssignment(ids, target);

      setFeedback({
        type: "success",
        message: `${ids.length} yayıncının yöneticisi başarıyla "${targetLabel}" olarak güncellendi ve sisteme kaydedildi.`,
      });

      setSelectedIds(new Set());
      setTargetManager("");

      if (typeof onReload === "function") {
        onReload();
      }
    } catch (err) {
      setFeedback({
        type: "error",
        message: `Atama hatası: ${err.message || "Bilinmeyen bir hata oluştu."}`,
      });
    } finally {
      setAssigning(false);
    }
  };

  // Inline row manager assignment
  const handleInlineAssign = async (publisherId, newManagerKey) => {
    try {
      setInlineAssigningId(publisherId);
      const cleanKey = newManagerKey === "__unassign__" ? "" : newManagerKey;
      const targetRecord = managerRows.find((m) => m.username === cleanKey || m.fullName === cleanKey);
      const newMgrName = !cleanKey ? "-" : (targetRecord?.fullName || cleanKey);
      const newAssignedUsername = !cleanKey ? "" : (targetRecord?.username || cleanKey);

      setLocalOverrides((prev) => ({
        ...prev,
        [publisherId]: {
          assignedEmployeeUsername: newAssignedUsername,
          managerName: newMgrName,
        },
      }));

      await executeAssignment([publisherId], cleanKey);

      setFeedback({
        type: "success",
        message: `Yayıncı yöneticisi başarıyla "${newMgrName}" olarak güncellendi.`,
      });

      if (typeof onReload === "function") {
        onReload();
      }
    } catch (err) {
      setFeedback({
        type: "error",
        message: `Güncelleme hatası: ${err.message || "Kaydedilemedi."}`,
      });
    } finally {
      setInlineAssigningId(null);
    }
  };

  return (
    <div style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }} className="space-y-5">
      {/* BAŞLIK & ÜST AKSİYONLAR */}
      <SectionHeader
        eyebrow="Yönetici Yönetimi"
        title="Yayıncı & Yönetici Eşleştirme"
        desc="Yayıncıları yöneticilerine toplu veya tekil olarak atayın, dağıtımı optimize edin ve yöneticisiz yayıncıları kolayca eşleştirin."
        action={
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              disabled={syncingMaster}
              onClick={handleSyncMasterData}
              className={`inline-flex items-center gap-2 rounded-xl border px-3.5 py-2 text-xs font-bold transition shadow-sm ${
                isDark
                  ? "border-yellow-500/40 bg-yellow-500/15 text-yellow-300 hover:bg-yellow-500/25"
                  : "border-yellow-400 bg-yellow-50 text-yellow-900 hover:bg-yellow-100"
              }`}
              title="Master veri tablosunu (1416 yayıncı, 9 resmi yönetici ve tüm kalıcı notları) sisteme senkronize eder"
            >
              {syncingMaster ? (
                <>
                  <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
                  <span>Eşitleniyor...</span>
                </>
              ) : (
                <>
                  <span>🔄</span>
                  <span>Master Listeyi Eşitle (1416 Yayıncı & 9 Yönetici)</span>
                </>
              )}
            </button>
            <button
              type="button"
              onClick={handleSelectAllUnassigned}
              className={`inline-flex items-center gap-2 rounded-xl border px-3.5 py-2 text-xs font-bold transition shadow-sm ${
                isDark
                  ? "border-amber-500/40 bg-amber-500/15 text-amber-300 hover:bg-amber-500/25"
                  : "border-amber-300 bg-amber-50 text-amber-900 hover:bg-amber-100"
              }`}
            >
              <span>⚠️</span>
              <span>Yöneticisiz Olanları Seç ({stats.unassignedCount})</span>
            </button>
            <ActionButton variant="dark" onClick={onReload}>
              Yenile
            </ActionButton>
          </div>
        }
      />

      {/* İSTATİSTİK KARTLARI */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {/* Toplam Yayıncı */}
        <div
          onClick={() => setFilterMode("all")}
          className={`cursor-pointer rounded-2xl border p-4 transition-all hover:scale-[1.01] ${
            filterMode === "all"
              ? isDark ? "border-blue-500/60 bg-blue-500/15" : "border-blue-400 bg-blue-50/70"
              : isDark ? "border-[#1e2838] bg-[#121620]" : "border-[#e2e8f0] bg-white"
          }`}
        >
          <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Toplam Yayıncı</div>
          <div className={`mt-1 text-2xl font-black ${isDark ? "text-white" : "text-slate-900"}`}>{stats.total}</div>
          <div className="mt-1 text-[11px] text-slate-500">Sistemde kayıtlı yayıncılar</div>
        </div>

        {/* Yöneticisi Olan */}
        <div
          onClick={() => setFilterMode("assigned")}
          className={`cursor-pointer rounded-2xl border p-4 transition-all hover:scale-[1.01] ${
            filterMode === "assigned"
              ? isDark ? "border-emerald-500/60 bg-emerald-500/15" : "border-emerald-400 bg-emerald-50/70"
              : isDark ? "border-[#1e2838] bg-[#121620]" : "border-[#e2e8f0] bg-white"
          }`}
        >
          <div className="text-[11px] font-semibold uppercase tracking-wider text-emerald-500">Yöneticisi Olan</div>
          <div className="mt-1 text-2xl font-black text-emerald-400">{stats.assignedCount}</div>
          <div className="mt-1 text-[11px] text-slate-500">Aktif eşleştirilmiş yayıncılar</div>
        </div>

        {/* Atama Bekleyen (Yöneticisiz) */}
        <div
          onClick={() => setFilterMode("unassigned")}
          className={`cursor-pointer rounded-2xl border p-4 transition-all hover:scale-[1.01] ${
            filterMode === "unassigned"
              ? isDark ? "border-amber-500/70 bg-amber-500/20 shadow-amber-500/10 shadow-lg" : "border-amber-400 bg-amber-50/90 shadow-sm"
              : isDark ? "border-[#1e2838] bg-[#121620]" : "border-[#e2e8f0] bg-white"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-semibold uppercase tracking-wider text-amber-400">Atama Bekleyen</span>
            {stats.unassignedCount > 0 && (
              <span className="inline-flex h-2 w-2 rounded-full bg-amber-400 animate-ping" />
            )}
          </div>
          <div className="mt-1 text-2xl font-black text-amber-400">{stats.unassignedCount}</div>
          <div className="mt-1 text-[11px] text-amber-500/80 font-medium">Yönetici atanmamış yayıncılar</div>
        </div>

        {/* Seçilen Yayıncı */}
        <div
          className={`rounded-2xl border p-4 transition-all ${
            stats.selectedCount > 0
              ? isDark ? "border-yellow-500/60 bg-yellow-500/15 shadow-yellow-500/10 shadow-lg" : "border-yellow-400 bg-yellow-50/80"
              : isDark ? "border-[#1e2838] bg-[#121620]" : "border-[#e2e8f0] bg-white"
          }`}
        >
          <div className="text-[11px] font-semibold uppercase tracking-wider text-yellow-400">Seçilen Yayıncı</div>
          <div className="mt-1 text-2xl font-black text-yellow-300">{stats.selectedCount}</div>
          <div className="mt-1 text-[11px] text-slate-500">
            {stats.selectedCount > 0 ? "Toplu işlem için hazır" : "Soldaki kutulardan seçin"}
          </div>
        </div>
      </div>

      {/* GERİ BİLDİRİM BİLDİRİMİ */}
      {feedback && (
        <div
          className={`flex items-center justify-between rounded-xl border p-4 text-xs font-semibold shadow-sm transition-all ${
            feedback.type === "success"
              ? isDark ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-emerald-300 bg-emerald-50 text-emerald-800"
              : feedback.type === "error"
              ? isDark ? "border-red-500/40 bg-red-500/10 text-red-300" : "border-red-300 bg-red-50 text-red-800"
              : isDark ? "border-blue-500/40 bg-blue-500/10 text-blue-300" : "border-blue-300 bg-blue-50 text-blue-800"
          }`}
        >
          <div className="flex items-center gap-2">
            <span>{feedback.type === "success" ? "✓" : feedback.type === "error" ? "⚠️" : "ℹ️"}</span>
            <span>{feedback.message}</span>
          </div>
          <button
            type="button"
            onClick={() => setFeedback(null)}
            className="rounded p-1 hover:bg-black/10 active:scale-95"
          >
            ✕
          </button>
        </div>
      )}

      {/* TOPLU YÖNETİCİ ATAMA ÇUBUĞU (ANA KONTROL PANELİ) */}
      <div
        className={`rounded-2xl border p-4 shadow-sm transition-all ${
          selectedIds.size > 0
            ? isDark
              ? "border-yellow-500/50 bg-gradient-to-r from-[#172133] via-[#1b253b] to-[#172133] shadow-[0_0_25px_rgba(234,179,8,0.12)]"
              : "border-yellow-400 bg-gradient-to-r from-yellow-50/60 via-amber-50/40 to-yellow-50/60 shadow-sm"
            : isDark
            ? "border-[#1e2838] bg-[#151c2a]"
            : "border-[#e2e8f0] bg-white"
        }`}
      >
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          {/* Sol: Seçim Kontrolleri */}
          <div className="flex flex-wrap items-center gap-3">
            <label className="flex items-center gap-2 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={allFilteredSelected}
                onChange={handleToggleSelectAll}
                className="h-4 w-4 rounded border-slate-400 text-yellow-500 focus:ring-yellow-400 cursor-pointer"
              />
              <span className={`text-xs font-bold ${isDark ? "text-slate-200" : "text-slate-800"}`}>
                {allFilteredSelected ? "Seçimi Kaldır" : "Tümünü Seç"}
              </span>
            </label>

            <span className={`text-xs px-2.5 py-1 rounded-full font-bold ${
              selectedIds.size > 0
                ? isDark ? "bg-yellow-400 text-slate-950 shadow-sm" : "bg-yellow-400 text-slate-950 shadow-sm"
                : isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-600"
            }`}>
              {selectedIds.size} Yayıncı Seçildi
            </span>

            {selectedIds.size > 0 && (
              <button
                type="button"
                onClick={handleClearSelection}
                className="text-xs font-semibold text-slate-400 hover:text-red-400 underline transition"
              >
                Seçimi Temizle
              </button>
            )}

            {/* Hızlı Filtre Butonları */}
            <div className="hidden sm:flex items-center gap-1.5 ml-2 border-l pl-3 border-slate-700/40">
              <button
                type="button"
                onClick={() => setFilterMode("all")}
                className={`px-2.5 py-1 text-[11px] rounded-lg font-bold transition ${
                  filterMode === "all"
                    ? isDark ? "bg-white/10 text-white" : "bg-slate-200 text-slate-900"
                    : isDark ? "text-slate-400 hover:text-white" : "text-slate-500 hover:text-slate-900"
                }`}
              >
                Tümü ({stats.total})
              </button>
              <button
                type="button"
                onClick={() => setFilterMode("unassigned")}
                className={`px-2.5 py-1 text-[11px] rounded-lg font-bold transition ${
                  filterMode === "unassigned"
                    ? isDark ? "bg-amber-500/20 text-amber-300 border border-amber-500/40" : "bg-amber-100 text-amber-900 border border-amber-300"
                    : "text-amber-400 hover:underline"
                }`}
              >
                ⚠️ Yöneticisiz ({stats.unassignedCount})
              </button>
              <button
                type="button"
                onClick={() => setFilterMode("assigned")}
                className={`px-2.5 py-1 text-[11px] rounded-lg font-bold transition ${
                  filterMode === "assigned"
                    ? isDark ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/40" : "bg-emerald-100 text-emerald-900 border border-emerald-300"
                    : "text-emerald-400 hover:underline"
                }`}
              >
                ✅ Yöneticili ({stats.assignedCount})
              </button>
            </div>
          </div>

          {/* Sağ: Yönetici Seçimi & Toplu Ata Butonu */}
          <div className="flex flex-wrap items-center gap-2.5">
            <div className="flex items-center gap-2">
              <span className={`text-xs font-bold whitespace-nowrap ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                Atanacak Yönetici:
              </span>
              <select
                value={targetManager}
                onChange={(e) => setTargetManager(e.target.value)}
                className={`rounded-xl border px-3 py-2 text-xs font-semibold outline-none transition min-w-[220px] ${
                  isDark
                    ? "border-[#2e3e5b] bg-[#121824] text-white focus:border-yellow-400"
                    : "border-slate-300 bg-white text-slate-800 focus:border-blue-500"
                }`}
              >
                <option value="">Yönetici Seçiniz...</option>
                <option value="__unassign__">⚠️ — Atamayı Kaldır (Yöneticisiz Yap) —</option>
                <optgroup label="Sistem Yöneticileri">
                  {managerRows.map((mgr) => {
                    const uKey = mgr.username || mgr.fullName;
                    const count = managerPublisherCounts[uKey] || 0;
                    return (
                      <option key={mgr.id || uKey} value={mgr.username || mgr.fullName}>
                        {mgr.fullName || mgr.username} (@{mgr.username}) — [{count} Yayıncı]
                      </option>
                    );
                  })}
                </optgroup>
              </select>
            </div>

            <button
              type="button"
              disabled={selectedIds.size === 0 || !targetManager || assigning}
              onClick={handleBulkAssignClick}
              className={`inline-flex items-center gap-2 rounded-xl px-5 py-2 text-xs font-black shadow-md transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed ${
                selectedIds.size > 0 && targetManager
                  ? "bg-gradient-to-r from-yellow-500 via-amber-500 to-yellow-600 text-slate-950 hover:brightness-110 shadow-yellow-500/25"
                  : isDark
                  ? "bg-slate-700 text-slate-300"
                  : "bg-slate-200 text-slate-500"
              }`}
            >
              {assigning ? (
                <>
                  <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-slate-900 border-t-transparent" />
                  <span>Atanıyor...</span>
                </>
              ) : (
                <>
                  <span className="text-base">⚡</span>
                  <span>Yönetici Ata {selectedIds.size > 0 ? `(${selectedIds.size})` : ""}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* ARAMA VE FİLTRE ÇUBUĞU */}
      <div className={`rounded-2xl border p-4 transition-colors ${
        isDark ? "bg-[#121620] border-[#1e2838]" : "bg-[#f4f7fb] border-[#e2e8f0]"
      }`}>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex-1 max-w-lg">
            <SearchBox
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Yayıncı ara (Ad, kullanıcı adı, TikTok, telefon, ID, mevcut yönetici)..."
            />
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center gap-1.5 text-xs text-slate-400">
              <span>Yönetici Filtresi:</span>
              <select
                value={filterMode}
                onChange={(e) => setFilterMode(e.target.value)}
                className={`rounded-lg border px-2.5 py-1.5 text-xs font-semibold outline-none ${
                  isDark ? "border-[#2a374e] bg-[#161e2e] text-white" : "border-slate-300 bg-white text-slate-800"
                }`}
              >
                <option value="all">Tüm Yayıncılar ({stats.total})</option>
                <option value="unassigned">⚠️ Sadece Yöneticisiz Olanlar ({stats.unassignedCount})</option>
                <option value="assigned">✅ Sadece Yöneticisi Olanlar ({stats.assignedCount})</option>
                <optgroup label="Yöneticisine Göre">
                  {managerRows.map((mgr) => {
                    const uKey = mgr.username || mgr.fullName;
                    const count = managerPublisherCounts[uKey] || 0;
                    return (
                      <option key={mgr.id || uKey} value={mgr.username}>
                        {mgr.fullName || mgr.username} ({count} Yayıncı)
                      </option>
                    );
                  })}
                </optgroup>
              </select>
            </div>

            <div className="text-xs text-slate-400 font-semibold pl-2">
              Görüntülenen: <strong className={isDark ? "text-white" : "text-slate-900"}>{filteredRows.length}</strong> / {stats.total}
            </div>
          </div>
        </div>

        <ApiNotice loading={loading} error={error} onReload={onReload} />
      </div>

      {/* YAYINCI LİSTESİ TABLOSU */}
      <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors ${
        isDark ? "bg-[#121620] border-[#1e2838]" : "bg-[#f4f7fb] border-[#e2e8f0]"
      }`}>
        <div className="overflow-x-auto min-w-full">
          <div className="min-w-[1180px]">
            {/* SÜTUN BAŞLIKLARI (SABİT PİKSEL HİZALI) */}
            <div className={`grid grid-cols-[48px_minmax(220px,1.5fr)_minmax(160px,1.1fr)_130px_190px_160px_230px] gap-3 px-5 py-3.5 text-[12px] font-[600] uppercase tracking-[0.06em] border-b items-center ${
              isDark ? "bg-[#182030] border-[#1e2838] text-[#8fa2be]" : "bg-[#edf3fa] border-[#e2e8f0] text-[#405674]"
            }`}>
              <div className="flex items-center justify-center">
                <input
                  type="checkbox"
                  checked={allFilteredSelected}
                  onChange={handleToggleSelectAll}
                  className="h-4 w-4 rounded border-slate-400 text-yellow-500 focus:ring-yellow-400 cursor-pointer"
                  title="Tümünü Seç / Seçimi Kaldır"
                />
              </div>
              <div>YAYINCI (AD SOYADI & GÖRSEL)</div>
              <div>GİRİŞ ADI / TIKTOK</div>
              <div>TELEFON</div>
              <div>ID</div>
              <div>MEVCUT YÖNETİCİ</div>
              <div className="text-left">HIZLI ATAMA / DEĞİŞTİR</div>
            </div>

            {/* TABLO SATIRLARI */}
            {!loading && filteredRows.length === 0 ? (
              <EmptyState text="Filtrelere uygun yayıncı bulunamadı." />
            ) : (
              filteredRows.map((user) => {
                const isSelected = selectedIds.has(user.id);
                const info = getPublisherManagerInfo(user);
                const publisherImg = user.image || user.profileImage || "";
                const isInlineLoading = inlineAssigningId === user.id;

                return (
                  <div
                    key={user.id}
                    className={`grid grid-cols-[48px_minmax(220px,1.5fr)_minmax(160px,1.1fr)_130px_190px_160px_230px] gap-3 px-5 py-3.5 text-[14px] items-center border-b transition-colors ${
                      isSelected
                        ? isDark
                          ? "bg-[#1a2942] border-[#253757] text-[#f1f5f9]"
                          : "bg-blue-50/80 border-blue-200 text-[#1e293b]"
                        : isDark
                        ? "bg-[#131925] border-[#1c2536] text-[#cbd5e1] hover:bg-[#1a2335]"
                        : "bg-white border-[#eef2f7] text-[#334155] hover:bg-[#ebf1f8]"
                    }`}
                  >
                    {/* 1. SEÇİM KUTUSU */}
                    <div className="flex items-center justify-center">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleToggleRow(user.id)}
                        className="h-4 w-4 rounded border-slate-400 text-yellow-500 focus:ring-yellow-400 cursor-pointer"
                      />
                    </div>

                    {/* 2. AD SOYADI & GÖRSEL */}
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="relative shrink-0">
                        {publisherImg ? (
                          <img
                            src={publisherImg}
                            alt={user.fullName}
                            className={`h-9 w-9 rounded-full object-cover border ${
                              isDark ? "border-[#2a374e]" : "border-[#cbd5e1]"
                            }`}
                          />
                        ) : (
                          <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border text-xs font-bold ${
                            isDark
                              ? "border-[#2a374e] bg-[#1c2434] text-yellow-300"
                              : "border-[#cbd5e1] bg-[#eef2f6] text-slate-700"
                          }`}>
                            {user.fullName?.slice(0, 2)?.toUpperCase() || "WM"}
                          </div>
                        )}
                      </div>
                      <div className="min-w-0">
                        <div className={`truncate font-[600] text-[14px] ${isDark ? "text-white" : "text-slate-900"}`}>
                          {user.fullName || "-"}
                        </div>
                        <div className={`truncate text-[12px] ${isDark ? "text-slate-400" : "text-slate-500"}`}>
                          Durum: {user.status || "Aktif"}
                        </div>
                      </div>
                    </div>

                    {/* 3. GİRİŞ ADI / TIKTOK */}
                    <div className="min-w-0">
                      <div className={`truncate text-[13px] font-mono ${isDark ? "text-slate-200" : "text-slate-700"}`}>
                        {user.system_username || user.username || "-"}
                      </div>
                      <div className={`truncate text-[12px] ${isDark ? "text-slate-400" : "text-slate-500"}`}>
                        @{user.tiktok_username || user.username || "-"}
                      </div>
                    </div>

                    {/* 4. TELEFON */}
                    <div className={`tabular-nums text-[13px] ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                      {user.phone || "-"}
                    </div>

                    {/* 5. HIDDEN ID */}
                    <div className={`tabular-nums font-mono text-[13px] ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                      {user.hiddenId || user.id || "-"}
                    </div>

                    {/* 6. MEVCUT YÖNETİCİ */}
                    <div className="min-w-0">
                      {info.hasManager ? (
                        <div className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold border ${
                          isDark
                            ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-300"
                            : "border-emerald-200 bg-emerald-50 text-emerald-800"
                        }`}>
                          <span className="text-[11px]">👤</span>
                          <span className="truncate max-w-[140px]" title={info.managerName}>
                            {info.managerName}
                          </span>
                        </div>
                      ) : (
                        <div className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold border ${
                          isDark
                            ? "border-amber-500/40 bg-amber-500/15 text-amber-300"
                            : "border-amber-300 bg-amber-50 text-amber-800"
                        }`}>
                          <span className="text-[11px]">⚠️</span>
                          <span>Atama Bekliyor</span>
                        </div>
                      )}
                    </div>

                    {/* 7. HIZLI ATAMA / DEĞİŞTİR */}
                    <div className="flex items-center gap-2">
                      <select
                        disabled={isInlineLoading}
                        value={info.assignedKey || ""}
                        onChange={(e) => handleInlineAssign(user.id, e.target.value)}
                        className={`rounded-lg border px-2.5 py-1.5 text-xs font-semibold outline-none transition w-full max-w-[210px] ${
                          isDark
                            ? "border-[#2e3e5b] bg-[#121824] text-slate-200 focus:border-yellow-400"
                            : "border-slate-300 bg-white text-slate-800 focus:border-blue-500"
                        }`}
                      >
                        <option value="">-- Yönetici Ata / Değiştir --</option>
                        <option value="__unassign__">⚠️ Atamayı Kaldır (Yöneticisiz)</option>
                        <optgroup label="Yöneticiler">
                          {managerRows.map((mgr) => (
                            <option key={mgr.id || mgr.username} value={mgr.username || mgr.fullName}>
                              {mgr.fullName || mgr.username} (@{mgr.username})
                            </option>
                          ))}
                        </optgroup>
                      </select>

                      {isInlineLoading && (
                        <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent" />
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {/* TOPLU ATAMA ONAY MODALI */}
      {confirmModal.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <div className={`w-full max-w-md rounded-2xl border p-6 shadow-2xl transition-all ${
            isDark ? "bg-[#151c2a] border-[#223049] text-white" : "bg-white border-[#cbd5e1] text-slate-900"
          }`}>
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-yellow-500/20 text-2xl text-yellow-400 border border-yellow-500/40">
                ⚡
              </div>
              <div>
                <h3 className="text-lg font-black tracking-tight">Toplu Yönetici Atama Onayı</h3>
                <p className="text-xs text-slate-400">Bu işlem seçilen tüm yayıncıların yöneticisini güncelleyecektir.</p>
              </div>
            </div>

            <div className={`mt-5 rounded-xl border p-4 space-y-2 text-xs ${
              isDark ? "bg-[#10141d] border-[#1e2838]" : "bg-slate-50 border-slate-200"
            }`}>
              <div className="flex justify-between items-center">
                <span className="text-slate-400">Seçilen Yayıncı Sayısı:</span>
                <span className="font-bold text-yellow-400 text-sm">{confirmModal.count} Yayıncı</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-slate-400">Atanacak Yönetici:</span>
                <span className="font-bold text-emerald-400 text-sm">{confirmModal.targetName}</span>
              </div>
            </div>

            <p className="mt-4 text-xs text-slate-400 leading-relaxed">
              Onayladığınızda seçilen {confirmModal.count} yayıncı için yönetici bilgisi veritabanında güncellenecek ve sistem anında yenilenecektir.
            </p>

            <div className="mt-6 flex items-center justify-end gap-3">
              <button
                type="button"
                onClick={() => setConfirmModal({ open: false, targetUsername: "", targetName: "", count: 0 })}
                className={`rounded-xl border px-4 py-2 text-xs font-bold transition ${
                  isDark
                    ? "border-[#2a374e] bg-[#1a2333] text-slate-300 hover:bg-[#202b3f]"
                    : "border-slate-300 bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                Vazgeç
              </button>
              <button
                type="button"
                onClick={handleConfirmAssignment}
                className="rounded-xl bg-gradient-to-r from-yellow-500 via-amber-500 to-yellow-600 px-5 py-2 text-xs font-black text-slate-950 shadow-md hover:brightness-110 active:scale-95 transition"
              >
                Evet, Atamayı Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ManagerGenericContent({ title, desc }) {
  return <GenericPanel eyebrow="Yönetici Yönetimi" title={title} desc={desc} items={["Ad Soyad", "Kullanıcı Adı", "Telefon", "Mail", "Bağlı Yayıncılar", "Ekip Raporu", "RLS Rolü", "Durum"]} />;
}

function GenericPanel({ eyebrow, title, desc, items }) {
  return (
    <div>
      <SectionHeader eyebrow={eyebrow} title={title} desc={desc} action={<ActionButton>Kaydet</ActionButton>} />
      <Card className="p-5"><div className="text-lg font-black text-white">Yönetilecek Alanlar</div><div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4">{items.map((item) => <div key={item} className="rounded-xl border border-white/10 bg-black/25 px-4 py-3 text-sm font-semibold text-white/58">{item}</div>)}</div></Card>
    </div>
  );
}

function DataTable({ columns = [], rows = [], renderRow }) {
  return (
    <Card className="overflow-hidden">
      <div className="hidden gap-3 bg-white/[0.035] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid" style={{ gridTemplateColumns: `repeat(${columns.length}, minmax(0, 1fr))` }}>{columns.map((col) => <div key={col}>{col}</div>)}</div>
      {rows.map((row, index) => renderRow(row, index))}
    </Card>
  );
}

function PowerBiPermissionsContent({ publisherRows, managerRows }) {
  const permissionRows = [
    ...publisherRows.map((user) => ({ id: `p-${user.id}`, userType: "Yayıncı", user: user.fullName, sourceUser: user, role: user.powerBIRole || "-", filter: `HiddenID = ${user.hiddenId}`, report: "Yayıncı Raporları", status: user.status })),
    ...managerRows.map((user) => ({ id: `m-${user.id}`, userType: "Yönetici", user: user.fullName, sourceUser: user, role: user.powerBIRole || "manager_team_rls", filter: `Yönetici = ${user.username}`, report: "Yönetici Raporları", status: user.status })),
  ];

  return (
    <div>
      <SectionHeader eyebrow="Raporlar" title="Rapor Yetkileri" desc="Kullanıcıların rapor erişimi, RLS rolü ve filtre değeri bu alanda yönetilir." action={<ActionButton>Yetki Ekle</ActionButton>} />
      <DataTable columns={["Tip", "Kullanıcı", "Rapor", "RLS Rolü", "Filtre", "Durum"]} rows={permissionRows} renderRow={(row) => <div key={row.id} className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-6"><div className="font-bold text-yellow-300">{row.userType}</div><div className="font-bold text-white">
          {row.userType === "Yayıncı" ? (
            <PublisherNameWithTier publisher={row.sourceUser} label={row.user} />
          ) : (
            row.user
          )}
        </div><div>{row.report}</div><div className="text-yellow-300">{row.role}</div><div className="text-white/45">{row.filter}</div><div><StatusBadge status={row.status} /></div></div>} />
    </div>
  );
}

function ReportsOverviewContent() {
  const publisherReports = powerBiReports.filter((item) => item.type === "Yayıncı");
  const managerReports = powerBiReports.filter((item) => item.type === "Yönetici");
  const adminReports = powerBiReports.filter((item) => item.type === "Admin");
  return (
    <div>
      <SectionHeader
        eyebrow="Raporlar"
        title="Rapor Merkezi"
        desc="Yayıncı, yönetici, admin raporları ve RLS filtre kuralları burada yönetilir."
        action={<ActionButton>Rapor Ekle</ActionButton>}
      />
      <div className="grid gap-4 xl:grid-cols-4"><StatCard title="Toplam Rapor" value={powerBiReports.length} note="Tanımlı rapor" /><StatCard title="Yayıncı Raporu" value={publisherReports.length} note="Hidden ID bazlı" /><StatCard title="Yönetici Raporu" value={managerReports.length} note="Yönetici bazlı" /><StatCard title="Admin Raporu" value={adminReports.length} note="Tam erişim" /></div>
    </div>
  );
}

function ReportOnlyContent({ title, type, desc }) {
  const rows = powerBiReports.filter((item) => item.type === type);
  return (
    <div>
      <SectionHeader eyebrow="Raporlar" title={title} desc={desc} action={<ActionButton>Rapor Ekle</ActionButton>} />
      <ReportBlock title={title} rows={rows} />
    </div>
  );
}

function ReportBlock({ title, rows }) {
  return (
    <Card className="overflow-hidden">
      <div className="border-b border-white/10 p-5"><div className="text-xl font-black text-white">{title}</div></div>
      <div className="hidden grid-cols-[1fr_1fr_1fr_1fr_.7fr] gap-3 bg-white/[0.035] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid"><div>Rapor</div><div>Tablo</div><div>Filtre</div><div>RLS Rolü</div><div>Durum</div></div>
      {rows.map((row) => <div key={row.id} className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-[1fr_1fr_1fr_1fr_.7fr]"><div className="font-bold text-white">{row.name}</div><div>{row.table}</div><div>{row.filter}</div><div className="text-yellow-300">{row.role}</div><div><StatusBadge status={row.status} /></div></div>)}
    </Card>
  );
}

function AdminFaqArchiveContent({ currentAdmin }) {
  const emptyForm = {
    question: "",
    answer: "",
    category: "Genel",
    targetRole: "publisher",
    status: "Aktif",
    sortOrder: 0,
  };

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [search, setSearch] = useState("");

  async function loadFaqs() {
    try {
      setLoading(true);
      const result = await requestJson(API_FAQ_LIST, { cache: "no-store" });
      setRows(result.faqs || []);
    } catch (err) {
      console.error("SS arşivi alınamadı:", err);
      setRows([]);
      alert(err.message || "SS arşivi alınamadı.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadFaqs();
  }, []);

  function resetForm() {
    setEditingId(null);
    setForm(emptyForm);
  }

  function handleEdit(item) {
    setEditingId(item.id);
    setForm({
      question: item.question || item.q || "",
      answer: item.answer || item.a || "",
      category: item.category || "Genel",
      targetRole: item.targetRole || "publisher",
      status: item.status || "Aktif",
      sortOrder: item.sortOrder || 0,
    });
  }

  async function handleSaveFaq() {
    if (!form.question.trim() || !form.answer.trim()) {
      alert("Soru ve cevap zorunlu.");
      return;
    }

    try {
      setSaving(true);

      await requestJson(API_FAQ_SAVE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingId,
          ...form,
          createdBy: currentAdmin?.username || "admin",
          createdByRole: "admin",
        }),
      });

      resetForm();
      await loadFaqs();
      alert("SS kaydı kaydedildi.");
    } catch (err) {
      alert(err.message || "SS kaydı kaydedilemedi.");
    } finally {
      setSaving(false);
    }
  }

  async function handleDeleteFaq(item) {
    if (!window.confirm(`${item.question || item.q} kaydını kaldırmak istiyor musunuz?`)) return;

    try {
      setSaving(true);

      await requestJson(API_FAQ_DELETE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      await loadFaqs();
      alert("SS kaydı kaldırıldı.");
    } catch (err) {
      alert(err.message || "SS kaydı kaldırılamadı.");
    } finally {
      setSaving(false);
    }
  }

  const activeRows = rows.filter((item) => item.status !== "Silindi");
  const filteredRows = activeRows.filter((item) =>
    `${item.question || item.q} ${item.answer || item.a} ${item.category}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="SS Arşivi Yönetimi"
        desc="Yayıncı panelindeki Sık Sorulan Sorular alanında gösterilecek soru-cevap arşivi bu ekrandan yönetilir."
        action={
          <ActionButton variant="dark" onClick={loadFaqs}>
            Yenile
          </ActionButton>
        }
      />

      <div className="mb-5 grid gap-4 md:grid-cols-4">
        <StatCard title="Toplam SS" value={activeRows.length} note="Silinmemiş kayıt" />
        <StatCard title="Aktif" value={activeRows.filter((i) => i.status === "Aktif").length} note="Yayında" />
        <StatCard title="Pasif" value={activeRows.filter((i) => i.status === "Pasif").length} note="Yayında değil" />
        <StatCard title="Durum" value={loading ? "Yükleniyor" : "Hazır"} note="API veri durumu" />
      </div>

      <div className="grid gap-5 xl:grid-cols-[1fr_.75fr]">
        <Card className="p-5">
          <SearchBox
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="SS ara..."
          />

          <div className="mt-4 space-y-3">
            {filteredRows.length === 0 && <EmptyState text="SS kaydı bulunamadı." />}

            {filteredRows.map((item) => (
              <div key={item.id} className="rounded-2xl border border-white/10 bg-white/[0.025] p-4">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-base font-bold text-white">{item.question || item.q}</div>
                    <p className="mt-2 text-sm leading-6 text-white/55">{item.answer || item.a}</p>
                  </div>

                  <StatusBadge status={item.status || "Aktif"} />
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  <ActionButton variant="dark" onClick={() => handleEdit(item)}>
                    Düzenle
                  </ActionButton>

                  <button
                    type="button"
                    onClick={() => handleDeleteFaq(item)}
                    className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-2.5 text-xs font-black text-red-300 transition hover:bg-red-500 hover:text-white"
                  >
                    Kaldır
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-5">
          <div className="text-xl font-bold text-white">
            {editingId ? "SS Kaydını Düzenle" : "Yeni SS Kaydı"}
          </div>

          <div className="mt-5 space-y-3">
            <FormInput label="Soru" name="question" value={form.question} onChange={(e) => setForm((p) => ({ ...p, question: e.target.value }))} />

            <textarea
              value={form.answer}
              onChange={(e) => setForm((p) => ({ ...p, answer: e.target.value }))}
              placeholder="Cevap metni..."
              className="form-textarea min-h-[140px]"
            />

            <FormInput label="Kategori" name="category" value={form.category} onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))} />

            <select value={form.targetRole} onChange={(e) => setForm((p) => ({ ...p, targetRole: e.target.value }))} className="form-input">
              <option value="publisher">Yayıncı Paneli</option>
              <option value="manager">Yönetici Paneli</option>
              <option value="all">Tüm Paneller</option>
            </select>

            <select value={form.status} onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))} className="form-input">
              <option>Aktif</option>
              <option>Pasif</option>
              <option>Taslak</option>
            </select>

            <FormInput label="Sıra" type="number" name="sortOrder" value={form.sortOrder} onChange={(e) => setForm((p) => ({ ...p, sortOrder: e.target.value }))} />

            <div className="flex flex-wrap gap-2">
              <ActionButton onClick={handleSaveFaq} disabled={saving}>
                {saving ? "Kaydediliyor..." : editingId ? "Güncelle" : "Yayınla"}
              </ActionButton>

              {editingId && (
                <ActionButton variant="dark" onClick={resetForm}>
                  Vazgeç
                </ActionButton>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

function FeaturedPublishersContent({ currentAdmin }) {
  const emptyForm = {
    name: "",
    username: "",
    tiktokUrl: "",
    imageBoxText: "",
    status: "Aktif",
    sortOrder: 0,
    currentImage: "",
  };

  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [imageFile, setImageFile] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  async function loadRows() {
    try {
      setLoading(true);
      const response = await fetch(API_FEATURED_PUBLISHER_LIST, { cache: "no-store" });
      const data = await response.json();

      if (data.success) {
        setRows(data.publishers || []);
      } else {
        alert(data.message || "Yayıncı listesi alınamadı.");
      }
    } catch (err) {
      console.error(err);
      alert("Yayıncı listesi alınırken bağlantı hatası oluştu.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRows();
  }, []);

  function resetForm() {
    setForm(emptyForm);
    setImageFile(null);
    setEditingId(null);
  }

  function handleEdit(item) {
    setEditingId(item.id);
    setForm({
      name: item.name || "",
      username: item.username || item.about || "",
      tiktokUrl: item.tiktokUrl || "",
      imageBoxText: item.imageBoxText || "",
      status: item.status || "Aktif",
      sortOrder: item.sortOrder || 0,
      currentImage: item.imageUrl || item.image || "",
    });
    setImageFile(null);
    
  }

  async function handleSave() {
    if (!form.name.trim() || !form.username.trim()) {
      alert("Yayıncı adı ve kullanıcı adı zorunludur.");
      return;
    }

    try {
      setSaving(true);

      const payload = new FormData();
      payload.append("id", editingId || "");
      payload.append("name", form.name);
      payload.append("username", form.username);
      payload.append("tiktokUrl", form.tiktokUrl);
      payload.append("imageBoxText", form.imageBoxText);
      payload.append("status", form.status);
      payload.append("sortOrder", form.sortOrder);
      payload.append("currentImage", form.currentImage);
      payload.append("createdBy", currentAdmin?.username || "admin");

      if (imageFile) {
        payload.append("image", imageFile);
      }

      const response = await fetch(API_FEATURED_PUBLISHER_SAVE, {
        method: "POST",
        body: payload,
      });

      const data = await response.json();

      if (!data.success) {
        alert(data.message || "Yayıncı kaydı kaydedilemedi.");
        return;
      }

      resetForm();
      await loadRows();
      alert("Yayıncı kaydı kaydedildi.");
    } catch (err) {
      console.error(err);
      alert("Yayıncı kaydı kaydedilirken bağlantı hatası oluştu.");
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(item) {
    if (!window.confirm(`${item.name} kaydını kaldırmak istiyor musunuz?`)) return;

    try {
      setSaving(true);

      const response = await fetch(API_FEATURED_PUBLISHER_DELETE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      const data = await response.json();

      if (!data.success) {
        alert(data.message || "Yayıncı kaldırılamadı.");
        return;
      }

      await loadRows();
      alert("Yayıncı kaldırıldı.");
    } catch (err) {
      console.error(err);
      alert("Yayıncı kaldırılırken bağlantı hatası oluştu.");
    } finally {
      setSaving(false);
    }
  }

  const activeRows = rows.filter((item) => item.status !== "Silindi");

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="Öne Çıkan Yayıncılar"
        desc="Ana sayfada dönen yayıncı görselleri, kullanıcı adları ve TikTok bağlantıları bu alandan yönetilir."
        action={
          <ActionButton variant="dark" onClick={loadRows}>
            Yenile
          </ActionButton>
        }
      />

      <div className="mb-5 grid gap-4 md:grid-cols-4">
        <StatCard title="Toplam Yayıncı" value={activeRows.length} note="Silinmemiş kayıt" />
        <StatCard title="Ana Carousel" value={Math.min(activeRows.length, 10)} note="İlk 10 kayıt döner" />
        <StatCard title="Tüm Yayıncılar" value={Math.min(activeRows.length, 15)} note="İlk 15 kayıt açılır" />
        <StatCard title="Durum" value={loading ? "Yükleniyor" : "Hazır"} note="API veri durumu" />
      </div>

      <div className="grid gap-5 xl:grid-cols-[1fr_.75fr]">
        <Card className="p-5">
          <div className="mb-4 text-xl font-bold text-white">
            Yayıncı Listesi
          </div>

          <div className="space-y-3">
            {activeRows.length === 0 && <EmptyState text="Henüz yayıncı kaydı bulunmuyor." />}

            {activeRows.map((item) => (
              <div key={item.id} className="rounded-2xl border border-white/10 bg-white/[0.025] p-4">
                <div className="flex items-center gap-4">
                  <div className="h-20 w-24 overflow-hidden rounded-xl border border-yellow-500/20 bg-black">
                    {item.image ? (
                      <img
                        src="/logo-text.png"
                        alt="Wolf Media Ajans"
                        className="h-[310px] w-full rounded-[1.25rem] object-contain"
                      />
                    ) : (
                      <div className="grid h-full w-full place-items-center text-xs text-white/35">
                        Görsel Yok
                      </div>
                    )}
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="truncate text-base font-bold text-white">{item.name}</div>
                    <div className="truncate text-sm text-white/45">@{item.username || item.about}</div>
                    <div className="mt-1 text-xs text-yellow-300">Sıra: {item.sortOrder}</div>
                  </div>

                  <StatusBadge status={item.status || "Aktif"} />
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  <ActionButton variant="dark" onClick={() => handleEdit(item)}>
                    Düzenle
                  </ActionButton>

                  <button
                    type="button"
                    onClick={() => handleDelete(item)}
                    className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-2.5 text-xs font-black text-red-300 transition hover:bg-red-500 hover:text-white"
                  >
                    Kaldır
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-5">
          <div className="text-xl font-bold text-white">
            {editingId ? "Yayıncıyı Düzenle" : "Yeni Yayıncı Ekle"}
          </div>

          <div className="mt-5 space-y-3">
            <FormInput
              label="Yayıncı Adı"
              name="name"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
            />

            <FormInput
              label="TikTok Kullanıcı Adı"
              name="username"
              value={form.username}
              onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))}
            />

            <FormInput
              label="Kare İç Yazı"
              name="imageBoxText"
              value={form.imageBoxText}
              onChange={(e) => setForm((p) => ({ ...p, imageBoxText: e.target.value }))}
            />

            <FormInput
              label="Sıra"
              type="number"
              name="sortOrder"
              value={form.sortOrder}
              onChange={(e) => setForm((p) => ({ ...p, sortOrder: e.target.value }))}
            />

            <select
              value={form.status}
              onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
              className="form-input"
            >
              <option>Aktif</option>
              <option>Pasif</option>
            </select>

            <div>
              <div className="mb-2 text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                Yayıncı Görseli
              </div>
              <input
                type="file"
                accept="image/png,image/jpeg,image/webp"
                onChange={(e) => setImageFile(e.target.files?.[0] || null)}
                className="form-input"
              />
            </div>

            {form.currentImage && (
              <div className="rounded-2xl border border-yellow-500/20 bg-black/30 p-3">
                <div className="mb-2 text-xs text-white/45">Mevcut Görsel</div>
                <img
                  src={`${form.currentImage}?v=${Date.now()}`}
                  alt="Mevcut yayıncı"
                  className="h-28 w-full rounded-xl object-contain"
                />
              </div>
            )}

            <div className="flex flex-wrap gap-2">
              <ActionButton onClick={handleSave} disabled={saving}>
                {saving ? "Kaydediliyor..." : editingId ? "Güncelle" : "Kaydet"}
              </ActionButton>

              {editingId && (
                <ActionButton variant="dark" onClick={resetForm}>
                  Vazgeç
                </ActionButton>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

const tierRewardEmptyForm = {
  id: "",
  tierNo: 1,
  rewardType: "upgrade",
  title: "",
  description: "",
  imageUrl: "",
  buttonText: "",
  buttonUrl: "",
  status: "Aktif",
  sortOrder: 0,
};

const tierRewardTypes = [
  { value: "upgrade", label: "Kademe Yükselme Ödülü" },
  { value: "double_upgrade", label: "2 Kademe Yükselme Ödülü" },
  { value: "protect", label: "Kademe Koruma Ödülü" },
  { value: "drop", label: "Kademe Düşüş Bilgilendirmesi" },
];

function getTierRewardTypeLabel(type) {
  return tierRewardTypes.find((item) => item.value === type)?.label || type;
}

function AdminTierRewardContent({ currentAdmin }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(tierRewardEmptyForm);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  async function loadRows() {
    try {
      setLoading(true);

      const result = await requestJson(API_TIER_REWARD_LIST, {
        cache: "no-store",
      });

      setRows(result.items || []);
    } catch (err) {
      console.error("Kademe ödülleri alınamadı:", err);
      setRows([]);
      alert(err.message || "Kademe ödülleri alınamadı.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRows();
  }, []);

  function resetForm() {
    setEditingId(null);
    setForm(tierRewardEmptyForm);
  }

  function handleEdit(item) {
    setEditingId(item.id);

    setForm({
      id: item.id || "",
      tierNo: item.rewardType === "drop" ? 0 : safeNumber(item.tierNo || item.tier_no) || 1,
      rewardType: item.rewardType || item.reward_type || "upgrade",
      title: item.title || "",
      description: item.description || "",
      imageUrl: item.imageUrl || item.image_url || "",
      buttonText: item.buttonText || item.button_text || "",
      buttonUrl: item.buttonUrl || item.button_url || "",
      status: item.status || "Aktif",
      sortOrder: item.sortOrder || item.sort_order || 0,
    });
  }

  async function handleSaveTierReward() {
    if (!form.title.trim()) {
      alert("Başlık zorunludur.");
      return;
    }

    if (
      form.rewardType !== "drop" &&
      (safeNumber(form.tierNo) < 1 || safeNumber(form.tierNo) > 10)
    ) {
      alert("Kademe 1 ile 10 arasında olmalıdır.");
      return;
    }

    try {
      setSaving(true);

      await requestJson(API_TIER_REWARD_SAVE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingId,
          tierNo: form.rewardType === "drop" ? 0 : safeNumber(form.tierNo),
          rewardType: form.rewardType,
          title: form.title,
          description: form.description,
          imageUrl: form.imageUrl,
          buttonText: form.buttonText,
          buttonUrl: form.buttonUrl,
          status: form.status,
          sortOrder: safeNumber(form.sortOrder),
          createdBy: currentAdmin?.username || "admin",
        }),
      });

      resetForm();
      await loadRows();

      alert("Kademe ödül içeriği kaydedildi.");
    } catch (err) {
      alert(err.message || "Kademe ödül içeriği kaydedilemedi.");
    } finally {
      setSaving(false);
    }
  }

  async function handleDeleteTierReward(item) {
    if (!window.confirm(`${item.title} kaydını kaldırmak istiyor musunuz?`)) return;

    try {
      setSaving(true);

      await requestJson(API_TIER_REWARD_DELETE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      await loadRows();

      alert("Kademe ödül içeriği kaldırıldı.");
    } catch (err) {
      alert(err.message || "Kademe ödül içeriği kaldırılamadı.");
    } finally {
      setSaving(false);
    }
  }

  const activeRows = rows.filter((item) => item.status !== "Silindi");

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="Yayıncı Kademe Ödülleri"
        desc="Yayıncıların güncel ve önceki ay kademelerine göre panelde gösterilecek yükselme ödülü, koruma ödülü ve düşüş bilgilendirmelerini bu ekrandan yönetebilirsiniz."
        action={
          <ActionButton variant="dark" onClick={loadRows}>
            Yenile
          </ActionButton>
        }
      />

      <div className="mb-5 grid gap-4 md:grid-cols-5">
        <StatCard title="Toplam İçerik" value={activeRows.length} note="Silinmemiş kayıt" />
        <StatCard title="Yükselme Ödülü" value={activeRows.filter((item) => (item.rewardType || item.reward_type) === "upgrade").length} note="Kademe yükselme" />
        <StatCard title="2 Kademe Ödülü" value={activeRows.filter((item) => (item.rewardType || item.reward_type) === "double_upgrade").length} note="2 kademe yükselme" />
        <StatCard title="Koruma Ödülü" value={activeRows.filter((item) => (item.rewardType || item.reward_type) === "protect").length} note="Kademe koruma" />
        <StatCard title="Düşüş Bilgisi" value={activeRows.filter((item) => (item.rewardType || item.reward_type) === "drop").length} note="Kademe düşüşü" />
      </div>

      <div className="grid gap-5 xl:grid-cols-[1fr_.75fr]">
        <Card className="p-5">
          <div className="mb-4 text-xl font-bold text-white">
            Tanımlı Kademe İçerikleri
          </div>

          <div className="space-y-3">
            {loading && <EmptyState text="Kademe ödülleri yükleniyor..." />}

            {!loading && activeRows.length === 0 && (
              <EmptyState text="Kademe ödül içeriği bulunmuyor." />
            )}

            {activeRows.map((item) => {
              const rewardType = item.rewardType || item.reward_type;
              const tierNo = item.tierNo || item.tier_no;

              return (
                <div key={item.id} className="rounded-2xl border border-white/10 bg-white/[0.025] p-4">
                  <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <Pill tone="gold">
                          {rewardType === "drop" ? "Kademe Düşüşü" : `Kademe ${tierNo}`}
                        </Pill>
                        <Pill>{getTierRewardTypeLabel(rewardType)}</Pill>
                        <StatusBadge status={item.status || "Aktif"} />
                      </div>

                      <div className="mt-3 text-lg font-black text-white">
                        {item.title}
                      </div>

                      <p className="mt-2 text-sm leading-6 text-white/55">
                        {item.description || "Açıklama bulunmuyor."}
                      </p>

                      {(item.imageUrl || item.image_url) && (
                        <img
                          src={item.imageUrl || item.image_url}
                          alt={item.title}
                          className="mt-3 max-h-44 w-full rounded-2xl border border-yellow-500/20 object-cover"
                        />
                      )}
                    </div>

                    <div className="flex shrink-0 flex-wrap gap-2">
                      <ActionButton variant="dark" onClick={() => handleEdit(item)}>
                        Düzenle
                      </ActionButton>

                      <button
                        type="button"
                        onClick={() => handleDeleteTierReward(item)}
                        className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-2.5 text-xs font-black text-red-300 transition hover:bg-red-500 hover:text-white"
                      >
                        Kaldır
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>

        <Card className="p-5">
          <div className="text-xl font-bold text-white">
            {editingId ? "Kademe İçeriğini Düzenle" : "Yeni Kademe İçeriği"}
          </div>

          <div className="mt-5 space-y-3">
            <label className="block">
              <span className="mb-1.5 block text-xs font-bold text-white/45">
                İçerik Tipi
              </span>

              <select
                value={form.rewardType}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    rewardType: event.target.value,
                    tierNo: event.target.value === "drop" ? 0 : 1,
                  }))
                }
                className="form-input"
              >
                {tierRewardTypes.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </label>

            {form.rewardType !== "drop" && (
              <label className="block">
                <span className="mb-1.5 block text-xs font-bold text-white/45">
                  Kademe
                </span>

                <select
                  value={form.tierNo}
                  onChange={(event) =>
                    setForm((prev) => ({ ...prev, tierNo: event.target.value }))
                  }
                  className="form-input"
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((tierNo) => (
                    <option key={tierNo} value={tierNo}>
                      Kademe {tierNo}
                    </option>
                  ))}
                </select>
              </label>
            )}

            <FormInput
              label="Başlık"
              name="title"
              value={form.title}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, title: event.target.value }))
              }
            />

            <textarea
              value={form.description}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, description: event.target.value }))
              }
              placeholder="Yayıncı panelinde gösterilecek açıklama metni..."
              className="form-textarea min-h-[130px]"
            />

            <FormInput
              label="Görsel URL"
              name="imageUrl"
              value={form.imageUrl}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, imageUrl: event.target.value }))
              }
            />

            <FormInput
              label="Buton Yazısı"
              name="buttonText"
              value={form.buttonText}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, buttonText: event.target.value }))
              }
              placeholder="Detayları Gör"
            />

            <FormInput
              label="Buton Linki"
              name="buttonUrl"
              value={form.buttonUrl}
              onChange={(event) =>
                setForm((prev) => ({ ...prev, buttonUrl: event.target.value }))
              }
              placeholder="https://..."
            />

            <div className="grid gap-3 md:grid-cols-2">
              <label className="block">
                <span className="mb-1.5 block text-xs font-bold text-white/45">
                  Durum
                </span>

                <select
                  value={form.status}
                  onChange={(event) =>
                    setForm((prev) => ({ ...prev, status: event.target.value }))
                  }
                  className="form-input"
                >
                  <option>Aktif</option>
                  <option>Pasif</option>
                </select>
              </label>

              <FormInput
                label="Sıra"
                type="number"
                name="sortOrder"
                value={form.sortOrder}
                onChange={(event) =>
                  setForm((prev) => ({ ...prev, sortOrder: event.target.value }))
                }
              />
            </div>

            <div className="flex flex-wrap gap-2 pt-2">
              <ActionButton onClick={handleSaveTierReward} disabled={saving}>
                {saving ? "Kaydediliyor..." : editingId ? "Güncelle" : "Kaydet"}
              </ActionButton>

              {editingId && (
                <ActionButton variant="dark" onClick={resetForm}>
                  Vazgeç
                </ActionButton>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

function AdminRewardManagementContent({ currentAdmin }) {
  const emptyForm = {
    title: "",
    badgeText: "",
    visualTitle: "",
    visualSub: "",
    desc: "",
    detailTitle: "",
    detailDescription: "",
    rewardText: "",
    targetText: "all",
    targetGroup: "all",
    contentKind: "image",
    imageUrl: "",
    videoUrl: "",
    startDate: "",
    endDate: "",
    accent: "gold",
    status: "Aktif",
  };

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [rewardUploadFile, setRewardUploadFile] = useState(null);
  const [rewardUploadProgressText, setRewardUploadProgressText] = useState("");

  async function loadRewards() {
    try {
      setLoading(true);
      const result = await requestJson(API_REWARD_LIST, { cache: "no-store" });
      setRows(result.rewards || []);
    } catch (err) {
      console.error("Ödül içerikleri alınamadı:", err);
      setRows([]);
      alert(err.message || "Ödül içerikleri alınamadı.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRewards();
  }, []);

  function resetForm() {
    setEditingId(null);
    setForm(emptyForm);
    setRewardUploadFile(null);
    setRewardUploadProgressText("");
  }

  function handleEdit(item) {
    setRewardUploadFile(null);
    setRewardUploadProgressText("");
    setEditingId(item.id);
    setForm({
      title: item.title || "",
      badgeText: item.badgeText || "",
      visualTitle: item.visualTitle || "",
      visualSub: item.visualSub || "",
      desc: item.desc || "",
      detailTitle: item.detailTitle || "",
      detailDescription: item.detailDescription || "",
      rewardText: item.rewardText || "",
      targetText: normalizeTargetGroup(item.targetGroup || item.targetText || "all"),
      targetGroup: normalizeTargetGroup(item.targetGroup || item.targetText || "all"),
      contentKind: item.contentKind || "image",
      imageUrl: item.imageUrl || "",
      videoUrl: item.videoUrl || "",
      startDate: item.startDate || "",
      endDate: item.endDate || "",
      accent: item.accent || "gold",
      status: item.status || "Aktif",
    });
  }

  function handleRewardFileChange(event) {
    const file = event.target.files?.[0] || null;
    setRewardUploadFile(file);
    setRewardUploadProgressText(file ? `${file.name} seçildi` : "");

    if (file?.type?.startsWith("video/")) {
      setForm((prev) => ({ ...prev, contentKind: "video" }));
    }

    if (file?.type?.startsWith("image/")) {
      setForm((prev) => ({ ...prev, contentKind: "image" }));
    }
  }

  async function uploadRewardFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(API_REWARD_UPLOAD, {
      method: "POST",
      body: formData,
    });

    const text = await response.text();
    const result = parseJsonResponse(text);

    if (!response.ok || result.success === false) {
      throw new Error(result.message || "Etkinlik dosyası yüklenemedi.");
    }

    return result.url || result.fileUrl || "";
  }

  async function handleSaveReward() {
    if (!form.title.trim()) {
      alert("Başlık zorunlu.");
      return;
    }

    try {
      setSaving(true);

      let payload = { ...form, targetGroup: normalizeTargetGroup(form.targetGroup || form.targetText), targetText: getTargetGroupLabel(form.targetGroup || form.targetText) };

      if (rewardUploadFile) {
        setRewardUploadProgressText("Dosya yükleniyor...");
        const uploadedUrl = await uploadRewardFile(rewardUploadFile);
        const uploadedIsVideo = rewardUploadFile.type?.startsWith("video/");

        payload = {
          ...payload,
          contentKind: uploadedIsVideo ? "video" : payload.contentKind,
          imageUrl: uploadedIsVideo ? payload.imageUrl : uploadedUrl,
          videoUrl: uploadedIsVideo ? uploadedUrl : payload.videoUrl,
        };

        setRewardUploadProgressText("Dosya yüklendi.");
      }

      await requestJson(API_REWARD_SAVE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingId,
          ...payload,
          createdBy: currentAdmin?.username || "admin",
          createdByRole: "admin",
        }),
      });

      resetForm();
      await loadRewards();
      alert("Ödül içeriği kaydedildi.");
    } catch (err) {
      alert(err.message || "Ödül içeriği kaydedilemedi.");
    } finally {
      setSaving(false);
    }
  }

  async function handleDeleteReward(item) {
    if (!window.confirm(`${item.title} içeriğini kaldırmak istiyor musunuz?`)) return;

    try {
      setSaving(true);

      await requestJson(API_REWARD_DELETE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      await loadRewards();
      alert("Ödül içeriği kaldırıldı.");
    } catch (err) {
      alert(err.message || "Ödül içeriği kaldırılamadı.");
    } finally {
      setSaving(false);
    }
  }

  const activeRows = rows.filter((item) => item.status !== "Silindi");
  const liveRows = activeRows.filter((item) => item.status === "Aktif");

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="Etkinlik / Ödül Yönetimi"
        desc="Yayıncı panelindeki Etkinlikler alanında gösterilecek ödül, yarışma, kampanya, görsel ve video içerikleri bu ekrandan yönetilir."
        action={
          <ActionButton variant="dark" onClick={loadRewards}>
            Yenile
          </ActionButton>
        }
      />

      <div className="mb-5 grid gap-4 md:grid-cols-4">
        <StatCard title="Toplam İçerik" value={activeRows.length} note="Silinmemiş içerik" />
        <StatCard title="Yayındaki İçerik" value={liveRows.length} note="Aktif içerik" />
        <StatCard title="Görsel İçerik" value={activeRows.filter((item) => item.contentKind !== "video").length} note="Görsel duyuru" />
        <StatCard title="Video İçerik" value={activeRows.filter((item) => item.contentKind === "video").length} note="Video duyuru" />
      </div>

      <div className="grid gap-5 xl:grid-cols-[1fr_.75fr]">
        <Card className="p-5">
          <div className="mb-4 flex items-center justify-between gap-3">
            <div>
              <div className="text-xl font-bold text-white">Yayınlanan Ödül / Etkinlikler</div>
              <div className="mt-1 text-sm text-white/45">Belirlenen tarih aralığında yayıncı panelinde görünür.</div>
            </div>

            <span className="rounded-full border border-yellow-500/25 bg-yellow-500/10 px-3 py-1 text-xs font-bold text-yellow-300">
              {loading ? "Yükleniyor" : `${activeRows.length} İçerik`}
            </span>
          </div>

          <div className="space-y-3">
            {activeRows.length === 0 && <EmptyState text="Henüz ödül veya etkinlik içeriği bulunmuyor." />}

            {activeRows.map((item) => (
              <div key={item.id} className="rounded-2xl border border-white/10 bg-white/[0.025] p-4">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-base font-bold text-white">{item.title}</div>
                    <p className="mt-2 text-sm leading-6 text-white/55">
                      {item.desc || "Açıklama yok."}
                    </p>
                  </div>

                  <StatusBadge status={item.status || "Aktif"} />
                </div>

                <div className="mt-4 grid gap-3 md:grid-cols-4">
                  <div className="rounded-xl border border-white/10 bg-black/25 p-3 text-sm text-white/60">
                    Tür: {item.contentKind === "video" ? "Video" : "Görsel"}
                  </div>
                  <div className="rounded-xl border border-white/10 bg-black/25 p-3 text-sm text-white/60">
                    <div className="mb-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white/35">Hedef</div>
                    <TargetGroupBadge value={item.targetGroup || item.targetText} compact />
                  </div>
                  <div className="rounded-xl border border-white/10 bg-black/25 p-3 text-sm text-white/60">
                    Ödül: {item.rewardText || "-"}
                  </div>
                  <div className="rounded-xl border border-white/10 bg-black/25 p-3 text-sm text-white/60">
                    Bitiş: {formatDateForDisplay(item.endDate)}
                  </div>
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  <ActionButton variant="dark" onClick={() => handleEdit(item)}>
                    Düzenle
                  </ActionButton>

                  <button
                    type="button"
                    onClick={() => handleDeleteReward(item)}
                    className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-2.5 text-xs font-black text-red-300 transition hover:bg-red-500 hover:text-white"
                  >
                    Kaldır
                  </button>

                  {(item.imageUrl || item.videoUrl) && (
                    <a
                      href={item.contentKind === "video" ? item.videoUrl : item.imageUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="rounded-xl border border-white/10 bg-white/[0.035] px-4 py-2.5 text-xs font-black text-white/65 hover:text-yellow-300"
                    >
                      İçeriği Aç
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-5">
          <div className="text-xl font-bold text-white">
            {editingId ? "Ödül İçeriğini Düzenle" : "Yeni Ödül / Etkinlik İçeriği"}
          </div>
          <div className="mt-1 text-sm text-white/45">
            Yayıncı panelinde gösterilecek ödül kartı, görsel veya video içeriği oluştur.
          </div>

          <div className="mt-5 space-y-3">
            <FormInput label="Üst Etiket" name="badgeText" value={form.badgeText} onChange={(e) => setForm((p) => ({ ...p, badgeText: e.target.value }))} />
            <FormInput label="Büyük Görsel Başlık" name="visualTitle" value={form.visualTitle} onChange={(e) => setForm((p) => ({ ...p, visualTitle: e.target.value }))} />
            <FormInput label="Alt Başlık / Hedef Yazısı" name="visualSub" value={form.visualSub} onChange={(e) => setForm((p) => ({ ...p, visualSub: e.target.value }))} />
            <FormInput label="Detay Başlığı" name="title" value={form.title} onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))} />
            <FormInput label="Ödül Detayı" name="rewardText" value={form.rewardText} onChange={(e) => setForm((p) => ({ ...p, rewardText: e.target.value }))} />
            <FormSelect
              label="Hedef Kitle"
              name="targetGroup"
              value={form.targetGroup || form.targetText || "all"}
              onChange={(e) =>
                setForm((p) => ({
                  ...p,
                  targetGroup: e.target.value,
                  targetText: getTargetGroupLabel(e.target.value),
                }))
              }
            >
              {TARGET_GROUP_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </FormSelect>

            <select value={form.contentKind} onChange={(e) => setForm((p) => ({ ...p, contentKind: e.target.value }))} className="form-input">
              <option value="image">Görsel İçerik</option>
              <option value="video">Video İçerik</option>
            </select>

            {form.contentKind === "image" ? (
              <FormInput label="Görsel URL" name="imageUrl" value={form.imageUrl} onChange={(e) => setForm((p) => ({ ...p, imageUrl: e.target.value }))} />
            ) : (
              <FormInput label="Video URL / YouTube / MP4" name="videoUrl" value={form.videoUrl} onChange={(e) => setForm((p) => ({ ...p, videoUrl: e.target.value }))} />
            )}

            <label className="block rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4">
              <span className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-yellow-300">
                Etkinlik Videosu / Görseli Yükle
              </span>
              <input
                type="file"
                accept="video/*,image/*"
                onChange={handleRewardFileChange}
                className="block w-full cursor-pointer rounded-xl border border-white/10 bg-black/35 px-4 py-3 text-sm text-white file:mr-4 file:rounded-lg file:border-0 file:bg-yellow-500 file:px-4 file:py-2 file:text-sm file:font-bold file:text-black hover:file:bg-yellow-400"
                disabled={saving}
              />
              <div className="mt-2 text-xs leading-5 text-white/50">
                {rewardUploadProgressText || "Telefon/kamera ile çektiğiniz etkinlik videosunu buradan seçip yükleyebilirsiniz."}
              </div>
              {rewardUploadFile ? (
                <div className="mt-2 text-xs font-semibold text-yellow-200">
                  Seçilen dosya: {rewardUploadFile.name}
                </div>
              ) : null}
            </label>

            <div className="grid gap-3 md:grid-cols-2">
              <FormInput label="Başlangıç Tarihi" type="date" name="startDate" value={form.startDate} onChange={(e) => setForm((p) => ({ ...p, startDate: e.target.value }))} />
              <FormInput label="Bitiş Tarihi" type="date" name="endDate" value={form.endDate} onChange={(e) => setForm((p) => ({ ...p, endDate: e.target.value }))} />
            </div>

            <select value={form.accent} onChange={(e) => setForm((p) => ({ ...p, accent: e.target.value }))} className="form-input">
              <option value="gold">Gold Tema</option>
              <option value="purple">Mor Tema</option>
            </select>

            <select value={form.status} onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))} className="form-input">
              <option>Aktif</option>
              <option>Planlandı</option>
              <option>Pasif</option>
            </select>

            <textarea
              value={form.desc}
              onChange={(e) => setForm((p) => ({ ...p, desc: e.target.value }))}
              placeholder="Kart açıklaması..."
              className="form-textarea min-h-[90px]"
            />

            <textarea
              value={form.detailDescription}
              onChange={(e) => setForm((p) => ({ ...p, detailDescription: e.target.value }))}
              placeholder="Detay açıklaması..."
              className="form-textarea min-h-[120px]"
            />

            <div className="flex flex-wrap gap-2">
              <ActionButton onClick={handleSaveReward} disabled={saving}>
                {saving ? "Kaydediliyor..." : editingId ? "Güncelle" : "Yayınla"}
              </ActionButton>

              {editingId && (
                <ActionButton variant="dark" onClick={resetForm}>
                  Vazgeç
                </ActionButton>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}


function AdminEditorRequestsContent({ currentAdmin }) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [stats, setStats] = useState({ total: 0, pending: 0, in_progress: 0, completed: 0 });
  const [editingRow, setEditingRow] = useState(null);
  const [deliveryInput, setDeliveryInput] = useState("");
  const [editorNoteInput, setEditorNoteInput] = useState("");
  const [savingId, setSavingId] = useState(null);

  const loadRequests = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await fetch(`/api/editadmin-requests-list.php?status=${encodeURIComponent(statusFilter)}&search=${encodeURIComponent(searchQuery)}`, { cache: "no-store" });
      const data = await res.json();
      if (data?.success) {
        setRequests(data.requests || []);
        if (data.stats) setStats(data.stats);
      } else {
        setError(data?.message || "Talepler yüklenemedi.");
      }
    } catch (err) {
      setError("Bağlantı hatası: " + err.message);
    } finally {
      setLoading(false);
    }
  }, [statusFilter, searchQuery]);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  async function handleStatusChange(id, newStatus) {
    try {
      setSavingId(id);
      const res = await fetch("/api/editadmin-request-update.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: newStatus })
      });
      const data = await res.json();
      if (data?.success) {
        setRequests((prev) => prev.map((r) => r.id === id ? { ...r, status: newStatus } : r));
      }
    } catch (err) {
      alert("Durum güncellenemedi: " + err.message);
    } finally {
      setSavingId(null);
    }
  }

  async function handleSaveDetails(id) {
    try {
      setSavingId(id);
      const res = await fetch("/api/editadmin-request-update.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, delivery_link: deliveryInput, editor_note: editorNoteInput })
      });
      const data = await res.json();
      if (data?.success) {
        setRequests((prev) => prev.map((r) => r.id === id ? { ...r, delivery_link: deliveryInput, editor_note: editorNoteInput } : r));
        setEditingRow(null);
      }
    } catch (err) {
      alert("Detaylar kaydedilemedi: " + err.message);
    } finally {
      setSavingId(null);
    }
  }

  async function handleDelete(id, username) {
    if (!window.confirm(`${username || "Yayıncı"} talebini silmek istediğinizden emin misiniz?`)) return;
    try {
      await fetch("/api/editadmin-request-delete.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      setRequests((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      alert("Silme hatası: " + err.message);
    }
  }

  const filtered = requests.filter((item) => {
    if (statusFilter !== "all" && item.status !== statusFilter) return false;
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      const target = `${item.username} ${item.full_name} ${item.phone} ${item.service_name} ${item.notes}`.toLowerCase();
      if (!target.includes(q)) return false;
    }
    return true;
  });

  return (
    <div>
      <SectionHeader
        eyebrow="Prodüksiyon & Destek"
        title="Zakan Bilişim & Editör Desteği Talepleri"
        desc="Yayıncıların yayıncı panelinden oluşturduğu video kurgu, tasarım ve OBS teknoloji talepleri bu alanda görüntülenir ve yönetilir."
        action={
          <ActionButton variant="dark" onClick={loadRequests}>
            Talepleri Yenile
          </ActionButton>
        }
      />

      <div className="mb-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard title="Toplam Talep" value={stats.total || requests.length} note="Gelen tüm kurgu & destek talepleri" />
        <StatCard title="İnceleniyor / Bekleyen" value={stats.pending} note="Henüz işleme alınmamış" danger={stats.pending > 0} />
        <StatCard title="Kurguda / Devam Eden" value={stats.in_progress} note="Zakan ekibinde hazırlanan" />
        <StatCard title="Tamamlanan" value={stats.completed} note="Teslim edilmiş talepler" />
      </div>

      <Card className="overflow-hidden">
        {/* Filtre ve Arama */}
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-white/10 p-4">
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Yayıncı adı, telefon veya hizmet ara..."
              className="h-10 w-72 rounded-xl border border-white/15 bg-black/60 px-3 text-xs text-white outline-none focus:border-yellow-400"
            />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="h-10 rounded-xl border border-white/15 bg-black/60 px-3 text-xs text-white outline-none focus:border-yellow-400 [color-scheme:dark]"
            >
              <option value="all">Tüm Durumlar</option>
              <option value="İnceleniyor">İnceleniyor</option>
              <option value="Kurguda">Kurguda</option>
              <option value="Tamamlandı">Tamamlandı</option>
              <option value="İptal">İptal</option>
            </select>
          </div>
          <div className="text-xs text-white/50">
            Toplam <strong>{filtered.length}</strong> talep listeleniyor
          </div>
        </div>

        {/* Tablo */}
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs border-collapse">
            <thead>
              <tr className="border-b border-white/10 bg-white/[0.03] text-[11px] font-bold uppercase tracking-wider text-white/40">
                <th className="p-3.5">#</th>
                <th className="p-3.5">YAYINCI</th>
                <th className="p-3.5">HİZMET TÜRÜ</th>
                <th className="p-3.5">KAYNAK DOSYA / LİNK</th>
                <th className="p-3.5">İLETİŞİM / WHATSAPP</th>
                <th className="p-3.5">NOTLAR & ÖZEL İSTEK</th>
                <th className="p-3.5">DURUM</th>
                <th className="p-3.5 text-center">İŞLEMLER</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {filtered.map((item, idx) => {
                const cleanPhone = (item.phone || "").replace(/\D/g, "");
                const waLink = cleanPhone ? `https://wa.me/${cleanPhone.startsWith("90") ? cleanPhone : "90" + cleanPhone.replace(/^0/, "")}` : null;

                return (
                  <tr key={item.id} className="hover:bg-white/[0.02] transition">
                    <td className="p-3.5 font-mono text-white/40">{idx + 1}</td>
                    <td className="p-3.5 font-bold text-white whitespace-nowrap">
                      <div>{item.full_name || item.username}</div>
                      <div className="text-[10px] font-mono text-amber-400/80">@{item.username.replace("@", "")}</div>
                    </td>
                    <td className="p-3.5 text-white/90">
                      <div className="font-bold">{item.service_name}</div>
                      {item.sample_ref && <div className="text-[10px] text-white/40">Ref: {item.sample_ref}</div>}
                    </td>
                    <td className="p-3.5">
                      {item.source_file ? (
                        <a
                          href={item.source_file}
                          target="_blank"
                          rel="noreferrer"
                          className="inline-flex items-center gap-1 rounded-lg border border-amber-500/40 bg-amber-500/10 px-2.5 py-1 text-[11px] font-bold text-amber-300 hover:bg-amber-500 hover:text-black transition"
                        >
                          <span>📥</span>
                          <span>Dosyayı İndir</span>
                        </a>
                      ) : item.source_link ? (
                        <a
                          href={item.source_link}
                          target="_blank"
                          rel="noreferrer"
                          className="inline-flex items-center gap-1 rounded-lg border border-cyan-500/40 bg-cyan-500/10 px-2.5 py-1 text-[11px] font-bold text-cyan-300 hover:bg-cyan-500 hover:text-black transition truncate max-w-[160px]"
                        >
                          <span>🔗</span>
                          <span>Linki Aç</span>
                        </a>
                      ) : (
                        <span className="text-white/30">-</span>
                      )}
                    </td>
                    <td className="p-3.5 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <span className="font-mono text-white/80">{item.phone || "-"}</span>
                        {waLink && (
                          <a
                            href={waLink}
                            target="_blank"
                            rel="noreferrer"
                            className="flex h-6 w-6 items-center justify-center rounded-md bg-emerald-600 text-xs text-white hover:bg-emerald-500 transition"
                            title="WhatsApp üzerinden mesaj at"
                          >
                            💬
                          </a>
                        )}
                      </div>
                    </td>
                    <td className="p-3.5 text-white/70 max-w-xs truncate">
                      {item.notes || "-"}
                    </td>
                    <td className="p-3.5">
                      <select
                        value={item.status || "İnceleniyor"}
                        onChange={(e) => handleStatusChange(item.id, e.target.value)}
                        className={`rounded-xl border px-2.5 py-1 text-xs font-bold outline-none transition [color-scheme:dark] ${
                          item.status === "Tamamlandı"
                            ? "border-emerald-500/40 bg-emerald-500/20 text-emerald-300"
                            : item.status === "Kurguda"
                            ? "border-cyan-500/40 bg-cyan-500/20 text-cyan-300"
                            : item.status === "İptal"
                            ? "border-red-500/40 bg-red-500/20 text-red-300"
                            : "border-amber-500/40 bg-amber-500/20 text-amber-300"
                        }`}
                      >
                        <option value="İnceleniyor">İnceleniyor</option>
                        <option value="Kurguda">Kurguda</option>
                        <option value="Tamamlandı">Tamamlandı</option>
                        <option value="İptal">İptal</option>
                      </select>
                    </td>
                    <td className="p-3.5 text-center whitespace-nowrap">
                      <div className="flex items-center justify-center gap-1.5">
                        <button
                          type="button"
                          onClick={() => {
                            setEditingRow(item);
                            setDeliveryInput(item.delivery_link || "");
                            setEditorNoteInput(item.editor_note || "");
                          }}
                          className="rounded-xl border border-white/15 bg-white/5 px-2.5 py-1 text-xs font-bold text-white hover:bg-white/15 transition"
                        >
                          Teslim / Not
                        </button>
                        <button
                          type="button"
                          onClick={() => handleDelete(item.id, item.username)}
                          className="flex h-7 w-7 items-center justify-center rounded-xl border border-red-500/30 bg-red-500/10 text-xs text-red-400 hover:bg-red-500 hover:text-white transition"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}

              {!loading && filtered.length === 0 && (
                <tr>
                  <td colSpan={8} className="p-12 text-center text-sm text-white/40">
                    Henüz editör veya prodüksiyon talebi bulunmuyor.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Teslim / Not Modalı */}
      {editingRow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-3xl border border-white/15 bg-[#101014] p-6 shadow-2xl">
            <h3 className="text-base font-black text-white">Teslimat & Editör Notu</h3>
            <div className="text-xs text-amber-400 mt-0.5">@{editingRow.username} — {editingRow.service_name}</div>

            <div className="mt-4 space-y-3">
              <label className="block">
                <span className="block text-xs font-bold text-white/60 mb-1">Teslim Linki (Drive, WeTransfer veya Video URL)</span>
                <input
                  type="text"
                  value={deliveryInput}
                  onChange={(e) => setDeliveryInput(e.target.value)}
                  placeholder="https://..."
                  className="w-full rounded-xl border border-white/15 bg-black/60 px-3 py-2 text-xs text-white outline-none focus:border-yellow-400"
                />
              </label>

              <label className="block">
                <span className="block text-xs font-bold text-white/60 mb-1">Editör / Prodüksiyon Notu</span>
                <textarea
                  rows={3}
                  value={editorNoteInput}
                  onChange={(e) => setEditorNoteInput(e.target.value)}
                  placeholder="Yayıncıya iletilecek açıklama veya revize bilgisi..."
                  className="w-full rounded-xl border border-white/15 bg-black/60 px-3 py-2 text-xs text-white outline-none focus:border-yellow-400"
                />
              </label>
            </div>

            <div className="mt-5 flex items-center justify-end gap-2">
              <button
                type="button"
                onClick={() => setEditingRow(null)}
                className="rounded-xl border border-white/15 px-4 py-2 text-xs font-bold text-white/60 hover:text-white"
              >
                İptal
              </button>
              <button
                type="button"
                onClick={() => handleSaveDetails(editingRow.id)}
                className="rounded-xl bg-yellow-500 px-5 py-2 text-xs font-black text-black hover:bg-yellow-400 shadow-md"
              >
                Kaydet & İlet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function AdminPasswordRequestsContent({ requests = [], loading, error, onReload }) {
  const pendingCount = requests.filter((item) => item.status === "Bekliyor").length;

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="Şifre Talepleri"
        desc="Yayıncıların login ekranından oluşturduğu şifre yenileme talepleri bu alanda görüntülenir."
        action={
          <ActionButton variant="dark" onClick={onReload}>
            Talepleri Yenile
          </ActionButton>
        }
      />

      <div className="mb-5 grid gap-4 md:grid-cols-3">
        <StatCard title="Toplam Talep" value={requests.length} note="Sisteme gelen tüm talepler" />
        <StatCard title="Bekleyen Talep" value={pendingCount} note="İşlem bekleyen kayıtlar" danger={pendingCount > 0} />
        <StatCard title="Tamamlanan" value={requests.length - pendingCount} note="Kapatılmış talepler" />
      </div>

      <Card className="overflow-hidden">
        <div className="border-b border-white/10 p-4">
          {loading && <div className="text-sm text-white/45">Şifre talepleri yükleniyor...</div>}
          {error && <div className="text-sm text-red-300">{error}</div>}
          {!loading && !error && (
            <div className="text-sm text-white/45">
              Tüm yayıncı şifre talepleri listelenir. Şifre güncelleme işlemi ilgili kullanıcı üzerinden yapılır.
            </div>
          )}
        </div>

        <div className="hidden grid-cols-[1fr_.8fr_.7fr_1fr_.7fr] gap-3 bg-white/[0.035] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid">
          <div>Kullanıcı Adı</div>
          <div>Telefon</div>
          <div>Durum</div>
          <div>Tarih</div>
          <div>Not</div>
        </div>

        {!loading && requests.length === 0 ? (
          <EmptyState text="Şifre talebi bulunmuyor." />
        ) : (
          requests.map((item) => (
            <div
              key={item.id}
              className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-[1fr_.8fr_.7fr_1fr_.7fr]"
            >
              <div className="font-bold text-white">{item.username || "-"}</div>
              <div>{item.phone || "-"}</div>
              <div>
                <StatusBadge status={item.status || "Bekliyor"} />
              </div>
              <div className="text-white/45">{item.created_at || "-"}</div>
              <div className="text-white/45">{item.note || "-"}</div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
}

function AdminMessagesContent({
  messages,
  selectedMessageId,
  setSelectedMessageId,
  reloadMessages,
}) {
  const selectedMessage =
    messages.find((item) => String(item.id) === String(selectedMessageId)) ||
    messages[0] ||
    null;

  return (
    <div>
      <SectionHeader
        eyebrow="Yönetim Paneli"
        title="Yayıncı Mesajları"
        desc="Yayıncılardan gelen mesajlar bu alanda konu ve kişi bazlı görüntülenir."
        action={
          <ActionButton variant="dark" onClick={reloadMessages}>
            Mesajları Yenile
          </ActionButton>
        }
      />

      <div className="grid gap-5 xl:grid-cols-[420px_1fr]">
        <Card className="overflow-hidden">
          <div className="border-b border-white/10 p-4 text-sm font-bold text-white">
            Gelen Mesajlar
          </div>

          {messages.length === 0 ? (
            <EmptyState text="Gelen mesaj bulunmuyor." />
          ) : (
            messages.map((message) => (
              <button
                key={message.id}
                type="button"
                onClick={() => setSelectedMessageId(message.id)}
                className={`block w-full border-t border-white/10 px-5 py-4 text-left transition ${
                  String(selectedMessageId) === String(message.id)
                    ? "bg-yellow-500/10"
                    : "hover:bg-white/[0.035]"
                }`}
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="font-bold text-white">
                    {message.senderName || message.senderUsername || "Yayıncı"}
                  </div>
                  <div className="text-xs text-white/35">{message.created_at || "-"}</div>
                </div>

                <div className="mt-1 text-sm font-bold text-yellow-300">
                  {message.subject || "Konu yok"}
                </div>

                <div className="mt-1 line-clamp-2 text-xs text-white/45">
                  {message.message || "-"}
                </div>
              </button>
            ))
          )}
        </Card>

        <Card className="p-5">
          {selectedMessage ? (
            <>
              <div className="mb-4 rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4">
                <div className="text-xs font-bold uppercase tracking-[0.22em] text-yellow-300">
                  Seçili Mesaj
                </div>
                <div className="mt-2 text-xl font-black text-white">
                  {selectedMessage.subject || "Konu yok"}
                </div>
                <div className="mt-2 text-sm text-white/45">
                  {selectedMessage.senderName || selectedMessage.senderUsername || "Yayıncı"} •{" "}
                  {selectedMessage.created_at || "-"}
                </div>
              </div>

              <div className="whitespace-pre-line text-sm leading-7 text-white/70">
                {selectedMessage.message || "-"}
              </div>
            </>
          ) : (
            <EmptyState text="Görüntülenecek mesaj bulunmuyor." />
          )}
        </Card>
      </div>
    </div>
  );
}

function CommonContent({ eyebrow = "Ortak Alanlar", title, rows = [], desc }) {
  return (
    <div>
      <SectionHeader eyebrow={eyebrow} title={title} desc={desc} action={<ActionButton>Yeni İçerik</ActionButton>} />
      <DataTable columns={["Başlık", "Hedef", "Tür", "Durum", "Görülme"]} rows={rows} renderRow={(row, index) => <div key={`${row.title}-${index}`} className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-5"><div className="font-bold text-white">{row.title}</div><div>{row.target}</div><div>{row.type}</div><div><StatusBadge status={row.status} /></div><div>{row.seen}</div></div>} />
    </div>
  );
}


function ActiveSessionsContent() {
  const [data, setData] = useState({ stats: {}, sessions: [] });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all"); // "all" | "online" | "publisher" | "manager"

  const fetchSessions = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch("/api/active-sessions-list.php");
      const json = await res.json();
      if (json && json.success) {
        setData({
          stats: json.stats || {},
          sessions: json.sessions || [],
        });
      }
    } catch (err) {
      console.error("Sessions fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSessions();
    const interval = setInterval(fetchSessions, 20000); // 20 saniyede bir canlı otomatik yenile
    return () => clearInterval(interval);
  }, [fetchSessions]);

  const filteredSessions = useMemo(() => {
    return (data.sessions || []).filter((s) => {
      if (filter === "online" && !s.is_online) return false;
      if (filter === "publisher" && s.role !== "publisher") return false;
      if (filter === "manager" && s.role === "publisher") return false;

      const q = search.toLowerCase().trim();
      if (!q) return true;
      return (
        s.full_name?.toLowerCase().includes(q) ||
        s.username?.toLowerCase().includes(q) ||
        s.device_type?.toLowerCase().includes(q) ||
        s.ip_address?.toLowerCase().includes(q) ||
        s.role_label?.toLowerCase().includes(q)
      );
    });
  }, [data.sessions, filter, search]);

  const stats = data.stats || {};

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="Giriş Yapanlar & Aktif Oturumlar"
        desc="Sisteme giriş yapan yayıncı, yönetici ve aday takip personellerini canlı takip edin; son görülme, cihaz ve oturum geçmişini inceleyin."
        action={
          <ActionButton onClick={fetchSessions}>
            {loading ? "Yenileniyor..." : "🔄 Canlı Yenile"}
          </ActionButton>
        }
      />

      {/* 🚀 4 CANLI İSTATİSTİK KARTI */}
      <div className="mb-4 grid gap-3 grid-cols-2 lg:grid-cols-4">
        <div className="rounded-2xl border border-emerald-500/40 bg-emerald-950/20 p-4 shadow-sm backdrop-blur-md">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-emerald-300">Şu An Sitede (Canlı)</span>
            <span className="inline-flex items-center gap-1 rounded-md border border-emerald-400/40 bg-emerald-500/20 px-2 py-0.5 text-[10px] font-black text-emerald-200 animate-pulse">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400"></span> CANLI
            </span>
          </div>
          <div className="mt-2 text-3xl font-black text-emerald-400">{stats.online_now || 0}</div>
          <div className="text-[11px] font-medium text-emerald-200/70 truncate">Aktif gezinen kullanıcılar</div>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-white/80">Bugün Giriş Yapanlar</span>
            <span className="rounded-md border border-white/10 bg-white/10 px-2 py-0.5 text-[10px] font-black text-white">
              Bugün
            </span>
          </div>
          <div className="mt-2 text-3xl font-black text-white">{stats.today_logins || 0}</div>
          <div className="text-[11px] font-medium text-white/60 truncate">Giriş yapan tekil kişi</div>
        </div>

        <div className="rounded-2xl border border-purple-500/30 bg-purple-950/20 p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-purple-300">Yayıncı Girişleri</span>
            <span className="rounded-md border border-purple-400/30 bg-purple-500/20 px-2 py-0.5 text-[10px] font-black text-purple-200">
              Yayıncı
            </span>
          </div>
          <div className="mt-2 text-3xl font-black text-purple-400">{stats.publisher_count || 0}</div>
          <div className="text-[11px] font-medium text-purple-200/70 truncate">Takip edilen yayıncı</div>
        </div>

        <div className="rounded-2xl border border-amber-500/30 bg-amber-950/20 p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-amber-300">Yönetici & Aday Takip</span>
            <span className="rounded-md border border-amber-400/30 bg-amber-500/20 px-2 py-0.5 text-[10px] font-black text-amber-200">
              Ekip
            </span>
          </div>
          <div className="mt-2 text-3xl font-black text-amber-400">{stats.manager_count || 0}</div>
          <div className="text-[11px] font-medium text-amber-200/70 truncate">Yönetici & Aday Takip ekibi</div>
        </div>
      </div>

      <Card className="overflow-hidden">
        {/* Üst Filtre Sekmeleri & Arama */}
        <div className="border-b border-white/10 p-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="inline-flex p-1 rounded-2xl bg-white/[0.04] border border-white/10 gap-1 flex-wrap">
            <button
              type="button"
              onClick={() => setFilter("all")}
              className={`px-3 py-1.5 rounded-xl text-xs font-bold transition ${
                filter === "all"
                  ? "bg-yellow-500 text-black shadow-sm font-black"
                  : "text-white/60 hover:text-white hover:bg-white/[0.05]"
              }`}
            >
              👥 Tüm Girişler ({data.sessions?.length || 0})
            </button>
            <button
              type="button"
              onClick={() => setFilter("online")}
              className={`px-3 py-1.5 rounded-xl text-xs font-bold transition flex items-center gap-1.5 ${
                filter === "online"
                  ? "bg-emerald-500 text-black shadow-sm font-black"
                  : "text-white/60 hover:text-white hover:bg-white/[0.05]"
              }`}
            >
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse"></span>
              <span>Canlı Sitede ({stats.online_now || 0})</span>
            </button>
            <button
              type="button"
              onClick={() => setFilter("publisher")}
              className={`px-3 py-1.5 rounded-xl text-xs font-bold transition ${
                filter === "publisher"
                  ? "bg-purple-500 text-white shadow-sm font-black"
                  : "text-white/60 hover:text-white hover:bg-white/[0.05]"
              }`}
            >
              🎬 Yayıncılar ({stats.publisher_count || 0})
            </button>
            <button
              type="button"
              onClick={() => setFilter("manager")}
              className={`px-3 py-1.5 rounded-xl text-xs font-bold transition ${
                filter === "manager"
                  ? "bg-amber-500 text-black shadow-sm font-black"
                  : "text-white/60 hover:text-white hover:bg-white/[0.05]"
              }`}
            >
              👔 Yöneticiler ({stats.manager_count || 0})
            </button>
          </div>

          <div className="flex-1 max-w-md">
            <SearchBox
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Kullanıcı adı, isim, cihaz veya IP ara..."
            />
          </div>
        </div>

        {/* Tablo Başlıkları */}
        <div className="hidden grid-cols-[1.3fr_1fr_1fr_1.3fr_1.1fr_.9fr_.7fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid">
          <div>Kullanıcı (Ad Soyad)</div>
          <div>Kullanıcı Adı</div>
          <div>Rol / Görev</div>
          <div>Canlı Durum / Son Görülme</div>
          <div>Cihaz & Platform</div>
          <div>IP Adresi</div>
          <div>Toplam Giriş</div>
        </div>

        {/* Tablo Satırları */}
        {loading && (data.sessions || []).length === 0 ? (
          <div className="p-8 text-center text-white/60 font-medium">Oturumlar yükleniyor...</div>
        ) : filteredSessions.length === 0 ? (
          <EmptyState text="Arama kriterine uygun oturum kaydı bulunamadı." />
        ) : (
          filteredSessions.map((session) => (
            <div
              key={session.id}
              className={`grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/70 hover:bg-white/[0.02] xl:grid-cols-[1.3fr_1fr_1fr_1.3fr_1.1fr_.9fr_.7fr] items-center ${
                session.is_online ? "bg-emerald-500/[0.03]" : ""
              }`}
            >
              <div className="font-bold text-white flex items-center gap-2">
                <span>{session.role === "publisher" ? "🎬" : session.role === "scout" ? "🎯" : "👔"}</span>
                <span className="truncate">{session.full_name || session.username}</span>
              </div>
              <div className="font-mono text-xs text-white/80 truncate">@{session.username}</div>
              <div>
                <span
                  className={`inline-flex items-center px-2 py-0.5 rounded-lg border text-[11px] font-bold ${
                    session.role === "publisher"
                      ? "border-purple-500/30 bg-purple-500/10 text-purple-300"
                      : session.role === "scout"
                      ? "border-indigo-500/30 bg-indigo-500/10 text-indigo-300"
                      : "border-amber-500/30 bg-amber-500/10 text-amber-300"
                  }`}
                >
                  {session.role_label}
                </span>
              </div>
              <div>
                {session.is_online ? (
                  <span className="inline-flex items-center gap-1.5 rounded-xl border border-emerald-500/40 bg-emerald-500/20 px-2.5 py-1 text-xs font-black text-emerald-300 shadow-xs">
                    <span className="h-2 w-2 rounded-full bg-emerald-400 animate-ping"></span>
                    <span>🟢 Şu An Sitede</span>
                  </span>
                ) : (
                  <span className="text-xs text-white/60 font-medium">
                    🕒 {session.time_label}
                  </span>
                )}
              </div>
              <div className="text-xs text-white/80 truncate flex items-center gap-1">
                <span>{session.device_type}</span>
              </div>
              <div className="font-mono text-xs text-white/50">{session.ip_address}</div>
              <div>
                <span className="inline-flex items-center px-2 py-0.5 rounded-md border border-white/10 bg-white/5 font-mono text-xs font-bold text-yellow-300">
                  {session.total_logins} kez
                </span>
              </div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
}


function SystemContent({ eyebrow = "Diğer Ayarlar", title, desc = "Bu alanda sistem bazlı genel ayarlar, onaylar ve operasyonel kontroller yönetilir." }) {
  return (
    <div>
      <SectionHeader eyebrow={eyebrow} title={title} desc={desc} action={<ActionButton>Ayarları Kaydet</ActionButton>} />
      <div className="grid gap-4 xl:grid-cols-3">{["Rol Yetkileri", "Bildirim Şablonları", "Onay Akışları", "Sistem Logları", "Modül Görünürlüğü", "Güvenlik Ayarları"].map((item) => <Card key={item} className="p-5"><div className="h-[2px] w-10 rounded-full bg-yellow-400/70" /><div className="mt-4 text-lg font-black text-white">{item}</div><p className="mt-2 text-sm leading-6 text-white/45">Admin tarafından yönetilecek ayar alanı.</p></Card>)}</div>
    </div>
  );
}


const GIFT_TARGET_POINTS = {
  protect: 1,
  upgrade: 2,
  premium: 3,
};

const GIFT_TARGET_LABELS = {
  protect: "Kademeni Koru",
  upgrade: "Hediye Seviyeni Artır",
  premium: "Premium Hediye Hedefi",
};

// Hediye artık yalnızca puan payına göre değil, yayıncının tahmini getirisine göre de kontrol edilir.
// Amaç: ödül motive etsin, fakat ajansın tahmini kazanımını tüketmesin.
const GIFT_ESTIMATED_AGENCY_RATE = 0.06;

const GIFT_MAX_REVENUE_RATIO = {
  protect: 0.40,
  upgrade: 0.60,
  premium: 0.80,
};

const GIFT_MAX_DIAMOND_RATIO = {
  protect: 0.01,
  upgrade: 0.02,
  premium: 0.04,
};

function getTierNoFromDiamonds(value) {
  const tier = getPublisherTierInfo({}, safeNumber(value));
  return Math.max(1, Math.min(10, safeNumber(tier.tierNo) || 1));
}

function getGiftMetricFromRows(rows = [], hiddenId, keys = []) {
  const found = (rows || []).find((item) => String(getPerformanceHiddenId(item)) === String(hiddenId));
  if (!found) return 0;
  return getSummaryNumber(found, keys);
}

function getGiftLiveDays(performanceData, hiddenId) {
  const dailyRows = performanceData?.publisherDaily || performanceData?.dailyByPublisher || [];
  const publisherDaily = dailyRows.filter((item) => String(getPerformanceHiddenId(item)) === String(hiddenId));

  if (publisherDaily.length > 0) {
    return new Set(
      publisherDaily
        .filter((item) =>
          safeNumber(item.liveCount || item.live_count) > 0 ||
          safeNumber(item.liveSeconds || item.live_seconds || item.totalLiveSeconds || item.total_live_seconds) > 0 ||
          safeNumber(item.diamonds || item.totalDiamonds || item.total_diamonds) > 0
        )
        .map((item) => String(item.report_date || item.reportDate || item.date || "").slice(0, 10))
        .filter(Boolean)
    ).size;
  }

  const rows = performanceData?.publishers || [];
  return getGiftMetricFromRows(rows, hiddenId, [
    "activeDays",
    "liveDays",
    "validLiveDays",
    "totalLiveDays",
    "total_live_days",
    "totalLiveCount",
    "liveCount",
    "total_live_count",
  ]);
}

function getGiftPublisherMetrics(performanceData, hiddenId) {
  const rows = performanceData?.publishers || [];
  const diamonds = getGiftMetricFromRows(rows, hiddenId, ["totalDiamonds", "total_diamonds", "diamonds", "elmas"]);
  const seconds = getGiftMetricFromRows(rows, hiddenId, ["totalLiveSeconds", "total_live_seconds", "liveSeconds", "live_seconds"]);
  const hours = secondsToGiftHours(seconds);
  const liveDays = getGiftLiveDays(performanceData, hiddenId);

  return { diamonds, hours, liveDays };
}

function secondsToGiftHours(seconds) {
  return Math.round((safeNumber(seconds) / 3600) * 10) / 10;
}

function resolveGiftRewardType({ previousTierNo, currentTierNo, currentDiamonds, currentHours, currentDays }) {
  const baseEligible = safeNumber(currentDiamonds) > 0 && safeNumber(currentHours) >= 15 && safeNumber(currentDays) >= 7;
  if (!baseEligible) return null;

  if (previousTierNo >= 10 && currentTierNo >= 10) return "premium";
  if (currentTierNo >= previousTierNo + 2) return "premium";
  if (currentTierNo > previousTierNo) return "upgrade";
  if (currentTierNo === previousTierNo) return "protect";
  return null;
}


function getGiftCampaignMonthRange(periodMonth) {
  const match = String(periodMonth || "").match(/^(\d{4})-(\d{2})$/);
  const today = new Date();
  const year = match ? Number(match[1]) : today.getFullYear();
  const monthIndex = match ? Number(match[2]) - 1 : today.getMonth();
  const start = new Date(year, monthIndex, 1);
  const end = new Date(year, monthIndex + 1, 0);

  return {
    start: toInputDate(start),
    end: toInputDate(end),
  };
}

function getGiftCampaignPreviousMonthRange(periodMonth) {
  const match = String(periodMonth || "").match(/^(\d{4})-(\d{2})$/);
  const today = new Date();
  const year = match ? Number(match[1]) : today.getFullYear();
  const monthIndex = match ? Number(match[2]) - 1 : today.getMonth();
  const start = new Date(year, monthIndex - 1, 1);
  const end = new Date(year, monthIndex, 0);

  return {
    start: toInputDate(start),
    end: toInputDate(end),
  };
}

function uniqueGiftHiddenIds(publisherRows = []) {
  return [
    ...new Set(
      (publisherRows || [])
        .map((publisher) => getPublisherHiddenId(publisher))
        .filter((hiddenId) => hiddenId && hiddenId !== "-")
    ),
  ];
}

function chunkGiftHiddenIds(hiddenIds = [], size = 25) {
  const chunks = [];
  for (let index = 0; index < hiddenIds.length; index += size) {
    chunks.push(hiddenIds.slice(index, index + size));
  }
  return chunks;
}

function mergeGiftPerformanceResults(results = []) {
  const merged = {
    success: true,
    summary: {},
    daily: [],
    publishers: [],
    publisherDaily: [],
    lastSeven: { rows: [] },
  };

  const dailyMap = {};

  results.forEach((result) => {
    const summary = result?.summary || {};
    merged.summary.totalLiveCount = safeNumber(merged.summary.totalLiveCount) + safeNumber(summary.totalLiveCount || summary.totalPublishCount || summary.total_live_count);
    merged.summary.totalLiveSeconds = safeNumber(merged.summary.totalLiveSeconds) + safeNumber(summary.totalLiveSeconds || summary.total_live_seconds);
    merged.summary.totalDiamonds = safeNumber(merged.summary.totalDiamonds) + safeNumber(summary.totalDiamonds || summary.total_diamonds);

    (result?.publishers || []).forEach((item) => merged.publishers.push(item));
    (result?.publisherDaily || result?.dailyByPublisher || []).forEach((item) => merged.publisherDaily.push(item));
    (result?.lastSeven?.rows || []).forEach((item) => merged.lastSeven.rows.push(item));

    (result?.daily || []).forEach((item) => {
      const date = String(item.report_date || item.reportDate || item.date || "").slice(0, 10);
      if (!date) return;
      if (!dailyMap[date]) {
        dailyMap[date] = { ...item, report_date: date, liveCount: 0, liveSeconds: 0, diamonds: 0 };
      }
      dailyMap[date].liveCount = safeNumber(dailyMap[date].liveCount) + safeNumber(item.liveCount || item.live_count || item.totalLiveCount || item.total_live_count);
      dailyMap[date].liveSeconds = safeNumber(dailyMap[date].liveSeconds) + safeNumber(item.liveSeconds || item.live_seconds || item.totalLiveSeconds || item.total_live_seconds);
      dailyMap[date].diamonds = safeNumber(dailyMap[date].diamonds) + safeNumber(item.diamonds || item.totalDiamonds || item.total_diamonds);
    });
  });

  merged.daily = Object.values(dailyMap).sort((a, b) => String(a.report_date).localeCompare(String(b.report_date)));
  return merged;
}

function normalizeGiftSinglePerformanceResult(result, hiddenId) {
  if (Array.isArray(result?.publishers)) return result;

  const summary = result?.summary || {};
  const daily = Array.isArray(result?.daily) ? result.daily : [];

  return {
    ...result,
    publishers: [
      {
        hiddenId,
        hidden_id: hiddenId,
        totalDiamonds: safeNumber(summary.totalDiamonds || summary.total_diamonds || summary.diamonds),
        totalLiveSeconds: safeNumber(summary.totalLiveSeconds || summary.total_live_seconds),
        totalLiveCount: safeNumber(summary.totalLiveCount || summary.total_live_count),
      },
    ],
    daily: daily.map((item) => ({
      ...item,
      hiddenId,
      hidden_id: hiddenId,
    })),
  };
}

async function fetchGiftPerformanceForSingleHiddenId(hiddenId, range) {
  const url = `${API_ADMIN_PERFORMANCE}?hiddenIds=${encodeURIComponent(hiddenId)}&startDate=${range.start}&endDate=${range.end}`;
  const result = await requestJson(url, { cache: "no-store" });
  return normalizeGiftSinglePerformanceResult(result, hiddenId);
}

async function fetchGiftPerformanceForRange(hiddenIds = [], range) {
  const cleanHiddenIds = uniqueGiftHiddenIds(hiddenIds.map((hiddenId) => ({ hiddenId })));

  if (cleanHiddenIds.length === 0) {
    throw new Error("Hesaplama için geçerli Hidden ID bulunamadı.");
  }

  const chunks = chunkGiftHiddenIds(cleanHiddenIds, 10);
  const results = [];
  const failedHiddenIds = [];

  for (const chunk of chunks) {
    const url = `${API_ADMIN_PERFORMANCE}?hiddenIds=${encodeURIComponent(chunk.join(","))}&startDate=${range.start}&endDate=${range.end}`;

    try {
      // eslint-disable-next-line no-await-in-loop
      const result = await requestJson(url, { cache: "no-store" });
      results.push(result);
    } catch (chunkError) {
      // Bazı sunucularda toplu hiddenIds isteği boş cevap döndürebiliyor.
      // Bu durumda aynı parçayı tek tek çekiyoruz; çalışan kayıtlar yine hesaplamaya girer.
      for (const hiddenId of chunk) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const singleResult = await fetchGiftPerformanceForSingleHiddenId(hiddenId, range);
          results.push(singleResult);
        } catch {
          failedHiddenIds.push(hiddenId);
        }
      }
    }
  }

  if (results.length === 0) {
    throw new Error("Performans API cevap vermedi. Hidden ID kayıtları tek tek sorgulandı ama geçerli veri alınamadı.");
  }

  const merged = mergeGiftPerformanceResults(results);
  merged.failedHiddenIds = failedHiddenIds;
  return merged;
}


function isGiftPublisherEligibleStatus(publisher = {}) {
  const statusText = String(
    publisher.status ||
      publisher.durum ||
      publisher.accountStatus ||
      publisher.account_status ||
      publisher.raw?.status ||
      publisher.raw?.durum ||
      "Aktif"
  ).toLowerCase();

  const passiveWords = [
    "pasif",
    "inactive",
    "silindi",
    "deleted",
    "ayrıldı",
    "ayrildi",
    "ajanstan ayrıldı",
    "ajanstan ayrildi",
    "ayrılan",
    "ayrilan",
    "kapalı",
    "kapali",
  ];

  return !passiveWords.some((word) => statusText.includes(word));
}

function normalizeAgencyTrackingStatus(value) {
  const text = String(value || "Aktif").toLowerCase().trim();
  return text.includes("pasif") || text.includes("passive") || text.includes("inactive") ? "Pasif" : "Aktif";
}

function getPublisherAgencyTrackingStatus(publisher = {}) {
  return normalizeAgencyTrackingStatus(
    publisher.agencyTrackingStatus ||
      publisher.agency_tracking_status ||
      publisher.agencyTracking ||
      publisher.agency_tracking ||
      publisher.raw?.agencyTrackingStatus ||
      publisher.raw?.agency_tracking_status ||
      publisher.raw?.agencyTracking ||
      publisher.raw?.agency_tracking ||
      "Aktif"
  );
}

function isAgencyTrackingActive(publisher = {}) {
  return getPublisherAgencyTrackingStatus(publisher) === "Aktif";
}

function getGiftRowAgencyTrackingStatus(row = {}) {
  return normalizeAgencyTrackingStatus(row.agencyTrackingStatus || row.agency_tracking_status || row.publisherAgencyTrackingStatus || row.publisher_agency_tracking_status || "Aktif");
}

function getGiftRowKey(row = {}, index = 0) {
  return String(row.id || row.winnerId || row.winner_id || row.hiddenId || row.hidden_id || row.publisherUsername || row.publisher_username || index);
}

function getGiftRowRewardType(row = {}) {
  return String(row.rewardType || row.reward_type || "").trim();
}

function getGiftRowManager(row = {}) {
  return String(row.managerUsername || row.manager_username || "").trim();
}

function getGiftRowStatus(row = {}) {
  return String(row.deliveryStatus || row.delivery_status || row.status || "Taslak").trim();
}

function getGiftRowFinalAmount(row = {}) {
  return safeNumber(row.finalGiftAmount || row.final_gift_amount || row.giftAmount || row.gift_amount);
}

function getGiftRowDiamonds(row = {}) {
  return safeNumber(row.currentDiamonds || row.current_diamonds || row.diamonds || row.totalDiamonds || row.total_diamonds);
}

function getGiftRowRawAmount(row = {}) {
  return safeNumber(row.rawGiftAmount || row.raw_gift_amount || row.giftAmountRaw || row.gift_amount_raw || row.finalGiftAmount || row.final_gift_amount || row.giftAmount || row.gift_amount);
}

function getGiftRevenueRatio(row = {}) {
  const rewardType = getGiftRowRewardType(row) || "protect";
  return safeNumber(row.maxRevenueRatio || row.max_revenue_ratio || GIFT_MAX_REVENUE_RATIO[rewardType] || 0);
}

function getGiftDiamondRatio(row = {}) {
  const rewardType = getGiftRowRewardType(row) || "protect";
  return safeNumber(row.maxDiamondRatio || row.max_diamond_ratio || GIFT_MAX_DIAMOND_RATIO[rewardType] || 0);
}

function getGiftEstimatedAgencyRevenue(row = {}) {
  const stored = row.estimatedAgencyRevenue || row.estimated_agency_revenue;
  if (stored !== undefined && stored !== null && stored !== "") return safeNumber(stored);
  return getGiftRowDiamonds(row) * GIFT_ESTIMATED_AGENCY_RATE;
}

function getGiftRevenueLimit(row = {}) {
  const stored = row.revenueGiftLimit || row.revenue_gift_limit;
  if (stored !== undefined && stored !== null && stored !== "") return safeNumber(stored);
  return getGiftEstimatedAgencyRevenue(row) * getGiftRevenueRatio(row);
}

function getGiftDiamondLimit(row = {}) {
  const stored = row.diamondGiftLimit || row.diamond_gift_limit;
  if (stored !== undefined && stored !== null && stored !== "") return safeNumber(stored);
  return getGiftRowDiamonds(row) * getGiftDiamondRatio(row);
}

function getGiftNetAfterGift(row = {}) {
  return getGiftEstimatedAgencyRevenue(row) - getGiftRowFinalAmount(row);
}

function getGiftGiftToRevenuePercent(row = {}) {
  const revenue = getGiftEstimatedAgencyRevenue(row);
  if (revenue <= 0) return 0;
  return (getGiftRowFinalAmount(row) / revenue) * 100;
}

function getGiftRiskStatus(row = {}) {
  if (row.isManualGift || row.is_manual_gift) return "Manuel";
  const raw = getGiftRowRawAmount(row);
  const final = getGiftRowFinalAmount(row);
  if (raw > 0 && final < raw) return "Kırpıldı";
  const ratio = getGiftGiftToRevenuePercent(row);
  if (ratio >= 80) return "Yüksek";
  if (ratio >= 60) return "Kontrol";
  return "Güvenli";
}

function applyGiftSafetyLimits(row = {}, rawGiftAmount = 0) {
  const rewardType = getGiftRowRewardType(row) || row.rewardType || "protect";
  const currentDiamonds = getGiftRowDiamonds(row);
  const estimatedAgencyRevenue = currentDiamonds * GIFT_ESTIMATED_AGENCY_RATE;
  const revenueGiftLimit = estimatedAgencyRevenue * safeNumber(GIFT_MAX_REVENUE_RATIO[rewardType] || 0);
  const diamondGiftLimit = currentDiamonds * safeNumber(GIFT_MAX_DIAMOND_RATIO[rewardType] || 0);
  const finalGiftAmount = Math.min(safeNumber(rawGiftAmount), revenueGiftLimit, diamondGiftLimit);

  return {
    estimatedAgencyRate: GIFT_ESTIMATED_AGENCY_RATE,
    maxRevenueRatio: GIFT_MAX_REVENUE_RATIO[rewardType] || 0,
    maxDiamondRatio: GIFT_MAX_DIAMOND_RATIO[rewardType] || 0,
    estimatedAgencyRevenue,
    revenueGiftLimit,
    diamondGiftLimit,
    cappedGiftAmount: finalGiftAmount,
    finalGiftAmount,
    giftRevenuePercent: estimatedAgencyRevenue > 0 ? (finalGiftAmount / estimatedAgencyRevenue) * 100 : 0,
    netAfterGift: estimatedAgencyRevenue - finalGiftAmount,
    riskStatus: finalGiftAmount < safeNumber(rawGiftAmount) ? "Kırpıldı" : "Güvenli",
  };
}

function enforceGiftBudgetCeiling(rows = [], budgetAmount = 0) {
  const budget = safeNumber(budgetAmount);
  const total = (rows || []).reduce((sum, row) => sum + getGiftRowFinalAmount(row), 0);

  if (budget <= 0 || total <= budget || total <= 0) {
    return rows;
  }

  const factor = budget / total;

  return (rows || []).map((row) => {
    const currentFinal = getGiftRowFinalAmount(row);
    const cappedFinal = currentFinal * factor;
    const estimatedAgencyRevenue = getGiftEstimatedAgencyRevenue(row);

    return {
      ...row,
      finalGiftAmount: cappedFinal,
      final_gift_amount: cappedFinal,
      budgetCapped: true,
      budget_capped: true,
      giftRevenuePercent: estimatedAgencyRevenue > 0 ? (cappedFinal / estimatedAgencyRevenue) * 100 : 0,
      netAfterGift: estimatedAgencyRevenue - cappedFinal,
      riskStatus: "Bütçe Kırpıldı",
    };
  });
}

function applyManualGiftEditsToRows(rows = [], manualGiftEdits = {}) {
  return (rows || []).map((row, index) => {
    const rowKey = getGiftRowKey(row, index);
    const manualValue = manualGiftEdits[rowKey];
    if (manualValue === undefined || manualValue === null || manualValue === "") return row;

    const amount = Math.max(0, safeNumber(manualValue));
    return {
      ...row,
      finalGiftAmount: amount,
      final_gift_amount: amount,
      manualGiftAmount: amount,
      isManualGift: true,
    };
  });
}

function buildGiftStats(rows = []) {
  const stats = {
    total: rows.length,
    protect: 0,
    upgrade: 0,
    premium: 0,
    published: 0,
    draft: 0,
    sent: 0,
    totalGift: 0,
    totalDiamonds: 0,
    tierUpOne: 0,
    tierUpTwo: 0,
  };

  (rows || []).forEach((row) => {
    const rewardType = getGiftRowRewardType(row);
    const previousTier = safeNumber(row.previousTierNo || row.previous_tier_no);
    const currentTier = safeNumber(row.currentTierNo || row.current_tier_no);
    const status = getGiftRowStatus(row).toLowerCase();

    if (rewardType === "protect") stats.protect += 1;
    if (rewardType === "upgrade") stats.upgrade += 1;
    if (rewardType === "premium") stats.premium += 1;
    if (currentTier > previousTier) stats.tierUpOne += 1;
    if (currentTier >= previousTier + 2) stats.tierUpTwo += 1;
    if (status.includes("publish")) stats.published += 1;
    if (status.includes("draft") || status.includes("taslak")) stats.draft += 1;
    if (status.includes("sent") || status.includes("gönder") || status.includes("gonder")) stats.sent += 1;

    stats.totalGift += getGiftRowFinalAmount(row);
    stats.totalDiamonds += getGiftRowDiamonds(row);
  });

  return stats;
}

function getUniqueGiftFilterOptions(rows = [], getValue) {
  return [...new Set((rows || []).map(getValue).filter((item) => item !== undefined && item !== null && String(item).trim() !== ""))]
    .sort((a, b) => String(a).localeCompare(String(b), "tr"));
}

function giftRowMatchesColumnFilters(row = {}, filters = {}, managerNameMap = {}) {
  const publisherText = `${row.publisherName || row.publisher_name || ""} ${row.publisherUsername || row.publisher_username || ""} ${row.hiddenId || row.hidden_id || ""}`.toLowerCase();
  const publisherFilter = String(filters.publisher || "").toLowerCase().trim();
  if (publisherFilter && !publisherText.includes(publisherFilter)) return false;

  const managerValue = getGiftRowManager(row);
  if (filters.manager && managerValue !== filters.manager) return false;

  if (filters.agencyTracking && getGiftRowAgencyTrackingStatus(row) !== filters.agencyTracking) return false;

  const rewardType = getGiftRowRewardType(row);
  if (filters.rewardType && rewardType !== filters.rewardType) return false;

  const previousTier = String(row.previousTierNo || row.previous_tier_no || "");
  if (filters.previousTier && previousTier !== String(filters.previousTier)) return false;

  const currentTier = String(row.currentTierNo || row.current_tier_no || "");
  if (filters.currentTier && currentTier !== String(filters.currentTier)) return false;

  const targetTier = String(row.targetTierNo || row.target_tier_no || "");
  if (filters.targetTier && targetTier !== String(filters.targetTier)) return false;

  const pointFilter = String(filters.point || "").trim();
  const rowPoint = safeNumber(row.rewardPoint || row.reward_point).toFixed(2);
  if (pointFilter && !rowPoint.includes(pointFilter)) return false;

  const giftFilter = String(filters.gift || "").trim();
  if (giftFilter && !String(getGiftRowFinalAmount(row)).includes(giftFilter)) return false;

  const diamondMin = safeNumber(filters.currentDiamondsMin || 0);
  if (diamondMin > 0 && getGiftRowDiamonds(row) < diamondMin) return false;

  if (filters.status && getGiftRowStatus(row) !== filters.status) return false;

  return true;
}

function exportGiftRowsToExcel(rows = [], periodMonth = "", summary = {}) {
  const escapeHtml = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

  const headers = [
    "Yayıncı",
    "Kullanıcı Adı",
    "Hidden ID",
    "Yönetici",
    "Ajans Takibi",
    "Hedef",
    "Önceki Kademe",
    "Bu Ay Kademe",
    "Hedef Kademe",
    "Bu Ay Elmas",
    "Tahmini Ajans Getirisi",
    "Ham Hediye",
    "Getiri Limiti",
    "Elmas Limiti",
    "Puan",
    "Net Hediye Elmas",
    "Hediye / Getiri %",
    "Net Kalan",
    "Risk",
    "Durum",
  ];

  const bodyRows = (rows || []).map((row) => [
    row.publisherName || row.publisher_name || "",
    row.publisherUsername || row.publisher_username || "",
    row.hiddenId || row.hidden_id || "",
    row.managerDisplayName || row.managerUsername || row.manager_username || "",
    getGiftRowAgencyTrackingStatus(row),
    GIFT_TARGET_LABELS[getGiftRowRewardType(row)] || row.rewardLabel || row.reward_label || "",
    `Kademe ${row.previousTierNo || row.previous_tier_no || ""}`,
    `Kademe ${row.currentTierNo || row.current_tier_no || ""}`,
    `Kademe ${row.targetTierNo || row.target_tier_no || ""}`,
    getGiftRowDiamonds(row),
    getGiftEstimatedAgencyRevenue(row),
    getGiftRowRawAmount(row),
    getGiftRevenueLimit(row),
    getGiftDiamondLimit(row),
    safeNumber(row.rewardPoint || row.reward_point).toFixed(2),
    getGiftRowFinalAmount(row),
    getGiftGiftToRevenuePercent(row).toFixed(2),
    getGiftNetAfterGift(row),
    getGiftRiskStatus(row),
    getGiftRowStatus(row),
  ]);

  const summaryRows = [
    ["Dönem", periodMonth],
    ["Kayıt Sayısı", rows.length],
    ["Toplam Hediye", summary.totalGift || 0],
    ["Kademe Koruyan", summary.protect || 0],
    ["Üst Kademe", summary.upgrade || 0],
    ["Premium", summary.premium || 0],
  ];

  const table = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head><meta charset="UTF-8"></head>
      <body>
        <table border="1">
          <tr><th colspan="${headers.length}">Wolf Media Hediye Kazanım Listesi</th></tr>
          ${summaryRows.map((row) => `<tr><td>${escapeHtml(row[0])}</td><td>${escapeHtml(row[1])}</td></tr>`).join("")}
          <tr></tr>
          <tr>${headers.map((header) => `<th>${escapeHtml(header)}</th>`).join("")}</tr>
          ${bodyRows.map((row) => `<tr>${row.map((cell) => `<td>${escapeHtml(cell)}</td>`).join("")}</tr>`).join("")}
        </table>
      </body>
    </html>
  `;

  const blob = new Blob([table], { type: "application/vnd.ms-excel;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `hediye-kazanim-listesi-${periodMonth || "donem"}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function buildGiftWinnerPreview({ publisherRows = [], adminPerformance, previousAdminPerformance, budgetAmount }) {
  const rawWinners = (publisherRows || []).map((publisher) => {
    if (!isGiftPublisherEligibleStatus(publisher)) return null;

    const hiddenId = getPublisherHiddenId(publisher);
    const current = getGiftPublisherMetrics(adminPerformance, hiddenId);
    const previous = getGiftPublisherMetrics(previousAdminPerformance, hiddenId);
    const previousTierNo = getTierNoFromDiamonds(previous.diamonds || publisher.currentDiamonds || 0);
    const currentTierNo = getTierNoFromDiamonds(current.diamonds || 0);
    const rewardType = resolveGiftRewardType({
      previousTierNo,
      currentTierNo,
      currentDiamonds: current.diamonds,
      currentHours: current.hours,
      currentDays: current.liveDays,
    });

    if (!rewardType) return null;

    const targetTierNo = rewardType === "premium"
      ? Math.min(10, previousTierNo >= 10 ? 10 : previousTierNo + 2)
      : rewardType === "upgrade"
        ? Math.min(10, Math.max(currentTierNo, previousTierNo + 1))
        : previousTierNo;

    const targetPoint = GIFT_TARGET_POINTS[rewardType] || 0;
    const rewardPoint = targetPoint * targetTierNo;

    return {
      publisherId: publisher.id,
      publisherUsername: publisher.username,
      publisherName: publisher.fullName,
      hiddenId,
      managerUsername: publisher.assignedEmployeeUsername || publisher.managerUsername || publisher.representative || "",
      agencyTrackingStatus: getPublisherAgencyTrackingStatus(publisher),
      previousTierNo,
      currentTierNo,
      rewardType,
      rewardLabel: GIFT_TARGET_LABELS[rewardType],
      targetTierNo,
      targetPoint,
      rewardPoint,
      currentDiamonds: current.diamonds,
      currentHours: current.hours,
      currentDays: current.liveDays,
      previousDiamonds: previous.diamonds,
      previousHours: previous.hours,
      previousDays: previous.liveDays,
    };
  }).filter(Boolean);

  const totalPoint = rawWinners.reduce((sum, item) => sum + safeNumber(item.rewardPoint), 0);

  const withAmounts = rawWinners.map((item) => {
    const rawGift = totalPoint > 0 ? safeNumber(budgetAmount) * safeNumber(item.rewardPoint) / totalPoint : 0;
    const safety = applyGiftSafetyLimits(item, rawGift);

    return {
      ...item,
      sharePercent: totalPoint > 0 ? (safeNumber(item.rewardPoint) / totalPoint) * 100 : 0,
      rawGiftAmount: rawGift,
      minAppliedGiftAmount: safety.finalGiftAmount,
      ...safety,
    };
  });

  const finalRows = enforceGiftBudgetCeiling(withAmounts, budgetAmount);

  return {
    winners: finalRows,
    totalPoint,
    rawTotal: withAmounts.reduce((sum, item) => sum + safeNumber(item.rawGiftAmount), 0),
    minTotal: withAmounts.reduce((sum, item) => sum + safeNumber(item.minAppliedGiftAmount), 0),
    finalTotal: finalRows.reduce((sum, item) => sum + safeNumber(item.finalGiftAmount), 0),
    diff: finalRows.reduce((sum, item) => sum + safeNumber(item.finalGiftAmount), 0) - safeNumber(budgetAmount),
  };
}

function GiftCampaignContent({ publisherRows = [], currentAdmin = {}, managerRows = [] }) {
  const now = new Date();
  const defaultPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const isMasterAdmin = String(currentAdmin?.role || "").toLowerCase() === "master_admin";

  const [periodMonth, setPeriodMonth] = useState(defaultPeriod);
  const [budgetAmount, setBudgetAmount] = useState(300000);
  const [campaignId, setCampaignId] = useState(null);
  const [preview, setPreview] = useState({ winners: [], totalPoint: 0, rawTotal: 0, minTotal: 0, finalTotal: 0, diff: 0 });
  const [loading, setLoading] = useState(false);
  const [apiNote, setApiNote] = useState("");
  const [publishedWinners, setPublishedWinners] = useState([]);
  const [filter, setFilter] = useState("all");
  const [manualGiftEdits, setManualGiftEdits] = useState({});
  const [columnFilters, setColumnFilters] = useState({
    publisher: "",
    manager: "",
    agencyTracking: "",
    rewardType: "",
    previousTier: "",
    currentTier: "",
    targetTier: "",
    currentDiamondsMin: "",
    point: "",
    gift: "",
    status: "",
  });
  const [giftPeriodPerformance, setGiftPeriodPerformance] = useState(null);
  const [giftPreviousPeriodPerformance, setGiftPreviousPeriodPerformance] = useState(null);
  const [giftPerformanceLoading, setGiftPerformanceLoading] = useState(false);
  const [giftPerformanceError, setGiftPerformanceError] = useState("");
  const [includeTrackingPassive, setIncludeTrackingPassive] = useState(false);
  const [agencyTrackingMap, setAgencyTrackingMap] = useState({});

  const emptyGiftPreview = useMemo(() => ({
    winners: [],
    totalPoint: 0,
    rawTotal: 0,
    minTotal: 0,
    finalTotal: 0,
    diff: 0,
  }), []);

  const managerNameMap = useMemo(() => {
    const map = {};
    managerRows.forEach((manager) => {
      map[manager.username] = manager.fullName;
    });
    return map;
  }, [managerRows]);

  useEffect(() => {
    let ignore = false;
    async function loadAgencyTrackingRows() {
      try {
        const result = await requestJson(API_AGENCY_TRACKING_LIST, { cache: "no-store" });
        const map = {};
        (result.items || []).forEach((item) => {
          const status = normalizeAgencyTrackingStatus(item.agencyTrackingStatus || item.agency_tracking_status);
          if (item.id) map[`id:${item.id}`] = status;
          if (item.username) map[`u:${item.username}`] = status;
          if (item.hiddenId || item.hidden_id) map[`h:${item.hiddenId || item.hidden_id}`] = status;
        });
        if (!ignore) setAgencyTrackingMap(map);
      } catch {
        if (!ignore) setAgencyTrackingMap({});
      }
    }
    loadAgencyTrackingRows();
    return () => { ignore = true; };
  }, []);

  const publisherRowsWithAgencyTracking = useMemo(() => {
    return (publisherRows || []).map((publisher) => {
      const status =
        agencyTrackingMap[`id:${publisher.id}`] ||
        agencyTrackingMap[`u:${publisher.username}`] ||
        agencyTrackingMap[`h:${publisher.hiddenId}`] ||
        getPublisherAgencyTrackingStatus(publisher);
      return { ...publisher, agencyTrackingStatus: normalizeAgencyTrackingStatus(status) };
    });
  }, [publisherRows, agencyTrackingMap]);

  const activePublisherRows = useMemo(
    () => publisherRowsWithAgencyTracking.filter((publisher) => isGiftPublisherEligibleStatus(publisher) && (includeTrackingPassive || isAgencyTrackingActive(publisher))),
    [publisherRowsWithAgencyTracking, includeTrackingPassive]
  );

  const passivePublisherCount = Math.max((publisherRows || []).filter((item) => !isGiftPublisherEligibleStatus(item)).length, 0);
  const agencyTrackingPassiveCount = publisherRowsWithAgencyTracking.filter((item) => isGiftPublisherEligibleStatus(item) && !isAgencyTrackingActive(item)).length;

  const giftHiddenIdList = useMemo(() => uniqueGiftHiddenIds(activePublisherRows), [activePublisherRows]);
  const giftHiddenIds = useMemo(() => giftHiddenIdList.join(","), [giftHiddenIdList]);

  const giftMonthRange = useMemo(() => getGiftCampaignMonthRange(periodMonth), [periodMonth]);
  const giftPreviousMonthRange = useMemo(() => getGiftCampaignPreviousMonthRange(periodMonth), [periodMonth]);

  useEffect(() => {
    setCampaignId(null);
    setPreview(emptyGiftPreview);
    setApiNote("");
    setPublishedWinners([]);
    setManualGiftEdits({});
  }, [periodMonth, emptyGiftPreview]);

  useEffect(() => {
    setPreview(emptyGiftPreview);
    setManualGiftEdits({});
  }, [budgetAmount, emptyGiftPreview]);

  useEffect(() => {
    if (!giftHiddenIds) {
      setGiftPeriodPerformance(null);
      setGiftPreviousPeriodPerformance(null);
      setGiftPerformanceError("Yayıncı Hidden ID bilgisi bulunamadı.");
      return;
    }

    let ignore = false;

    async function loadGiftPerformanceForPeriod() {
      try {
        setGiftPerformanceLoading(true);
        setGiftPerformanceError("");

        const [currentResult, previousResult] = await Promise.all([
          fetchGiftPerformanceForRange(giftHiddenIdList, giftMonthRange),
          fetchGiftPerformanceForRange(giftHiddenIdList, giftPreviousMonthRange),
        ]);

        if (!ignore) {
          setGiftPeriodPerformance(currentResult);
          setGiftPreviousPeriodPerformance(previousResult);
        }
      } catch (err) {
        if (!ignore) {
          setGiftPeriodPerformance(null);
          setGiftPreviousPeriodPerformance(null);
          setGiftPerformanceError(err.message || "Seçili ay performans verisi alınamadı.");
        }
      } finally {
        if (!ignore) {
          setGiftPerformanceLoading(false);
        }
      }
    }

    loadGiftPerformanceForPeriod();

    return () => {
      ignore = true;
    };
  }, [giftHiddenIds, giftHiddenIdList, giftMonthRange.start, giftMonthRange.end, giftPreviousMonthRange.start, giftPreviousMonthRange.end]);

  const calculatePreview = useCallback(() => {
    if (giftPerformanceLoading) {
      setApiNote("Seçili ay performans verisi yükleniyor. Lütfen birkaç saniye sonra tekrar deneyin.");
      return;
    }

    if (giftPerformanceError || !giftPeriodPerformance || !giftPreviousPeriodPerformance) {
      setApiNote(giftPerformanceError || "Seçili ay performans verisi bulunamadı.");
      setPreview(emptyGiftPreview);
      return;
    }

    const result = buildGiftWinnerPreview({
      publisherRows: activePublisherRows,
      adminPerformance: giftPeriodPerformance,
      previousAdminPerformance: giftPreviousPeriodPerformance,
      budgetAmount,
    });

    setPreview(result);
    setPublishedWinners([]);
    setCampaignId(null);
    setManualGiftEdits({});
    setApiNote(result.winners.length ? `${periodMonth} dönemi için ön hesaplama hazırlandı.` : `${periodMonth} dönemi performans verisiyle hediye kazanan bulunamadı.`);
  }, [activePublisherRows, giftPeriodPerformance, giftPreviousPeriodPerformance, giftPerformanceLoading, giftPerformanceError, budgetAmount, periodMonth, emptyGiftPreview]);

  const loadPublishedWinners = useCallback(async () => {
    try {
      const result = await requestJson(`${API_GIFT_WINNERS_LIST}?period_month=${encodeURIComponent(periodMonth)}`, { cache: "no-store" });
      const nextWinners = result.winners || [];
      setPublishedWinners(nextWinners);
      setManualGiftEdits({});
      const firstCampaignId = nextWinners[0]?.campaignId || nextWinners[0]?.campaign_id;
      if (firstCampaignId) setCampaignId(firstCampaignId);
    } catch (err) {
      setPublishedWinners([]);
    }
  }, [periodMonth]);

  useEffect(() => {
    loadPublishedWinners();
  }, [loadPublishedWinners]);

  async function saveDraft() {
    if (!isMasterAdmin) {
      alert("Bu işlem için Master Admin yetkisi gerekir.");
      return null;
    }
    if (!preview.winners.length) {
      setApiNote("Önce Ön Hesapla butonu ile kazanan listesi oluşturun.");
      return null;
    }
    try {
      setLoading(true);
      setApiNote("");
      const saved = await requestJson(API_GIFT_CAMPAIGN_SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: campaignId,
          periodMonth,
          budgetAmount,
          budgetType: "diamond",
          minimumGiftAmount: 0,
              createdBy: currentAdmin?.username || "master_admin",
        }),
      });
      const nextCampaignId = saved.id || saved.campaignId || campaignId;
      if (!nextCampaignId) throw new Error("Kampanya ID alınamadı.");
      setCampaignId(nextCampaignId);
      const calculated = await requestJson(API_GIFT_CAMPAIGN_CALCULATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          campaignId: nextCampaignId,
          periodMonth,
          budgetAmount,
          minimumGiftAmount: 0,
              winners: enforceGiftBudgetCeiling(applyManualGiftEditsToRows(preview.winners, manualGiftEdits), budgetAmount),
        }),
      });
      setApiNote(calculated.message || "Taslak kaydedildi.");
      await loadPublishedWinners();
      return nextCampaignId;
    } catch (err) {
      setApiNote(err.message || "Taslak kaydedilemedi.");
      return null;
    } finally {
      setLoading(false);
    }
  }

  async function publishCampaign() {
    if (!isMasterAdmin) {
      alert("Bu işlem için Master Admin yetkisi gerekir.");
      return;
    }
    let targetCampaignId = campaignId;
    if (!targetCampaignId) {
      targetCampaignId = await saveDraft();
      if (!targetCampaignId) return;
    }
    if (!window.confirm("Bu dönem hediyelerini yayınlamak istiyor musunuz? Yayınlanan tutarlar sabitlenecek.")) return;
    try {
      setLoading(true);
      const result = await requestJson(API_GIFT_CAMPAIGN_PUBLISH, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ campaignId: targetCampaignId, periodMonth, publishedBy: currentAdmin?.username || "master_admin" }),
      });
      setApiNote(result.message || "Kampanya yayınlandı.");
      await loadPublishedWinners();
    } catch (err) {
      setApiNote(err.message || "Yayınlama başarısız.");
    } finally {
      setLoading(false);
    }
  }

  async function unpublishCampaign() {
    if (!isMasterAdmin) {
      alert("Bu işlem için Master Admin yetkisi gerekir.");
      return;
    }
    if (!window.confirm("Bu dönem hediyelerini yayından kaldırmak istiyor musunuz? Yayıncı tarafında hediye kazanımı görünmeyecektir.")) return;
    try {
      setLoading(true);
      const result = await requestJson(API_GIFT_CAMPAIGN_UNPUBLISH, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ campaignId, periodMonth, unpublishedBy: currentAdmin?.username || "master_admin" }),
      });
      setApiNote(result.message || "Kampanya yayından kaldırıldı.");
      await loadPublishedWinners();
    } catch (err) {
      setApiNote(err.message || "Yayından kaldırma başarısız.");
    } finally {
      setLoading(false);
    }
  }

  function setColumnFilterValue(key, value) {
    setColumnFilters((prev) => ({ ...prev, [key]: value }));
  }

  function clearColumnFilters() {
    setColumnFilters({
      publisher: "",
      manager: "",
      agencyTracking: "",
      rewardType: "",
      previousTier: "",
      currentTier: "",
      targetTier: "",
      currentDiamondsMin: "",
      point: "",
      gift: "",
      status: "",
    });
    setFilter("all");
  }

  function handleManualGiftChange(row, index, value) {
    const rowKey = getGiftRowKey(row, index);
    setManualGiftEdits((prev) => ({ ...prev, [rowKey]: value }));
  }

  async function saveManualGift(row, index) {
    const rowKey = getGiftRowKey(row, index);
    const amount = safeNumber(manualGiftEdits[rowKey]);
    if (amount <= 0) {
      setApiNote("Manuel hediye tutarı 0'dan büyük olmalıdır.");
      return;
    }

    const projectedRows = applyManualGiftEditsToRows(listRows, { ...manualGiftEdits, [rowKey]: amount });
    const projectedTotal = projectedRows.reduce((sum, item) => sum + getGiftRowFinalAmount(item), 0);
    if (projectedTotal > safeNumber(budgetAmount)) {
      setApiNote(`Manuel tutar kaydedilemedi. Toplam hediye bütçeyi aşamaz. Bütçe: ${formatNumber(budgetAmount)} elmas, yeni toplam: ${formatNumber(projectedTotal)} elmas.`);
      return;
    }

    const winnerId = row.id || row.winnerId || row.winner_id;
    if (!winnerId) {
      setApiNote("Manuel tutar ön hesaplamaya uygulandı. Kalıcı olması için Taslak Kaydet / Yayınla işlemini yapın.");
      return;
    }

    try {
      setLoading(true);
      const result = await requestJson(API_GIFT_WINNER_MANUAL_UPDATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          winnerId,
          finalGiftAmount: amount,
          updatedBy: currentAdmin?.username || "master_admin",
        }),
      });
      setApiNote(result.message || "Manuel hediye tutarı güncellendi.");
      await loadPublishedWinners();
    } catch (err) {
      setApiNote(err.message || "Manuel tutar kaydedilemedi.");
    } finally {
      setLoading(false);
    }
  }

  const sourceRowsRaw = preview.winners.length > 0 ? preview.winners : publishedWinners;
  const publisherAgencyStatusByHidden = useMemo(() => {
    const map = {};
    publisherRowsWithAgencyTracking.forEach((publisher) => {
      const status = getPublisherAgencyTrackingStatus(publisher);
      if (publisher.hiddenId) map[String(publisher.hiddenId)] = status;
      if (publisher.username) map[`u:${publisher.username}`] = status;
      if (publisher.id) map[`id:${publisher.id}`] = status;
    });
    return map;
  }, [publisherRowsWithAgencyTracking]);

  const sourceRows = sourceRowsRaw.map((row) => {
    const hiddenKey = String(row.hiddenId || row.hidden_id || "");
    const usernameKey = `u:${row.publisherUsername || row.publisher_username || ""}`;
    const idKey = `id:${row.publisherId || row.publisher_id || ""}`;
    return {
      ...row,
      agencyTrackingStatus: normalizeAgencyTrackingStatus(row.agencyTrackingStatus || row.agency_tracking_status || publisherAgencyStatusByHidden[hiddenKey] || publisherAgencyStatusByHidden[usernameKey] || publisherAgencyStatusByHidden[idKey] || "Aktif"),
    };
  });

  const listRows = applyManualGiftEditsToRows(sourceRows, manualGiftEdits).map((row) => ({
    ...row,
    managerDisplayName: managerNameMap[row.managerUsername || row.manager_username] || row.managerUsername || row.manager_username || "-",
  }));

  const filteredByTopSelect = listRows.filter((row) => filter === "all" ? true : getGiftRowRewardType(row) === filter);
  const filteredRows = filteredByTopSelect.filter((row) => giftRowMatchesColumnFilters(row, columnFilters, managerNameMap));
  const stats = buildGiftStats(listRows);
  const filteredStats = buildGiftStats(filteredRows);

  const currentFinalTotal = listRows.reduce((sum, row) => sum + getGiftRowFinalAmount(row), 0);
  const currentRawTotal = listRows.reduce((sum, row) => sum + safeNumber(row.rawGiftAmount || row.raw_gift_amount), 0) || preview.rawTotal;
  const currentMinTotal = listRows.reduce((sum, row) => sum + safeNumber(row.minAppliedGiftAmount || row.min_applied_gift_amount), 0) || preview.minTotal;
  const currentDiff = currentFinalTotal - safeNumber(budgetAmount);

  const summaryRows = [
    { label: "Girilen Bütçe", value: `${formatNumber(budgetAmount)} elmas` },
    { label: "Ham Dağıtım", value: `${formatNumber(currentRawTotal)} elmas` },
    { label: "Limit Sonrası", value: `${formatNumber(currentMinTotal)} elmas` },
    { label: "Net / Manuel Sonrası", value: `${formatNumber(currentFinalTotal)} elmas` },
    { label: "Bütçe Farkı", value: `${currentDiff >= 0 ? "+" : ""}${formatNumber(currentDiff)} elmas` },
  ];

  const managerOptions = getUniqueGiftFilterOptions(listRows, getGiftRowManager);
  const agencyTrackingOptions = getUniqueGiftFilterOptions(listRows, getGiftRowAgencyTrackingStatus);
  const previousTierOptions = getUniqueGiftFilterOptions(listRows, (row) => row.previousTierNo || row.previous_tier_no);
  const currentTierOptions = getUniqueGiftFilterOptions(listRows, (row) => row.currentTierNo || row.current_tier_no);
  const targetTierOptions = getUniqueGiftFilterOptions(listRows, (row) => row.targetTierNo || row.target_tier_no);
  const statusOptions = getUniqueGiftFilterOptions(listRows, getGiftRowStatus);

  const filterInputClass = "mt-2 h-9 w-full rounded-lg border border-white/10 bg-black/35 px-2 text-[11px] font-semibold text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35 [color-scheme:dark]";

  return (
    <div>
      <SectionHeader
        eyebrow="Master Admin"
        title="Hediye Bütçe Yönetimi"
        desc="Aylık elmas bütçesi girilir; hediye önce puan payına göre hesaplanır, sonra yayıncının tahmini ajans getirisi ve elmas limitiyle kontrol edilerek net tutar belirlenir."
        action={<Pill tone={isMasterAdmin ? "gold" : "default"}>{isMasterAdmin ? "Master Admin" : "Takip Modu"}</Pill>}
      />

      <div className="grid gap-4 xl:grid-cols-[420px_minmax(0,1fr)]">
        <Card className="p-5">
          <div className="text-lg font-black text-white">Dönem ve Bütçe</div>
          <div className="mt-4 grid gap-4">
            <FormInput label="Dönem" type="month" name="periodMonth" value={periodMonth} onChange={(event) => setPeriodMonth(event.target.value)} />
            <div className="rounded-2xl border border-white/10 bg-black/25 px-4 py-3 text-xs font-bold leading-5 text-white/55">
              Hesaplanacak ay: <span className="text-yellow-200">{formatDateForDisplay(giftMonthRange.start)} - {formatDateForDisplay(giftMonthRange.end)}</span><br />
              Kıyas alınan önceki ay: <span className="text-cyan-200">{formatDateForDisplay(giftPreviousMonthRange.start)} - {formatDateForDisplay(giftPreviousMonthRange.end)}</span><br />
              Hesaba dahil Hidden ID: <span className="text-yellow-200">{giftHiddenIdList.length}</span><br />
              Hariç tutulan pasif / ayrılmış kayıt: <span className="text-red-200">{passivePublisherCount}</span><br />
              Ajans takibi pasif kayıt: <span className="text-yellow-200">{agencyTrackingPassiveCount}</span>
              {giftPerformanceLoading && <div className="mt-2 text-yellow-200">Performans verisi yükleniyor...</div>}
              {giftPerformanceError && <div className="mt-2 text-red-200">{giftPerformanceError}</div>}
            </div>
            <FormInput label="Aylık Hediye Bütçesi / Elmas" type="number" name="budgetAmount" value={budgetAmount} onChange={(event) => setBudgetAmount(event.target.value)} />
            <div className="rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4 text-sm leading-6 text-yellow-100">
              Formül: <b>Puan = Hedef Puanı x Hedef Kademe</b><br />
              Koruma: 1 • Üst Kademe: 2 • Premium: 3<br />
              Minimum hediye yok • Yuvarlama yok • Getiri ve elmas limitini aşan hediye otomatik düşürülür<br />
              Pasif / ajanstan ayrılmış yayıncılar ve ajans takibi pasif olanlar otomatik hediye hesabına dahil edilmez.
            </div>
            <label className="flex cursor-pointer items-start gap-3 rounded-2xl border border-cyan-500/20 bg-cyan-500/10 p-4 text-sm text-cyan-100">
              <input
                type="checkbox"
                checked={includeTrackingPassive}
                onChange={(event) => setIncludeTrackingPassive(event.target.checked)}
                className="mt-1 h-4 w-4 accent-yellow-400"
              />
              <span>
                <span className="block font-black text-white">Ajans takibi pasif yayıncıları da hesaba dahil et</span>
                <span className="mt-1 block text-xs leading-5 text-white/55">Varsayılan olarak pasif takip seçen yayıncılar ödül/hedef hesabına dahil edilmez. Bu seçeneği yalnızca manuel kontrol amacıyla aç.</span>
              </span>
            </label>
            <div className="flex flex-wrap gap-2">
              <ActionButton onClick={calculatePreview} disabled={loading || giftPerformanceLoading}>Ön Hesapla</ActionButton>
              <ActionButton variant="dark" onClick={saveDraft} disabled={loading || preview.winners.length === 0}>Taslak Kaydet</ActionButton>
              <ActionButton onClick={publishCampaign} disabled={loading || (!campaignId && preview.winners.length === 0)}>Yayınla</ActionButton>
              <ActionButton variant="dark" onClick={unpublishCampaign} disabled={loading || !periodMonth}>Yayından Kaldır</ActionButton>
            </div>
            {apiNote && <div className="rounded-xl border border-yellow-500/20 bg-yellow-500/10 px-4 py-3 text-xs font-bold text-yellow-100">{apiNote}</div>}
          </div>
        </Card>

        <Card className="p-5">
          <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
            {summaryRows.map((item) => (
              <div key={item.label} className="rounded-2xl border border-white/10 bg-black/25 p-4">
                <div className="text-[10px] font-black uppercase tracking-[0.2em] text-white/35">{item.label}</div>
                <div className="mt-2 text-xl font-black text-yellow-200">{item.value}</div>
              </div>
            ))}
          </div>

          <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
            <div className="rounded-2xl border border-emerald-500/25 bg-emerald-500/10 p-4">
              <div className="text-[10px] font-black uppercase tracking-[0.18em] text-emerald-200/75">Kademe Koruyan</div>
              <div className="mt-2 text-2xl font-black text-emerald-200">{stats.protect}</div>
              <div className="mt-1 text-xs text-white/40">Filtreli: {filteredStats.protect}</div>
            </div>
            <div className="rounded-2xl border border-cyan-500/25 bg-cyan-500/10 p-4">
              <div className="text-[10px] font-black uppercase tracking-[0.18em] text-cyan-200/75">Üst Kademe</div>
              <div className="mt-2 text-2xl font-black text-cyan-200">{stats.upgrade}</div>
              <div className="mt-1 text-xs text-white/40">Kademe yükselten: {stats.tierUpOne}</div>
            </div>
            <div className="rounded-2xl border border-fuchsia-500/25 bg-fuchsia-500/10 p-4">
              <div className="text-[10px] font-black uppercase tracking-[0.18em] text-fuchsia-200/75">Premium / 2 Kademe</div>
              <div className="mt-2 text-2xl font-black text-fuchsia-200">{stats.premium}</div>
              <div className="mt-1 text-xs text-white/40">2 kademe yükselten: {stats.tierUpTwo}</div>
            </div>
            <div className="rounded-2xl border border-yellow-500/25 bg-yellow-500/10 p-4">
              <div className="text-[10px] font-black uppercase tracking-[0.18em] text-yellow-200/75">Toplam Hediye</div>
              <div className="mt-2 text-2xl font-black text-yellow-200">{formatNumber(stats.totalGift)}</div>
              <div className="mt-1 text-xs text-white/40">Elmas • Kazanan: {stats.total}</div>
            </div>
          </div>

          <div className="mt-4 rounded-2xl border border-red-500/25 bg-red-500/10 p-4 text-sm font-bold text-red-100">
            Hediye önce puan payıyla hesaplanır; ardından tahmini ajans getirisi (%6), hedef tipine göre hediye/getiri limiti ve elmas limiti uygulanır. Toplam net hediye hiçbir durumda girilen bütçeyi aşamaz.
          </div>
        </Card>
      </div>

      <Card className="mt-5 overflow-hidden">
        <div className="flex flex-col gap-3 border-b border-white/10 bg-white/[0.035] px-5 py-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="text-lg font-black text-white">Kazanan ve Dağıtım Listesi</div>
            <div className="mt-1 text-xs text-white/40">{filteredRows.length} kayıt görüntüleniyor. Toplam liste: {listRows.length} kişi.</div>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => exportGiftRowsToExcel(filteredRows, periodMonth, filteredStats)}
              disabled={filteredRows.length === 0}
              className="rounded-xl border border-emerald-500/25 bg-emerald-500/10 px-4 py-3 text-sm font-black text-emerald-200 transition hover:bg-emerald-500 hover:text-black disabled:cursor-not-allowed disabled:opacity-45"
            >
              Excel Al
            </button>
            <button
              type="button"
              onClick={clearColumnFilters}
              className="rounded-xl border border-white/10 bg-white/[0.035] px-4 py-3 text-sm font-black text-white/65 transition hover:border-yellow-500/25 hover:text-yellow-300"
            >
              Filtreleri Temizle
            </button>
            <select value={filter} onChange={(event) => setFilter(event.target.value)} className="rounded-xl border border-yellow-500/20 bg-[#070707] px-4 py-3 text-sm text-white outline-none [color-scheme:dark]">
              <option value="all">Tüm Kazananlar</option>
              <option value="protect">Kademeni Koru</option>
              <option value="upgrade">Hediye Seviyeni Artır</option>
              <option value="premium">Premium Hediye</option>
            </select>
          </div>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-[2500px]">
            <div className="grid grid-cols-[1.45fr_.85fr_.75fr_.95fr_.65fr_.65fr_.75fr_.85fr_.9fr_.9fr_.8fr_.8fr_.9fr_.75fr_.75fr_1fr_.75fr] gap-3 px-5 py-3 text-[10px] font-black uppercase tracking-[0.13em] text-white/35">
              <div>
                Yayıncı
                <input value={columnFilters.publisher} onChange={(event) => setColumnFilterValue("publisher", event.target.value)} placeholder="Ad / kullanıcı / ID" className={filterInputClass} />
              </div>
              <div>
                Yönetici
                <select value={columnFilters.manager} onChange={(event) => setColumnFilterValue("manager", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  {managerOptions.map((item) => <option key={item} value={item}>{managerNameMap[item] || item}</option>)}
                </select>
              </div>
              <div>
                Ajans Takibi
                <select value={columnFilters.agencyTracking} onChange={(event) => setColumnFilterValue("agencyTracking", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  {agencyTrackingOptions.map((item) => <option key={item} value={item}>{item}</option>)}
                </select>
              </div>
              <div>
                Hedef
                <select value={columnFilters.rewardType} onChange={(event) => setColumnFilterValue("rewardType", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  <option value="protect">Kademeni Koru</option>
                  <option value="upgrade">Üst Kademe</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div>
                Önceki
                <select value={columnFilters.previousTier} onChange={(event) => setColumnFilterValue("previousTier", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  {previousTierOptions.map((item) => <option key={item} value={item}>Kademe {item}</option>)}
                </select>
              </div>
              <div>
                Bu Ay
                <select value={columnFilters.currentTier} onChange={(event) => setColumnFilterValue("currentTier", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  {currentTierOptions.map((item) => <option key={item} value={item}>Kademe {item}</option>)}
                </select>
              </div>
              <div>
                Hedef Kademe
                <select value={columnFilters.targetTier} onChange={(event) => setColumnFilterValue("targetTier", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  {targetTierOptions.map((item) => <option key={item} value={item}>Kademe {item}</option>)}
                </select>
              </div>
              <div>
                Bu Ay Elmas
                <input type="number" value={columnFilters.currentDiamondsMin} onChange={(event) => setColumnFilterValue("currentDiamondsMin", event.target.value)} placeholder="Min" className={filterInputClass} />
              </div>
              <div>Tahmini Getiri</div>
              <div>Ham Hediye</div>
              <div>Getiri Limiti</div>
              <div>Elmas Limiti</div>
              <div>
                Puan
                <input value={columnFilters.point} onChange={(event) => setColumnFilterValue("point", event.target.value)} placeholder="Puan" className={filterInputClass} />
              </div>
              <div>
                Net Hediye
                <input value={columnFilters.gift} onChange={(event) => setColumnFilterValue("gift", event.target.value)} placeholder="Elmas" className={filterInputClass} />
              </div>
              <div>Net Kalan</div>
              <div>Risk</div>
              <div>Manuel Düzenle</div>
              <div>
                Durum
                <select value={columnFilters.status} onChange={(event) => setColumnFilterValue("status", event.target.value)} className={filterInputClass}>
                  <option value="">Tümü</option>
                  {statusOptions.map((item) => <option key={item} value={item}>{item}</option>)}
                </select>
              </div>
            </div>

            {filteredRows.map((row, index) => {
              const rowKey = getGiftRowKey(row, index);
              const manualValue = manualGiftEdits[rowKey] ?? "";
              const giftAmount = getGiftRowFinalAmount(row);
              const estimatedRevenue = getGiftEstimatedAgencyRevenue(row);
              const rawGiftAmount = getGiftRowRawAmount(row);
              const revenueLimit = getGiftRevenueLimit(row);
              const diamondLimit = getGiftDiamondLimit(row);
              const netAfterGift = getGiftNetAfterGift(row);
              const riskStatus = getGiftRiskStatus(row);

              return (
                <div key={`${row.hiddenId || row.hidden_id}-${index}`} className="grid grid-cols-[1.45fr_.85fr_.75fr_.95fr_.65fr_.65fr_.75fr_.85fr_.9fr_.9fr_.8fr_.8fr_.9fr_.75fr_.75fr_1fr_.75fr] gap-3 border-t border-white/10 px-5 py-3 text-sm text-white/70 hover:bg-yellow-500/[0.035]">
                  <div><div className="font-black text-white">{row.publisherName || row.publisher_name || row.publisherUsername || row.publisher_username || "-"}</div><div className="text-xs text-white/35">{row.hiddenId || row.hidden_id || "-"}</div></div>
                  <div>{row.managerDisplayName || managerNameMap[row.managerUsername || row.manager_username] || row.managerUsername || row.manager_username || "-"}</div>
                  <div><span className={`rounded-full border px-2 py-1 text-[10px] font-black ${getGiftRowAgencyTrackingStatus(row) === "Aktif" ? "border-emerald-500/25 bg-emerald-500/10 text-emerald-200" : "border-white/15 bg-white/[0.04] text-white/55"}`}>{getGiftRowAgencyTrackingStatus(row)}</span></div>
                  <div>{GIFT_TARGET_LABELS[getGiftRowRewardType(row)] || row.rewardLabel || row.reward_label || "-"}</div>
                  <div>Kademe {row.previousTierNo || row.previous_tier_no || "-"}</div>
                  <div>Kademe {row.currentTierNo || row.current_tier_no || "-"}</div>
                  <div>Kademe {row.targetTierNo || row.target_tier_no || "-"}</div>
                  <div className="font-black text-yellow-200">{formatNumber(getGiftRowDiamonds(row))}</div>
                  <div className="font-bold text-emerald-200">{formatNumber(estimatedRevenue)}</div>
                  <div className="font-bold text-white/70">{formatNumber(rawGiftAmount)}</div>
                  <div className="font-bold text-cyan-200">{formatNumber(revenueLimit)}</div>
                  <div className="font-bold text-fuchsia-200">{formatNumber(diamondLimit)}</div>
                  <div>{safeNumber(row.rewardPoint || row.reward_point).toFixed(2)}</div>
                  <div className="font-black text-yellow-300">{formatNumber(giftAmount)} elmas</div>
                  <div className={netAfterGift >= 0 ? "font-bold text-emerald-200" : "font-bold text-red-300"}>{formatNumber(netAfterGift)}</div>
                  <div>
                    <span className={`rounded-full border px-2 py-1 text-[10px] font-black ${riskStatus === "Kırpıldı" ? "border-red-500/25 bg-red-500/10 text-red-200" : riskStatus === "Manuel" ? "border-yellow-500/25 bg-yellow-500/10 text-yellow-200" : "border-emerald-500/25 bg-emerald-500/10 text-emerald-200"}`}>
                      {riskStatus}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      value={manualValue}
                      onChange={(event) => handleManualGiftChange(row, index, event.target.value)}
                      placeholder={String(giftAmount)}
                      className="h-9 w-24 rounded-lg border border-yellow-500/20 bg-black/35 px-2 text-xs font-bold text-white outline-none focus:border-yellow-500/45"
                    />
                    <button
                      type="button"
                      onClick={() => saveManualGift(row, index)}
                      disabled={loading || manualValue === ""}
                      className="h-9 rounded-lg border border-yellow-500/25 bg-yellow-500/10 px-3 text-[11px] font-black text-yellow-200 hover:bg-yellow-500 hover:text-black disabled:cursor-not-allowed disabled:opacity-45"
                    >
                      Kaydet
                    </button>
                  </div>
                  <div>{getGiftRowStatus(row)}</div>
                </div>
              );
            })}
            {filteredRows.length === 0 && <EmptyState text="Kazanan kayıt bulunamadı. Önce dönem ve bütçe seçip ön hesaplama yapın." />}
          </div>
        </div>
      </Card>
    </div>
  );
}


function formatAdminDateTime(value) {
  if (!value) return "-";

  const normalized = String(value).replace(" ", "T");
  const date = new Date(normalized);

  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatTimeAgo(value) {
  if (!value) return "Henüz giriş yapmadı";
  const normalized = String(value).replace(" ", "T");
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return String(value);

  const diffMs = Date.now() - date.getTime();
  if (diffMs < 0) return "Az önce";
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  if (diffMinutes <= 5) return "🟢 Şu an Çevrim İçi";
  if (diffMinutes < 60) return `${diffMinutes} dk önce`;
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours} saat önce`;
  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} gün önce (${date.toLocaleDateString("tr-TR")})`;
}

function ConsentAndVisitorContent(props = {}) {
  const [activeTab, setActiveTab] = useState("user_activity");
  const [roleFilter, setRoleFilter] = useState("all");
  const [loginFilter, setLoginFilter] = useState("all");
  const [consentFilter, setConsentFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [fetchedUsers, setFetchedUsers] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [sessionStats, setSessionStats] = useState({});
  const [consents, setConsents] = useState([]);
  const [consentSummary, setConsentSummary] = useState({ total: 0, today: 0, versions: 0 });
  const [visitors, setVisitors] = useState([]);
  const [visitorSummary, setVisitorSummary] = useState({
    totalVisits: 0,
    uniqueVisitors: 0,
    todayVisits: 0,
    weekVisits: 0,
    onlineNow: 0,
  });

  const loadTrackingData = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const [usersState, sessionState, consentState, visitorState] = await Promise.allSettled([
        requestJson(API_USERS_LIST, { cache: "no-store" }),
        requestJson(API_ACTIVE_SESSIONS_LIST, { cache: "no-store" }),
        requestJson(API_ADMIN_CONSENT_LIST, { cache: "no-store" }),
        requestJson(`${API_ADMIN_VISITOR_LIST}?limit=500`, { cache: "no-store" }),
      ]);

      const errors = [];

      if (usersState.status === "fulfilled") {
        const uRes = usersState.value;
        const uList = Array.isArray(uRes?.users)
          ? uRes.users
          : (Array.isArray(uRes) ? uRes : (Array.isArray(uRes?.data) ? uRes.data : []));
        setFetchedUsers(uList);
      } else {
        errors.push(usersState.reason?.message || "Kullanıcı listesi alınamadı.");
      }

      if (sessionState.status === "fulfilled") {
        const sRes = sessionState.value;
        setSessions(Array.isArray(sRes?.sessions) ? sRes.sessions : []);
        setSessionStats(sRes?.stats || {});
      } else {
        setSessions([]);
        // Non-blocking error for sessions
      }

      if (consentState.status === "fulfilled") {
        const cRes = consentState.value;
        setConsents(Array.isArray(cRes?.consents) ? cRes.consents : []);
        setConsentSummary(cRes?.summary || { total: 0, today: 0, versions: 0 });
      } else {
        setConsents([]);
        errors.push(consentState.reason?.message || "Sözleşme onay listesi alınamadı.");
      }

      if (visitorState.status === "fulfilled") {
        const vRes = visitorState.value;
        setVisitors(Array.isArray(vRes?.visitors) ? vRes.visitors : []);
        setVisitorSummary(vRes?.stats || {
          totalVisits: 0,
          uniqueVisitors: 0,
          todayVisits: 0,
          weekVisits: 0,
          onlineNow: 0,
        });
      } else {
        setVisitors([]);
        errors.push(visitorState.reason?.message || "Ziyaretçi trafiği alınamadı.");
      }

      if (errors.length) setError(errors.join(" "));
    } catch (err) {
      setError(err.message || "Onay ve takip verileri alınamadı.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTrackingData();
  }, [loadTrackingData]);

  // Unified User Activity Rows with login counts and contract approvals
  const userActivityRows = useMemo(() => {
    const rawUsers = fetchedUsers.length > 0 ? fetchedUsers : (props.allUsers || []);
    const poolUsernameMap = new Set();

    const rows = rawUsers.map((u, idx) => {
      const uClean = String(u.username || "").trim().toLowerCase();
      if (uClean) poolUsernameMap.add(uClean);

      const matchedSession = sessions.find((s) => {
        const sClean = String(s.username || "").trim().toLowerCase();
        return (sClean && uClean && sClean === uClean) || (s.user_id && String(s.user_id) === String(u.id));
      });

      const matchedConsent = consents.find((c) => {
        const cClean = String(c.username || "").trim().toLowerCase();
        return (cClean && uClean && cClean === uClean) || (c.userId && String(c.userId) === String(u.id));
      });

      const roleStr = String(u.role || u.userRole || "").toLowerCase().trim();
      const uNameLower = String(u.fullName || u.name || "").toLowerCase();

      let roleType = "publisher";
      let roleLabel = "Yayıncı";
      let roleTone = "purple";

      if (
        roleStr === "admin" ||
        roleStr === "superadmin" ||
        uClean === "admin" ||
        uClean === "superadmin" ||
        uNameLower.includes("admin")
      ) {
        roleType = "admin";
        roleLabel = "Sistem Yöneticisi";
        roleTone = "red";
      } else if (
        roleStr === "employee" ||
        roleStr === "manager" ||
        roleStr === "yonetici" ||
        roleStr === "yönetici" ||
        uClean.startsWith("wolfmedia") ||
        uClean.includes("manager") ||
        uClean.includes("yonetici")
      ) {
        roleType = "manager";
        roleLabel = "Ekip Yöneticisi";
        roleTone = "gold";
      } else if (
        roleStr === "scout" ||
        roleStr === "scout_manager" ||
        uClean.startsWith("scout")
      ) {
        roleType = "scout";
        roleLabel = "Aday Takip Sorumlusu";
        roleTone = "cyan";
      }

      const totalLogins = Number(matchedSession?.total_logins ?? matchedSession?.totalLogins ?? (matchedSession ? 1 : 0));
      const lastActiveAt = matchedSession?.last_active_at || matchedSession?.login_at || null;
      const isOnline = Boolean(matchedSession?.is_online);
      const timeLabel = isOnline
        ? "🟢 Şu an Çevrim İçi"
        : (lastActiveAt ? formatTimeAgo(lastActiveAt) : "Henüz giriş yapmadı");

      const hasConsent = Boolean(matchedConsent) || Boolean(u.consentAccepted);
      const consentVersion = matchedConsent?.consentVersion || (u.consentAccepted ? "v1.0" : null);
      const consentAcceptedAt = matchedConsent?.acceptedAt || u.consentAcceptedAt || null;

      return {
        id: u.id || `user-${idx}`,
        fullName: u.fullName || u.name || u.full_name || u.username || "-",
        username: u.username || "-",
        role: roleType,
        roleLabel,
        roleTone,
        phone: u.phone || "-",
        email: u.email || "-",
        representative: u.representative || u.assignedEmployeeUsername || "-",
        hiddenId: u.hiddenId || "-",
        status: u.status || "Aktif",
        totalLogins,
        lastActiveAt,
        loginAt: matchedSession?.login_at || null,
        isOnline,
        timeLabel,
        deviceType: matchedSession?.device_type || "-",
        ipAddress: matchedSession?.ip_address || matchedConsent?.ipMasked || "-",
        hasConsent,
        consentVersion,
        consentAcceptedAt,
        consentSource: matchedConsent?.source || (hasConsent ? "Web Portalı" : "-"),
      };
    });

    sessions.forEach((s, sIdx) => {
      const sClean = String(s.username || "").trim().toLowerCase();
      if (!sClean || poolUsernameMap.has(sClean)) return;
      poolUsernameMap.add(sClean);

      const matchedConsent = consents.find((c) => {
        const cClean = String(c.username || "").trim().toLowerCase();
        return cClean && sClean && cClean === sClean;
      });

      const roleStr = String(s.role || "").toLowerCase().trim();
      const sNameLower = String(s.full_name || s.username || "").toLowerCase();

      let roleType = "publisher";
      let roleLabel = s.role_label || "Yayıncı";
      let roleTone = s.role_badge || "purple";

      if (
        roleStr === "admin" ||
        roleStr === "superadmin" ||
        sClean === "admin" ||
        sClean === "superadmin" ||
        sNameLower.includes("admin")
      ) {
        roleType = "admin";
        roleLabel = "Sistem Yöneticisi";
        roleTone = "red";
      } else if (
        roleStr === "employee" ||
        roleStr === "manager" ||
        roleStr === "yonetici" ||
        roleStr === "yönetici" ||
        sClean.startsWith("wolfmedia") ||
        sClean.includes("manager") ||
        sClean.includes("yonetici")
      ) {
        roleType = "manager";
        roleLabel = "Ekip Yöneticisi";
        roleTone = "gold";
      } else if (
        roleStr === "scout" ||
        roleStr === "scout_manager" ||
        sClean.startsWith("scout")
      ) {
        roleType = "scout";
        roleLabel = "Aday Takip Sorumlusu";
        roleTone = "cyan";
      }

      const totalLogins = Number(s.total_logins ?? s.totalLogins ?? 1);
      const isOnline = Boolean(s.is_online);
      const timeLabel = isOnline
        ? "🟢 Şu an Çevrim İçi"
        : (s.last_active_at ? formatTimeAgo(s.last_active_at) : "Bilinmiyor");

      rows.push({
        id: s.user_id || `session-${sIdx}`,
        fullName: s.full_name || s.username || "-",
        username: s.username || "-",
        role: roleType,
        roleLabel,
        roleTone,
        phone: "-",
        email: "-",
        representative: "-",
        hiddenId: "-",
        status: "Aktif",
        totalLogins,
        lastActiveAt: s.last_active_at || s.login_at || null,
        loginAt: s.login_at || null,
        isOnline,
        timeLabel,
        deviceType: s.device_type || "-",
        ipAddress: s.ip_address || matchedConsent?.ipMasked || "-",
        hasConsent: Boolean(matchedConsent),
        consentVersion: matchedConsent?.consentVersion || null,
        consentAcceptedAt: matchedConsent?.acceptedAt || null,
        consentSource: matchedConsent?.source || "-",
      });
    });

    return rows.sort((a, b) => {
      if (a.isOnline && !b.isOnline) return -1;
      if (!a.isOnline && b.isOnline) return 1;
      return (b.totalLogins || 0) - (a.totalLogins || 0);
    });
  }, [fetchedUsers, props.allUsers, sessions, consents]);

  // Aggregated Counts for Filters & Stat Cards
  const managerCount = useMemo(() => userActivityRows.filter((r) => r.role === "manager").length, [userActivityRows]);
  const publisherCount = useMemo(() => userActivityRows.filter((r) => r.role === "publisher").length, [userActivityRows]);
  const scoutCount = useMemo(() => userActivityRows.filter((r) => r.role === "scout").length, [userActivityRows]);
  const adminCount = useMemo(() => userActivityRows.filter((r) => r.role === "admin").length, [userActivityRows]);

  const loggedInUsersCount = useMemo(() => userActivityRows.filter((r) => r.totalLogins > 0).length, [userActivityRows]);
  const onlineUsersCount = useMemo(() => userActivityRows.filter((r) => r.isOnline).length, [userActivityRows]);
  const approvedConsentCount = useMemo(() => userActivityRows.filter((r) => r.hasConsent).length, [userActivityRows]);
  const todayLoginsTotal = useMemo(() => {
    return sessionStats.today_logins || userActivityRows.filter((r) => r.lastActiveAt && String(r.lastActiveAt).slice(0, 10) === new Date().toISOString().slice(0, 10)).length;
  }, [sessionStats, userActivityRows]);

  // Filtered Rows for User Activity Tab
  const filteredUserActivityRows = useMemo(() => {
    let list = userActivityRows;

    if (roleFilter !== "all") {
      list = list.filter((r) => r.role === roleFilter);
    }

    if (loginFilter === "online") {
      list = list.filter((r) => r.isOnline);
    } else if (loginFilter === "has_logged") {
      list = list.filter((r) => r.totalLogins > 0);
    } else if (loginFilter === "never") {
      list = list.filter((r) => r.totalLogins === 0);
    }

    if (consentFilter === "approved") {
      list = list.filter((r) => r.hasConsent);
    } else if (consentFilter === "pending") {
      list = list.filter((r) => !r.hasConsent);
    }

    const query = search.trim().toLowerCase();
    if (!query) return list;

    return list.filter((item) =>
      `${item.fullName || ""} ${item.username || ""} ${item.roleLabel || ""} ${item.phone || ""} ${item.email || ""} ${item.representative || ""} ${item.hiddenId || ""} ${item.ipAddress || ""} ${item.deviceType || ""} ${item.consentVersion || ""}`
        .toLowerCase()
        .includes(query)
    );
  }, [userActivityRows, roleFilter, loginFilter, consentFilter, search]);

  const filteredConsents = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return consents;

    return consents.filter((item) =>
      `${item.fullName || ""} ${item.username || ""} ${item.role || ""} ${item.consentVersion || ""} ${item.source || ""} ${item.ipMasked || ""}`
        .toLowerCase()
        .includes(query)
    );
  }, [consents, search]);

  const filteredVisitors = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return visitors;

    return visitors.filter((item) =>
      `${item.sessionKey || ""} ${item.lastPath || ""} ${item.referrer || ""} ${item.deviceType || ""} ${item.browserName || ""} ${item.ipMasked || ""}`
        .toLowerCase()
        .includes(query)
    );
  }, [visitors, search]);

  function exportUserActivityCsv() {
    const headers = [
      "Ad Soyad",
      "Kullanici Adi",
      "Rol",
      "Giris Sayisi",
      "Son Aktiflik / Giris Tarihi",
      "Cevrimici Durumu",
      "Sozlesme Onayi",
      "Sozlesme Surumu",
      "Sozlesme Onay Tarihi",
      "Cihaz",
      "IP Adresi",
      "Bagli Yonetici",
      "Hesap Durumu",
    ];

    const rows = filteredUserActivityRows.map((u) => [
      `"${String(u.fullName || "").replace(/"/g, '""')}"`,
      `"${String(u.username || "").replace(/"/g, '""')}"`,
      `"${String(u.roleLabel || "").replace(/"/g, '""')}"`,
      u.totalLogins || 0,
      `"${u.lastActiveAt ? formatAdminDateTime(u.lastActiveAt) : "Henüz Giriş Yapmadı"}"`,
      u.isOnline ? "Çevrimiçi" : "Çevrimdışı",
      u.hasConsent ? "Onaylandı" : "Onay Bekliyor",
      `"${u.consentVersion || "-"}"`,
      `"${u.consentAcceptedAt ? formatAdminDateTime(u.consentAcceptedAt) : "-"}"`,
      `"${String(u.deviceType || "").replace(/"/g, '""')}"`,
      `"${String(u.ipAddress || "").replace(/"/g, '""')}"`,
      `"${String(u.representative || "-").replace(/"/g, '""')}"`,
      `"${String(u.status || "Aktif").replace(/"/g, '""')}"`,
    ]);

    const csvContent = "\uFEFF" + [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `Kullanici_Giris_ve_Sozlesme_Takip_Raporu_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const loginRate = userActivityRows.length > 0 ? Math.round((loggedInUsersCount / userActivityRows.length) * 100) : 0;
  const consentRate = userActivityRows.length > 0 ? Math.round((approvedConsentCount / userActivityRows.length) * 100) : 0;

  return (
    <div className="space-y-5">
      <SectionHeader
        eyebrow="Denetim & Güvenlik"
        title="Kullanıcı Giriş & Sözleşme Onay Takibi"
        desc="Yöneticilerin, yayıncıların ve aday takip ekibinin siteye giriş sayıları, son aktiflik zamanları ve sözleşme/gizlilik metni onay durumları canlı olarak bu ekranda izlenir."
        action={
          <div className="flex items-center gap-2">
            <ActionButton variant="dark" onClick={exportUserActivityCsv} disabled={loading || userActivityRows.length === 0}>
              📥 CSV İndir
            </ActionButton>
            <ActionButton variant="gold" onClick={loadTrackingData} disabled={loading}>
              {loading ? "Yenileniyor..." : "🔄 Yenile"}
            </ActionButton>
          </div>
        }
      />

      {/* Üst Özet Kartları */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5">
        <StatCard
          title="Toplam Hesap"
          value={formatNumber(userActivityRows.length)}
          note={`${managerCount} Yönetici, ${publisherCount} Yayıncı`}
        />
        <StatCard
          title="Giriş Yapanlar"
          value={formatNumber(loggedInUsersCount)}
          note={`%${loginRate} hesap oturum açtı`}
        />
        <StatCard
          title="Şu an Çevrimiçi"
          value={formatNumber(onlineUsersCount)}
          note="Son 5 dakikada aktif olan"
        />
        <StatCard
          title="Sözleşme Onayı"
          value={formatNumber(approvedConsentCount)}
          note={`%${consentRate} onaylanma oranı`}
        />
        <StatCard
          title="Bugünkü Oturum"
          value={formatNumber(todayLoginsTotal)}
          note="Bugün açılan oturumlar"
        />
      </div>

      {/* Ana Veri Kartı */}
      <Card className="overflow-hidden border border-white/10 bg-black/40 backdrop-blur-md shadow-2xl">
        <div className="space-y-4 border-b border-white/10 p-4 lg:p-5">
          {/* Ana Sekmeler */}
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div className="inline-flex flex-wrap gap-1 rounded-2xl border border-yellow-500/25 bg-black/50 p-1.5 shadow-inner">
              <button
                type="button"
                onClick={() => {
                  setActiveTab("user_activity");
                  setSearch("");
                }}
                className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black transition ${
                  activeTab === "user_activity"
                    ? "bg-gradient-to-r from-yellow-500 to-amber-500 text-black shadow-md shadow-yellow-500/20"
                    : "text-white/65 hover:text-yellow-200 hover:bg-white/5"
                }`}
              >
                <span>👤 Kullanıcı Giriş & Onay Takibi</span>
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                  activeTab === "user_activity" ? "bg-black/25 text-black" : "bg-white/10 text-white/70"
                }`}>
                  {userActivityRows.length}
                </span>
              </button>

              <button
                type="button"
                onClick={() => {
                  setActiveTab("consents");
                  setSearch("");
                }}
                className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black transition ${
                  activeTab === "consents"
                    ? "bg-gradient-to-r from-yellow-500 to-amber-500 text-black shadow-md shadow-yellow-500/20"
                    : "text-white/65 hover:text-yellow-200 hover:bg-white/5"
                }`}
              >
                <span>📜 Sözleşme Onay Günlüğü</span>
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                  activeTab === "consents" ? "bg-black/25 text-black" : "bg-white/10 text-white/70"
                }`}>
                  {consents.length}
                </span>
              </button>

              <button
                type="button"
                onClick={() => {
                  setActiveTab("visitors");
                  setSearch("");
                }}
                className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black transition ${
                  activeTab === "visitors"
                    ? "bg-gradient-to-r from-yellow-500 to-amber-500 text-black shadow-md shadow-yellow-500/20"
                    : "text-white/65 hover:text-yellow-200 hover:bg-white/5"
                }`}
              >
                <span>🌐 Site / Ziyaretçi Trafiği</span>
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                  activeTab === "visitors" ? "bg-black/25 text-black" : "bg-white/10 text-white/70"
                }`}>
                  {visitors.length}
                </span>
              </button>
            </div>

            <div className="w-full lg:max-w-md">
              <SearchBox
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder={
                  activeTab === "user_activity"
                    ? "Ad, kullanıcı adı, telefon, rol veya IP ara..."
                    : activeTab === "consents"
                    ? "Onaylayan kullanıcı, rol veya sürüm ara..."
                    : "Cihaz, tarayıcı, sayfa veya IP ara..."
                }
              />
            </div>
          </div>

          {/* Kullanıcı Giriş & Onay Alt Filtreleri */}
          {activeTab === "user_activity" && (
            <div className="flex flex-wrap items-center justify-between gap-3 pt-2">
              {/* Rol Filtreleri */}
              <div className="flex flex-wrap items-center gap-1.5">
                <span className="mr-1 text-[11px] font-bold uppercase tracking-wider text-white/40">Rol:</span>
                <button
                  type="button"
                  onClick={() => setRoleFilter("all")}
                  className={`rounded-lg px-3 py-1.5 text-xs font-bold transition ${
                    roleFilter === "all"
                      ? "bg-yellow-500 text-black shadow-sm"
                      : "bg-white/5 text-white/65 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  Tümü ({userActivityRows.length})
                </button>
                <button
                  type="button"
                  onClick={() => setRoleFilter("manager")}
                  className={`rounded-lg px-3 py-1.5 text-xs font-bold transition ${
                    roleFilter === "manager"
                      ? "bg-amber-400 text-black shadow-sm"
                      : "bg-white/5 text-white/65 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  🛡️ Yöneticiler ({managerCount})
                </button>
                <button
                  type="button"
                  onClick={() => setRoleFilter("publisher")}
                  className={`rounded-lg px-3 py-1.5 text-xs font-bold transition ${
                    roleFilter === "publisher"
                      ? "bg-purple-400 text-black shadow-sm"
                      : "bg-white/5 text-white/65 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  💎 Yayıncılar ({publisherCount})
                </button>
                <button
                  type="button"
                  onClick={() => setRoleFilter("scout")}
                  className={`rounded-lg px-3 py-1.5 text-xs font-bold transition ${
                    roleFilter === "scout"
                      ? "bg-cyan-400 text-black shadow-sm"
                      : "bg-white/5 text-white/65 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  🎯 Aday Sorumluları ({scoutCount})
                </button>
                <button
                  type="button"
                  onClick={() => setRoleFilter("admin")}
                  className={`rounded-lg px-3 py-1.5 text-xs font-bold transition ${
                    roleFilter === "admin"
                      ? "bg-rose-400 text-black shadow-sm"
                      : "bg-white/5 text-white/65 hover:bg-white/10 hover:text-white"
                  }`}
                >
                  👑 Adminler ({adminCount})
                </button>
              </div>

              {/* Oturum & Sözleşme Durumu Filtreleri */}
              <div className="flex flex-wrap items-center gap-2">
                <select
                  value={loginFilter}
                  onChange={(e) => setLoginFilter(e.target.value)}
                  className="rounded-lg border border-white/10 bg-black/60 px-3 py-1.5 text-xs font-bold text-white/90 outline-none hover:border-yellow-500/40 focus:border-yellow-500"
                >
                  <option value="all" className="bg-[#121212] text-white">Tüm Giriş Durumları</option>
                  <option value="online" className="bg-[#121212] text-emerald-300">🟢 Şu an Çevrim İçi ({onlineUsersCount})</option>
                  <option value="has_logged" className="bg-[#121212] text-white">🔑 Giriş Yapmış Olanlar ({loggedInUsersCount})</option>
                  <option value="never" className="bg-[#121212] text-white/60">⏳ Hiç Giriş Yapmayanlar ({userActivityRows.length - loggedInUsersCount})</option>
                </select>

                <select
                  value={consentFilter}
                  onChange={(e) => setConsentFilter(e.target.value)}
                  className="rounded-lg border border-white/10 bg-black/60 px-3 py-1.5 text-xs font-bold text-white/90 outline-none hover:border-yellow-500/40 focus:border-yellow-500"
                >
                  <option value="all" className="bg-[#121212] text-white">Tüm Sözleşme Durumları</option>
                  <option value="approved" className="bg-[#121212] text-emerald-300">✅ Sözleşmeyi Onaylayanlar ({approvedConsentCount})</option>
                  <option value="pending" className="bg-[#121212] text-amber-300">⏳ Onay Bekleyenler ({userActivityRows.length - approvedConsentCount})</option>
                </select>
              </div>
            </div>
          )}

          {error ? (
            <div className="mt-3 rounded-xl border border-red-500/20 bg-red-500/10 px-4 py-3 text-sm font-semibold text-red-200">
              {error}
            </div>
          ) : null}
        </div>

        {/* Tablo İçeriği */}
        {loading ? (
          <div className="flex items-center justify-center p-12 text-sm text-white/45">
            <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-yellow-500 border-t-transparent" />
            Kullanıcı oturumları ve sözleşme onayları yükleniyor...
          </div>
        ) : activeTab === "user_activity" ? (
          <UserActivityTrackingTable rows={filteredUserActivityRows} />
        ) : activeTab === "consents" ? (
          <ConsentApprovalTable rows={filteredConsents} />
        ) : (
          <VisitorTrackingTable rows={filteredVisitors} summary={visitorSummary} />
        )}
      </Card>
    </div>
  );
}

function UserActivityTrackingTable({ rows = [] }) {
  if (!rows.length) {
    return <EmptyState text="Filtrelere uygun kullanıcı kaydı bulunamadı." />;
  }

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[1220px]">
        <div className="wm-audit-table-header grid grid-cols-[1.55fr_1.1fr_.85fr_1.3fr_1.35fr_1.1fr_.65fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-black uppercase tracking-[0.14em] text-white/50 border-b border-white/10">
          <div className="flex items-center gap-1.5"><span>👤</span><span>Kullanıcı & İletişim</span></div>
          <div className="flex items-center gap-1.5"><span>🛡️</span><span>Rol & Sorumlu</span></div>
          <div className="flex items-center gap-1.5"><span>🔑</span><span>Giriş Sayısı</span></div>
          <div className="flex items-center gap-1.5"><span>⏱️</span><span>Son Aktiflik</span></div>
          <div className="flex items-center gap-1.5"><span>📜</span><span>Sözleşme Onayı</span></div>
          <div className="flex items-center gap-1.5"><span>💻</span><span>Cihaz & IP</span></div>
          <div className="flex items-center justify-end gap-1.5"><span>⚡</span><span>Durum</span></div>
        </div>

        <div className="divide-y divide-white/5">
          {rows.map((item, index) => {
            const initial = (item.fullName || item.username || "U").charAt(0).toUpperCase();

            let roleBadgeClass = "border-purple-500/35 bg-purple-500/15 text-purple-300";
            let roleIcon = "💎";
            let avatarRingClass = "bg-purple-500/20 text-purple-300 border-purple-500/35";

            if (item.role === "manager") {
              roleBadgeClass = "border-amber-500/35 bg-amber-500/15 text-amber-300";
              roleIcon = "🛡️";
              avatarRingClass = "bg-amber-500/20 text-yellow-300 border-amber-500/35";
            } else if (item.role === "scout") {
              roleBadgeClass = "border-cyan-500/35 bg-cyan-500/15 text-cyan-300";
              roleIcon = "🎯";
              avatarRingClass = "bg-cyan-500/20 text-cyan-300 border-cyan-500/35";
            } else if (item.role === "admin") {
              roleBadgeClass = "border-rose-500/35 bg-rose-500/15 text-rose-300";
              roleIcon = "👑";
              avatarRingClass = "bg-rose-500/20 text-rose-300 border-rose-500/35";
            }

            const deviceStr = String(item.deviceType || "").toLowerCase();
            const deviceIcon = deviceStr.includes("windows") || deviceStr.includes("mac") || deviceStr.includes("pc")
              ? "💻"
              : deviceStr.includes("iphone") || deviceStr.includes("ios")
              ? "📱"
              : deviceStr.includes("android")
              ? "📱"
              : "🌐";

            return (
              <div
                key={`${item.id}-${item.username}-${index}`}
                className="wm-audit-table-row grid grid-cols-[1.55fr_1.1fr_.85fr_1.3fr_1.35fr_1.1fr_.65fr] items-center gap-3 px-5 py-3.5 text-sm"
              >
                {/* 1. Kullanıcı & İletişim */}
                <div className="flex items-center gap-3 min-w-0">
                  <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-black text-sm shadow-md border ${avatarRingClass}`}>
                    {initial}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="truncate font-black text-white text-sm">{item.fullName || "-"}</div>
                    <div className="flex items-center gap-1.5 mt-0.5">
                      <span translate="no" className="notranslate truncate text-xs font-bold text-yellow-200">
                        @{item.username || "-"}
                      </span>
                    </div>
                    {item.phone && item.phone !== "-" && (
                      <div className="mt-0.5 flex items-center gap-1 text-[11px] text-white/45">
                        <span>📞</span>
                        <span>{item.phone}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* 2. Rol & Sorumlu */}
                <div>
                  <span className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-black shadow-sm ${roleBadgeClass}`}>
                    <span>{roleIcon}</span>
                    <span>{item.roleLabel}</span>
                  </span>
                  {item.role === "publisher" && item.representative && item.representative !== "-" && (
                    <div className="mt-1.5 flex items-center gap-1 truncate text-[11px] text-white/50" title={`Sorumlu Yönetici: @${item.representative}`}>
                      <span className="opacity-60">Sorumlu:</span>
                      <span className="font-semibold text-yellow-300/90">@{item.representative}</span>
                    </div>
                  )}
                </div>

                {/* 3. Giriş Sayısı */}
                <div>
                  {item.totalLogins > 0 ? (
                    <span className="inline-flex items-center gap-1.5 rounded-lg border border-yellow-500/30 bg-yellow-500/10 px-3 py-1.5 text-xs font-black text-yellow-300 shadow-sm">
                      <span>🔑</span>
                      <span>{item.totalLogins} kez</span>
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 rounded-lg border border-white/10 bg-white/[0.03] px-2.5 py-1 text-xs font-semibold text-white/35">
                      <span>0 (Giriş Yok)</span>
                    </span>
                  )}
                </div>

                {/* 4. Son Giriş / Aktiflik */}
                <div>
                  {item.isOnline ? (
                    <div className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 bg-emerald-500/15 px-3 py-1 text-xs font-black text-emerald-300 shadow-sm shadow-emerald-500/20">
                      <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
                      </span>
                      Çevrim İçi
                    </div>
                  ) : item.lastActiveAt ? (
                    <div className="space-y-0.5">
                      <div className="font-bold text-white/90 text-xs sm:text-sm">{formatAdminDateTime(item.lastActiveAt)}</div>
                      <div className="text-[11px] font-semibold text-white/45">{item.timeLabel}</div>
                    </div>
                  ) : (
                    <span className="text-xs italic text-white/30">Henüz giriş yapmadı</span>
                  )}
                </div>

                {/* 5. Sözleşme / Gizlilik Onayı */}
                <div>
                  {item.hasConsent ? (
                    <div className="space-y-0.5">
                      <div className="inline-flex items-center gap-1.5 rounded-lg border border-emerald-500/35 bg-emerald-500/15 px-2.5 py-1 text-xs font-black text-emerald-300 shadow-sm">
                        <span>✅ Onaylandı</span>
                        <span className="rounded bg-emerald-500/25 px-1.5 py-0.2 text-[10px] font-black">{item.consentVersion || "v1.0"}</span>
                      </div>
                      <div className="text-[11px] font-medium text-white/45">
                        {item.consentAcceptedAt ? formatAdminDateTime(item.consentAcceptedAt) : "Sistemde Kayıtlı"}
                      </div>
                    </div>
                  ) : (
                    <div className="inline-flex items-center gap-1.5 rounded-lg border border-amber-500/35 bg-amber-500/15 px-2.5 py-1 text-xs font-black text-amber-300 shadow-sm">
                      <span>⏳ Onay Bekliyor</span>
                    </div>
                  )}
                </div>

                {/* 6. Cihaz & IP Adresi */}
                <div className="space-y-0.5 text-xs">
                  <div className="flex items-center gap-1.5 font-bold text-white/85">
                    <span>{deviceIcon}</span>
                    <span>{item.deviceType || "Bilinmiyor"}</span>
                  </div>
                  <div className="font-mono text-[11px] font-medium text-white/40">{item.ipAddress || "—"}</div>
                </div>

                {/* 7. Hesap Durumu */}
                <div className="flex justify-end">
                  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-black shadow-sm ${
                    item.status === "Aktif"
                      ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-300"
                      : "border-rose-500/30 bg-rose-500/10 text-rose-300"
                  }`}>
                    <span className={`h-1.5 w-1.5 rounded-full ${item.status === "Aktif" ? "bg-emerald-400" : "bg-rose-400"}`} />
                    <span>{item.status || "Aktif"}</span>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function ConsentApprovalTable({ rows = [] }) {
  if (!rows.length) {
    return <EmptyState text="Kullanım ve gizlilik onayı kaydı bulunamadı." />;
  }

  return (
    <div className="overflow-x-auto">
      <div className="min-w-[1060px]">
        <div className="wm-audit-table-header grid grid-cols-[1.3fr_1fr_.85fr_.75fr_1.1fr_.9fr_.8fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-black uppercase tracking-[0.14em] text-white/50 border-b border-white/10">
          <div>👤 Ad Soyadı</div>
          <div>🏷️ Kullanıcı</div>
          <div>🛡️ Rol</div>
          <div>📌 Sürüm</div>
          <div>📅 Onay Tarihi</div>
          <div>🌐 IP</div>
          <div>📱 Kaynak</div>
        </div>

        <div className="divide-y divide-white/5">
          {rows.map((item, index) => (
            <div
              key={`${item.userId || item.username}-${item.consentVersion}-${index}`}
              className="wm-audit-table-row grid grid-cols-[1.3fr_1fr_.85fr_.75fr_1.1fr_.9fr_.8fr] items-center gap-3 px-5 py-3.5 text-sm text-white/80"
            >
              <div className="font-bold text-white">{item.fullName || "-"}</div>
              <div translate="no" className="notranslate font-semibold text-yellow-200">@{item.username || "-"}</div>
              <div>
                <span className="inline-flex items-center rounded-md border border-white/10 bg-white/5 px-2 py-0.5 text-xs font-bold text-white/75">
                  {item.role || "-"}
                </span>
              </div>
              <div><Pill tone="gold">{item.consentVersion || "v1.0"}</Pill></div>
              <div className="font-medium text-white/85">{formatAdminDateTime(item.acceptedAt)}</div>
              <div className="font-mono text-xs text-white/45">{item.ipMasked || "-"}</div>
              <div className="text-xs text-white/50">{item.source || "-"}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function VisitorTrackingTable({ rows = [], summary = {} }) {
  if (!rows.length) {
    return <EmptyState text="Henüz site ziyaret kaydı bulunmuyor. Ana sayfa yeni paketle açıldığında kayıtlar oluşmaya başlayacak." />;
  }

  return (
    <div>
      <div className="grid grid-cols-2 gap-3 border-b border-white/10 p-4 md:grid-cols-4">
        <div className="rounded-xl border border-white/10 bg-black/25 p-3.5 shadow-sm">
          <div className="text-[10px] font-black uppercase tracking-[0.14em] text-white/40">Bugün</div>
          <div className="mt-1 text-2xl font-black text-white">{formatNumber(summary.todayVisits)}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-black/25 p-3.5 shadow-sm">
          <div className="text-[10px] font-black uppercase tracking-[0.14em] text-white/40">Son 7 Gün</div>
          <div className="mt-1 text-2xl font-black text-white">{formatNumber(summary.weekVisits)}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-black/25 p-3.5 shadow-sm">
          <div className="text-[10px] font-black uppercase tracking-[0.14em] text-white/40">Tekil Ziyaretçi</div>
          <div className="mt-1 text-2xl font-black text-white">{formatNumber(summary.uniqueVisitors)}</div>
        </div>
        <div className="rounded-xl border border-emerald-500/25 bg-emerald-500/10 p-3.5 shadow-sm">
          <div className="text-[10px] font-black uppercase tracking-[0.14em] text-emerald-300/70">Şu An Çevrimiçi</div>
          <div className="mt-1 text-2xl font-black text-emerald-300">{formatNumber(summary.onlineNow)}</div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="min-w-[1180px]">
          <div className="wm-audit-table-header grid grid-cols-[.75fr_.75fr_1fr_.7fr_.9fr_1fr_.7fr_.65fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-black uppercase tracking-[0.14em] text-white/50 border-b border-white/10">
            <div>🔑 Oturum</div>
            <div>⚡ Durum</div>
            <div>📅 Son Ziyaret</div>
            <div>📊 Ziyaret</div>
            <div>💻 Cihaz</div>
            <div>🔗 Son Sayfa</div>
            <div>🌐 Kaynak</div>
            <div>🛡️ IP</div>
          </div>

          <div className="divide-y divide-white/5">
            {rows.map((item, index) => (
              <div
                key={`${item.sessionKey}-${index}`}
                className="wm-audit-table-row grid grid-cols-[.75fr_.75fr_1fr_.7fr_.9fr_1fr_.7fr_.65fr] items-center gap-3 px-5 py-3.5 text-sm text-white/75"
              >
                <div className="font-mono text-xs font-bold text-yellow-200">{item.sessionKey || "-"}</div>
                <div>
                  <span className={`rounded-full border px-2.5 py-0.5 text-[10px] font-black ${item.isOnline ? "border-emerald-500/35 bg-emerald-500/15 text-emerald-300" : "border-white/10 bg-white/[0.035] text-white/45"}`}>
                    {item.isOnline ? "🟢 Çevrimiçi" : "⚪ Ayrıldı"}
                  </span>
                </div>
                <div className="font-semibold text-white/90">{formatAdminDateTime(item.lastSeenAt)}</div>
                <div className="font-black text-white">{formatNumber(item.visitCount)}</div>
                <div>
                  <div className="font-bold text-white/85">{item.deviceType || "-"}</div>
                  <div className="text-xs text-white/40">{item.browserName || "-"}</div>
                </div>
                <div className="truncate font-medium text-yellow-200" title={item.lastPath || "/"}>{item.lastPath || "/"}</div>
                <div className="truncate text-white/55" title={item.referrer || "Doğrudan"}>{item.referrer || "Doğrudan"}</div>
                <div className="font-mono text-xs text-white/45">{item.ipMasked || "-"}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function ContentRouter(props) {
  const {
    activeKey,
    setActiveKey,
    publisherRows,
    managerRows,
    loading,
    error,
    reload,
    actions,
    adminMessages,
    selectedAdminMessageId,
    setSelectedAdminMessageId,
    reloadAdminMessages,
    passwordRequests,
    passwordRequestsLoading,
    passwordRequestsError,
    loadPasswordRequests,
    adminPerformance,
    previousAdminPerformance,
    adminPerformanceLoading,
    adminPerformanceError,
    reportStartDate,
    reportEndDate,
    setReportStartDate,
    setReportEndDate,
    selectedManagerFilter,
    setSelectedManagerFilter,
    selectedPublisherFilter,
    setSelectedPublisherFilter,
    filteredPublisherRowsForPerformance,
    currentAdmin,
    adminTheme = "dark",
  } = props;

  if (activeKey === "dashboard") {
    return <DashboardContent {...props} />;
  }

  if (activeKey === "scout_publisher_tracking") {
    return (
      <PublisherTrackingContent
        publisherRows={publisherRows}
        managers={managerRows}
        loading={loading}
        onReload={reload}
        currentAdmin={currentAdmin}
      />
    );
  }

  if (activeKey === "scout_reports") {
    return (
      <PublisherReportsManagementContent
        publisherRows={publisherRows}
        managers={managerRows}
        loading={loading}
        onReload={reload}
        actions={actions}
        onReportUploadClick={props.onReportUploadClick}
        currentAdmin={currentAdmin}
      />
    );
  }

  if (activeKey === "scout_personnel") {
    return (
      <ScoutPersonnelContent
        rows={props.scoutRows || []}
        loading={loading}
        error={error}
        onReload={reload}
        onAdd={actions.openAddScout}
        onEdit={actions.openEditScout}
        onPassword={actions.openPassword}
        onDelete={actions.openDelete}
      />
    );
  }

  if (activeKey.startsWith("scout_")) {
    const scoutSectionMap = {
      scout_dashboard: "pool",
      scout_followup: "followup",
    };

    return (
      <ScoutCenterPage
        embedded
        theme={adminTheme}
        section={scoutSectionMap[activeKey] || "pool"}
        currentAdmin={currentAdmin}
        publisherRows={publisherRows}
        managerRows={managerRows}
        onReload={reload}
      />
    );
  }

  if (workManagementSubModules.some((item) => item.key === activeKey)) {
    return (
      <WorkManagementCenter
        activeModule={activeKey}
        currentUsername={currentAdmin?.username || currentAdmin?.fullName || "admin"}
        publishers={publisherRows}
        managers={managerRows}
      />
    );
  }

  if (activeKey === "publisher_list") {
    const publisherRowsWithPerformance = buildPublisherPerformanceRows(
      publisherRows,
      adminPerformance
    );

    return (
      <PublisherListContent
        rows={publisherRowsWithPerformance}
        managers={managerRows}
        loading={loading}
        error={error}
        onReload={reload}
        onAdd={actions.openAddPublisher}
        onEdit={actions.openEditPublisher}
        onPassword={actions.openPassword}
        onDelete={actions.openDelete}
        onBulk={actions.openBulkUpload}
        currentAdmin={currentAdmin}
        theme={adminTheme}
        canEdit={true}
        canDelete={true}
      />
    );
  }

  if (activeKey === "publisher_training") {
    return <TrainingCenterContent />;
  }

  if (activeKey === "featured_publishers") {
    return <FeaturedPublishersContent currentAdmin={currentAdmin} />;
  }

  if (activeKey === "publisher_tier_rewards") {
    return <AdminTierRewardContent currentAdmin={currentAdmin} />;
  }

  if (activeKey === "publisher_content") {
    const publisherRowsWithPerformance = buildPublisherPerformanceRows(
      publisherRows,
      adminPerformance
    );
    return <PublisherEyeExperienceContent publisherRows={publisherRowsWithPerformance} currentAdmin={currentAdmin} />;
  }

  if (activeKey === "publisher_messages") {
    return (
      <AdminMessagesContent
        messages={adminMessages}
        selectedMessageId={selectedAdminMessageId}
        setSelectedMessageId={setSelectedAdminMessageId}
        reloadMessages={reloadAdminMessages}
      />
    );
  }

  if (activeKey.startsWith("publisher_")) {
    return (
      <PublisherGenericContent
        title={managementSubModules.find((item) => item.key === activeKey)?.label || otherSettingsSubModules.find((item) => item.key === activeKey)?.label || "Yayıncı Yönetimi"}
        desc="Yayıncı süreçlerine ait detaylar bu alanda yönetilir."
      />
    );
  }

  if (activeKey === "manager_list") {
    return (
      <ManagerListContent
        rows={managerRows}
        loading={loading}
        error={error}
        onReload={reload}
        onAdd={actions.openAddManager}
        onEdit={actions.openEditManager}
        onPassword={actions.openPassword}
        onDelete={actions.openDelete}
      />
    );
  }

  if (activeKey === "manager_content") {
    return (
      <ManagerEyeExperienceContent
        managerRows={managerRows}
        publisherRows={publisherRows}
        currentAdmin={currentAdmin}
      />
    );
  }

  if (activeKey === "manager_assignment") {
    return (
      <PublisherManagerAssignmentContent
        publisherRows={publisherRows}
        managerRows={managerRows}
        loading={loading}
        error={error}
        onReload={reload}
        currentAdmin={currentAdmin}
        theme={adminTheme}
      />
    );
  }

  if (activeKey.startsWith("manager_")) {
    return (
      <ManagerGenericContent
        title={managementSubModules.find((item) => item.key === activeKey)?.label || otherSettingsSubModules.find((item) => item.key === activeKey)?.label || "Yönetici Yönetimi"}
        desc="Yönetici süreçlerine ait detaylar bu alanda yönetilir."
      />
    );
  }

  if (activeKey === "reports_overview") {
    return <ReportsOverviewContent />;
  }

  if (activeKey === "powerbi_permissions") {
    return (
      <PowerBiPermissionsContent
        publisherRows={publisherRows}
        managerRows={managerRows}
      />
    );
  }

  if (activeKey === "publisher_reports") {
    return (
      <ReportOnlyContent
        title="Yayıncı Raporları"
        type="Yayıncı"
        desc="Yayıncıların Hidden ID bazlı rapor erişimleri bu alanda yönetilir."
      />
    );
  }

  if (activeKey === "manager_report_definitions") {
    return (
      <ReportOnlyContent
        title="Yönetici Raporları"
        type="Yönetici"
        desc="Yöneticilerin ekip bazlı rapor erişimleri bu alanda yönetilir."
      />
    );
  }

  if (activeKey === "admin_reports") {
    return (
      <ReportOnlyContent
        title="Admin Raporları"
        type="Admin"
        desc="Admin kullanıcılarının genel rapor erişimleri bu alanda yönetilir."
      />
    );
  }

  if (activeKey === "report_filters") {
    return (
      <SystemContent
        eyebrow="Raporlar"
        title="RLS / Filtre Kuralları"
        desc="Rapor filtreleri ve erişim kuralları bu alanda yönetilir."
      />
    );
  }

  if (activeKey === "reward_settings") {
    return <AdminRewardManagementContent currentAdmin={currentAdmin} />;
  }

  if (activeKey.startsWith("gift_") && !isUserSuperAdmin(currentAdmin)) {
    return (
      <Card className="p-8 text-center border-red-500/30 bg-red-500/10 max-w-2xl mx-auto my-12">
        <div className="text-4xl mb-3">🚫</div>
        <h3 className="text-xl font-black text-white">Erişim Yetkisi Kısıtlandı</h3>
        <p className="mt-2 text-xs text-red-200/90 leading-relaxed">
          <strong>Hediye / Prim Yönetimi</strong> modülü ve bu modüle ait tüm sayfalar yalnızca <strong>Ana Yönetici (Admin)</strong> yetkisine açıktır.
          Müdür, yönetici veya diğer unvanlı kullanıcılar bu alana erişemez.
        </p>
      </Card>
    );
  }

  if (activeKey === "gift_active_details" || activeKey === "gift_campaigns") {
    return (
      <GiftActiveDetailsContent
        publisherRows={publisherRows}
        managerRows={managerRows}
        currentAdmin={currentAdmin}
      />
    );
  }

  if (activeKey === "gift_awards" || activeKey === "gift_winners") {
    return (
      <GiftDispatchManagementContent
        publisherRows={publisherRows}
        managerRows={managerRows}
        currentAdmin={currentAdmin}
      />
    );
  }

  if (activeKey === "gift_balances") {
    return (
      <PublisherBalancesContent
        publisherRows={publisherRows}
        managerRows={managerRows}
        currentAdmin={currentAdmin}
      />
    );
  }

  if (
    activeKey === "gift_monthly_tracking" ||
    activeKey === "gift_delivery_tracking" ||
    activeKey === "gift_history"
  ) {
    return <GiftMonthlyTrackingContent currentAdmin={currentAdmin} />;
  }

  if (activeKey === "gift_reports" || activeKey === "manager_bonus") {
    return <GiftReportsContent currentAdmin={currentAdmin} setActiveKey={setActiveKey} />;
  }

  if (activeKey === "faq") {
    return <AdminFaqArchiveContent currentAdmin={currentAdmin} />;
  }

  if (activeKey === "editor_requests") {
    return <AdminEditorRequestsContent currentAdmin={currentAdmin} />;
  }

  if (activeKey === "gifts") {
    return (
      <AdminPasswordRequestsContent
        requests={passwordRequests}
        loading={passwordRequestsLoading}
        error={passwordRequestsError}
        onReload={loadPasswordRequests}
      />
    );
  }

  if (activeKey === "approvals") {
    return <ConsentAndVisitorContent />;
  }

  if (activeKey === "content_settings") {
    return (
      <CommonContent
        eyebrow="Diğer Ayarlar"
        title="İçerik Ayarları"
        desc="Genel içerik ve duyuru ayarları bu alanda yönetilir."
        rows={eventRows}
      />
    );
  }

  return (
    <SystemContent
      title={otherSettingsSubModules.find((item) => item.key === activeKey)?.label || "Sistem Ayarları"}
    />
  );
}

function PublisherEyeExperienceContent({ publisherRows = [], currentAdmin = {} }) {
  // Alfabetik olarak A'dan Z'ye kullanici adina gore siralama
  const sortedPublishers = useMemo(() => {
    return [...(publisherRows || [])].sort((a, b) => {
      const userA = String(a.username || a.fullName || "").replace(/^@+/, "").trim();
      const userB = String(b.username || b.fullName || "").replace(/^@+/, "").trim();
      return userA.localeCompare(userB, "tr", { sensitivity: "base" });
    });
  }, [publisherRows]);

  const [selectedUsername, setSelectedUsername] = useState("ALL");
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Aktif simule edilen yayinci
  const activePublisher = useMemo(() => {
    if (selectedUsername === "ALL" || !selectedUsername) {
      return null;
    }
    return sortedPublishers.find((p) => String(p.username) === String(selectedUsername)) || null;
  }, [selectedUsername, sortedPublishers]);

  // Arama filtrelemesi: 'za' yazıldığında kullanıcı adı 'za' ile başlayanları en üste getiren akıllı autocomplete
  const filteredPublishers = useMemo(() => {
    if (!searchQuery.trim()) return sortedPublishers;
    const q = searchQuery.toLowerCase().replace(/^@+/, "").trim();
    
    // 1. Öncelik: Kullanıcı adı 'za' ile başlayanlar
    const startsWithUsername = [];
    // 2. Öncelik: İsim 'za' ile başlayanlar
    const startsWithName = [];
    // 3. Öncelik: İçinde 'za' geçenler
    const containsOther = [];

    sortedPublishers.forEach((p) => {
      const u = String(p.username || "").toLowerCase().replace(/^@+/, "").trim();
      const f = String(p.fullName || "").toLowerCase().trim();
      const h = String(p.hiddenId || "").toLowerCase().trim();
      const ph = String(p.phone || "").toLowerCase().trim();

      if (u.startsWith(q)) {
        startsWithUsername.push(p);
      } else if (f.startsWith(q)) {
        startsWithName.push(p);
      } else if (u.includes(q) || f.includes(q) || h.includes(q) || ph.includes(q)) {
        containsOther.push(p);
      }
    });

    return [...startsWithUsername, ...startsWithName, ...containsOther];
  }, [sortedPublishers, searchQuery]);

  // Dışarı tıklandığında dropdown'ı kapat
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Alfabetik sira indeksi
  const currentIndex = useMemo(() => {
    if (!activePublisher) return -1;
    return sortedPublishers.findIndex((p) => String(p.username) === String(activePublisher.username));
  }, [activePublisher, sortedPublishers]);

  const handleSelectPublisher = (pub) => {
    if (!pub || pub === "ALL") {
      setSelectedUsername("ALL");
      setSearchQuery("");
    } else {
      setSelectedUsername(pub.username);
      setSearchQuery("@" + String(pub.username).replace(/^@+/, "") + " — " + (pub.fullName || ""));
    }
    setIsDropdownOpen(false);
  };

  const handlePrev = () => {
    if (sortedPublishers.length === 0) return;
    let nextPub;
    if (currentIndex <= 0) {
      nextPub = sortedPublishers[sortedPublishers.length - 1];
    } else {
      nextPub = sortedPublishers[currentIndex - 1];
    }
    if (nextPub) {
      setSelectedUsername(nextPub.username);
      setSearchQuery("@" + String(nextPub.username).replace(/^@+/, "") + " — " + (nextPub.fullName || ""));
    }
  };

  const handleNext = () => {
    if (sortedPublishers.length === 0) return;
    let nextPub;
    if (currentIndex === -1 || currentIndex >= sortedPublishers.length - 1) {
      nextPub = sortedPublishers[0];
    } else {
      nextPub = sortedPublishers[currentIndex + 1];
    }
    if (nextPub) {
      setSelectedUsername(nextPub.username);
      setSearchQuery("@" + String(nextPub.username).replace(/^@+/, "") + " — " + (nextPub.fullName || ""));
    }
  };

  const handleOpenInNewTab = () => {
    if (activePublisher) {
      try {
        localStorage.setItem("user", JSON.stringify(activePublisher));
      } catch {}
    }
    window.open("/publisher-dashboard", "_blank");
  };

  return (
    <div className="space-y-6">
      {/* 👑 1. UST KONTROL & ALFABETIK YAYINCI SECIM MASASI */}
      <div className="rounded-3xl border border-amber-500/40 bg-gradient-to-br from-zinc-950 via-zinc-900 to-black p-6 shadow-2xl text-white">
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-white/10 pb-5">
          <div className="space-y-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-3 w-3 rounded-full bg-emerald-400 animate-ping" />
              <span className="text-[11px] font-black uppercase tracking-[0.25em] text-amber-400">
                WOLF MEDIA AJANS • CANLI YAYINCI DENEYIMI SIMULATORU
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-black tracking-tight text-white flex items-center gap-3">
              <span>👁️ Yayıncı İçerikleri — Yayıncının Gözünden</span>
            </h2>
            <p className="text-xs sm:text-sm text-zinc-400 max-w-3xl">
              Yayıncı sisteme şifresiyle giriş yaptığında tam olarak ne görüyorsa, seçtiğiniz yayıncının verileri, görevleri, VIP seviyesi ve editör masası ile birebir onun ekranından izleyin.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleOpenInNewTab}
              className="inline-flex items-center gap-2 rounded-xl border border-amber-500/50 bg-amber-500/15 px-4 py-2.5 text-xs font-black text-amber-300 hover:bg-amber-500/30 transition shadow-lg cursor-pointer"
            >
              <span>↗️</span>
              <span>Yeni Sekmede Tam Ekran Aç</span>
            </button>
          </div>
        </div>

        {/* 🎛️ 2. AKILLI AUTOCOMPLETE YAYINCI ARAMA & FILTRELEME MASASI */}
        <div className="mt-5 space-y-2 relative" ref={dropdownRef}>
          <div className="flex items-center justify-between">
            <label className="text-xs font-bold text-amber-400 flex items-center gap-2">
              <span>🔍 YAYINCI SEÇİNİZ VEYA ARAYINIZ (KULLANICI ADI, İSİM VEYA TİKTOK ID)</span>
            </label>
            <div className="flex items-center gap-2 text-[11px] text-zinc-400 font-mono">
              <span>Toplam: {sortedPublishers.length} Yayıncı</span>
              {currentIndex >= 0 && (
                <span className="text-amber-400 font-bold bg-amber-500/10 px-2 py-0.5 rounded-full border border-amber-500/30">
                  Alfabetik Sıra: {currentIndex + 1} / {sortedPublishers.length}
                </span>
              )}
            </div>
          </div>

          <div className="relative flex items-center gap-2">
            {/* Arama ve Autocomplete Input */}
            <div className="relative flex-1">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setIsDropdownOpen(true);
                }}
                onFocus={() => setIsDropdownOpen(true)}
                placeholder="Yayıncı kullanıcı adı yazın (örn: za, @zafer, ahmet)..."
                className="w-full rounded-2xl border border-amber-500/50 bg-zinc-900/95 pl-11 pr-24 py-3.5 text-sm font-bold text-white placeholder-zinc-500 shadow-inner focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-500/30 transition cursor-text"
              />
              <span className="absolute left-4 top-3.5 text-base text-amber-400 pointer-events-none">🔍</span>

              <div className="absolute right-3 top-2.5 flex items-center gap-1.5">
                {searchQuery && (
                  <button
                    type="button"
                    onClick={() => {
                      setSearchQuery("");
                      setSelectedUsername("ALL");
                      setIsDropdownOpen(false);
                    }}
                    className="h-7 w-7 rounded-lg bg-zinc-800 text-xs font-bold text-zinc-400 hover:text-white hover:bg-zinc-700 flex items-center justify-center transition cursor-pointer"
                    title="Aramayı Temizle"
                  >
                    ✕
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="h-7 px-2.5 rounded-lg bg-amber-500/20 text-xs font-bold text-amber-300 hover:bg-amber-500/30 border border-amber-500/40 flex items-center gap-1 transition cursor-pointer"
                  title="Listeyi Aç / Kapat"
                >
                  <span>{isDropdownOpen ? "▲" : "▼"}</span>
                </button>
              </div>

              {/* 🌟 Açılır Autocomplete Dropdown Listesi */}
              {isDropdownOpen && (
                <div className="absolute left-0 right-0 top-full mt-2 z-50 max-h-80 overflow-y-auto rounded-2xl border border-amber-500/40 bg-zinc-950/98 backdrop-blur-2xl shadow-[0_20px_60px_rgba(0,0,0,0.9)] divide-y divide-white/5 animate-fadeIn">
                  {/* Demo / Tüm Yayıncılar Seçeneği */}
                  <div
                    onClick={() => handleSelectPublisher("ALL")}
                    className={`p-3.5 flex items-center justify-between cursor-pointer transition ${
                      selectedUsername === "ALL" ? "bg-amber-500/20 text-amber-300 font-bold" : "hover:bg-white/5 text-zinc-300"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-500/20 text-base font-black text-amber-300 border border-amber-500/40">
                        🌟
                      </div>
                      <div>
                        <div className="text-xs font-black text-white">Tüm Yayıncılar (Varsayılan Demo / Genel Önizleme)</div>
                        <div className="text-[11px] text-zinc-400">Genel yayıncı deneyimi modu</div>
                      </div>
                    </div>
                    {selectedUsername === "ALL" && (
                      <span className="text-xs font-black text-amber-400 bg-amber-400/20 px-2.5 py-0.5 rounded-full border border-amber-400/30">Seçili ✓</span>
                    )}
                  </div>

                  {filteredPublishers.length > 0 ? (
                    filteredPublishers.map((pub) => {
                      const isSelected = String(pub.username) === String(selectedUsername);
                      const cleanUser = String(pub.username || "").replace(/^@+/, "");
                      return (
                        <div
                          key={pub.username || pub.id}
                          onClick={() => handleSelectPublisher(pub)}
                          className={`p-3 flex items-center justify-between cursor-pointer transition ${
                            isSelected ? "bg-amber-500/20 text-amber-300" : "hover:bg-white/5 text-zinc-200"
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl font-black text-sm border ${
                              isSelected ? "bg-amber-400 text-black border-amber-300 shadow-md" : "bg-zinc-900 text-amber-400 border-white/10"
                            }`}>
                              {String(pub.fullName || cleanUser || "W").charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <div className="flex items-center gap-2">
                                <span className="text-xs font-black text-amber-300 font-mono">
                                  @{cleanUser}
                                </span>
                                <span className="text-xs font-semibold text-white">
                                  {pub.fullName || "-"}
                                </span>
                              </div>
                              <div className="flex items-center gap-2 text-[10px] text-zinc-400 mt-0.5">
                                <span className="text-cyan-400 font-mono">🆔 TikTok: {pub.hiddenId || "-"}</span>
                                <span>•</span>
                                <span className="text-amber-300">🏆 {pub.tier || "1. Kademe"}</span>
                                <span>•</span>
                                <span className="text-emerald-400 font-mono">💎 {Number(pub.currentDiamonds || 0).toLocaleString("tr-TR")}</span>
                              </div>
                            </div>
                          </div>

                          <div className="flex items-center gap-2">
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${
                              pub.status === "Aktif" ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/40" : "bg-zinc-800 text-zinc-400"
                            }`}>
                              {pub.status || "Aktif"}
                            </span>
                            {isSelected && (
                              <span className="text-xs font-black text-amber-400 bg-amber-500/20 px-2 py-0.5 rounded-full border border-amber-500/30">✓</span>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="p-6 text-center text-xs text-zinc-400 font-medium">
                      "{searchQuery}" aramasıyla eşleşen yayıncı bulunamadı.
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Alfabetik Önceki / Sonraki Butonları */}
            <button
              type="button"
              onClick={handlePrev}
              title="Önceki Yayıncı (Alfabetik)"
              className="h-12 w-12 shrink-0 flex items-center justify-center rounded-2xl border border-white/20 bg-white/5 text-xl font-bold text-white hover:bg-amber-500/20 hover:border-amber-400 hover:text-amber-300 transition cursor-pointer shadow"
            >
              ‹
            </button>
            <button
              type="button"
              onClick={handleNext}
              title="Sonraki Yayıncı (Alfabetik)"
              className="h-12 w-12 shrink-0 flex items-center justify-center rounded-2xl border border-white/20 bg-white/5 text-xl font-bold text-white hover:bg-amber-500/20 hover:border-amber-400 hover:text-amber-300 transition cursor-pointer shadow"
            >
              ›
            </button>
          </div>
        </div>

        {/* 🌟 3. SECILI YAYINCI BILGI & SIMULASYON SERIDI */}
        {activePublisher ? (
          <div className="mt-5 rounded-2xl border border-amber-500/30 bg-amber-500/10 p-4 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3.5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-amber-400/60 bg-black text-xl font-black text-amber-300 shadow-md">
                {String(activePublisher.fullName || activePublisher.username || "W").charAt(0).toUpperCase()}
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-base font-black text-white">
                    {activePublisher.fullName || "İsimsiz Yayıncı"}
                  </span>
                  <span className="rounded-full bg-amber-500/20 px-2.5 py-0.5 text-xs font-mono font-bold text-amber-300">
                    @{(activePublisher.username || "").replace(/^@+/, "")}
                  </span>
                  <span className={"rounded-full px-2 py-0.5 text-[10px] font-bold " + (activePublisher.status === "Aktif" ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/40" : "bg-zinc-700 text-zinc-300")}>
                    {activePublisher.status || "Aktif"}
                  </span>
                </div>
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-zinc-300 mt-1">
                  <span>📱 <b>Tel:</b> {activePublisher.phone || "-"}</span>
                  <span>🆔 <b>TikTok ID:</b> {activePublisher.hiddenId || "-"}</span>
                  <span>👔 <b>Temsilci:</b> {activePublisher.managerName || activePublisher.assignedEmployeeUsername || "-"}</span>
                  <span>💎 <b>Elmas:</b> {Number(activePublisher.performanceDiamonds ?? activePublisher.currentDiamonds ?? 0).toLocaleString("tr-TR")}</span>
                  <span>🏆 <b>Kademe:</b> {activePublisher.tier || "1. Kademe"}</span>
                </div>
              </div>
            </div>
            <div className="inline-flex items-center gap-2 rounded-xl bg-black/60 px-3.5 py-2 border border-white/10 text-xs font-bold text-emerald-300">
              <span className="flex h-2 w-2 rounded-full bg-emerald-400 animate-ping" />
              <span>Birebir Yayıncı Oturumu Simüle Ediliyor</span>
            </div>
          </div>
        ) : (
          <div className="mt-5 rounded-2xl border border-white/10 bg-white/5 p-3.5 flex items-center justify-between text-xs text-zinc-300">
            <div className="flex items-center gap-2">
              <span>💡</span>
              <span><b>Tüm Yayıncılar Modu:</b> Yukarıdaki açılır listeden dilediğiniz yayıncıyı alfabetik sırayla seçerek onun gözünden panel deneyimini canlı görüntüleyebilirsiniz.</span>
            </div>
            <span className="font-mono text-amber-400 font-bold">{sortedPublishers.length} Yayıncı Hazır</span>
          </div>
        )}
      </div>

      {/* 🖥️ 4. YAYINCININ GOZUNDEN CANLI DASHBOARD GORUNUMU */}
      <div className="rounded-[2.5rem] border border-white/15 bg-zinc-950/80 backdrop-blur-xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between border-b border-white/10 bg-zinc-900/90 px-6 py-3.5 text-xs">
          <div className="flex items-center gap-2">
            <span className="h-3 w-3 rounded-full bg-rose-500/80" />
            <span className="h-3 w-3 rounded-full bg-amber-500/80" />
            <span className="h-3 w-3 rounded-full bg-emerald-500/80" />
            <span className="ml-2 font-mono text-[11px] text-zinc-400">
              wolfmediaajans.com/publisher-dashboard {activePublisher ? "[@" + String(activePublisher.username).replace(/^@+/,"") + "]" : "[Demo Görünüm]"}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="rounded-full bg-amber-500/15 border border-amber-500/30 px-3 py-1 text-[11px] font-black text-amber-300">
              {activePublisher ? "CANLI: " + activePublisher.fullName : "GENEL YAYINCI GÖRÜNÜMÜ"}
            </span>
          </div>
        </div>

        <div className="p-4 sm:p-8">
          <PublisherDashboard
            overridePublisher={activePublisher || undefined}
            isImpersonated={true}
          />
        </div>
      </div>
    </div>
  );
}


function ManagerEyeExperienceContent({ managerRows = [], publisherRows = [], currentAdmin = {} }) {
  const sortedManagers = useMemo(() => {
    return [...(managerRows || [])].sort((a, b) => {
      const userA = String(a.username || a.fullName || "").replace(/^@+/, "").trim();
      const userB = String(b.username || b.fullName || "").replace(/^@+/, "").trim();
      return userA.localeCompare(userB, "tr", { sensitivity: "base" });
    });
  }, [managerRows]);

  const [selectedUsername, setSelectedUsername] = useState("ALL");
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const activeManager = useMemo(() => {
    if (selectedUsername === "ALL" || !selectedUsername) {
      return null;
    }
    return sortedManagers.find((m) => String(m.username) === String(selectedUsername)) || null;
  }, [selectedUsername, sortedManagers]);

  const filteredManagers = useMemo(() => {
    if (!searchQuery.trim()) return sortedManagers;
    const q = searchQuery.toLowerCase().replace(/^@+/, "").trim();

    const startsWithUsername = [];
    const startsWithName = [];
    const containsOther = [];

    sortedManagers.forEach((m) => {
      const u = String(m.username || "").toLowerCase().replace(/^@+/, "").trim();
      const f = String(m.fullName || "").toLowerCase().trim();
      const ph = String(m.phone || "").toLowerCase().trim();
      const em = String(m.email || "").toLowerCase().trim();

      if (u.startsWith(q)) {
        startsWithUsername.push(m);
      } else if (f.startsWith(q)) {
        startsWithName.push(m);
      } else if (u.includes(q) || f.includes(q) || ph.includes(q) || em.includes(q)) {
        containsOther.push(m);
      }
    });

    return [...startsWithUsername, ...startsWithName, ...containsOther];
  }, [sortedManagers, searchQuery]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentIndex = useMemo(() => {
    if (!activeManager) return -1;
    return sortedManagers.findIndex((m) => String(m.username) === String(activeManager.username));
  }, [activeManager, sortedManagers]);

  const handleSelectManager = (mgr) => {
    if (!mgr || mgr === "ALL") {
      setSelectedUsername("ALL");
      setSearchQuery("");
    } else {
      setSelectedUsername(mgr.username);
      setSearchQuery("@" + String(mgr.username).replace(/^@+/, "") + " — " + (mgr.fullName || ""));
    }
    setIsDropdownOpen(false);
  };

  const handlePrev = () => {
    if (sortedManagers.length === 0) return;
    let nextMgr;
    if (currentIndex <= 0) {
      nextMgr = sortedManagers[sortedManagers.length - 1];
    } else {
      nextMgr = sortedManagers[currentIndex - 1];
    }
    if (nextMgr) {
      setSelectedUsername(nextMgr.username);
      setSearchQuery("@" + String(nextMgr.username).replace(/^@+/, "") + " — " + (nextMgr.fullName || ""));
    }
  };

  const handleNext = () => {
    if (sortedManagers.length === 0) return;
    let nextMgr;
    if (currentIndex === -1 || currentIndex >= sortedManagers.length - 1) {
      nextMgr = sortedManagers[0];
    } else {
      nextMgr = sortedManagers[currentIndex + 1];
    }
    if (nextMgr) {
      setSelectedUsername(nextMgr.username);
      setSearchQuery("@" + String(nextMgr.username).replace(/^@+/, "") + " — " + (nextMgr.fullName || ""));
    }
  };

  const handleOpenInNewTab = () => {
    if (activeManager) {
      try {
        localStorage.setItem("user", JSON.stringify(activeManager));
      } catch {}
    }
    window.open("/employee-dashboard", "_blank");
  };

  return (
    <div className="space-y-6">
      <div className="rounded-3xl border border-amber-500/40 bg-gradient-to-br from-zinc-950 via-zinc-900 to-black p-6 shadow-2xl text-white">
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-white/10 pb-5">
          <div className="space-y-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-3 w-3 rounded-full bg-emerald-400 animate-ping" />
              <span className="text-[11px] font-black uppercase tracking-[0.25em] text-amber-400">
                WOLF MEDIA AJANS • CANLI YÖNETİCİ DENEYİMİ SİMÜLATÖRÜ
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-black tracking-tight text-white flex items-center gap-3">
              <span>👔 Yönetici İçerikleri — Yöneticinin Gözünden</span>
            </h2>
            <p className="text-xs sm:text-sm text-zinc-400 max-w-3xl">
              Yönetici sisteme şifresiyle giriş yaptığında tam olarak ne görüyorsa, seçtiğiniz yöneticinin bağlı yayıncıları, ekip performansı, görevleri ve iletişim masası ile birebir onun ekranından izleyin.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleOpenInNewTab}
              className="inline-flex items-center gap-2 rounded-xl border border-amber-500/50 bg-amber-500/15 px-4 py-2.5 text-xs font-black text-amber-300 hover:bg-amber-500/30 transition shadow-lg cursor-pointer"
            >
              <span>↗️</span>
              <span>Yeni Sekmede Tam Ekran Aç</span>
            </button>
          </div>
        </div>

        <div className="mt-5 space-y-2 relative" ref={dropdownRef}>
          <div className="flex items-center justify-between">
            <label className="text-xs font-bold text-amber-400 flex items-center gap-2">
              <span>🔍 YÖNETİCİ SEÇİNİZ VEYA ARAYINIZ (KULLANICI ADI, İSİM, TELEFON VEYA MAİL)</span>
            </label>
            <div className="flex items-center gap-2 text-[11px] text-zinc-400 font-mono">
              <span>Toplam: {sortedManagers.length} Yönetici</span>
              {currentIndex >= 0 && (
                <span className="text-amber-400 font-bold bg-amber-500/10 px-2 py-0.5 rounded-full border border-amber-500/30">
                  Alfabetik Sıra: {currentIndex + 1} / {sortedManagers.length}
                </span>
              )}
            </div>
          </div>

          <div className="relative flex items-center gap-2">
            <div className="relative flex-1">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setIsDropdownOpen(true);
                }}
                onFocus={() => setIsDropdownOpen(true)}
                placeholder="Yönetici kullanıcı adı yazın (örn: @yonetici, mehmet, ahmet)..."
                className="w-full rounded-2xl border border-amber-500/50 bg-zinc-900/95 pl-11 pr-24 py-3.5 text-sm font-bold text-white placeholder-zinc-500 shadow-inner focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-500/30 transition cursor-text"
              />
              <span className="absolute left-4 top-3.5 text-base text-amber-400 pointer-events-none">🔍</span>

              <div className="absolute right-3 top-2.5 flex items-center gap-1.5">
                {searchQuery && (
                  <button
                    type="button"
                    onClick={() => {
                      setSearchQuery("");
                      setSelectedUsername("ALL");
                      setIsDropdownOpen(false);
                    }}
                    className="h-7 w-7 rounded-lg bg-zinc-800 text-xs font-bold text-zinc-400 hover:text-white hover:bg-zinc-700 flex items-center justify-center transition cursor-pointer"
                    title="Aramayı Temizle"
                  >
                    ✕
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="h-7 px-2.5 rounded-lg bg-amber-500/20 text-xs font-bold text-amber-300 hover:bg-amber-500/30 border border-amber-500/40 flex items-center gap-1 transition cursor-pointer"
                  title="Listeyi Aç / Kapat"
                >
                  <span>{isDropdownOpen ? "▲" : "▼"}</span>
                </button>
              </div>

              {isDropdownOpen && (
                <div className="absolute left-0 right-0 top-full mt-2 z-50 max-h-80 overflow-y-auto rounded-2xl border border-amber-500/40 bg-zinc-950/98 backdrop-blur-2xl shadow-[0_20px_60px_rgba(0,0,0,0.9)] divide-y divide-white/5 animate-fadeIn">
                  <div
                    onClick={() => handleSelectManager("ALL")}
                    className={`p-3.5 flex items-center justify-between cursor-pointer transition ${
                      selectedUsername === "ALL" ? "bg-amber-500/20 text-amber-300 font-bold" : "hover:bg-white/5 text-zinc-300"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-500/20 text-base font-black text-amber-300 border border-amber-500/40">
                        🌟
                      </div>
                      <div>
                        <div className="text-xs font-black text-white">Tüm Yöneticiler (Varsayılan Demo / Genel Önizleme)</div>
                        <div className="text-[11px] text-zinc-400">Genel yönetici deneyimi modu</div>
                      </div>
                    </div>
                    {selectedUsername === "ALL" && (
                      <span className="text-xs font-black text-amber-400 bg-amber-400/20 px-2.5 py-0.5 rounded-full border border-amber-400/30">Seçili ✓</span>
                    )}
                  </div>

                  {filteredManagers.length > 0 ? (
                    filteredManagers.map((mgr) => {
                      const isSelected = String(mgr.username) === String(selectedUsername);
                      const cleanUser = String(mgr.username || "").replace(/^@+/, "");
                      return (
                        <div
                          key={mgr.username || mgr.id}
                          onClick={() => handleSelectManager(mgr)}
                          className={`p-3 flex items-center justify-between cursor-pointer transition ${
                            isSelected ? "bg-amber-500/20 text-amber-300" : "hover:bg-white/5 text-zinc-200"
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl font-black text-sm border ${
                              isSelected ? "bg-amber-400 text-black border-amber-300 shadow-md" : "bg-zinc-900 text-amber-400 border-white/10"
                            }`}>
                              {String(mgr.fullName || cleanUser || "M").charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <div className="flex items-center gap-2">
                                <span className="text-xs font-black text-amber-300 font-mono">
                                  @{cleanUser}
                                </span>
                                <span className="text-xs font-semibold text-white">
                                  {mgr.fullName || "-"}
                                </span>
                              </div>
                              <div className="flex items-center gap-2 text-[10px] text-zinc-400 mt-0.5">
                                <span className="text-cyan-400 font-mono">📞 {mgr.phone || "-"}</span>
                                <span>•</span>
                                <span className="text-amber-300">👥 {mgr.publisherCount || 0} Yayıncı</span>
                                <span>•</span>
                                <span className="text-emerald-400 font-mono">{mgr.powerBIRole || "manager_team_rls"}</span>
                              </div>
                            </div>
                          </div>

                          <div className="flex items-center gap-2">
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${
                              mgr.status === "Aktif" ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/40" : "bg-zinc-800 text-zinc-400"
                            }`}>
                              {mgr.status || "Aktif"}
                            </span>
                            {isSelected && (
                              <span className="text-xs font-black text-amber-400 bg-amber-500/20 px-2 py-0.5 rounded-full border border-amber-500/30">✓</span>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="p-6 text-center text-xs text-zinc-400 font-medium">
                      "{searchQuery}" aramasıyla eşleşen yönetici bulunamadı.
                    </div>
                  )}
                </div>
              )}
            </div>

            <button
              type="button"
              onClick={handlePrev}
              title="Önceki Yönetici (Alfabetik)"
              className="h-12 w-12 shrink-0 flex items-center justify-center rounded-2xl border border-white/20 bg-white/5 text-xl font-bold text-white hover:bg-amber-500/20 hover:border-amber-400 hover:text-amber-300 transition cursor-pointer shadow"
            >
              ‹
            </button>
            <button
              type="button"
              onClick={handleNext}
              title="Sonraki Yönetici (Alfabetik)"
              className="h-12 w-12 shrink-0 flex items-center justify-center rounded-2xl border border-white/20 bg-white/5 text-xl font-bold text-white hover:bg-amber-500/20 hover:border-amber-400 hover:text-amber-300 transition cursor-pointer shadow"
            >
              ›
            </button>
          </div>
        </div>

        {activeManager ? (
          <div className="mt-5 rounded-2xl border border-amber-500/30 bg-amber-500/10 p-4 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3.5">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-amber-400/60 bg-black text-xl font-black text-amber-300 shadow-md">
                {String(activeManager.fullName || activeManager.username || "M").charAt(0).toUpperCase()}
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-base font-black text-white">
                    {activeManager.fullName || "İsimsiz Yönetici"}
                  </span>
                  <span className="rounded-full bg-amber-500/20 px-2.5 py-0.5 text-xs font-mono font-bold text-amber-300">
                    @{(activeManager.username || "").replace(/^@+/, "")}
                  </span>
                  <span className={"rounded-full px-2 py-0.5 text-[10px] font-bold " + (activeManager.status === "Aktif" ? "bg-emerald-500/20 text-emerald-300 border border-emerald-500/40" : "bg-zinc-700 text-zinc-300")}>
                    {activeManager.status || "Aktif"}
                  </span>
                </div>
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-zinc-300 mt-1">
                  <span>📱 <b>Tel:</b> {activeManager.phone || "-"}</span>
                  <span>📧 <b>Mail:</b> {activeManager.email || "-"}</span>
                  <span>👥 <b>Bağlı Yayıncı:</b> {activeManager.publisherCount || 0}</span>
                  <span>🛡️ <b>Yetki Rolü:</b> {activeManager.powerBIRole || "manager_team_rls"}</span>
                </div>
              </div>
            </div>
            <div className="inline-flex items-center gap-2 rounded-xl bg-black/60 px-3.5 py-2 border border-white/10 text-xs font-bold text-emerald-300">
              <span className="flex h-2 w-2 rounded-full bg-emerald-400 animate-ping" />
              <span>Birebir Yönetici Oturumu Simüle Ediliyor</span>
            </div>
          </div>
        ) : (
          <div className="mt-5 rounded-2xl border border-white/10 bg-white/5 p-3.5 flex items-center justify-between text-xs text-zinc-300">
            <div className="flex items-center gap-2">
              <span>💡</span>
              <span><b>Tüm Yöneticiler Modu:</b> Yukarıdaki açılır listeden dilediğiniz yöneticiyi seçerek onun gözünden yönetici paneli deneyimini canlı görüntüleyebilirsiniz.</span>
            </div>
            <span className="font-mono text-amber-400 font-bold">{sortedManagers.length} Yönetici Hazır</span>
          </div>
        )}
      </div>

      <div className="rounded-[2.5rem] border border-white/15 bg-zinc-950/80 backdrop-blur-xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between border-b border-white/10 bg-zinc-900/90 px-6 py-3.5 text-xs">
          <div className="flex items-center gap-2">
            <span className="h-3 w-3 rounded-full bg-rose-500/80" />
            <span className="h-3 w-3 rounded-full bg-amber-500/80" />
            <span className="h-3 w-3 rounded-full bg-emerald-500/80" />
            <span className="ml-2 font-mono text-[11px] text-zinc-400">
              wolfmediaajans.com/employee-dashboard {activeManager ? "[@" + String(activeManager.username).replace(/^@+/,"") + "]" : "[Demo Görünüm]"}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="rounded-full bg-amber-500/15 border border-amber-500/30 px-3 py-1 text-[11px] font-black text-amber-300">
              {activeManager ? "CANLI: " + activeManager.fullName : "GENEL YÖNETİCİ GÖRÜNÜMÜ"}
            </span>
          </div>
        </div>

        <div className="p-4 sm:p-8">
          <EmployeeDashboard
            overrideEmployee={activeManager || undefined}
            isImpersonated={true}
          />
        </div>
      </div>
    </div>
  );
}


function PublisherReportsManagementContent({
  publisherRows = [],
  managers = [],
  loading = false,
  onReload,
  actions = {},
  onReportUploadClick,
  currentAdmin,
}) {
  const [activeTab, setActiveTab] = useState("not_in_system"); // "not_in_system" | "username_changed"
  const [search, setSearch] = useState("");
  const [diffData, setDiffData] = useState({
    notInSystem: [],
    usernameChanged: [],
    stats: {
      notInSystemCount: 0,
      usernameChangedCount: 0,
      totalReportPublishers: 0,
      latestReportDate: "",
    },
  });
  const [diffLoading, setDiffLoading] = useState(false);
  const [diffError, setDiffError] = useState("");
  const [copiedId, setCopiedId] = useState(null);

  const loadDiff = useCallback(async () => {
    try {
      setDiffLoading(true);
      setDiffError("");
      const res = await requestJson(API_PUBLISHER_REPORT_DIFF, { cache: "no-store" });
      if (res && res.success) {
        setDiffData({
          notInSystem: res.notInSystem || [],
          usernameChanged: res.usernameChanged || [],
          stats: res.stats || {
            notInSystemCount: (res.notInSystem || []).length,
            usernameChangedCount: (res.usernameChanged || []).length,
            totalReportPublishers: 0,
            latestReportDate: "",
          },
        });
      } else {
        throw new Error(res?.message || "Rapor karşılaştırma verisi alınamadı.");
      }
    } catch (err) {
      setDiffError(err.message || "Rapor verileri taranamadı.");
    } finally {
      setDiffLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDiff();
  }, [loadDiff, publisherRows]);

  const handleRefreshAll = async () => {
    if (onReload) {
      await onReload();
    }
    await loadDiff();
  };

  const copyToClipboard = (text, id) => {
    if (!text) return;
    navigator.clipboard?.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const findManagerForReport = (managerEmail) => {
    if (!managerEmail) return "";
    const clean = String(managerEmail).toLowerCase().trim();
    const found = (managers || []).find(
      (m) =>
        (m.email && m.email.toLowerCase().trim() === clean) ||
        (m.username && m.username.toLowerCase().trim() === clean)
    );
    return found ? found.username : "";
  };

  const filteredNotInSystem = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return diffData.notInSystem;
    return diffData.notInSystem.filter((item) => {
      const matchHidden = String(item.hiddenId || "").toLowerCase().includes(q);
      const matchUser = String(item.username || "").toLowerCase().includes(q);
      const matchName = String(item.fullName || "").toLowerCase().includes(q);
      const matchGroup = String(item.agencyGroup || "").toLowerCase().includes(q);
      return matchHidden || matchUser || matchName || matchGroup;
    });
  }, [diffData.notInSystem, search]);

  const filteredUsernameChanged = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return diffData.usernameChanged;
    return diffData.usernameChanged.filter((item) => {
      const matchHidden = String(item.hiddenId || "").toLowerCase().includes(q);
      const matchOldUser = String(item.oldUsername || "").toLowerCase().includes(q);
      const matchNewUser = String(item.newUsername || "").toLowerCase().includes(q);
      const matchOldName = String(item.oldFullName || "").toLowerCase().includes(q);
      return matchHidden || matchOldUser || matchNewUser || matchOldName;
    });
  }, [diffData.usernameChanged, search]);

  const handleAddNewPublisher = (item) => {
    const cleanUser = String(item.username || "").replace(/[@\s]+/g, "");
    actions.openAddPublisherWithData?.(
      {
        hiddenId: item.hiddenId || "",
        username: cleanUser,
        fullName: item.fullName || cleanUser,
        system_username: `wolf.${cleanUser.toLowerCase()}`,
        password: "123456",
        assignedEmployeeUsername: findManagerForReport(item.managerEmail),
        status: "Aktif",
        agencyTrackingStatus: "Aktif",
      },
      () => {
        loadDiff();
      }
    );
  };

  const handleEditPublisherUsername = (item) => {
    const cleanNewUser = String(item.newUsername || "").replace(/[@\s]+/g, "");
    actions.openEditPublisherWithData?.(
      item.user,
      {
        username: cleanNewUser,
        hiddenId: item.hiddenId || item.user.hiddenId || "",
      },
      () => {
        loadDiff();
      }
    );
  };

  return (
    <div className="space-y-6">
      {/* 1. Başlık & Aksiyon Alanı */}
      <SectionHeader
        eyebrow="Yayıncı Takip Modülü"
        title="Yayıncı Raporları (Yeni Yayıncı & Kullanıcı Adı Değişikliği Takibi)"
        desc="Günlük yüklenen raporlardaki yayıncıları sabit TikTok ID üzerinden sistemle karşılaştırır; yeni yayıncıları ve kullanıcı adı değişenleri tespit ederek standart yayıncı sistemine aktarmanızı sağlar."
        action={
          <div className="flex flex-wrap items-center gap-2.5">
            {onReportUploadClick && (
              <ActionButton variant="dark" onClick={onReportUploadClick}>
                📥 Günlük Rapor Yükle
              </ActionButton>
            )}
            <ActionButton onClick={handleRefreshAll} disabled={diffLoading || loading}>
              {diffLoading ? (
                <span className="flex items-center gap-2">
                  <span className="h-3 w-3 animate-spin rounded-full border-2 border-black border-t-transparent" />
                  Taranıyor...
                </span>
              ) : (
                "🔄 Yeniden Karşılaştır"
              )}
            </ActionButton>
          </div>
        }
      />

      {/* 2. KPI / Sayaç Kartları */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Kart 1: Sistemde Olmayan Yayıncılar */}
        <div
          onClick={() => setActiveTab("not_in_system")}
          className={`cursor-pointer rounded-2xl border p-5 transition-all duration-200 relative overflow-hidden ${
            activeTab === "not_in_system"
              ? "border-amber-400 bg-amber-500/15 shadow-[0_0_24px_rgba(245,158,11,0.22)] ring-1 ring-amber-400/40"
              : "border-white/10 bg-white/[0.03] hover:border-amber-500/40 hover:bg-white/[0.05]"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wider text-amber-300">
              Sistemde Olmayanlar
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-amber-500/20 text-base">
              👤➕
            </span>
          </div>
          <div className="mt-3 text-3xl font-black text-white">
            {diffData.stats.notInSystemCount}
          </div>
          <p className="mt-1 text-xs text-white/50 leading-relaxed">
            Günlük raporda bulunup sistemde kaydı olmayan kişiler
          </p>
          {activeTab === "not_in_system" && (
            <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-bold text-amber-300">
              <span className="h-1.5 w-1.5 rounded-full bg-amber-400 animate-ping" />
              Aktif Filtre
            </div>
          )}
        </div>

        {/* Kart 2: Kullanıcı Adı Değişenler */}
        <div
          onClick={() => setActiveTab("username_changed")}
          className={`cursor-pointer rounded-2xl border p-5 transition-all duration-200 relative overflow-hidden ${
            activeTab === "username_changed"
              ? "border-cyan-400 bg-cyan-500/15 shadow-[0_0_24px_rgba(6,182,212,0.22)] ring-1 ring-cyan-400/40"
              : "border-white/10 bg-white/[0.03] hover:border-cyan-500/40 hover:bg-white/[0.05]"
          }`}
        >
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wider text-cyan-300">
              Kullanıcı Adı Değişenler
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-cyan-500/20 text-base">
              🔄
            </span>
          </div>
          <div className="mt-3 text-3xl font-black text-white">
            {diffData.stats.usernameChangedCount}
          </div>
          <p className="mt-1 text-xs text-white/50 leading-relaxed">
            TikTok ID'si eşleşen ancak kullanıcı adı değişmiş kişiler
          </p>
          {activeTab === "username_changed" && (
            <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-bold text-cyan-300">
              <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 animate-ping" />
              Aktif Filtre
            </div>
          )}
        </div>

        {/* Kart 3: En Güncel Rapor Tarihi */}
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wider text-yellow-300">
              En Güncel Rapor Tarihi
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-yellow-500/20 text-base">
              📅
            </span>
          </div>
          <div className="mt-3 text-xl font-black text-white">
            {diffData.stats.latestReportDate
              ? formatDateForDisplay(diffData.stats.latestReportDate)
              : "Rapor Yok"}
          </div>
          <p className="mt-1 text-xs text-white/50 leading-relaxed">
            Karşılaştırmada en son yüklenen günlük rapor esas alınır
          </p>
        </div>

        {/* Kart 4: Toplam Rapor Yayıncısı */}
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wider text-white/60">
              Rapor Havuzundaki Yayıncı
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-white/10 text-base">
              📊
            </span>
          </div>
          <div className="mt-3 text-3xl font-black text-white">
            {diffData.stats.totalReportPublishers}
          </div>
          <p className="mt-1 text-xs text-white/50 leading-relaxed">
            Günlük raporlardaki tekilleştirilmiş toplam yayıncı
          </p>
        </div>
      </div>

      {/* 3. Ana Tablo & Filtre Alanı */}
      <Card className="overflow-hidden">
        {/* Filtre Başlığı & Arama Kutusu */}
        <div className="border-b border-white/10 p-4 sm:p-5 flex flex-col md:flex-row gap-4 items-stretch md:items-center justify-between bg-white/[0.01]">
          {/* İki Filtre Seçeneği (Sekmeler) */}
          <div className="flex flex-wrap items-center gap-2 p-1 rounded-2xl bg-black/60 border border-white/10">
            <button
              type="button"
              onClick={() => setActiveTab("not_in_system")}
              className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black transition cursor-pointer ${
                activeTab === "not_in_system"
                  ? "bg-amber-500 text-black shadow-md shadow-amber-500/20"
                  : "text-white/70 hover:text-white hover:bg-white/5"
              }`}
            >
              <span>👤 Sistemde Olmayan Yayıncılar</span>
              <span
                className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                  activeTab === "not_in_system"
                    ? "bg-black/25 text-black"
                    : "bg-amber-500/20 text-amber-300 border border-amber-500/30"
                }`}
              >
                {diffData.stats.notInSystemCount}
              </span>
            </button>

            <button
              type="button"
              onClick={() => setActiveTab("username_changed")}
              className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-black transition cursor-pointer ${
                activeTab === "username_changed"
                  ? "bg-cyan-500 text-black shadow-md shadow-cyan-500/20"
                  : "text-white/70 hover:text-white hover:bg-white/5"
              }`}
            >
              <span>🔄 Kullanıcı Adı Değişenler</span>
              <span
                className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                  activeTab === "username_changed"
                    ? "bg-black/25 text-black"
                    : "bg-cyan-500/20 text-cyan-300 border border-cyan-500/30"
                }`}
              >
                {diffData.stats.usernameChangedCount}
              </span>
            </button>
          </div>

          {/* Arama Alanı (ID ve Kullanıcı Adı ile Arama) */}
          <div className="w-full md:w-80">
            <SearchBox
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="TikTok ID veya Kullanıcı Adı ile ara..."
            />
          </div>
        </div>

        {/* Hata Banner */}
        {diffError && (
          <div className="m-4 rounded-xl border border-red-500/30 bg-red-500/10 p-4 text-xs font-semibold text-red-300 flex items-center justify-between">
            <span>⚠️ {diffError}</span>
            <button
              onClick={loadDiff}
              className="underline text-red-200 hover:text-white cursor-pointer ml-3 font-bold"
            >
              Tekrar Dene
            </button>
          </div>
        )}

        {/* Tablo İçeriği: Sistemde Olmayan Yayıncılar */}
        {activeTab === "not_in_system" && (
          <>
            <div className="hidden grid-cols-[1.4fr_1.2fr_1fr_1.2fr_1fr_0.9fr_1.3fr] gap-3 bg-white/[0.04] px-5 py-3.5 text-[11px] font-black uppercase tracking-[0.14em] text-white/40 xl:grid border-b border-white/5">
              <div>TikTok ID (Hidden ID)</div>
              <div>Rapordaki Kullanıcı Adı</div>
              <div>Son Rapor Tarihi</div>
              <div>Son Canlı & Elmas</div>
              <div>Grup / Sorumlu</div>
              <div>Durum</div>
              <div className="text-right">İşlem</div>
            </div>

            {diffLoading && diffData.notInSystem.length === 0 ? (
              <div className="p-12 text-center text-sm font-bold text-white/50">
                <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-yellow-400 border-t-transparent mr-2 align-middle" />
                Günlük raporlar ve yayıncı havuzu taranıyor...
              </div>
            ) : filteredNotInSystem.length === 0 ? (
              <div className="p-12 text-center border-dashed border-t border-white/10 bg-white/[0.01]">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-500/15 border border-emerald-500/30 text-emerald-400 text-2xl mb-3 shadow-inner">
                  ✅
                </div>
                <h4 className="text-base font-black text-white">
                  {search ? "Aramaya Uygun Kayıt Bulunamadı" : "Sistemde Olmayan Yayıncı Bulunmuyor"}
                </h4>
                <p className="mt-1.5 text-xs text-white/50 max-w-md mx-auto leading-relaxed">
                  {search
                    ? "Farklı bir TikTok ID veya kullanıcı adı ile aramayı deneyebilirsiniz."
                    : "Yüklenen tüm günlük raporlardaki yayıncılar başarıyla standart yayıncı sistemine aktarılmış durumda."}
                </p>
              </div>
            ) : (
              <div className="divide-y divide-white/5">
                {filteredNotInSystem.map((item) => (
                  <div
                    key={item.id}
                    className="grid grid-cols-1 gap-3 px-5 py-4 transition hover:bg-white/[0.02] xl:grid-cols-[1.4fr_1.2fr_1fr_1.2fr_1fr_0.9fr_1.3fr] xl:items-center"
                  >
                    {/* TikTok ID */}
                    <div className="flex items-center gap-2">
                      <span className="font-mono text-xs font-bold text-yellow-300 bg-yellow-500/10 px-2.5 py-1 rounded-lg border border-yellow-500/20">
                        {item.hiddenId || "-"}
                      </span>
                      {item.hiddenId && (
                        <button
                          type="button"
                          onClick={() => copyToClipboard(item.hiddenId, item.id)}
                          className="text-[11px] text-white/40 hover:text-white transition cursor-pointer"
                          title="TikTok ID Kopyala"
                        >
                          {copiedId === item.id ? "✓" : "📋"}
                        </button>
                      )}
                    </div>

                    {/* Rapordaki Kullanıcı Adı */}
                    <div>
                      <div className="font-black text-sm text-white">
                        @{item.username}
                      </div>
                      <div className="text-[11px] text-white/45">
                        {item.fullName && item.fullName !== item.username ? item.fullName : "TikTok Yayıncısı"}
                      </div>
                    </div>

                    {/* Son Rapor Tarihi */}
                    <div className="text-xs font-semibold text-white/70">
                      {formatDateForDisplay(item.latestReportDate)}
                    </div>

                    {/* Son Canlı & Elmas */}
                    <div>
                      <div className="text-xs font-black text-yellow-300">
                        💎 {formatNumber(item.diamonds)} Elmas
                      </div>
                      <div className="text-[11px] text-white/45">
                        ⏱️ {(Number(item.liveSeconds || 0) / 3600).toFixed(1)} Saat
                      </div>
                    </div>

                    {/* Grup / Sorumlu */}
                    <div className="text-xs text-white/60 truncate" title={item.agencyGroup || item.managerEmail}>
                      {item.agencyGroup || item.managerEmail || "-"}
                    </div>

                    {/* Durum */}
                    <div>
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 px-2.5 py-1 text-[10px] font-black uppercase text-amber-300">
                        <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
                        Sistemde Yok
                      </span>
                    </div>

                    {/* İşlem Butonu */}
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => handleAddNewPublisher(item)}
                        className="inline-flex items-center gap-1.5 rounded-xl border border-yellow-500/50 bg-gradient-to-r from-yellow-500/25 via-amber-500/20 to-yellow-500/25 px-3.5 py-2 text-xs font-black text-yellow-200 transition hover:border-yellow-400 hover:bg-yellow-500/40 hover:scale-105 active:scale-95 shadow-md shadow-yellow-500/10 cursor-pointer"
                        title="Standart yayıncı ekleme panelini açarak bu kişiyi sisteme aktar"
                      >
                        <span>➕</span>
                        <span>İncele & Sisteme Ekle</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* Tablo İçeriği: Kullanıcı Adı Değişenler */}
        {activeTab === "username_changed" && (
          <>
            <div className="hidden grid-cols-[1.2fr_1.3fr_1.4fr_1fr_1fr_1.3fr] gap-3 bg-white/[0.04] px-5 py-3.5 text-[11px] font-black uppercase tracking-[0.14em] text-white/40 xl:grid border-b border-white/5">
              <div>TikTok ID (Hidden ID)</div>
              <div>Mevcut (Eski) Kullanıcı Adı</div>
              <div>➡️ Rapordan Gelen (Yeni) Kullanıcı Adı</div>
              <div>Sorumlu Yönetici</div>
              <div>Son Rapor Tarihi</div>
              <div className="text-right">İşlem</div>
            </div>

            {diffLoading && diffData.usernameChanged.length === 0 ? (
              <div className="p-12 text-center text-sm font-bold text-white/50">
                <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-cyan-400 border-t-transparent mr-2 align-middle" />
                Kullanıcı adı değişiklikleri taranıyor...
              </div>
            ) : filteredUsernameChanged.length === 0 ? (
              <div className="p-12 text-center border-dashed border-t border-white/10 bg-white/[0.01]">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-cyan-500/15 border border-cyan-500/30 text-cyan-400 text-2xl mb-3 shadow-inner">
                  ✅
                </div>
                <h4 className="text-base font-black text-white">
                  {search ? "Aramaya Uygun Değişiklik Bulunamadı" : "Kullanıcı Adı Değişen Yayıncı Yok"}
                </h4>
                <p className="mt-1.5 text-xs text-white/50 max-w-md mx-auto leading-relaxed">
                  {search
                    ? "Farklı bir TikTok ID veya kullanıcı adı ile aramayı deneyebilirsiniz."
                    : "Sistemdeki tüm yayıncıların kullanıcı adları son günlük raporlarla tam uyumlu ve güncel."}
                </p>
              </div>
            ) : (
              <div className="divide-y divide-white/5">
                {filteredUsernameChanged.map((item) => (
                  <div
                    key={item.id}
                    className="grid grid-cols-1 gap-3 px-5 py-4 transition hover:bg-white/[0.02] xl:grid-cols-[1.2fr_1.3fr_1.4fr_1fr_1fr_1.3fr] xl:items-center"
                  >
                    {/* TikTok ID */}
                    <div className="flex items-center gap-2">
                      <span className="font-mono text-xs font-bold text-cyan-300 bg-cyan-500/10 px-2.5 py-1 rounded-lg border border-cyan-500/20">
                        {item.hiddenId || "-"}
                      </span>
                      {item.hiddenId && (
                        <button
                          type="button"
                          onClick={() => copyToClipboard(item.hiddenId, item.id)}
                          className="text-[11px] text-white/40 hover:text-white transition cursor-pointer"
                          title="TikTok ID Kopyala"
                        >
                          {copiedId === item.id ? "✓" : "📋"}
                        </button>
                      )}
                    </div>

                    {/* Eski Kullanıcı Adı */}
                    <div>
                      <div className="font-bold text-sm text-white/80 line-through decoration-red-400/70">
                        @{item.oldUsername}
                      </div>
                      <div className="text-[11px] text-white/40 truncate">
                        {item.oldFullName || "Mevcut Kayıt"}
                      </div>
                    </div>

                    {/* Rapordan Gelen Yeni Kullanıcı Adı */}
                    <div>
                      <div className="inline-flex items-center gap-2 rounded-xl border border-emerald-500/40 bg-emerald-500/15 px-3 py-1.5 shadow-sm">
                        <span className="text-xs font-black text-emerald-300">
                          @{item.newUsername}
                        </span>
                        <span className="rounded-full bg-emerald-400 px-1.5 py-0.5 text-[9px] font-black uppercase text-black">
                          Yeni
                        </span>
                      </div>
                      <div className="text-[10px] text-emerald-200/60 mt-0.5">
                        Günlük raporda tespit edilen güncel isim
                      </div>
                    </div>

                    {/* Sorumlu Yönetici */}
                    <div className="text-xs text-white/70">
                      {item.user.representative || item.user.assignedEmployeeUsername || "-"}
                    </div>

                    {/* Son Rapor Tarihi */}
                    <div className="text-xs font-semibold text-white/70">
                      {formatDateForDisplay(item.latestReportDate)}
                    </div>

                    {/* İşlem Butonu */}
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => handleEditPublisherUsername(item)}
                        className="inline-flex items-center gap-1.5 rounded-xl border border-cyan-500/50 bg-gradient-to-r from-cyan-500/20 via-teal-500/20 to-cyan-500/20 px-3.5 py-2 text-xs font-black text-cyan-200 transition hover:border-cyan-400 hover:bg-cyan-500/35 hover:scale-105 active:scale-95 shadow-md shadow-cyan-500/10 cursor-pointer"
                        title="Standart yayıncı düzenleme panelini açarak ismi ve bilgileri güncelle"
                      >
                        <span>✏️</span>
                        <span>İncele & Güncelle</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

function PublisherTrackingContent({ publisherRows = [], managers = [], loading, onReload, currentAdmin }) {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [managerFilter, setManagerFilter] = useState("all");
  const [selectedCrmUser, setSelectedCrmUser] = useState(null);

  const filteredRows = useMemo(() => {
    return (publisherRows || []).filter((item) => {
      const q = search.toLowerCase().trim();
      const matchSearch = !q || `${item.fullName} ${item.username} ${item.hiddenId} ${item.phone} ${item.assignedEmployeeUsername || item.managerName}`.toLowerCase().includes(q);
      const matchStatus = statusFilter === "all" || item.status === statusFilter;
      const matchManager = managerFilter === "all" || String(item.assignedEmployeeUsername || item.managerName) === managerFilter;
      return matchSearch && matchStatus && matchManager;
    });
  }, [publisherRows, search, statusFilter, managerFilter]);

  return (
    <div className="space-y-5">
      <SectionHeader
        eyebrow="Yayıncı Takip Modülü"
        title="Yayıncı Takibi"
        desc="Aktif yayıncıların günlük yayın disiplini, yayın süresi, elmas hedefleri ve ajans takip / iletişim (CRM) süreçleri bu ekrandan yürütülür."
        action={
          <ActionButton onClick={onReload}>
            {loading ? "Yenileniyor..." : "Takip Listesini Yenile"}
          </ActionButton>
        }
      />

      <Card className="overflow-hidden">
        <div className="border-b border-white/10 p-4 flex flex-col sm:flex-row gap-3 items-center justify-between">
          <div className="w-full sm:w-80">
            <SearchBox value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Yayıncı, TikTok ID veya yönetici ara..." />
          </div>
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="rounded-xl border border-white/10 bg-black/40 px-3 py-2 text-xs font-semibold text-white outline-none [color-scheme:dark]"
            >
              <option value="all">Tüm Durumlar</option>
              <option value="Aktif">Aktif</option>
              <option value="Pasif">Pasif</option>
            </select>

            <select
              value={managerFilter}
              onChange={(e) => setManagerFilter(e.target.value)}
              className="rounded-xl border border-white/10 bg-black/40 px-3 py-2 text-xs font-semibold text-white outline-none [color-scheme:dark]"
            >
              <option value="all">Tüm Yöneticiler</option>
              {managers.map((m) => (
                <option key={m.username} value={m.username}>{m.fullName || m.username}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="hidden grid-cols-[1.2fr_1fr_1fr_1fr_1fr_1fr_.8fr_1.1fr] gap-3 bg-white/[0.04] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid">
          <div>Yayıncı Adı</div>
          <div>Kullanıcı Adı</div>
          <div>TikTok Hidden ID</div>
          <div>Sorumlu Yönetici</div>
          <div>Aylık Elmas</div>
          <div>Canlı Süre / Gün</div>
          <div>Durum</div>
          <div>İletişim & CRM</div>
        </div>

        {!loading && filteredRows.length === 0 ? (
          <EmptyState text="Eşleşen takip kaydı bulunamadı." />
        ) : (
          filteredRows.map((user) => (
            <div
              key={user.id || user.username}
              className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-[1.2fr_1fr_1fr_1fr_1fr_1fr_.8fr_1.1fr] items-center"
            >
              <div className="font-bold text-white flex items-center gap-2">
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-amber-500/20 text-xs font-black text-amber-300 border border-amber-500/30">
                  {String(user.fullName || user.username || "Y").charAt(0).toUpperCase()}
                </div>
                <span className="truncate">{user.fullName || "-"}</span>
              </div>
              <div className="font-mono text-xs text-amber-300 truncate">@{String(user.username || "").replace(/^@+/, "")}</div>
              <div className="font-mono text-xs text-cyan-300 truncate">{user.hiddenId || "-"}</div>
              <div className="text-xs text-white/80 truncate">
                {user.assignedEmployeeUsername || user.managerName || "Atanmadı"}
              </div>
              <div className="font-mono text-xs text-emerald-400 font-bold">
                💎 {Number(user.performanceDiamonds ?? user.currentDiamonds ?? 0).toLocaleString("tr-TR")}
              </div>
              <div className="text-xs text-white/70 font-mono">
                {user.liveHours || user.liveDuration || "-"} / {user.liveDays || user.validDays || "-"} Gün
              </div>
              <div>
                <StatusBadge status={user.status || "Aktif"} />
              </div>
              <div>
                <PublisherCrmBadgeButton
                  publisher={user}
                  onClick={() => setSelectedCrmUser(user)}
                />
              </div>
            </div>
          ))
        )}
      </Card>

      {/* YANDA AÇILIP KAPANAN SLIDE-OVER CRM MASASI */}
      <PublisherCrmSlideOver
        publisher={selectedCrmUser}
        currentUser={currentAdmin}
        isOpen={Boolean(selectedCrmUser)}
        onClose={() => setSelectedCrmUser(null)}
      />
    </div>
  );
}

function TrainingCenterContent() {
  const [trainingRows, setTrainingRows] = useState([]);
  const [trainingLoading, setTrainingLoading] = useState(false);
  const [trainingError, setTrainingError] = useState("");
  const [trainingSaving, setTrainingSaving] = useState(false);
  const [trainingModal, setTrainingModal] = useState({
    open: false,
    mode: "add",
    form: emptyTrainingForm,
  });
  const [trainingUploadFile, setTrainingUploadFile] = useState(null);
  const [trainingUploadProgressText, setTrainingUploadProgressText] = useState("");
  const [trainingDetailModal, setTrainingDetailModal] = useState({
    open: false,
    loading: false,
    content: null,
    views: [],
  });

  const loadTrainings = useCallback(async () => {
    try {
      setTrainingLoading(true);
      setTrainingError("");

      const result = await requestJson(API_TRAINING_LIST, { cache: "no-store" });
      setTrainingRows(Array.isArray(result.data) ? result.data : []);
    } catch (err) {
      setTrainingRows([]);
      setTrainingError(err.message || "Eğitim listesi alınamadı.");
    } finally {
      setTrainingLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTrainings();
  }, [loadTrainings]);

  const totalViewCount = trainingRows.reduce((sum, item) => sum + safeNumber(item.viewCount), 0);
  const totalCompletedCount = trainingRows.reduce((sum, item) => sum + safeNumber(item.completedCount), 0);
  const avgProgress =
    trainingRows.length > 0
      ? Math.round(trainingRows.reduce((sum, item) => sum + safeNumber(item.avgProgress), 0) / trainingRows.length)
      : 0;

  function openAddTraining() {
    setTrainingUploadFile(null);
    setTrainingUploadProgressText("");
    setTrainingModal({
      open: true,
      mode: "add",
      form: emptyTrainingForm,
    });
  }

  function openEditTraining(item) {
    setTrainingUploadFile(null);
    setTrainingUploadProgressText("");
    setTrainingModal({
      open: true,
      mode: "edit",
      form: {
        id: item.id || "",
        title: item.title || "",
        description: item.description || "",
        contentType: item.contentType || "video",
        targetGroup: normalizeTargetGroup(item.targetGroup || item.target_group || "all"),
        fileUrl: item.fileUrl || "",
        externalUrl: item.externalUrl || "",
        status: item.status || "Aktif",
      },
    });
  }

  function closeTrainingModal() {
    setTrainingUploadFile(null);
    setTrainingUploadProgressText("");
    setTrainingModal({
      open: false,
      mode: "add",
      form: emptyTrainingForm,
    });
  }

  function handleTrainingFormChange(event) {
    const { name, value } = event.target;

    setTrainingModal((prev) => ({
      ...prev,
      form: {
        ...prev.form,
        [name]: value,
      },
    }));
  }

  function handleTrainingFileChange(event) {
    const file = event.target.files?.[0] || null;
    setTrainingUploadFile(file);
    setTrainingUploadProgressText(file ? `${file.name} seçildi` : "");

    if (file?.type?.startsWith("video/")) {
      setTrainingModal((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          contentType: "video",
        },
      }));
    }
  }

  async function uploadTrainingFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(API_TRAINING_UPLOAD, {
      method: "POST",
      body: formData,
    });

    const text = await response.text();
    const result = parseJsonResponse(text);

    if (!response.ok || result.success === false) {
      throw new Error(result.message || "Dosya yüklenemedi.");
    }

    return result.url || result.fileUrl || "";
  }

  async function submitTraining(event) {
    event.preventDefault();

    if (!trainingModal.form.title.trim()) {
      alert("Eğitim başlığı zorunlu.");
      return;
    }

    try {
      setTrainingSaving(true);

      let payload = { ...trainingModal.form, targetGroup: normalizeTargetGroup(trainingModal.form.targetGroup) };

      if (trainingUploadFile) {
        setTrainingUploadProgressText("Dosya yükleniyor...");
        const uploadedUrl = await uploadTrainingFile(trainingUploadFile);
        payload = {
          ...payload,
          fileUrl: uploadedUrl,
          externalUrl: payload.externalUrl || "",
        };
        setTrainingUploadProgressText("Dosya yüklendi.");
      }

      await requestJson(API_TRAINING_SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      closeTrainingModal();
      await loadTrainings();
      alert("Eğitim kaydedildi.");
    } catch (err) {
      alert(err.message || "Eğitim kaydedilemedi.");
    } finally {
      setTrainingSaving(false);
    }
  }

  async function handleDeleteTraining(item) {
    if (!window.confirm(`${item.title || "Eğitim"} içeriğini silmek istiyor musunuz?`)) return;

    try {
      setTrainingSaving(true);

      await requestJson(API_TRAINING_DELETE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      await loadTrainings();
      alert("Eğitim içeriği silindi.");
    } catch (err) {
      alert(err.message || "Eğitim içeriği silinemedi.");
    } finally {
      setTrainingSaving(false);
    }
  }

  async function openTrainingDetail(item) {
    try {
      setTrainingDetailModal({
        open: true,
        loading: true,
        content: item,
        views: [],
      });

      const result = await requestJson(`${API_TRAINING_DETAIL}?trainingId=${encodeURIComponent(item.id)}`, {
        cache: "no-store",
      });

      setTrainingDetailModal({
        open: true,
        loading: false,
        content: result.content || item,
        views: Array.isArray(result.views) ? result.views : [],
      });
    } catch (err) {
      setTrainingDetailModal({
        open: true,
        loading: false,
        content: item,
        views: [],
      });

      alert(err.message || "Eğitim detayı alınamadı.");
    }
  }

  function exportTrainingCsv(item, views = []) {
    const header = ["Ad Soyad", "Kullanıcı Adı", "Hidden ID", "Telefon", "İzleme Yüzdesi", "Tamamlandı", "İlk Görüntüleme", "Son Görüntüleme"];
    const rows = views.map((view) => [
      view.fullName || "",
      view.username || "",
      view.hiddenId || "",
      view.phone || "",
      view.progressPercent || 0,
      Number(view.completed) === 1 ? "Evet" : "Hayır",
      view.firstViewedAt || "",
      view.lastViewedAt || "",
    ]);

    const csv = [header, ...rows]
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","))
      .join("\n");

    const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${item?.title || "egitim"}-izlenme-raporu.csv`;
    link.click();

    URL.revokeObjectURL(url);
  }

  return (
    <div>
      <SectionHeader
        eyebrow="Diğer Ayarlar"
        title="Eğitim Merkezi"
        desc="Yayıncılara video veya görsel eğitim içerikleri eklenir; görüntüleme, katılım ve izleme oranları takip edilir."
        action={<ActionButton onClick={openAddTraining}>Yeni Eğitim Ekle</ActionButton>}
      />

      <div className="mb-5 grid gap-4 md:grid-cols-3">
        <StatCard title="Toplam Eğitim" value={trainingRows.length} note="Kayıtlı eğitim içeriği" />
        <StatCard title="Toplam Görüntüleme" value={formatNumber(totalViewCount)} note="Yayıncı görüntüleme sayısı" />
        <StatCard title="Tamamlama" value={formatNumber(totalCompletedCount)} note={`Ortalama ilerleme: %${avgProgress}`} />
      </div>

      <Card className="overflow-hidden">
        <div className="border-b border-white/10 p-5">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <div className="text-xl font-black text-white">Eğitim İçerikleri</div>
              <p className="mt-2 text-sm text-white/45">
                Yeni içerik eklendiğinde yayıncı panelinde görünür. Kim görüntüledi, yüzde kaç izledi ve tamamladı bilgisi burada takip edilir.
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              <ActionButton variant="dark" onClick={loadTrainings}>Yenile</ActionButton>
              <ActionButton onClick={openAddTraining}>İçerik Ekle</ActionButton>
            </div>
          </div>

          {trainingError ? (
            <div className="mt-4 rounded-2xl border border-red-500/20 bg-red-500/10 p-4 text-sm text-red-200">
              {trainingError}
            </div>
          ) : null}
        </div>

        <div className="hidden grid-cols-[1.2fr_.65fr_.9fr_.6fr_.7fr_.7fr_.8fr_1.1fr] gap-3 bg-white/[0.035] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid">
          <div>İçerik</div>
          <div>Tip</div>
          <div>Hedef</div>
          <div>Görüntüleme</div>
          <div>Tamamlama</div>
          <div>Ortalama</div>
          <div>Durum</div>
          <div>İşlem</div>
        </div>

        {trainingLoading ? (
          <EmptyState text="Eğitim içerikleri yükleniyor..." />
        ) : trainingRows.length === 0 ? (
          <EmptyState text="Henüz eğitim içeriği bulunamadı." />
        ) : (
          trainingRows.map((item) => (
            <div
              key={item.id}
              className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 hover:bg-yellow-500/[0.025] xl:grid-cols-[1.2fr_.65fr_.9fr_.6fr_.7fr_.7fr_.8fr_1.1fr]"
            >
              <div>
                <div className="font-bold text-white">{item.title}</div>
                <div className="mt-1 line-clamp-1 text-xs text-white/35">{item.description || "-"}</div>
              </div>
              <div>{item.contentType || "-"}</div>
              <div><TargetGroupBadge value={item.targetGroup} compact /></div>
              <div className="font-bold text-yellow-200">{formatNumber(item.viewCount)}</div>
              <div className="font-bold text-yellow-200">{formatNumber(item.completedCount)}</div>
              <div className="font-bold text-yellow-200">%{safeNumber(item.avgProgress)}</div>
              <div><StatusBadge status={item.status} /></div>
              <div className="flex flex-wrap gap-2">
                <RowActionButton onClick={() => openTrainingDetail(item)}>Detay</RowActionButton>
                <RowActionButton onClick={() => openEditTraining(item)}>Düzenle</RowActionButton>
                <RowActionButton danger onClick={() => handleDeleteTraining(item)}>Sil</RowActionButton>
              </div>
            </div>
          ))
        )}
      </Card>

      <TrainingContentModal
        open={trainingModal.open}
        mode={trainingModal.mode}
        form={trainingModal.form}
        saving={trainingSaving}
        uploadFile={trainingUploadFile}
        uploadProgressText={trainingUploadProgressText}
        onChange={handleTrainingFormChange}
        onFileChange={handleTrainingFileChange}
        onClose={closeTrainingModal}
        onSubmit={submitTraining}
      />

      <TrainingDetailModal
        open={trainingDetailModal.open}
        loading={trainingDetailModal.loading}
        content={trainingDetailModal.content}
        views={trainingDetailModal.views}
        onClose={() => setTrainingDetailModal({ open: false, loading: false, content: null, views: [] })}
        onExport={() => exportTrainingCsv(trainingDetailModal.content, trainingDetailModal.views)}
      />
    </div>
  );
}

function TrainingContentModal({ open, mode, form, saving, uploadFile, uploadProgressText, onChange, onFileChange, onClose, onSubmit }) {
    if (!open) return null;

    const isEdit = mode === "edit";

    return (
      <ModalShell title={isEdit ? "Eğitim Düzenle" : "Yeni Eğitim Ekle"} subtitle="Video, görsel veya doküman bağlantısı / dosya yükleme" onClose={onClose} wide>
        <form onSubmit={onSubmit} className="grid gap-4">
          <FormInput label="Eğitim Başlığı" name="title" value={form.title} onChange={onChange} />

          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Açıklama</span>
            <textarea
              name="description"
              value={form.description || ""}
              onChange={onChange}
              placeholder="Eğitim açıklaması"
              className="h-28 w-full resize-none rounded-2xl border border-white/10 bg-white/[0.035] px-4 py-3 text-sm text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35"
            />
          </label>

          <div className="grid gap-4 md:grid-cols-3">
            <FormSelect label="İçerik Tipi" name="contentType" value={form.contentType} onChange={onChange}>
              <option value="video">Video</option>
              <option value="image">Görsel</option>
              <option value="document">Doküman</option>
            </FormSelect>

            <FormSelect label="Hedef Kitle" name="targetGroup" value={form.targetGroup} onChange={onChange}>
              {TARGET_GROUP_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </FormSelect>

            <FormSelect label="Durum" name="status" value={form.status} onChange={onChange}>
              <option value="Aktif">Aktif</option>
              <option value="Taslak">Taslak</option>
              <option value="Pasif">Pasif</option>
            </FormSelect>
          </div>

          <label className="block rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4">
            <span className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-yellow-300">
              Video / Görsel / Doküman Yükle
            </span>
            <input
              type="file"
              accept="video/*,image/*,.pdf,.doc,.docx,.ppt,.pptx"
              onChange={onFileChange}
              className="block w-full cursor-pointer rounded-xl border border-white/10 bg-black/35 px-4 py-3 text-sm text-white file:mr-4 file:rounded-lg file:border-0 file:bg-yellow-500 file:px-4 file:py-2 file:text-sm file:font-bold file:text-black hover:file:bg-yellow-400"
              disabled={saving}
            />
            <div className="mt-2 text-xs leading-5 text-white/50">
              {uploadProgressText || "Telefon/kamera ile çektiğiniz videoyu buradan seçip yükleyebilirsiniz."}
            </div>
            {uploadFile ? (
              <div className="mt-2 text-xs font-semibold text-yellow-200">
                Seçilen dosya: {uploadFile.name}
              </div>
            ) : null}
          </label>

          <FormInput label="Dosya URL" name="fileUrl" value={form.fileUrl} onChange={onChange} placeholder="Dosya yüklenirse otomatik dolar. İstersen manuel /uploads/training/video.mp4 yazabilirsin." />
          <FormInput label="Harici URL" name="externalUrl" value={form.externalUrl} onChange={onChange} placeholder="YouTube, Drive veya farklı bağlantı" />

          <div className="rounded-2xl border border-yellow-500/20 bg-yellow-500/10 p-4 text-sm leading-6 text-yellow-100">
            Dosya seçersen önce sunucuya yüklenir, sonra oluşan bağlantı eğitim kaydına otomatik yazılır. Harici URL alanını YouTube/Drive gibi dış bağlantılar için kullanabilirsin.
          </div>

          <ModalActions onClose={onClose} saving={saving} submitText={isEdit ? "Güncelle" : "Kaydet"} />
        </form>
      </ModalShell>
    );
  }
function TrainingDetailModal({ open, loading, content, views, onClose, onExport }) {
    if (!open) return null;

    return (
      <ModalShell title="Eğitim İzlenme Detayı" subtitle={content?.title || "Eğitim detayı"} onClose={onClose} wide>
        <div className="mb-5 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="rounded-2xl border border-white/10 bg-black/25 p-4 text-sm text-white/55">
            Toplam görüntüleyen: <span className="font-bold text-yellow-300">{views.length}</span>
          </div>
          <ActionButton variant="dark" onClick={onExport}>Excel / CSV İndir</ActionButton>
        </div>

        {loading ? (
          <div className="rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/45">
            Detaylar yükleniyor...
          </div>
        ) : views.length === 0 ? (
          <div className="rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/45">
            Bu eğitim için henüz izlenme kaydı bulunmuyor.
          </div>
        ) : (
          <Card className="overflow-hidden">
            <div className="hidden grid-cols-[1fr_1fr_1fr_.7fr_.7fr_1fr_1fr] gap-3 bg-white/[0.035] px-5 py-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/38 xl:grid">
              <div>Ad Soyad</div>
              <div>Kullanıcı</div>
              <div>Hidden ID</div>
              <div>İlerleme</div>
              <div>Tamamlandı</div>
              <div>İlk Görüntüleme</div>
              <div>Son Görüntüleme</div>
            </div>

            {views.map((view) => (
              <div key={view.id} className="grid gap-3 border-t border-white/10 px-5 py-4 text-sm text-white/68 xl:grid-cols-[1fr_1fr_1fr_.7fr_.7fr_1fr_1fr]">
                <div className="font-bold text-white">{view.fullName || "-"}</div>
                <div>{view.username || "-"}</div>
                <div className="break-all text-white/45">{view.hiddenId || "-"}</div>
                <div className="font-bold text-yellow-200">%{safeNumber(view.progressPercent)}</div>
                <div>{Number(view.completed) === 1 ? "Evet" : "Hayır"}</div>
                <div className="text-white/40">{view.firstViewedAt || "-"}</div>
                <div className="text-white/40">{view.lastViewedAt || "-"}</div>
              </div>
            ))}
          </Card>
        )}
      </ModalShell>
    );
}

export default function AdminDashboard() {
  useMobileOnlyResponsiveLayout("wm-admin-dashboard-mobile");

  const [adminTheme, setAdminTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    const savedTheme = localStorage.getItem("wolf-admin-theme");
    return savedTheme === "light" || savedTheme === "dark" ? savedTheme : "dark";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    localStorage.setItem("wolf-admin-theme", adminTheme);
  }, [adminTheme]);

  const [activeKey, setActiveKey] = useState("dashboard");
  const { users, loading, error, reload } = useAdminUsers();
  const [saving, setSaving] = useState(false);
  const [publisherModal, setPublisherModal] = useState({ open: false, mode: "add" });
  const [managerModal, setManagerModal] = useState({ open: false, mode: "add" });
  const [scoutModal, setScoutModal] = useState({ open: false, mode: "add" });
  const [publisherForm, setPublisherForm] = useState(emptyPublisherForm);
  const [managerForm, setManagerForm] = useState(emptyManagerForm);
  const [scoutForm, setScoutForm] = useState(emptyScoutForm);
  const [editingId, setEditingId] = useState(null);
  const [passwordModal, setPasswordModal] = useState({ open: false, target: null });
  const [passwordForm, setPasswordForm] = useState(emptyPasswordForm);
  const [deleteModal, setDeleteModal] = useState({ open: false, target: null, type: "" });
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkSummary, setBulkSummary] = useState(null);
  const [bulkPasswordModal, setBulkPasswordModal] = useState(false);
  const [bulkPasswordSummary, setBulkPasswordSummary] = useState(null);
  const [reportUploadModal, setReportUploadModal] = useState(false);
  const [reportUploadSummary, setReportUploadSummary] = useState(null);
  const [performanceSummaryRows, setPerformanceSummaryRows] = useState([]);
  const [performanceSummaryLoading, setPerformanceSummaryLoading] = useState(false);
  const [performanceReloadKey, setPerformanceReloadKey] = useState(0);
  const [passwordRequests, setPasswordRequests] = useState([]);
  const [passwordRequestsLoading, setPasswordRequestsLoading] = useState(false);
  const [passwordRequestsError, setPasswordRequestsError] = useState("");
  const [publisherImageFile, setPublisherImageFile] = useState(null);
  const [featuredPublishersList, setFeaturedPublishersList] = useState([]);
  const [adminMessages, setAdminMessages] = useState([]);
  const [selectedAdminMessageId, setSelectedAdminMessageId] = useState(null);
  const [academyRows, setAcademyRows] = useState([]);
  const [academyLoading, setAcademyLoading] = useState(false);
  const currentAdmin = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, []);
  const isSuperAdmin = isUserSuperAdmin(currentAdmin);
  const allItems = useMemo(() => [
    { key: "dashboard", label: "Yönetim Özeti" },
    ...managementSubModules,
    ...scoutSubModules,
    ...reportSubModules,
    ...(isSuperAdmin ? giftPrimeSubModules : []),
    ...otherSettingsSubModules,
  ], [isSuperAdmin]);
  const activeLabel = allItems.find((item) => item.key === activeKey)?.label || "Kontrol Merkezi";
  const publisherRows = useMemo(() => buildPublisherRows(users), [users]);
  const managerRows = useMemo(() => buildManagerRows(users), [users]);
  const scoutRows = useMemo(() => buildScoutRows(users), [users]);
  const [selectedManagerFilter, setSelectedManagerFilter] = useState("all");
  const [selectedPublisherFilter, setSelectedPublisherFilter] = useState("all");

  const filteredPublisherRowsForPerformance = useMemo(() => {
    let rows = publisherRows || [];

    if (selectedManagerFilter && selectedManagerFilter !== "all") {
      const targetManager = String(selectedManagerFilter).toLowerCase().trim();
      const matchedMgr = (managerRows || []).find(
        (m) =>
          String(m.username || "").toLowerCase().trim() === targetManager ||
          String(m.id || "") === targetManager
      );
      const mgrFullName = matchedMgr ? String(matchedMgr.fullName || "").toLowerCase().trim() : "";

      rows = rows.filter((publisher) => {
        const assigned = String(publisher.assignedEmployeeUsername || publisher.representative || "").toLowerCase().trim();
        const mName = String(publisher.managerName || "").toLowerCase().trim();
        return (
          assigned === targetManager ||
          mName === targetManager ||
          (mgrFullName && (assigned === mgrFullName || mName === mgrFullName))
        );
      });
    }

    if (selectedPublisherFilter && selectedPublisherFilter !== "all") {
      rows = rows.filter(
        (publisher) => String(publisher.id) === String(selectedPublisherFilter)
      );
    }

    return rows;
  }, [publisherRows, managerRows, selectedManagerFilter, selectedPublisherFilter]);
  
  const defaultReportRange = useMemo(() => getDefaultReportRange(), []);

  const [reportStartDate, setReportStartDate] = useState(defaultReportRange.start);
  const [reportEndDate, setReportEndDate] = useState(defaultReportRange.end);

  const [adminPerformance, setAdminPerformance] = useState(null);
  const [agencyOverallPerformance, setAgencyOverallPerformance] = useState(null);
  const [previousAdminPerformance, setPreviousAdminPerformance] = useState(null);
  const [adminPerformanceLoading, setAdminPerformanceLoading] = useState(false);
  const [adminPerformanceError, setAdminPerformanceError] = useState("");

  const hiddenIdsForPerformance = useMemo(() => {
    return filteredPublisherRowsForPerformance
      .map((publisher) => getPublisherHiddenId(publisher))
      .filter((hiddenId) => hiddenId && hiddenId !== "-")
      .join(",");
  }, [filteredPublisherRowsForPerformance]);

  const usernamesForPerformance = useMemo(() => {
    return filteredPublisherRowsForPerformance
      .map((publisher) => normalizeUsername(publisher.username || publisher.name || ""))
      .filter(Boolean)
      .join(",");
  }, [filteredPublisherRowsForPerformance]);

  useEffect(() => {
    if (!hiddenIdsForPerformance && !usernamesForPerformance && filteredPublisherRowsForPerformance.length > 0) {
      setAdminPerformance(null);
      setPreviousAdminPerformance(null);
      return;
    }

    let ignore = false;

    async function loadAdminPerformance() {
      try {
        setAdminPerformanceLoading(true);
        setAdminPerformanceError("");

        const previousRange = getPreviousEqualDateRange(
          reportStartDate,
          reportEndDate
        );

        const isAllSelected = (!selectedManagerFilter || selectedManagerFilter === "all") && (!selectedPublisherFilter || selectedPublisherFilter === "all");

        let queryParams = `startDate=${encodeURIComponent(reportStartDate)}&endDate=${encodeURIComponent(reportEndDate)}`;
        let prevQueryParams = `startDate=${encodeURIComponent(previousRange.start)}&endDate=${encodeURIComponent(previousRange.end)}`;

        if (!isAllSelected) {
          if (hiddenIdsForPerformance) {
            queryParams += `&hiddenIds=${encodeURIComponent(hiddenIdsForPerformance)}`;
            prevQueryParams += `&hiddenIds=${encodeURIComponent(hiddenIdsForPerformance)}`;
          }
          if (usernamesForPerformance) {
            queryParams += `&usernames=${encodeURIComponent(usernamesForPerformance)}`;
            prevQueryParams += `&usernames=${encodeURIComponent(usernamesForPerformance)}`;
          }
        }

        const currentUrl = `${API_ADMIN_PERFORMANCE}?${queryParams}`;
        const previousUrl = `${API_ADMIN_PERFORMANCE}?${prevQueryParams}`;
        const agencyUrl = `${API_ADMIN_PERFORMANCE}?startDate=${encodeURIComponent(reportStartDate)}&endDate=${encodeURIComponent(reportEndDate)}`;

        const [currentResult, previousResult, agencyResult] = await Promise.all([
          requestJson(currentUrl, { cache: "no-store" }),
          requestJson(previousUrl, { cache: "no-store" }),
          isAllSelected ? null : requestJson(agencyUrl, { cache: "no-store" }).catch(() => null),
        ]);

        if (!ignore) {
          setAdminPerformance(currentResult);
          setPreviousAdminPerformance(previousResult);
          if (isAllSelected) {
            setAgencyOverallPerformance(currentResult);
          } else if (agencyResult) {
            setAgencyOverallPerformance(agencyResult);
          }

          if (currentResult?.summary?.effectiveStartDate && currentResult.summary.effectiveStartDate !== reportStartDate) {
            setReportStartDate(currentResult.summary.effectiveStartDate);
            if (currentResult.summary.effectiveEndDate) {
              setReportEndDate(currentResult.summary.effectiveEndDate);
            }
          }
        }
      } catch (err) {
        console.error("Admin performans verisi alınamadı:", err);

        if (!ignore) {
          setAdminPerformanceError(err.message || "Performans verisi alınamadı.");
          setPreviousAdminPerformance(null);
        }
      } finally {
        if (!ignore) {
          setAdminPerformanceLoading(false);
        }
      }
    }

    loadAdminPerformance();

    return () => {
      ignore = true;
    };
  }, [hiddenIdsForPerformance, usernamesForPerformance, reportStartDate, reportEndDate, performanceReloadKey]);
  
const loadAdminMessages = useCallback(async () => {
  try {
    const adminId = currentAdmin?.id || 1;

    const result = await requestJson(
      `${API_MESSAGES_LIST}?user_id=${adminId}&role=admin`,
      { cache: "no-store" }
    );

    const list = result.messages || [];
    setAdminMessages(list);
    setSelectedAdminMessageId((prev) => prev || (list.length > 0 ? list[0].id : null));
  } catch (err) {
    console.error("Admin mesajları alınamadı:", err);
  }
}, [currentAdmin?.id]);

async function loadAcademyRows() {
  try {
    setAcademyLoading(true);

    const result = await requestJson(API_ACADEMY_LIST, {
      cache: "no-store",
    });

    setAcademyRows(result.trainings || []);
  } catch (err) {
    console.error("Akademi içerikleri alınamadı:", err);
    setAcademyRows([]);
  } finally {
    setAcademyLoading(false);
  }
}

useEffect(() => {
  loadAcademyRows();
}, []);

const loadPasswordRequests = useCallback(async () => {
  try {
    setPasswordRequestsLoading(true);
    setPasswordRequestsError("");

    const result = await requestJson(API_PASSWORD_RESET_LIST, { cache: "no-store" });
    setPasswordRequests(result.requests || result.data || []);
  } catch (err) {
    setPasswordRequests([]);
    setPasswordRequestsError(err.message || "Şifre talepleri alınamadı.");
  } finally {
    setPasswordRequestsLoading(false);
  }
}, []);

useEffect(() => {
  loadPasswordRequests();
}, [loadPasswordRequests]);

useEffect(() => {
  loadAdminMessages();
}, [loadAdminMessages]);

  const loadFeaturedListForSync = useCallback(async () => {
    try {
      const res = await requestJson(API_FEATURED_PUBLISHER_LIST, { cache: "no-store" });
      setFeaturedPublishersList(Array.isArray(res.publishers) ? res.publishers : []);
    } catch {
      setFeaturedPublishersList([]);
    }
  }, []);

  useEffect(() => {
    loadFeaturedListForSync();
  }, [loadFeaturedListForSync]);

  function handlePublisherFormChange(event) {
    const { name, value, type, checked } = event.target;
    setPublisherForm((prev) => {
      const next = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
      if (name === "username" && (!prev.system_username || prev.system_username.startsWith("wolf."))) {
        const cleanU = String(value || "").replace(/[@\s]+/g, "").toLowerCase();
        if (cleanU) {
          next.system_username = `wolf.${cleanU}`;
        }
      }
      return next;
    });
  }

  function handlePublisherImageFileChange(event) {
    const file = event.target.files?.[0] || null;
    setPublisherImageFile(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPublisherForm((prev) => ({ ...prev, image: previewUrl }));
    }
  }

  function handleManagerFormChange(event) {
    const { name, value } = event.target;
    setManagerForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleScoutFormChange(event) {
    const { name, value } = event.target;
    setScoutForm((prev) => ({ ...prev, [name]: value }));
  }

  function handlePasswordFormChange(event) {
    const { name, value } = event.target;
    setPasswordForm((prev) => ({ ...prev, [name]: value }));
  }

  function openAddPublisher() {
    setPublisherImageFile(null);
    setPublisherForm(emptyPublisherForm);
    setEditingId(null);
    setPublisherModal({ open: true, mode: "add" });
    setActiveKey("publisher_list");
  }

  function openEditPublisher(user) {
    setPublisherImageFile(null);
    setEditingId(user.id);
    const userCleanUser = String(user.username || "").replace(/[@\s]+/g, "").toLowerCase();
    const matchedFeatured = featuredPublishersList.find((fp) => {
      const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
      return (
        (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
        String(fp.id) === String(user.id)
      );
    });

    const sysUser = user.system_username || user.systemUsername || (user.username ? `wolf.${String(user.username).replace(/[@\s]+/g, "").toLowerCase()}` : "");

    setPublisherForm({
      fullName: user.fullName || "",
      system_username: sysUser,
      username: user.username || "",
      email: user.email || "",
      password: "",
      phone: user.phone === "-" ? "" : user.phone || "",
      hiddenId: user.hiddenId === "-" ? "" : user.hiddenId || "",
      assignedEmployeeUsername: user.assignedEmployeeUsername || "",
      powerBIRole: user.powerBIRole === "-" ? "" : user.powerBIRole || "",
      agencyTrackingStatus: getPublisherAgencyTrackingStatus(user),
      status: user.status || "Aktif",
      note: user.note || "",
      image: user.image || user.profileImage || matchedFeatured?.image || matchedFeatured?.currentImage || "",
      isFeatured: Boolean(matchedFeatured),
    });
    setPublisherModal({ open: true, mode: "edit" });
  }

  function openAddPublisherWithData(initialData = {}, onComplete = null) {
    setPublisherImageFile(null);
    const rawUser = String(initialData.username || "").trim();
    const cleanU = rawUser.replace(/[@\s]+/g, "").toLowerCase();
    const sysUser = initialData.system_username || (cleanU ? `wolf.${cleanU}` : "");

    setPublisherForm({
      ...emptyPublisherForm,
      fullName: initialData.fullName || rawUser || "",
      username: rawUser,
      system_username: sysUser,
      hiddenId: initialData.hiddenId || "",
      password: initialData.password || "123456",
      assignedEmployeeUsername: initialData.assignedEmployeeUsername || "",
      powerBIRole: initialData.powerBIRole || "",
      agencyTrackingStatus: "Aktif",
      status: "Aktif",
      ...initialData,
    });
    setEditingId(null);
    setPublisherModal({ open: true, mode: "add", onSavedCallback: onComplete });
  }

  function openEditPublisherWithData(user, updatedData = {}, onComplete = null) {
    setPublisherImageFile(null);
    setEditingId(user.id);
    const newUsername = updatedData.username || user.username || "";
    const userCleanUser = String(newUsername || "").replace(/[@\s]+/g, "").toLowerCase();
    const matchedFeatured = featuredPublishersList.find((fp) => {
      const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
      return (
        (fpCleanUser && userCleanUser && fpCleanUser === userCleanUser) ||
        String(fp.id) === String(user.id)
      );
    });

    const sysUser = user.system_username || user.systemUsername || (userCleanUser ? `wolf.${userCleanUser}` : "");

    setPublisherForm({
      fullName: user.fullName || "",
      system_username: sysUser,
      username: newUsername,
      email: user.email === "-" ? "" : user.email || "",
      password: "",
      phone: user.phone === "-" ? "" : user.phone || "",
      hiddenId: updatedData.hiddenId || (user.hiddenId === "-" ? "" : user.hiddenId || ""),
      assignedEmployeeUsername: user.assignedEmployeeUsername || user.representative || "",
      powerBIRole: user.powerBIRole === "-" ? "" : user.powerBIRole || "",
      agencyTrackingStatus: getPublisherAgencyTrackingStatus(user),
      status: user.status || "Aktif",
      image: user.image || user.profileImage || matchedFeatured?.image || matchedFeatured?.currentImage || "",
      isFeatured: Boolean(matchedFeatured),
      ...updatedData,
    });
    setPublisherModal({ open: true, mode: "edit", onSavedCallback: onComplete });
  }

  function openAddManager() {
    setManagerForm(emptyManagerForm);
    setEditingId(null);
    setManagerModal({ open: true, mode: "add" });
    setActiveKey("manager_list");
  }

  function openEditManager(user) {
    setEditingId(user.id);
    setManagerForm({
      fullName: user.fullName || "",
      username: user.username || "",
      password: "",
      phone: user.phone === "-" ? "" : user.phone || "",
      email: user.email === "-" ? "" : user.email || "",
      status: user.status || "Aktif",
    });
    setManagerModal({ open: true, mode: "edit" });
  }

  function openAddScout() {
    setScoutForm(emptyScoutForm);
    setEditingId(null);
    setScoutModal({ open: true, mode: "add" });
    setActiveKey("scout_personnel");
  }

  function openEditScout(user) {
    setEditingId(user.id);
    setScoutForm({
      fullName: user.fullName || "",
      username: user.username || "",
      password: "",
      phone: user.phone === "-" ? "" : user.phone || "",
      email: user.email === "-" ? "" : user.email || "",
      status: user.status || "Aktif",
    });
    setScoutModal({ open: true, mode: "edit" });
  }

  function openPassword(target) {
    setPasswordModal({ open: true, target });
    setPasswordForm(emptyPasswordForm);
  }

  function openDelete(target, type) {
    setDeleteModal({ open: true, target, type });
  }

  async function submitPublisher(event) {
    event.preventDefault();
    const isEdit = publisherModal.mode === "edit";

    if (!publisherForm.fullName.trim() || !publisherForm.username.trim()) {
      alert("Ad soyadı ve kullanıcı adı zorunlu.");
      return;
    }

    if (!isEdit && !publisherForm.password.trim()) {
      alert("Şifre zorunlu.");
      return;
    }

    try {
      setSaving(true);
      const cleanU = publisherForm.username.trim().replace(/[@\s]+/g, "").toLowerCase();
      const payload = {
        fullName: publisherForm.fullName.trim(),
        username: publisherForm.username.trim(),
        system_username: (publisherForm.system_username && publisherForm.system_username.trim()) || `wolf.${cleanU}`,
        role: "publisher",
        phone: publisherForm.phone.trim(),
        email: publisherForm.email.trim(),
        hiddenId: publisherForm.hiddenId.trim(),
        representative: publisherForm.assignedEmployeeUsername,
        powerBIRole: publisherForm.powerBIRole.trim(),
        agencyTrackingStatus: publisherForm.agencyTrackingStatus || "Aktif",
        status: publisherForm.status,
        note: publisherForm.note || "",
      };

      if (isEdit) {
        payload.id = editingId;
      } else {
        payload.password = publisherForm.password.trim();
      }

      await requestJson(isEdit ? API_USER_UPDATE : API_USER_ADD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      // Handle Featured Status Sync
      try {
        const formCleanUser = String(publisherForm.username || "").replace(/[@\s]+/g, "").toLowerCase();
        const matchedFeatured = featuredPublishersList.find((fp) => {
          const fpCleanUser = String(fp.username || "").replace(/[@\s]+/g, "").toLowerCase();
          return (
            (fpCleanUser && formCleanUser && fpCleanUser === formCleanUser) ||
            (isEdit && String(fp.id) === String(editingId))
          );
        });

        if (publisherForm.isFeatured) {
          const featuredPayload = new FormData();
          if (matchedFeatured && matchedFeatured.id) {
            featuredPayload.append("id", matchedFeatured.id);
          }
          featuredPayload.append("name", publisherForm.fullName.trim());
          featuredPayload.append("username", publisherForm.username.trim());
          featuredPayload.append("tiktokUrl", `https://www.tiktok.com/@${publisherForm.username.trim()}`);
          featuredPayload.append("imageBoxText", publisherForm.fullName.trim());
          featuredPayload.append("status", "Aktif");
          featuredPayload.append("sortOrder", "0");
          featuredPayload.append("currentImage", publisherForm.image || "");
          featuredPayload.append("createdBy", currentAdmin?.username || "admin");
          if (publisherImageFile) {
            featuredPayload.append("image", publisherImageFile);
          }

          await fetch(API_FEATURED_PUBLISHER_SAVE, {
            method: "POST",
            body: featuredPayload,
          });
        } else if (matchedFeatured && matchedFeatured.id) {
          await fetch(API_FEATURED_PUBLISHER_DELETE, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: matchedFeatured.id }),
          });
        }

        await loadFeaturedListForSync();
      } catch (featErr) {
        console.warn("Öne çıkan yayıncı kaydedilemedi:", featErr);
      }

      try {
        await requestJson(API_AGENCY_TRACKING_SAVE, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: isEdit ? editingId : undefined,
            username: publisherForm.username.trim(),
            hiddenId: publisherForm.hiddenId.trim(),
            status: publisherForm.agencyTrackingStatus || "Aktif",
            source: isEdit ? "admin_edit" : "admin_create",
            updatedBy: currentAdmin?.username || "admin",
          }),
        });
      } catch (agencyErr) {
        console.warn("Ajans takip tercihi kaydedilemedi:", agencyErr);
      }

      const callback = publisherModal.onSavedCallback;
      setPublisherModal({ open: false, mode: "add", onSavedCallback: null });
      setPublisherForm(emptyPublisherForm);
      setPublisherImageFile(null);
      setEditingId(null);
      await reload();
      if (typeof callback === "function") {
        try { callback(); } catch (_) {}
      }
      alert(isEdit ? "Yayıncı başarıyla güncellendi ve yayınlandı." : "Yayıncı başarıyla eklendi ve yayınlandı.");
    } catch (err) {
      alert(err.message || "Yayıncı işlemi başarısız.");
    } finally {
      setSaving(false);
    }
  }

  async function submitManager(event) {
    event.preventDefault();
    const isEdit = managerModal.mode === "edit";

    if (!managerForm.fullName.trim() || !managerForm.username.trim() || !managerForm.email.trim()) {
      alert("Ad soyadı, kullanıcı adı ve mail zorunlu.");
      return;
    }

    if (!isEdit && !managerForm.password.trim()) {
      alert("Şifre zorunlu.");
      return;
    }

    try {
      setSaving(true);
      const payload = {
        fullName: managerForm.fullName.trim(),
        username: managerForm.username.trim(),
        role: "employee",
        phone: managerForm.phone.trim(),
        email: managerForm.email.trim(),
        hiddenId: "",
        representative: "",
        powerBIRole: "manager_team_rls",
        status: managerForm.status,
      };

      if (isEdit) {
        payload.id = editingId;
        if (managerForm.password && managerForm.password.trim()) {
          payload.password = managerForm.password.trim();
        }
      } else {
        payload.password = managerForm.password.trim();
      }

      await requestJson(isEdit ? API_USER_UPDATE : API_USER_ADD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      setManagerModal({ open: false, mode: "add" });
      setManagerForm(emptyManagerForm);
      setEditingId(null);
      await reload();
      alert(isEdit ? "Yönetici güncellendi." : "Yönetici oluşturuldu.");
    } catch (err) {
      alert(err.message || "Yönetici işlemi başarısız.");
    } finally {
      setSaving(false);
    }
  }

  async function submitScout(event) {
    event.preventDefault();
    const isEdit = scoutModal.mode === "edit";

    if (!scoutForm.fullName.trim() || !scoutForm.username.trim() || !scoutForm.email.trim()) {
      alert("Ad soyadı, kullanıcı adı ve e-posta zorunlu.");
      return;
    }

    if (!isEdit && !scoutForm.password.trim()) {
      alert("Geçici şifre zorunlu.");
      return;
    }

    try {
      setSaving(true);

      const payload = {
        fullName: scoutForm.fullName.trim(),
        username: scoutForm.username.trim(),
        role: "scout",
        phone: scoutForm.phone.trim(),
        email: scoutForm.email.trim(),
        hiddenId: "",
        representative: "",
        powerBIRole: "",
        status: scoutForm.status,
      };

      if (isEdit) {
        payload.id = editingId;
      } else {
        payload.password = scoutForm.password.trim();
      }

      await requestJson(isEdit ? API_USER_UPDATE : API_USER_ADD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      setScoutModal({ open: false, mode: "add" });
      setScoutForm(emptyScoutForm);
      setEditingId(null);
      await reload();
      alert(isEdit ? "Aday takip personeli güncellendi." : "Aday takip personeli oluşturuldu.");
    } catch (err) {
      alert(err.message || "Aday takip personeli işlemi başarısız.");
    } finally {
      setSaving(false);
    }
  }

  async function submitPassword(event) {
    event.preventDefault();

    if (!passwordForm.newPassword.trim() || !passwordForm.confirmPassword.trim()) {
      alert("Yeni şifre alanları zorunlu.");
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      alert("Şifreler eşleşmiyor.");
      return;
    }

    if (!passwordModal.target?.id) {
      alert("Kullanıcı ID bulunamadı.");
      return;
    }

    try {
      setSaving(true);
      await requestJson(API_PASSWORD_UPDATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: passwordModal.target.id, password: passwordForm.newPassword.trim() }),
      });

      setPasswordModal({ open: false, target: null });
      setPasswordForm(emptyPasswordForm);
      alert("Şifre güncellendi.");
    } catch (err) {
      alert(err.message || "Şifre güncellenemedi.");
    } finally {
      setSaving(false);
    }
  }

  async function confirmDelete() {
    if (!deleteModal.target?.id) return;

    try {
      setSaving(true);
      await requestJson(API_USER_DELETE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: deleteModal.target.id }),
      });

      setDeleteModal({ open: false, target: null, type: "" });
      await reload();
      alert("Kayıt silindi.");
    } catch (err) {
      alert(err.message || "Silme işlemi başarısız.");
    } finally {
      setSaving(false);
    }
  }

  async function handleBulkImportFile(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      setSaving(true);
      setBulkSummary(null);

      const text = await file.text();
      const rows = csvToPublisherRows(text);

      if (!rows.length) {
        alert("CSV içinde aktarılacak kayıt bulunamadı.");
        return;
      }

      const result = await requestJson(API_BULK_UPLOAD, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rows }),
      });

      setBulkSummary(result);
      await reload();

      alert(`Toplu yükleme tamamlandı. Oluşturulan: ${result.createdCount || 0}, Güncellenen: ${result.updatedCount || 0}, Hatalı: ${result.errorCount || 0}`);
    } catch (err) {
      alert(err.message || "Toplu yükleme hatası.");
    } finally {
      setSaving(false);
      event.target.value = "";
    }
  }

  async function handleBulkPasswordImportFile(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      setSaving(true);
      setBulkPasswordSummary(null);

      const text = await file.text();
      const rows = csvToPasswordRows(text);

      if (!rows.length) {
        alert("CSV içinde güncellenecek şifre kaydı bulunamadı.");
        return;
      }

      const result = await requestJson(API_BULK_PASSWORD_UPDATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rows }),
      });

      setBulkPasswordSummary(result);
      await reload();

      alert(`Toplu şifre güncelleme tamamlandı. Güncellenen: ${result.updatedCount || 0}, Hatalı: ${result.errorCount || 0}`);
    } catch (err) {
      alert(err.message || "Toplu şifre güncelleme hatası.");
    } finally {
      setSaving(false);
      event.target.value = "";
    }
  }

  async function loadPerformanceSummary() {
    try {
      setPerformanceSummaryLoading(true);

      const result = await requestJson(`${API_PERFORMANCE_SUMMARY}?key=123456`, {
        cache: "no-store",
      });

      setPerformanceSummaryRows(Array.isArray(result.data) ? result.data : []);
    } catch (err) {
      setPerformanceSummaryRows([]);
      console.warn("Yüklü rapor özeti alınamadı:", err);
    } finally {
      setPerformanceSummaryLoading(false);
    }
  }
    
  async function handleReportUploadFile(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      setSaving(true);
      setReportUploadSummary(null);

      const formData = new FormData();
      formData.append("csv_file", file);

      const response = await fetch(`${API_PERFORMANCE_UPLOAD}?key=123456`, {
        method: "POST",
        body: formData,
      });

      const text = await response.text();
      let result = null;
      try {
        result = JSON.parse(text);
      } catch {}

      if (!response.ok || (result && result.success === false)) {
        throw new Error(result?.message || text || "Rapor yükleme başarısız.");
      }

      setReportUploadSummary({
        success: true,
        message: result?.message || "Rapor başarıyla yüklendi.",
        createdCount: result?.count || 0,
        updatedCount: 0,
        errorCount: 0,
      });

      setPerformanceReloadKey((prev) => prev + 1);
      await loadPerformanceSummary();

      alert(result?.message || "Rapor yükleme başarıyla tamamlandı.");
    } catch (err) {
      alert(err.message || "Rapor yükleme hatası.");
    } finally {
      setSaving(false);
      event.target.value = "";
    }
  }

  async function handleDeleteReportDate(date) {
    if (!window.confirm(`${formatDateForDisplay(date)} (${date}) gününe ait TÜM performans kayıtlarını veritabanından kalıcı olarak silmek istediğinize emin misiniz?`)) return;
    try {
      setSaving(true);
      const response = await fetch(API_PERFORMANCE_DELETE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ date }),
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.message || "Silme işlemi başarısız.");
      alert(data.message || "Tarih kaydı başarıyla silindi.");
      setPerformanceReloadKey((prev) => prev + 1);
      await loadPerformanceSummary();
    } catch (err) {
      alert(err.message || "Silme hatası oluştu.");
    } finally {
      setSaving(false);
    }
  }

  async function handleDeleteReportMonth(month, label) {
    if (!window.confirm(`${label || month} ayına ait TÜM performans verilerini veritabanından kalıcı olarak silmek istediğinize emin misiniz?`)) return;
    try {
      setSaving(true);
      const response = await fetch(API_PERFORMANCE_DELETE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ month }),
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.message || "Silme işlemi başarısız.");
      alert(data.message || "Ay verileri başarıyla silindi.");
      setPerformanceReloadKey((prev) => prev + 1);
      await loadPerformanceSummary();
    } catch (err) {
      alert(err.message || "Silme hatası oluştu.");
    } finally {
      setSaving(false);
    }
  }

  async function handleDeleteAllReports() {
    const confirm1 = window.confirm("DİKKAT! Veritabanındaki TÜM geçmiş TikTok performans verileri kalıcı olarak silinecek ve tablo tamamen sıfırlanacaktır.\n\nBu işlem geri alınamaz! Devam etmek istiyor musunuz?");
    if (!confirm1) return;
    const confirm2 = window.prompt("Tüm verileri silmeyi onaylamak için lütfen 'SIL' yazıp Tamam'a basınız:");
    if (confirm2 !== "SIL") {
      alert("İşlem iptal edildi.");
      return;
    }
    try {
      setSaving(true);
      const response = await fetch(API_PERFORMANCE_DELETE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "truncate" }),
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.message || "Sıfırlama işlemi başarısız.");
      alert(data.message || "Tüm performans verileri başarıyla sıfırlandı.");
      setPerformanceReloadKey((prev) => prev + 1);
      await loadPerformanceSummary();
    } catch (err) {
      alert(err.message || "Sıfırlama hatası oluştu.");
    } finally {
      setSaving(false);
    }
  }

  const actions = {
    openAddPublisher,
    openEditPublisher,
    openAddPublisherWithData,
    openEditPublisherWithData,
    openAddManager,
    openEditManager,
    openAddScout,
    openEditScout,
    openPassword,
    openDelete,
    openBulkUpload: () => setBulkModal(true),
  };

  function handleNewRecord() {
    if (activeKey.startsWith("manager_")) {
      openAddManager();
    } else {
      openAddPublisher();
    }
  }

  return (
    <div
      className={`wm-admin-theme wm-admin-${adminTheme} min-h-screen ${
        adminTheme === "dark" ? "bg-black text-white" : "bg-[#f4f6f8] text-[#182230]"
      }`}
    >
      <style>{`::selection { background: rgba(234,179,8,.35); }`}</style>
      <style>{ADMIN_THEME_STYLES}</style>
      <div className="fixed inset-0 bg-[radial-gradient(circle_at_top,rgba(212,175,55,0.13),transparent_34%),linear-gradient(180deg,#050505_0%,#090909_45%,#000_100%)]" />
      <div className="fixed inset-0 opacity-[0.04] [background-image:linear-gradient(rgba(255,255,255,.14)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.14)_1px,transparent_1px)] [background-size:42px_42px]" />
      <div className="relative z-10 flex min-h-screen">
        <Sidebar activeKey={activeKey} setActiveKey={setActiveKey} currentAdmin={currentAdmin} />
        <main className={`min-w-0 flex-1 overflow-x-hidden ${workManagementSubModules.some((item) => item.key === activeKey) ? "p-0 pb-0" : "p-4 pb-24 lg:p-6 xl:p-8 xl:pb-8"}`}>
          {!workManagementSubModules.some((item) => item.key === activeKey) && (
            <Header
              activeLabel={activeLabel}
              apiError={error}
              onReportUploadClick={async () => {
                setReportUploadModal(true);
                await loadPerformanceSummary();
              }}
              onNewRecord={handleNewRecord}
              onBulkClick={() => setBulkModal(true)}
              onBulkPasswordClick={() => setBulkPasswordModal(true)}
              theme={adminTheme}
              setTheme={setAdminTheme}
            />
          )}
          {!workManagementSubModules.some((item) => item.key === activeKey) && (
            <MobileMenu activeKey={activeKey} setActiveKey={setActiveKey} currentAdmin={currentAdmin} />
          )}
          <ContentRouter
            activeKey={activeKey}
            setActiveKey={setActiveKey}
            publisherRows={publisherRows}
            managerRows={managerRows}
            scoutRows={scoutRows}
            loading={loading}
            error={error}
            reload={reload}
            actions={actions}
            adminMessages={adminMessages}
            selectedAdminMessageId={selectedAdminMessageId}
            setSelectedAdminMessageId={setSelectedAdminMessageId}
            reloadAdminMessages={loadAdminMessages}
            passwordRequests={passwordRequests}
            passwordRequestsLoading={passwordRequestsLoading}
            passwordRequestsError={passwordRequestsError}
            loadPasswordRequests={loadPasswordRequests}
            adminPerformance={adminPerformance}
            previousAdminPerformance={previousAdminPerformance}
            adminPerformanceLoading={adminPerformanceLoading}
            adminPerformanceError={adminPerformanceError}
            reportStartDate={reportStartDate}
            reportEndDate={reportEndDate}
            setReportStartDate={setReportStartDate}
            setReportEndDate={setReportEndDate}
            selectedManagerFilter={selectedManagerFilter}
            setSelectedManagerFilter={setSelectedManagerFilter}
            selectedPublisherFilter={selectedPublisherFilter}
            setSelectedPublisherFilter={setSelectedPublisherFilter}
            filteredPublisherRowsForPerformance={filteredPublisherRowsForPerformance}
          agencyOverallPerformance={agencyOverallPerformance}
            academyRows={academyRows}
            academyLoading={academyLoading}
            loadAcademyRows={loadAcademyRows}
            currentAdmin={currentAdmin}
            adminTheme={adminTheme}
            onReportUploadClick={() => setReportUploadModal(true)}
          />
        </main>
      </div>

      <PublisherModal mode={publisherModal.mode} open={publisherModal.open} form={publisherForm} setForm={setPublisherForm} managers={managerRows} saving={saving} onChange={handlePublisherFormChange} onFileChange={handlePublisherImageFileChange} onClose={() => setPublisherModal({ open: false, mode: "add" })} onSubmit={submitPublisher} />
      <ManagerModal mode={managerModal.mode} open={managerModal.open} form={managerForm} saving={saving} onChange={handleManagerFormChange} onClose={() => setManagerModal({ open: false, mode: "add" })} onSubmit={submitManager} />
      <ScoutPersonnelModal mode={scoutModal.mode} open={scoutModal.open} form={scoutForm} saving={saving} onChange={handleScoutFormChange} onClose={() => setScoutModal({ open: false, mode: "add" })} onSubmit={submitScout} />
      <PasswordModal open={passwordModal.open} target={passwordModal.target} form={passwordForm} saving={saving} onChange={handlePasswordFormChange} onClose={() => setPasswordModal({ open: false, target: null })} onSubmit={submitPassword} />
      <DeleteModal open={deleteModal.open} target={deleteModal.target} saving={saving} onClose={() => setDeleteModal({ open: false, target: null, type: "" })} onConfirm={confirmDelete} />
      <BulkUploadModal
        open={bulkModal}
        summary={bulkSummary}
        saving={saving}
        onClose={() => setBulkModal(false)}
        onFileChange={handleBulkImportFile}
      />

      <BulkPasswordUpdateModal
        open={bulkPasswordModal}
        summary={bulkPasswordSummary}
        saving={saving}
        onClose={() => setBulkPasswordModal(false)}
        onFileChange={handleBulkPasswordImportFile}
      />

      <ReportUploadModal
        open={reportUploadModal}
        summary={reportUploadSummary}
        saving={saving}
        summaryRows={performanceSummaryRows}
        summaryLoading={performanceSummaryLoading}
        onClose={() => setReportUploadModal(false)}
        onFileChange={handleReportUploadFile}
        onDeleteDate={handleDeleteReportDate}
        onDeleteMonth={handleDeleteReportMonth}
        onDeleteAll={handleDeleteAllReports}
      />
    </div>
  );
}
